import { CircularProgress, Paper, Box, Typography, Grid, Backdrop, Container, TextField, InputAdornment, IconButton, withTheme as withTheme$1, Checkbox, FormControlLabel, Button, Link as Link$1, Tooltip, ListSubheader, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, SvgIcon, Dialog, MenuItem, Breadcrumbs, createStyles as createStyles$1, DialogTitle, DialogContent, DialogActions, TableRow, TableCell, TableContainer, LinearProgress, Table, TableHead, TableSortLabel, TableBody, TableFooter, makeStyles as makeStyles$1, Portal, Toolbar, Tabs, Tab, useTheme as useTheme$1, CardContent, Card, CardMedia, CardActions, List, ListItem, FormHelperText, FormControl, InputLabel, Chip, ListItemText, createMuiTheme, ThemeProvider, Popper, Grow, ClickAwayListener, MenuList, Collapse, Divider, Popover, useMediaQuery, AppBar, Snackbar, withStyles } from '@material-ui/core';
import { NotificationWidget } from '@platform/notification-widget';
import { useFeature, FeaturesProvider } from 'feature-toggle-jsx';
import { observer as observer$1, useLocalStore, Provider } from 'mobx-react';
import React__default, { useState, useMemo, useContext, useEffect, useCallback, createElement, memo, forwardRef, useRef } from 'react';
import { FormattedMessage, useIntl, FormattedDate, FormattedTime, createIntl, createIntlCache, RawIntlProvider } from 'react-intl';
import { fromPromise, actionAsync, asyncAction, createViewModel } from 'mobx-utils';
import { useLocation, Redirect, Switch, Route, useParams, Link, generatePath, NavLink, useHistory, matchPath, Prompt, Router } from 'react-router-dom';
import { withTheme, makeStyles, createStyles, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import totBackgroundLayer2 from './tot-background-layer-2~bmhcQBNH.png';
import totBackgroundLayer3 from './tot-background-layer-3~QOSedDuF.png';
import { di, DiProvider } from 'react-magnetic-di';
import queryString from 'query-string';
import { CheckCircleOutline, AccessTime, Block, Visibility, VisibilityOff, Close, Clear, ExpandMore, Edit, Delete, FormatListNumbered, Language } from '@material-ui/icons';
import { Alert, Autocomplete, PaginationItem, Pagination } from '@material-ui/lab';
import classNames from 'classnames';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { computed, observable, action, reaction, spy, Reaction, getDependencyTree } from 'mobx';
import debounce, { debounce as debounce$1 } from 'debounce';
import { formatISO, startOfDay, endOfDay, isAfter } from 'date-fns';
import KeyboardTabIcon from '@material-ui/icons/KeyboardTab';
import { TTableSelectForFilter, TTable, ttable_en, ttable_ru } from '@platform/ttable';
import Button$1 from '@material-ui/core/Button';
import DialogTitle$1 from '@material-ui/core/DialogTitle';
import DialogContent$1 from '@material-ui/core/DialogContent';
import DialogActions$1 from '@material-ui/core/DialogActions';
import Dialog$1 from '@material-ui/core/Dialog';
import Sticky, { RenderPropSticky } from 'react-sticky-el';
import { DigitalSignature, SignatureStatus } from '@platform/crypto-ui';
import downloadFile from 'js-file-download';
import { Form, FormView, FormModel, validateReadonlyPage, MultiLangFormEdit, FormioSidebarStore } from '@platform/formiojs-react';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { ApprovalTab, ApprovalTabLabel } from '@platform/approval-ui';
import { v4 } from 'uuid';
import Pagination$1 from '@material-ui/lab/Pagination';
import DOMPurify from 'dompurify';
import DoneIcon from '@material-ui/icons/Done';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Alert$1 from '@material-ui/lab/Alert';
import AddIcon from '@material-ui/icons/Add';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import { ruRU } from '@material-ui/core/locale';
import PersonAddDisabledIcon from '@material-ui/icons/PersonAddDisabled';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-scala';
import 'prismjs/themes/prism.css';
import Editor from 'react-simple-code-editor';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import axios from 'axios';
import DataLoader from 'dataloader';
import AllComponents, { withFunctionCallComponents } from '@platform/formio/components';
import Components from '@platform/formio/components/Components';
import CodeOutlinedIcon from '@material-ui/icons/CodeOutlined';
import PeopleIcon from '@material-ui/icons/People';
import { multilevelCatalog_en, multilevelCatalog_ru } from '@platform/multilevel-catalog';
import { ModularNavigationWidget } from '@platform/modular-navigation-widget';
import SwapHorizSharpIcon from '@material-ui/icons/SwapHorizSharp';
import CompareArrowsSharpIcon from '@material-ui/icons/CompareArrowsSharp';
import { DropzoneArea } from 'material-ui-dropzone';
import ym, { YMInitializer } from 'react-yandex-metrika';
import DateFnsUtils from '@date-io/date-fns';
import { ru as ru$1 } from 'date-fns/locale';
import './complete-icon~xnmIKyAv.svg';

var entities = {
  System: 'System',
  User: 'User',
  Campaign: 'Campaign',
  CampaignRegForm: 'CampaignRegForm',
  CampaignPfTemplate: 'CampaignPfTemplate',
  CampaignRequest: 'CampaignRequest',
  RequestCustomForm: 'RequestCustomForm'
};
var permissions = {
  System: {
    Administration: 'Administration',
    AddCampaign: 'AddCampaign',
    ViewCampaignList: 'ViewCampaignList',
    ViewCampRequestList: 'ViewCampRequestList',
    ViewCampRequestRegistry: 'ViewCampRequestRegistry',
    ExportCampRequestList: 'ExportCampRequestList',
    ViewPersonList: 'ViewPersonList',
    ViewUserList: 'ViewUserList',
    AddCampaignRequest: 'AddCampaignRequest',
    ViewCampReqExecutorColumn: 'ViewCampReqExecutorColumn',
    ViewLogsRegistry: 'ViewLogsRegistry',
    Logout: 'Logout',
    ViewNotifications: 'ViewNotifications'
  },
  User: {
    LoginAs: 'LoginAs',
    Update: 'Update',
    UpdateForm: 'UpdateForm',
    View: 'View'
  },
  Campaign: {
    View: 'View',
    Edit: 'Edit',
    Delete: 'Delete',
    AddCampRequest: 'AddCampRequest',
    ApproveProvisionalAppointment: 'ApproveProvisionalAppointment'
  },
  CampaignRegForm: {
    Edit: 'Edit',
    Delete: 'Delete',
    EditCampRegFormSetting: 'EditCampRegFormSetting'
  },
  CampaignPfTemplate: {
    Edit: 'Edit',
    Delete: 'Delete'
  },
  CampaignRequest: {
    View: 'View',
    Edit: 'Edit',
    EditPf: 'EditPf',
    Delete: 'Delete',
    Send: 'Send',
    UpdateActualAppointment: 'UpdateActualAppointment',
    AddActualAppointment: 'AddActualAppointment'
  }
};
var permissionsConfig = {
  updateActualAppointment: function updateActualAppointment(campaignRequestId) {
    return {
      permCode: permissions.CampaignRequest.UpdateActualAppointment,
      entityCode: entities.CampaignRequest,
      entityId: campaignRequestId
    };
  },
  addActualAppointment: function addActualAppointment(campaignRequestId) {
    return {
      permCode: permissions.CampaignRequest.AddActualAppointment,
      entityCode: entities.CampaignRequest,
      entityId: campaignRequestId
    };
  },
  editCampaignRequest: function editCampaignRequest(campaignRequestId) {
    return {
      permCode: permissions.CampaignRequest.Edit,
      entityCode: entities.CampaignRequest,
      entityId: campaignRequestId
    };
  },
  deleteCampaignRequest: function deleteCampaignRequest(campaignRequestId) {
    return {
      permCode: permissions.CampaignRequest.Delete,
      entityCode: entities.CampaignRequest,
      entityId: campaignRequestId
    };
  }
};
var authSchemeConfig = {
  entities: entities,
  permissions: permissions,
  permissionsConfig: permissionsConfig
};

const EsiaGetAuthUrlPage = observer$1(() => {
  const {
    authenticationStore
  } = useStore();
  const [getAuthUrl] = useState(authenticationStore.esiaGetAuthUrl());

  const redirectToAuthUrl = authUrl => {
    window.location.href = authUrl;
    return React__default.createElement(React__default.Fragment, null);
  };

  return fromPromise(getAuthUrl).case({
    pending: () => React__default.createElement(CircularProgress, null),
    fulfilled: redirectToAuthUrl,
    rejected: () => React__default.createElement(Paper, {
      elevation: 0
    }, React__default.createElement(Box, {
      p: 12
    }, React__default.createElement(Typography, {
      variant: "h5"
    }, React__default.createElement(Box, {
      fontWeight: "fontWeightBold"
    }, React__default.createElement(FormattedMessage, {
      id: "authentication.error"
    })))))
  });
});

const EsiaLoginPage = observer$1(() => {
  const {
    authenticationStore,
    personStore
  } = useStore();
  const location = useLocation();
  const [login] = useState(authenticationStore.esiaLogin(location.search).then(() => personStore.getInfo()));
  return fromPromise(login).case({
    pending: () => React__default.createElement(CircularProgress, null),
    fulfilled: () => React__default.createElement(Redirect, {
      to: personStore.redirectPath
    }),
    rejected: () => React__default.createElement(Paper, {
      elevation: 0
    }, React__default.createElement(Box, {
      p: 12
    }, React__default.createElement(Typography, {
      variant: "h5"
    }, React__default.createElement(Box, {
      fontWeight: "fontWeightBold"
    }, React__default.createElement(FormattedMessage, {
      id: "authentication.error"
    })))))
  });
});

var ClientRoute = function ClientRoute() {
  var _this = this;

  this.root = '/';
  this.notFound = '/404';
  this.notAllowed = '/403';
  this.logout = '/logout';
  this.campaigns = '/campaigns';
  this.campaign = '/campaigns/:id';
  this.createCampaign = '/campaigns/:id/create';
  this.campaignSettings = '/campaigns/:id/settings';
  this.campaignSettingsEdit = '/campaigns/:id/settings/edit';
  this.campaignRegForms = '/campaigns/:id/settings/rf';
  this.campaignRegForm = '/campaigns/:id/settings/rf/:rfId/info';
  this.campaignRegFormExecutors = '/campaigns/:id/settings/rf/:rfId/executors';
  this.campaignRegFormTabsSettings = '/campaigns/:id/settings/rf/:rfId/tabsSettings';
  this.campaignRequestFormTabSetting = '/campaigns/:id/settings/rf/:rfId/tabsSettings/:settingId/edit';
  this.campaignRequestFormTabSettingCreate = '/campaigns/:id/settings/rf/:rfId/tabsSettings/:settingId/create';
  this.campaignRegFormTemplates = '/campaigns/:id/settings/rf/:rfId/templates';
  this.campaignRegFormTemplatesEdit = '/campaigns/:id/settings/rf/:rfId/templates/:templateId/settings/:settingsId/edit';
  this.campaignRegFormTemplatesCreate = '/campaigns/:id/settings/rf/:rfId/templates/settings/:settingsId/create';
  this.campaignRegFormTemplatesPermissionSettings = '/campaigns/:id/settings/rf/:rfId/templates/settings/:settingsId/permissionSettings';
  this.campaignRegFormCreate = '/campaigns/:id/settings/rf/:rfId/create';
  this.campaignRegFormEdit = '/campaigns/:id/settings/rf/:rfId/edit';
  this.campaignDocs = '/campaigns/:id/settings/docs';
  this.campaignManagement = '/campaigns/:id/settings/management';
  this.generalSettings = '/campaigns/:id/settings/general';
  this.requests = '/requests';
  this.requestsNew = '/requests/new';
  this.regFormSelect = '/campaigns/:campaignId/regForms';
  this.request = '/requests/:id';
  this.requestForm = '/requests/:id/form/:formId';
  this.requestEdit = '/requests/:id/edit';
  this.requestFormEdit = '/requests/:id/form/:formId/edit';
  this.requestApprovalSheets = '/requests/:id/approval';
  this.requestLog = '/request-log/:id';
  this.users = '/users';
  this.user = '/users/:id';
  this.userEdit = '/users/:id/edit';
  this.console = '/console';
  this.login = '/login';
  this.recoveryPassword = '/recovery';
  this.newPassword = '/recovery/:token';
  this.registration = '/registration';
  this.authenticationInfo = '/info';
  this.registrationInfoSuccess = '/info/registration/success';
  this.registrationInfoExpired = '/info/registration/expired';
  this.registrationInfoNotFound = '/info/registration/404';
  this.recoveryPasswordInfoSuccess = '/info/recovery-password/success';
  this.registrationConfirm = '/registration/confirm/:token';
  this.esia = '/esia';
  this.esiaGetAuthUrl = '/esia/auth-url';
  this.esiaLogin = '/esia/login';
  this.saml = '/saml';
  this.samlGetAuthUrl = '/saml/:provider/auth-url';

  this.filteringWithCampaign = function (campaignId) {
    return _this.requests + ("?campaignId=" + campaignId);
  };
};

var clientRoute = new ClientRoute();

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n        height: 100%;\n        background: ", ";\n        background-size: cover;\n        background-blend-mode: soft-light, overlay, normal;\n        display: flex;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        height: 100%;\n        background: ", ";\n        background-blend-mode: soft-light, overlay, normal;\n        display: flex;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Background = withTheme(styled.div.attrs(function () {
  return {
    className: 'tot-background'
  };
})(_templateObject(), function (props) {
  var secondary = props.theme.palette.secondary;
  return "url(" + totBackgroundLayer3 + ") center,\n                    url(" + totBackgroundLayer2 + ") center,\n                    linear-gradient(-55deg, " + secondary.main + " 0%, " + secondary.dark + " 100%)";
}));
var CustomBackground = withTheme(styled.div(_templateObject2(), function (props) {
  var backgroundImage = props.backgroundImage,
      variables = props.theme.variables;
  return variables.palette.background.overlay ? "url(" + backgroundImage + ") center, " + variables.palette.background.overlay : "url(" + backgroundImage + ") center";
}));
var TotBackground = observer$1(function (props) {
  var _useFeature = useFeature('customBackground'),
      customBackground = _useFeature[0],
      config = _useFeature[1];

  if (customBackground) {
    return config.src ? React__default.createElement(CustomBackground, {
      backgroundImage: config.src,
      style: config.style
    }, props.children) : React__default.createElement(CustomBackground, null, React__default.createElement(Grid, {
      container: true,
      style: {
        zIndex: 2
      }
    }, props.children), React__default.createElement(Backdrop, {
      style: {
        zIndex: 1
      },
      open: true
    }));
  }

  return React__default.createElement(Background, null, props.children);
});
var TotBackgroundWithAvailableHeader = observer$1(function (props) {
  var _useFeature2 = useFeature('customBackground'),
      customBackground = _useFeature2[0],
      config = _useFeature2[1];

  if (customBackground) {
    return React__default.createElement(CustomBackground, {
      backgroundImage: config.src || '',
      style: config.style
    }, React__default.createElement(Grid, {
      container: true,
      style: {
        zIndex: 2
      }
    }, props.children), React__default.createElement(Backdrop, {
      style: {
        zIndex: 1
      },
      open: true
    }));
  }

  return React__default.createElement(Background, null, React__default.createElement(Grid, {
    container: true,
    style: {
      zIndex: 2
    }
  }, props.children), React__default.createElement(Backdrop, {
    style: {
      zIndex: 1
    },
    open: true
  }));
});

const EsiaPages = () => {
  const [TotBackground$1] = di([TotBackground], EsiaPages);
  const [EsiaGetAuthUrlPage$1] = di([EsiaGetAuthUrlPage], EsiaPages);
  const [EsiaLoginPage$1] = di([EsiaLoginPage], EsiaPages);
  return React__default.createElement(TotBackground$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.esiaGetAuthUrl
  }, React__default.createElement(EsiaGetAuthUrlPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.esiaLogin
  }, React__default.createElement(EsiaLoginPage$1, null)))));
};

const SamlGetAuthUrlPage = observer$1(() => {
  const {
    provider
  } = useParams();
  const location = useLocation();
  const queries = queryString.parse(location.search);
  const backUrl = queries.backUrl;
  const absoluteBackUrl = backUrl ? window.location.origin + backUrl : '';
  const {
    authenticationStore
  } = useStore();
  const getAuthUrl = useMemo(() => {
    return authenticationStore.samlGetAuthUrl(provider, absoluteBackUrl);
  }, [provider, absoluteBackUrl]);

  const redirectToAuthUrl = authUrl => {
    window.location.href = authUrl;
    return React__default.createElement(React__default.Fragment, null);
  };

  return fromPromise(getAuthUrl).case({
    pending: () => React__default.createElement(CircularProgress, null),
    fulfilled: redirectToAuthUrl,
    rejected: () => React__default.createElement(Paper, {
      elevation: 0
    }, React__default.createElement(Box, {
      p: 12
    }, React__default.createElement(Typography, {
      variant: "h5"
    }, React__default.createElement(Box, {
      fontWeight: "fontWeightBold"
    }, React__default.createElement(FormattedMessage, {
      id: "authentication.error"
    })))))
  });
});

const SamlPages = () => {
  const [TotBackground$1] = di([TotBackground], SamlPages);
  const [SamlGetAuthUrlPage$1] = di([SamlGetAuthUrlPage], SamlPages);
  return React__default.createElement(TotBackground$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.samlGetAuthUrl
  }, React__default.createElement(SamlGetAuthUrlPage$1, null)))));
};

var AuthenticationInfoPage = function AuthenticationInfoPage() {
  var _di = di([TotBackground], AuthenticationInfoPage),
      TotBackground$1 = _di[0];

  return React__default.createElement(TotBackground$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Container, {
    className: "t-authentication-info-page",
    maxWidth: "xs"
  }, React__default.createElement(Paper, {
    elevation: 0
  }, React__default.createElement(Box, {
    p: 12,
    textAlign: "center"
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.registrationInfoSuccess
  }, React__default.createElement(CheckCircleOutline, {
    fontSize: "large",
    color: "action"
  }), React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "authentication.confirmingEmailSent"
  }))), React__default.createElement(Route, {
    path: clientRoute.registrationInfoExpired
  }, React__default.createElement(AccessTime, {
    fontSize: "large",
    color: "action"
  }), React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "authentication.confirmingEmailExpired"
  }))), React__default.createElement(Route, {
    path: clientRoute.registrationInfoNotFound
  }, React__default.createElement(Block, {
    fontSize: "large",
    color: "action"
  }), React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "authentication.confirmingEmailNotFound"
  }))), React__default.createElement(Route, {
    path: clientRoute.recoveryPasswordInfoSuccess
  }, React__default.createElement(CheckCircleOutline, {
    fontSize: "large",
    color: "action"
  }), React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "authentication.recoveryLinkSent"
  })))))))));
};

var EmailField = observer$1(function (props) {
  var model = props.model;
  return React__default.createElement(TextField, {
    inputProps: {
      className: 't-email-field'
    },
    FormHelperTextProps: {
      className: 't-email-field-help-text'
    },
    required: true,
    type: "email",
    onChange: model.onChangeEmail,
    fullWidth: true,
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.email"
    }),
    variant: "outlined",
    error: !!model.errorEmail,
    helperText: model.errorEmail
  });
});

var PasswordField = observer$1(function (props) {
  var model = props.model,
      label = props.label;

  var _useState = useState(false),
      showPassword = _useState[0],
      setShowPassword = _useState[1];

  var toggleVisibilityPassword = function toggleVisibilityPassword() {
    setShowPassword(function (password) {
      return !password;
    });
  };

  var fieldType = showPassword ? 'text' : 'password';
  return React__default.createElement(TextField, {
    inputProps: {
      className: 't-password-field'
    },
    FormHelperTextProps: {
      className: 't-password-field-help-text'
    },
    required: true,
    onChange: model.onChangePassword,
    fullWidth: true,
    label: label || React__default.createElement(FormattedMessage, {
      id: "authentication.password"
    }),
    variant: "outlined",
    type: fieldType,
    error: !!model.errorPassword,
    helperText: model.errorPassword,
    InputProps: {
      endAdornment: React__default.createElement(InputAdornment, {
        position: "end"
      }, React__default.createElement(IconButton, {
        className: "t-visibility-password",
        onClick: toggleVisibilityPassword
      }, showPassword ? React__default.createElement(Visibility, null) : React__default.createElement(VisibilityOff, null)))
    }
  });
});

var StoreContext = React__default.createContext({});

function useStore() {
  return useContext(StoreContext);
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 2px !important;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var LoginCheckbox = withTheme$1(styled(Checkbox)(_templateObject$1()));
var useLoginDialogStyles = makeStyles(function () {
  return createStyles({
    container: {
      padding: 0
    }
  });
});
var LoginDialog = observer$1(function () {
  var _di = di([PasswordField], LoginDialog),
      PasswordField$1 = _di[0];

  var _di2 = di([EmailField], LoginDialog),
      EmailField$1 = _di2[0];

  var _useFeature = useFeature('redirectToCampaignsAllUsers'),
      redirectToCampaignsAllUsers = _useFeature[0];

  var _useStore = useStore(),
      authenticationStore = _useStore.authenticationStore,
      personStore = _useStore.personStore;

  var loginModel = useMemo(function () {
    return authenticationStore.loginModel;
  }, [authenticationStore]);
  var loginFailedMessage = loginModel.loginFailedMessage;
  var location = useLocation();
  var queries = queryString.parse(location.search);
  var backUrl = queries.backUrl;

  var _useFeature2 = useFeature('esiaLogin'),
      esiaLogin = _useFeature2[0];

  var _useFeature3 = useFeature('loginDialogClose'),
      loginDialogClose = _useFeature3[0];

  var _useFeature4 = useFeature('loginDialogAlert'),
      loginDialogAlert = _useFeature4[0];

  var _useFeature5 = useFeature('samlAuth'),
      samlAuth = _useFeature5[0],
      samlAuthConfig = _useFeature5[1];

  var backUrlParam = backUrl ? "?backUrl=" + backUrl : '';
  var redirectCampaignsOrRolePath = redirectToCampaignsAllUsers ? clientRoute.campaigns : personStore.redirectPath;
  var redirectPath = Boolean(backUrl) ? backUrl : redirectCampaignsOrRolePath;
  var classes = useLoginDialogStyles();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center",
    style: {
      zIndex: 2
    }
  }, React__default.createElement(Container, {
    className: classNames('t-registration-page', classes.container),
    maxWidth: "xs"
  }, React__default.createElement(Paper, {
    elevation: 0
  }, React__default.createElement(Box, Object.assign({}, !loginDialogClose && {
    pt: 8
  }, {
    px: 12,
    pb: 12
  }), loginDialogClose && React__default.createElement(Box, {
    pt: 4,
    mr: -8
  }, React__default.createElement(Grid, {
    container: true,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    className: "t-close-login",
    component: Link,
    to: "/"
  }, React__default.createElement(Close, null))))), React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h5",
    className: "t-login-title"
  }, React__default.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.loginTitle"
  }))))), React__default.createElement(Box, {
    pt: 8
  }, React__default.createElement("form", {
    noValidate: true,
    onSubmit: loginModel.login
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column"
  }, loginFailedMessage && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: "t-login-failed-message",
    color: "error"
  }, loginFailedMessage)), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(EmailField$1, {
    model: loginModel
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(PasswordField$1, {
    model: loginModel
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormControlLabel, {
    value: "top",
    control: React__default.createElement(LoginCheckbox, {
      className: "t-remember-me",
      color: "primary",
      onChange: loginModel.onChangeRememberMe
    }),
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.rememberMe"
    }),
    labelPlacement: "end"
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    className: "t-login",
    fullWidth: true,
    size: "large",
    variant: "contained",
    type: "submit",
    color: "primary"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.login"
  }))), esiaLogin && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Link$1, {
    className: "t-esia-login",
    component: Link,
    to: clientRoute.esiaGetAuthUrl,
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.loginEsia"
  }))), samlAuth && samlAuthConfig.providers.map(function (provider) {
    return React__default.createElement(Grid, {
      item: true,
      key: provider.code
    }, React__default.createElement(Link$1, {
      className: "t-saml-login",
      component: Link,
      to: generatePath(clientRoute.samlGetAuthUrl, {
        provider: provider.code
      }) + backUrlParam,
      underline: "none"
    }, React__default.createElement(FormattedMessage, {
      id: "authentication.samlAuth",
      values: {
        title: provider.title
      }
    })));
  }), React__default.createElement(Grid, {
    item: true,
    container: true,
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Link$1, {
    className: "t-forgot-password",
    component: Link,
    to: clientRoute.recoveryPassword,
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.forgotPassword"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Link$1, {
    className: "t-registration",
    component: Link,
    to: clientRoute.registration,
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.register"
  })))))))), loginDialogAlert && React__default.createElement(Alert, {
    severity: "info"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.alertInfo"
  }))))), loginModel.loginSucceed && React__default.createElement(Redirect, {
    push: true,
    to: redirectPath
  }));
});

var NewPasswordPage = observer$1(function () {
  var _di = di([PasswordField], NewPasswordPage),
      PasswordField$1 = _di[0];

  var _di2 = di([TotBackgroundWithAvailableHeader], NewPasswordPage),
      TotBackgroundWithAvailableHeader$1 = _di2[0];

  var _useParams = useParams(),
      token = _useParams.token;

  var _useStore = useStore(),
      personStore = _useStore.personStore,
      authenticationStore = _useStore.authenticationStore;

  var newPasswordModel = useMemo(function () {
    var newModel = authenticationStore.newPasswordModel;
    newModel.token = token;
    return newModel;
  }, [token]);
  var failedMessage = newPasswordModel.failedMessage,
      isTokenValid = newPasswordModel.isTokenValid;
  useEffect(function () {
    newPasswordModel.validateToken();
  }, []);
  return React__default.createElement(TotBackgroundWithAvailableHeader$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Container, {
    className: "t-new-password-page",
    maxWidth: "xs"
  }, React__default.createElement(Paper, {
    elevation: 0
  }, isTokenValid ? React__default.createElement(Box, {
    p: 12
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h5",
    className: "t-new-password-title"
  }, React__default.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.newPasswordTitle"
  }))))), React__default.createElement(Box, {
    pt: 8
  }, React__default.createElement("form", {
    noValidate: true,
    onSubmit: newPasswordModel.updatePassword
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column"
  }, failedMessage && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: "t-failed-message",
    color: "error"
  }, failedMessage)), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(PasswordField$1, {
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.newPassword"
    }),
    model: newPasswordModel.newPasswordModel
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(PasswordField$1, {
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.repeatPassword"
    }),
    model: newPasswordModel.repeatPasswordModel
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    className: "t-confirm",
    fullWidth: true,
    size: "large",
    variant: "contained",
    type: "submit"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.confirm"
  }))), React__default.createElement(Grid, {
    item: true,
    container: true,
    justify: "center"
  }, React__default.createElement(Link$1, {
    className: "t-login",
    component: Link,
    to: clientRoute.login
  }, React__default.createElement(Typography, {
    variant: "caption"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.login"
  })))))))) : isTokenValid === false ? React__default.createElement(Box, {
    p: 12
  }, React__default.createElement(Typography, {
    align: "center",
    className: "t-failed-message",
    color: "error"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.linkInvalidOrExpired"
  }))) : React__default.createElement(Box, {
    p: 6
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CircularProgress, null))))), newPasswordModel.changedSucceed && React__default.createElement(Redirect, {
    to: personStore.redirectPath
  }))));
});

var useRecoveryPasswordPage = makeStyles(function () {
  return createStyles({
    container: {
      padding: 0
    }
  });
});
var RecoveryPasswordPage = observer$1(function () {
  var _di = di([EmailField], RecoveryPasswordPage),
      EmailField$1 = _di[0];

  var _di2 = di([TotBackgroundWithAvailableHeader], RecoveryPasswordPage),
      TotBackgroundWithAvailableHeader$1 = _di2[0];

  var _useStore = useStore(),
      authenticationStore = _useStore.authenticationStore;

  var recoveryPasswordModel = useMemo(function () {
    return authenticationStore.recoveryPasswordModel;
  }, [authenticationStore]);
  var classes = useRecoveryPasswordPage();
  return React__default.createElement(TotBackgroundWithAvailableHeader$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Container, {
    className: classNames('t-recovery-password-page', classes.container),
    maxWidth: "xs"
  }, React__default.createElement(Paper, {
    elevation: 0
  }, React__default.createElement(Box, {
    p: 12
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h5",
    className: "t-recovery-title"
  }, React__default.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.recoveryTitle"
  }))))), React__default.createElement(Box, {
    pt: 8
  }, React__default.createElement("form", {
    noValidate: true,
    onSubmit: recoveryPasswordModel.sendToken
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(EmailField$1, {
    model: recoveryPasswordModel
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: "t-recovery-info"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.recoveryInfo"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    className: "t-recovery",
    fullWidth: true,
    size: "large",
    variant: "contained",
    type: "submit"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.sendToken"
  }))), React__default.createElement(Grid, {
    item: true,
    container: true,
    justify: "center"
  }, React__default.createElement(Link$1, {
    className: "t-login",
    component: Link,
    to: clientRoute.login,
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.goBackToSignIn"
  })))))))), recoveryPasswordModel.sentSucceed && React__default.createElement(Redirect, {
    to: clientRoute.recoveryPasswordInfoSuccess
  }))));
});

var RegistrationConfirmPage = observer$1(function () {
  var _di = di([TotBackground], RegistrationConfirmPage),
      TotBackground$1 = _di[0];

  var _useParams = useParams(),
      token = _useParams.token;

  var _useStore = useStore(),
      personStore = _useStore.personStore,
      authenticationStore = _useStore.authenticationStore;

  var _useState = useState(authenticationStore.registrationConfirmModel),
      registrationConfirmModel = _useState[0];

  useEffect(function () {
    registrationConfirmModel.confirmEmail(token);
  }, [registrationConfirmModel, token]);

  var renderByStatus = function renderByStatus() {
    var status = registrationConfirmModel.status;

    switch (status) {
      case 'pending':
        return React__default.createElement(CircularProgress, null);

      case 'success':
        return React__default.createElement(Redirect, {
          to: personStore.redirectPath
        });

      case 'expired':
        return React__default.createElement(Redirect, {
          to: clientRoute.registrationInfoExpired
        });

      case 'not-found':
        return React__default.createElement(Redirect, {
          to: clientRoute.registrationInfoNotFound
        });

      default:
        return null;
    }
  };

  return React__default.createElement(TotBackground$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Box, null, renderByStatus(), " ")));
});

var useStyles = makeStyles(function () {
  return {
    termsOfServiceLink: {
      display: 'inline-block',
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  };
});
var RegistrationPage = observer$1(function () {
  var _di = di([PasswordField], RegistrationPage),
      PasswordField$1 = _di[0];

  var _di2 = di([EmailField], RegistrationPage),
      EmailField$1 = _di2[0];

  var _di3 = di([TotBackgroundWithAvailableHeader], RegistrationPage),
      TotBackground = _di3[0];

  var _useStore = useStore(),
      authenticationStore = _useStore.authenticationStore,
      env = _useStore.env;

  var registrationModel = useMemo(function () {
    return authenticationStore.registrationModel;
  }, [authenticationStore]);
  var errorLastName = registrationModel.errorLastName,
      errorFirstName = registrationModel.errorFirstName;
  var termsOfService = env.termsOfServiceLink;
  var classes = useStyles();
  var renderTermsOfServiceLink = termsOfService && termsOfService !== '#' ? React__default.createElement("a", {
    target: "_blank",
    href: termsOfService,
    className: classes.termsOfServiceLink
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.termsLinkTitle"
  })) : React__default.createElement(FormattedMessage, {
    id: "authentication.termsLinkTitle"
  });
  return React__default.createElement(TotBackground, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center",
    style: {
      zIndex: 2
    }
  }, React__default.createElement(Container, {
    className: "t-registration-page",
    maxWidth: "sm"
  }, React__default.createElement(Paper, {
    elevation: 0
  }, React__default.createElement(Box, {
    p: 12
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h5",
    className: "t-registration-title"
  }, React__default.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.registrationTitle"
  }))))), React__default.createElement(Box, {
    pt: 8
  }, React__default.createElement("form", {
    noValidate: true,
    onSubmit: registrationModel.register
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TextField, {
    inputProps: {
      className: 't-last-name-field'
    },
    FormHelperTextProps: {
      className: 't-last-name-field-help-text'
    },
    required: true,
    onChange: registrationModel.onChangeLastName,
    fullWidth: true,
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.lastName"
    }),
    variant: "outlined",
    error: !!errorLastName,
    helperText: errorLastName
  })), React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 6,
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(TextField, {
    inputProps: {
      className: 't-first-name-field'
    },
    FormHelperTextProps: {
      className: 't-first-name-field-help-text'
    },
    required: true,
    onChange: registrationModel.onChangeFirstName,
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.firstName"
    }),
    variant: "outlined",
    error: !!errorFirstName,
    helperText: errorFirstName,
    fullWidth: true
  })), React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(TextField, {
    inputProps: {
      className: 't-middle-name-field'
    },
    onChange: registrationModel.onChangeMiddleName,
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.middleName"
    }),
    fullWidth: true,
    variant: "outlined"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(EmailField$1, {
    model: registrationModel
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(PasswordField$1, {
    model: registrationModel
  })), termsOfService && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormControlLabel, {
    value: "top",
    control: React__default.createElement(Checkbox, {
      className: "t-terms-is-accepted",
      color: "primary",
      onChange: registrationModel.onChangeTermsIsAccepted
    }),
    label: React__default.createElement(FormattedMessage, {
      id: "authentication.termsIsAccepted",
      values: {
        link: renderTermsOfServiceLink
      }
    }),
    labelPlacement: "end"
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    className: "t-register",
    fullWidth: true,
    size: "large",
    variant: "contained",
    type: "submit",
    disabled: !!termsOfService && !registrationModel.termsIsAccepted
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.register"
  }))), React__default.createElement(Grid, {
    item: true,
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Link$1, {
    className: "t-login",
    component: Link,
    to: clientRoute.login,
    underline: "always"
  }, React__default.createElement(FormattedMessage, {
    id: "authentication.alreadyHaveAccount"
  }))))))))), registrationModel.registerSucceed && React__default.createElement(Redirect, {
    to: clientRoute.registrationInfoSuccess
  }))));
});

var AuthorizationCheck = observer$1(function (props) {
  var onAllowed = props.onAllowed,
      entityCode = props.entityCode,
      permCode = props.permCode,
      entityId = props.entityId,
      children = props.children,
      pendingElement = props.pendingElement,
      errorElement = props.errorElement,
      isWithRedirect = props.isWithRedirect;

  var _useStore = useStore(),
      authorizationStore = _useStore.authorizationStore;

  var checkIsAllowed = useCallback(function () {
    return authorizationStore.check({
      entityCode: entityCode,
      permCode: permCode,
      entityId: entityId
    }).then(function (allowedRes) {
      if (allowedRes && onAllowed) {
        onAllowed();
      }

      return allowedRes;
    });
  }, [entityCode, permCode, entityId, onAllowed]);

  var _useState = useState(Promise.resolve(false)),
      allowed = _useState[0],
      setAllowed = _useState[1];

  useEffect(function () {
    setAllowed(checkIsAllowed());
  }, [checkIsAllowed]);
  var renderChildren = useCallback(function (allowed) {
    if (typeof children === 'function') {
      var render = children;
      return render(allowed);
    }

    if (allowed) {
      return children;
    }

    return isWithRedirect ? React__default.createElement(Redirect, {
      to: clientRoute.notAllowed
    }) : React__default.createElement(React__default.Fragment, null);
  }, [children]);
  return fromPromise(allowed).case({
    pending: function pending() {
      return pendingElement || React__default.createElement(React__default.Fragment, null);
    },
    fulfilled: renderChildren,
    rejected: function rejected() {
      return errorElement || React__default.createElement(React__default.Fragment, null);
    }
  });
});

var _path;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function SvgCheckboxDefault(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M15.009 1.005c1.103 0 2 .897 2 1.999v12.001c0 1.102-.897 2-2 2h-12c-1.103 0-2-.898-2-2V3.004c0-1.102.897-1.999 2-1.999h12m0-1h-12a3 3 0 00-3 2.999v12.001a3 3 0 003 3h12a3 3 0 003-3V3.004a3 3 0 00-3-2.999z"
  })));
}

var _path$1;

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function SvgCheckboxChecked(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M15 0H3a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V3a3 3 0 00-3-3zm-2.29 7.669l-4.08 4.08a.999.999 0 01-1.42 0l-1.92-1.92a1.001 1.001 0 010-1.419 1.003 1.003 0 011.42 0l1.21 1.219 3.37-3.38a1.004 1.004 0 011.42 1.42z"
  })));
}

var _path$2;

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function SvgDeleteChipIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "28 22 14 14"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M39.006 31.999c0 .267-.107.522-.296.71a.997.997 0 01-1.42 0l-2.29-2.3-2.29 2.3a.997.997 0 01-1.42 0 1.001 1.001 0 010-1.42l2.3-2.29-2.3-2.29a1.001 1.001 0 010-1.42 1.001 1.001 0 011.42 0l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42l-2.3 2.29 2.3 2.29c.189.188.296.443.296.71z"
  })));
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n        &.MuiCheckbox-colorPrimary {\n            padding: 0;\n            color: ", ";\n            margin-right: ", ";\n        }\n    "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var checkboxProps = {
  icon: React__default.createElement(SvgCheckboxDefault, null),
  checkedIcon: React__default.createElement(SvgCheckboxChecked, null),
  color: 'primary'
};
var SelectCheckbox = withTheme(styled(Checkbox)(_templateObject$2(), function (_ref) {
  var theme = _ref.theme;
  return theme.variables.palette.mainMiddleLight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2) + "px";
}));
var useStyles$1 = makeStyles(function (theme) {
  return createStyles({
    groupLabel: {
      lineHeight: '180%',
      padding: '5px 15px',
      backgroundColor: theme.palette.background.paper,
      top: -8,
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden'
    },
    listBox: {
      boxSizing: 'border-box',
      '& ul': {
        padding: 0,
        margin: 0
      }
    },
    groupUl: {
      padding: 0
    }
  });
});
var Select = function Select(props) {
  var selectData = props.selectData,
      multiple = props.multiple,
      values = props.values,
      placeholder = props.placeholder,
      label = props.label,
      textFieldProps = props.textFieldProps,
      autoCompleteProps = props.autoCompleteProps,
      onChange = props.onChange;
  var classes = useStyles$1();

  var groupByFunc = function groupByFunc(option) {
    var selectDataGrouped = selectData;
    return getTitle(option, selectDataGrouped, true);
  };

  var renderOptionArrayData = function renderOptionArrayData(option, _ref3) {
    var selected = _ref3.selected;
    var selectDataArray = selectData;

    if (multiple) {
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(SelectCheckbox, Object.assign({}, checkboxProps, {
        checked: selected
      })), getArrayDataTitle(option, selectDataArray));
    }

    return React__default.createElement(React__default.Fragment, null, getArrayDataTitle(option, selectDataArray));
  };

  var renderOptionGroupedData = function renderOptionGroupedData(option, _ref4) {
    var selected = _ref4.selected;
    var selectDataGrouped = selectData;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(SelectCheckbox, Object.assign({}, checkboxProps, {
      checked: selected
    })), getTitle(option, selectDataGrouped, false));
  };

  var getOptionLabelArrayData = function getOptionLabelArrayData(option) {
    var selectDataArray = selectData;
    return getArrayDataTitle(option, selectDataArray);
  };

  var getOptionLabelGroupedData = function getOptionLabelGroupedData(option) {
    var selectDataGrouped = selectData;
    return getTitle(option, selectDataGrouped, false);
  };

  var renderInput = function renderInput(params) {
    return React__default.createElement(TextField, Object.assign({}, params, textFieldProps, {
      label: label,
      placeholder: values.length && placeholder ? '' : placeholder
    }));
  };

  var renderGroup = function renderGroup(params) {
    return [React__default.createElement("li", {
      key: params.key
    }, React__default.createElement(Tooltip, {
      title: params.group.length > 90 ? params.group : ''
    }, React__default.createElement(ListSubheader, {
      className: classes === null || classes === void 0 ? void 0 : classes.groupLabel,
      component: "div"
    }, params.group)), React__default.createElement("ul", {
      className: classes === null || classes === void 0 ? void 0 : classes.groupUl
    }, params.children))];
  };

  var isArray = isArrayFunc(selectData);
  var selectDataArray = selectData;
  var selectDataGrouped = selectData;
  var options = isArray ? idArray(selectDataArray) : idArrayGroupedData(selectDataGrouped);
  var groupBy;
  var renderOption = renderOptionArrayData;
  var getOptionLabel = getOptionLabelArrayData;

  if (!isArray) {
    groupBy = groupByFunc;
    renderOption = renderOptionGroupedData;
    getOptionLabel = getOptionLabelGroupedData;
  }

  if (multiple) {
    var filteringValues = values.filter(function (value) {
      return options.includes(value);
    });

    if (options.length) {
      if (values.length !== filteringValues.length) {
        onChange({}, filteringValues);
      }
    }
  }

  return React__default.createElement(Autocomplete, Object.assign({
    multiple: multiple
  }, autoCompleteProps, {
    popupIcon: React__default.createElement(ExpandMoreIcon, null),
    value: multiple ? values : values,
    noOptionsText: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.resultsOption"
    }),
    ChipProps: {
      deleteIcon: React__default.createElement(SvgDeleteChipIcon, null),
      size: 'small'
    },
    groupBy: groupBy,
    disableCloseOnSelect: multiple,
    disableClearable: false,
    options: options,
    getOptionLabel: getOptionLabel,
    onChange: onChange,
    renderOption: renderOption,
    renderInput: renderInput
  }, multiple && {
    renderGroup: renderGroup
  }));
};

function isArrayFunc(data) {
  var array = '[object Array]';
  return Object.prototype.toString.call(data) === array;
}

function idArray(selectData) {
  return selectData.map(function (o) {
    return o.id;
  });
}

function idArrayGroupedData(selectData) {
  var idArray = [];
  Object.keys(selectData).forEach(function (groupName) {
    selectData[groupName].forEach(function (i) {
      idArray.push(i.id);
    });
  });
  return idArray;
}

function getArrayDataTitle(option, data) {
  var selectDataItem = data.find(function (o) {
    return o.id === option;
  });
  return selectDataItem ? selectDataItem.title : '';
}

function getTitle(option, data, isGroupBy) {
  var title = '';
  Object.keys(data).find(function (groupName) {
    var groupedItem = data[groupName].find(function (itemGroup) {
      return itemGroup.id === option;
    });

    if (groupedItem) {
      title = isGroupBy ? groupName : groupedItem.title;
      return true;
    } else {
      return false;
    }
  });
  return title;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var Filter = /*#__PURE__*/function () {
  function Filter(defaultValue) {
    this.value = defaultValue;
  }

  _createClass(Filter, [{
    key: "isActive",
    get: function get() {
      return this.checkActive(this.value);
    }
  }]);

  return Filter;
}();

__decorate([observable], Filter.prototype, "value", void 0);

__decorate([computed], Filter.prototype, "isActive", null);

class InSetFilter extends Filter {
  constructor(defaultValue = []) {
    super(observable.array(defaultValue));
  }

  checkActive(value) {
    return value.length > 0;
  }

  onChange(e, value) {
    this.value = observable.array(value);
  }

  clear() {
    this.value = observable.array();
  }

  get values() {
    return this.value.toJSON();
  }

  get asJson() {
    return this.values;
  }

}

__decorate([action.bound], InSetFilter.prototype, "onChange", null);

__decorate([action.bound], InSetFilter.prototype, "clear", null);

__decorate([computed], InSetFilter.prototype, "values", null);

__decorate([computed], InSetFilter.prototype, "asJson", null);

const ClearFilterButton = props => {
  const {
    clear
  } = props;
  return React__default.createElement(IconButton, {
    onClick: e => {
      e.stopPropagation();
      clear();
    }
  }, React__default.createElement(Clear, null));
};

const textFieldProps = {
  variant: 'outlined',
  fullWidth: true,
  InputLabelProps: {
    shrink: true
  },
  size: 'small'
};
const AutocompleteProps = {
  disableClearable: true,
  freeSolo: false,
  fullWidth: true
};
const pickerProps = {
  autoOk: true,
  variant: 'inline',
  inputVariant: 'outlined',
  format: 'dd.MM.yyyy',
  disableFuture: true,
  size: 'small',
  InputLabelProps: {
    shrink: true
  },
  invalidDateMessage: React__default.createElement(FormattedMessage, {
    id: 'campaignRequest.invalidDateMessage'
  }),
  maxDateMessage: React__default.createElement(FormattedMessage, {
    id: 'campaignRequest.maxDateMessage'
  })
};
const checkboxProps$1 = {
  icon: React__default.createElement(SvgCheckboxDefault, null),
  checkedIcon: React__default.createElement(SvgCheckboxChecked, null),
  color: 'primary'
};

const SelectRegFormInj = observer$1(props => {
  const {
    model,
    intl
  } = props;
  const {
    filtering
  } = model;
  const [Select$1] = di([Select], SelectRegFormInj);
  return React__default.createElement(Select$1, {
    multiple: true,
    textFieldProps: { ...textFieldProps
    },
    selectData: model.regFormFilterData,
    onChange: filtering.regForm.onChange,
    values: filtering.regForm.values,
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.regForm"
    }),
    placeholder: intl.formatMessage('common.all'),
    autoCompleteProps: { ...AutocompleteProps
    }
  });
});
const AdditionalFiltersInj = props => React__default.createElement(React__default.Fragment, null);
const CampaignRequestListFilterPanel = observer$1(props => {
  const [SelectRegForm] = di([SelectRegFormInj], CampaignRequestListFilterPanel);
  const [AdditionalFilters] = di([AdditionalFiltersInj], CampaignRequestListFilterPanel);
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignRequestListFilterPanel);
  const [ClearFilterButton$1] = di([ClearFilterButton], CampaignRequestListFilterPanel);
  const [Select$1] = di([Select], SelectRegFormInj);
  const {
    model,
    isExecutorsAllowed
  } = props;
  const location = useLocation();
  const {
    intlStore: intl
  } = useStore();
  useEffect(() => {
    const campaignId = queryString.parse(location.search).campaignId;

    if (campaignId) {
      model.filtering.campaign = new InSetFilter(observable.array([campaignId]));
    }
  }, [location.search, model]);

  const clearButtonHandler = handler => {
    return () => handler(null);
  };

  const {
    filtering
  } = model;

  const campaignFilterChange = (event, value) => {
    model.getFilterData(value);
    filtering.campaign.onChange(event, value);

    if (!filtering.campaign.values.length) {
      filtering.regForm.onChange(event, []);
    }
  };

  return React__default.createElement(ExpansionPanel, null, React__default.createElement(ExpansionPanelSummary, {
    expandIcon: React__default.createElement(ExpandMore, null)
  }, React__default.createElement(Typography, {
    variant: "subtitle2"
  }, React__default.createElement(FormattedMessage, {
    id: "common.filters"
  }))), React__default.createElement(ExpansionPanelDetails, null, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 6
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 6
  }, React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(TextField, Object.assign({}, textFieldProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.number"
    }),
    placeholder: intl.formatMessage('common.all'),
    value: filtering.number.value,
    onChange: filtering.number.onChange
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(SelectRegForm, {
    model: model,
    intl: intl
  })), React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(Select$1, {
    multiple: true,
    values: filtering.state.values,
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.state"
    }),
    placeholder: intl.formatMessage('common.all'),
    selectData: model.stateFilterData,
    onChange: filtering.state.onChange,
    textFieldProps: { ...textFieldProps
    },
    autoCompleteProps: { ...AutocompleteProps
    }
  })), React__default.createElement(AdditionalFilters, {
    model: model,
    intl: intl
  }), React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    permCode: permissions.System.ViewPersonList
  }, allowed => React__default.createElement(Select$1, {
    multiple: true,
    values: filtering.author.values,
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.author"
    }),
    selectData: model.personsFilterData,
    onChange: filtering.author.onChange,
    placeholder: intl.formatMessage('common.all'),
    textFieldProps: { ...textFieldProps
    },
    autoCompleteProps: { ...AutocompleteProps,
      disabled: !allowed
    }
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(Select$1, {
    multiple: true,
    textFieldProps: { ...textFieldProps
    },
    selectData: model.campaignFilterData,
    onChange: campaignFilterChange,
    values: filtering.campaign.values,
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.campaign"
    }),
    placeholder: intl.formatMessage('common.all'),
    autoCompleteProps: { ...AutocompleteProps
    }
  })), isExecutorsAllowed && React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(Select$1, {
    multiple: true,
    textFieldProps: { ...textFieldProps
    },
    selectData: model.employeeFilterData,
    onChange: filtering.executors.onChange,
    values: filtering.executors.values,
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.executor"
    }),
    placeholder: intl.formatMessage('common.all'),
    autoCompleteProps: { ...AutocompleteProps
    }
  })), React__default.createElement(Grid, {
    item: true,
    xs: 4,
    container: true,
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(DatePicker, Object.assign({}, pickerProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.created"
    }),
    placeholder: intl.formatMessage('common.from'),
    value: filtering.created.value.from,
    onChange: filtering.created.onFromChange
  }, filtering.created.value.to && {
    maxDate: filtering.created.value.to
  }, {
    InputProps: {
      endAdornment: React__default.createElement(ClearFilterButton$1, {
        clear: clearButtonHandler(filtering.created.onFromChange)
      })
    }
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(DatePicker, Object.assign({}, pickerProps, {
    placeholder: intl.formatMessage('common.until'),
    value: filtering.created.value.to,
    onChange: filtering.created.onToChange
  }, filtering.created.value.from && {
    minDate: filtering.created.value.from
  }, {
    InputProps: {
      endAdornment: React__default.createElement(ClearFilterButton$1, {
        clear: clearButtonHandler(filtering.created.onToChange)
      })
    }
  })))), React__default.createElement(Grid, {
    item: true,
    xs: 4,
    container: true,
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(DatePicker, Object.assign({}, pickerProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.registryColumns.sent"
    }),
    placeholder: intl.formatMessage('common.from'),
    value: filtering.sent.value.from,
    onChange: filtering.sent.onFromChange
  }, filtering.sent.value.to && {
    maxDate: filtering.sent.value.to
  }, {
    InputProps: {
      endAdornment: React__default.createElement(ClearFilterButton$1, {
        clear: clearButtonHandler(filtering.sent.onFromChange)
      })
    }
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(DatePicker, Object.assign({}, pickerProps, {
    placeholder: intl.formatMessage('common.until'),
    value: filtering.sent.value.to,
    onChange: filtering.sent.onToChange
  }, filtering.sent.value.from && {
    minDate: filtering.sent.value.from
  }, {
    InputProps: {
      endAdornment: React__default.createElement(ClearFilterButton$1, {
        clear: clearButtonHandler(filtering.sent.onToChange)
      })
    }
  }))))))));
});

var _path$3;

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function SvgDotMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "-10 -3 24 24"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M2 17.998A2 2 0 111.998 14 2 2 0 012 17.998zm0-11a2 2 0 11-.001 4.001A2 2 0 012 6.998zM2-.001a2 2 0 110 4 2 2 0 010-4z"
  })));
}

var ConfirmationButtons;

(function (ConfirmationButtons) {
  ConfirmationButtons["delete"] = "delete";
  ConfirmationButtons["addExecutor"] = "addExecutor";
})(ConfirmationButtons || (ConfirmationButtons = {}));

function settingsConfirmDialog(props) {
  return {
    delete: {
      id: ConfirmationButtons.delete,
      title: 'common.confirmDeletion',
      message: 'campaignRequest.confirmDeletionInfoText',
      onConfirm: props[ConfirmationButtons.delete]
    },
    addExecutor: {
      id: ConfirmationButtons.addExecutor,
      title: 'campaignRequest.dialog.executorsTitle',
      message: 'campaignRequest.dialog.executorsMessage',
      onConfirm: props[ConfirmationButtons.addExecutor]
    }
  };
}

const usePermissionsActionButtons = props => {
  const {
    rowId
  } = props;
  const [permissionsData, setPermissionsData] = useState([]);
  const {
    authorizationStore
  } = useStore();
  const allPermissionsQueries = useMemo(() => {
    return [permissionsConfig.addActualAppointment(rowId), permissionsConfig.updateActualAppointment(rowId), permissionsConfig.editCampaignRequest(rowId), permissionsConfig.deleteCampaignRequest(rowId)];
  }, [rowId]);
  useEffect(() => {
    authorizationStore.checkAll(allPermissionsQueries).then(setPermissionsData);
  }, [allPermissionsQueries]);

  const reloadPermission = () => {
    authorizationStore.checkAll(allPermissionsQueries).then(setPermissionsData);
  };

  return [permissionsData, reloadPermission];
};

const useSettingsConfirmDialog = props => {
  const settings = settingsConfirmDialog(props);
  const [settingsConfirm, setSettingsConfirm] = useState(settings[ConfirmationButtons.delete]);

  const setSettings = actionButton => {
    setSettingsConfirm(settings[actionButton]);
  };

  return [settingsConfirm, setSettings];
};

const CampaignRequestActionsBtns = observer$1(props => {
  const {
    campaignRow,
    reloadData,
    isConfirm,
    setIsConfirm,
    handleEditExecutorDialogOpen
  } = props;
  const {
    id
  } = campaignRow;
  const {
    intlStore: intl
  } = useStore();
  const [ConfirmationDialog$1] = di([ConfirmationDialog], CampaignRequestActionsBtns);
  const [MenuButton$1] = di([MenuButton], CampaignRequestActionsBtns);
  const [ActionMenuItem$1] = di([ActionMenuItem], CampaignRequestActionsBtns);
  const [open, setModalIsOpen, setModalIsClosed] = useModal();
  const [permissionsData, reloadPermission] = usePermissionsActionButtons({
    rowId: id
  });
  const [addActualAppointment, updateActualAppointment, editCampaignRequest, deleteCampaignRequest] = permissionsData;
  const {
    requestStore
  } = useStore();
  useEffect(() => {
    if (setIsConfirm && isConfirm) {
      setIsConfirm(false);
      reloadData();
      reloadPermission();
    }
  }, [isConfirm, setIsConfirm]);
  const deleteCampaign = useCallback(() => {
    try {
      requestStore.deleteRequest(id).finally(reloadData);
    } catch (error) {
      console.error(error);
    }
  }, [reloadData, id, requestStore]);

  const onDeleteConfirm = function () {
    try {
      return Promise.resolve(deleteCampaign()).then(function () {
        setModalIsClosed();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const handleConfirmAddExecutor = useCallback(() => {
    return requestStore.setCurrentUserAsExecutor(id).finally(() => {
      reloadPermission();
      reloadData();
      setModalIsClosed();
    });
  }, [reloadData, id, reloadPermission]);
  const [settings, setSettings] = useSettingsConfirmDialog({
    delete: onDeleteConfirm,
    addExecutor: handleConfirmAddExecutor
  });
  const renderActionItems = useCallback(() => {
    return hideMenu => {
      const onDeleteClick = () => {
        setSettings(ConfirmationButtons.delete);
        hideMenu && hideMenu();
        setModalIsOpen();
      };

      const onAddExecutorClick = () => {
        setSettings(ConfirmationButtons.addExecutor);
        hideMenu && hideMenu();
        setModalIsOpen();
      };

      const onAppointExecutorClick = () => {
        hideMenu && hideMenu();
        handleEditExecutorDialogOpen(campaignRow);
      };

      const onChangeExecutorClick = () => {
        hideMenu && hideMenu();
        handleEditExecutorDialogOpen(campaignRow, 'campaignRequest.dialog.changeExecutorTitle');
      };

      return [React__default.createElement(React__default.Fragment, {
        key: "actionBtns"
      }, addActualAppointment && updateActualAppointment && React__default.createElement(ActionMenuItem$1, {
        messageId: "campaignRequest.actions.appointExecutor",
        onClick: onAppointExecutorClick
      }), !addActualAppointment && updateActualAppointment && React__default.createElement(ActionMenuItem$1, {
        messageId: "campaignRequest.actions.changeExecutor",
        onClick: onChangeExecutorClick
      }), addActualAppointment && React__default.createElement(ActionMenuItem$1, {
        messageId: "campaignRequest.actions.requestToWork",
        onClick: onAddExecutorClick
      }), editCampaignRequest && React__default.createElement(ActionMenuItem$1, {
        messageId: "common.edit",
        path: generatePath(clientRoute.requestEdit, {
          id
        })
      }), deleteCampaignRequest && React__default.createElement(ActionMenuItem$1, {
        messageId: "common.delete",
        onClick: onDeleteClick
      }))];
    };
  }, [permissionsData, campaignRow, handleEditExecutorDialogOpen]);

  const renderActionsButton = onClick => {
    const atLeastOneAllowed = permissionsData.some(isPermissionAllowed => isPermissionAllowed);
    return atLeastOneAllowed ? React__default.createElement(IconButton, {
      onClick: onClick
    }, React__default.createElement(SvgIcon, null, React__default.createElement(SvgDotMenu, null))) : React__default.createElement(React__default.Fragment, null);
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(MenuButton$1, {
    renderButton: renderActionsButton,
    renderMenuItems: renderActionItems()
  }), React__default.createElement(ConfirmationDialog$1, {
    id: settings.id,
    open: open,
    title: intl.formatMessage(settings.title),
    message: intl.formatMessage(settings.message, {
      number: campaignRow.number
    }),
    onConfirm: settings.onConfirm,
    onCancel: setModalIsClosed,
    keepMounted: true
  }));
});

var renderAutoCompleteInput = function renderAutoCompleteInput(label, required, errorText, textFieldProps) {
  return function (params) {
    return React__default.createElement(TextField, Object.assign({}, params, {
      required: required,
      label: label,
      variant: "outlined",
      error: !!errorText,
      helperText: errorText
    }, textFieldProps));
  };
};

const CampaignRequestCreateDialog = observer$1(props => {
  const {
    onClose
  } = props;
  const [renderAutoCompleteInput$1] = di([renderAutoCompleteInput], CampaignRequestCreateDialog);
  const [activeCampaigns, setActiveCampaigns] = useState([]);
  const [isLoadingActiveCampaigns, setIsLoadingActiveCampaigns] = useState(true);
  const [activeCampaign, setActiveCampaign] = useState('');
  const [validationStarted, setValidationStarted] = useState(false);
  const {
    campaignsStore,
    intlStore: intl
  } = useStore();
  const {
    createRequest
  } = campaignsStore;
  useEffect(() => {
    campaignsStore.getActualCampaignList().then(r => {
      setIsLoadingActiveCampaigns(false);
      setActiveCampaigns(r);
    });
  }, [campaignsStore]);
  const error = useMemo(() => {
    if (validationStarted && !activeCampaign) {
      return intl.formatMessage('validation.required');
    }

    return '';
  }, [activeCampaign, intl, validationStarted]);

  const onChangeCategory = (e, value) => {
    setValidationStarted(true);
    setActiveCampaign(value ? value.id : '');
  };

  return React__default.createElement(Dialog, {
    maxWidth: "xs",
    fullWidth: true,
    open: true,
    scroll: "body"
  }, React__default.createElement(Box, {
    pt: 4,
    pr: 4
  }, React__default.createElement(Grid, {
    container: true,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    onClick: onClose
  }, React__default.createElement(Close, null))))), React__default.createElement(Box, {
    pl: 12,
    pr: 12,
    pb: 12
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h5"
  }, React__default.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.newRequest"
  }))))), React__default.createElement(Box, {
    pt: 8
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column",
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Autocomplete, {
    onChange: onChangeCategory,
    getOptionSelected: (option, value) => option.id === value.id,
    getOptionLabel: option => option.title,
    options: activeCampaigns,
    loading: isLoadingActiveCampaigns,
    renderInput: renderAutoCompleteInput$1(intl.formatMessage('campaign.titleCampaignListPage'), true, error)
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 3
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    disabled: !activeCampaign,
    color: "primary",
    fullWidth: true,
    size: "large",
    variant: "contained",
    onClick: () => createRequest(activeCampaign)
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.createRequest"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: onClose,
    fullWidth: true,
    size: "large",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })))))))));
});

var TableModel = /*#__PURE__*/function () {
  function TableModel(defaultFilter, defaultSorting, pageSizeOptions) {
    var _this = this;

    if (pageSizeOptions === void 0) {
      pageSizeOptions = [10, 25, 50, 100];
    }

    this.isLoading = true;
    this.rows = [];
    this.pageNumber = 0;
    this.rowsCount = 0;

    this.changeSorting = function (sort) {
      return function () {
        if (_this.currentSorting !== sort) {
          var _this$currentSorting;

          (_this$currentSorting = _this.currentSorting) === null || _this$currentSorting === void 0 ? void 0 : _this$currentSorting.off();
        }

        sort.changeDirection();
        _this.pageNumber = 0;
      };
    };

    this.filtering = observable(defaultFilter);
    this.sorting = observable(defaultSorting);
    this.pageSizeOptions = pageSizeOptions;
    this.pageSize = this.pageSizeOptions[0] | 10;
    this.loadingDisposer = reaction(function () {
      return _this.queryData;
    }, function () {
      return _this.isLoading = true;
    }, {
      fireImmediately: true
    });
    this.pageNumberDisposer = reaction(function () {
      return _this.filterData;
    }, function () {
      return _this.pageNumber = 0;
    });
    this.loadRowsDisposer = reaction(function () {
      return _this.queryData;
    }, debounce(this.loadRowsData, 500), {
      fireImmediately: true
    });
  }

  var _proto = TableModel.prototype;

  _proto.loadRowsData = function loadRowsData(queryData) {
    try {
      var _this3 = this;

      return Promise.resolve(_this3.getRowsData(queryData)).then(function (data) {
        _this3.rows = data.rows;
        _this3.rowsCount = data.count;
        _this3.isLoading = false;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reloadData = function reloadData() {
    return this.loadRowsData(this.queryData);
  };

  _proto.clearFilters = function clearFilters() {
    var _this4 = this;

    Object.keys(this.filtering).forEach(function (name) {
      return _this4.filtering[name].clear();
    });
  };

  _proto.onChangePageSize = function onChangePageSize(e) {
    this.pageNumber = 0;
    this.pageSize = Number(e.target.value);
  };

  _proto.onChangePage = function onChangePage(e, newPage) {
    this.pageNumber = newPage - 1;
  };

  _proto.dispose = function dispose() {
    this.loadingDisposer();
    this.loadRowsDisposer();
    this.pageNumberDisposer();
  };

  _createClass(TableModel, [{
    key: "currentSorting",
    get: function get() {
      return Object.values(this.sorting).find(function (s) {
        return s.isActive;
      });
    }
  }, {
    key: "filterNames",
    get: function get() {
      return Object.keys(this.filtering);
    }
  }, {
    key: "filterData",
    get: function get() {
      var _this5 = this;

      return this.filterNames.filter(function (name) {
        return _this5.filtering[name].isActive;
      }).map(function (name) {
        var _ref;

        return _ref = {}, _ref[name] = _this5.filtering[name].asJson, _ref;
      }).reduce(function (acc, f) {
        return Object.assign(acc, f);
      }, {});
    }
  }, {
    key: "sortNames",
    get: function get() {
      return Object.keys(this.sorting);
    }
  }, {
    key: "sortData",
    get: function get() {
      var _this6 = this;

      return this.sortNames.filter(function (name) {
        return _this6.sorting[name].isActive;
      }).map(function (name) {
        var _ref2;

        return _ref2 = {}, _ref2[name] = _this6.sorting[name].direction, _ref2;
      });
    }
  }, {
    key: "queryData",
    get: function get() {
      return {
        page: this.pageNumber + 1,
        pageSize: this.pageSize,
        filter: this.filterData,
        sort: this.sortData
      };
    }
  }]);

  return TableModel;
}();

__decorate([observable], TableModel.prototype, "filtering", void 0);

__decorate([observable], TableModel.prototype, "sorting", void 0);

__decorate([observable], TableModel.prototype, "isLoading", void 0);

__decorate([observable], TableModel.prototype, "rows", void 0);

__decorate([observable], TableModel.prototype, "pageNumber", void 0);

__decorate([observable], TableModel.prototype, "pageSize", void 0);

__decorate([observable], TableModel.prototype, "rowsCount", void 0);

__decorate([observable], TableModel.prototype, "loadingDisposer", void 0);

__decorate([observable], TableModel.prototype, "pageNumberDisposer", void 0);

__decorate([observable], TableModel.prototype, "loadRowsDisposer", void 0);

__decorate([action.bound, actionAsync], TableModel.prototype, "loadRowsData", null);

__decorate([action.bound], TableModel.prototype, "reloadData", null);

__decorate([action.bound], TableModel.prototype, "clearFilters", null);

__decorate([action.bound], TableModel.prototype, "changeSorting", void 0);

__decorate([action.bound], TableModel.prototype, "onChangePageSize", null);

__decorate([action.bound], TableModel.prototype, "onChangePage", null);

__decorate([action.bound], TableModel.prototype, "dispose", null);

__decorate([computed], TableModel.prototype, "currentSorting", null);

__decorate([computed], TableModel.prototype, "filterNames", null);

__decorate([computed], TableModel.prototype, "filterData", null);

__decorate([computed], TableModel.prototype, "sortNames", null);

__decorate([computed], TableModel.prototype, "sortData", null);

__decorate([computed], TableModel.prototype, "queryData", null);

var ApiConfigs = function ApiConfigs() {
  var _this = this;

  this.login = function (data) {
    return {
      url: '/login',
      method: 'PUT',
      data: data
    };
  };

  this.esiaAuthUrl = {
    url: '/authUrl/esia',
    method: 'GET'
  };

  this.esiaLogin = function (search) {
    return {
      url: "/login/esia" + search,
      method: 'PUT'
    };
  };

  this.samlAuthUrl = function (provider, backUrl) {
    var backUrlParam = backUrl ? "?backUrl=" + backUrl : '';
    return {
      url: "/saml/" + provider + "/loginUrl" + backUrlParam,
      method: 'GET'
    };
  };

  this.logout = {
    url: '/logout',
    method: 'PUT'
  };

  this.resetPassword = function (data) {
    return {
      url: '/reset-password',
      method: 'PUT',
      data: data
    };
  };

  this.forgotPassword = function (data) {
    return {
      url: '/forgot-password',
      method: 'PUT',
      data: data
    };
  };

  this.confirmEmail = function (data) {
    return {
      url: '/confirm-email',
      method: 'PUT',
      data: data
    };
  };

  this.register = function (data) {
    return {
      url: '/register',
      method: 'PUT',
      data: data
    };
  };

  this.authorizationCheck = function (queries) {
    return {
      url: '/check',
      method: 'PUT',
      data: queries
    };
  };

  this.person = function (lang) {
    return {
      url: '/person',
      method: 'GET',
      params: {
        lang: lang
      }
    };
  };

  this.setLang = function (lang) {
    return {
      url: "/person?lang=" + lang,
      method: 'PUT'
    };
  };

  this.userList = function (data) {
    return {
      url: '/administration/users',
      method: 'PUT',
      data: data
    };
  };

  this.loadUser = function (id) {
    return {
      url: "/administration/user/" + id,
      method: 'GET'
    };
  };

  this.saveUser = function (id, submission) {
    return {
      url: "/administration/user/" + id,
      method: 'PUT',
      data: submission
    };
  };

  this.userRoleList = {
    url: "roles",
    method: 'GET'
  };

  this.saveUserHead = function (id, body) {
    return {
      url: "/administration/user/" + id + "/update",
      method: 'PUT',
      data: body
    };
  };

  this.blockUser = function (id) {
    return {
      url: "/administration/user/" + id + "/block",
      method: 'PUT'
    };
  };

  this.unblockUser = function (id) {
    return {
      url: "/administration/user/" + id + "/unblock",
      method: 'PUT'
    };
  };

  this.deleteUser = function (id) {
    return {
      url: "/administration/user/" + id,
      method: 'DELETE'
    };
  };

  this.loginAsUser = function (id) {
    return {
      url: "/login-as/" + id,
      method: 'PUT'
    };
  };

  this.createCampaign = function (lifecycleCode) {
    return {
      url: '/campaign',
      method: 'POST',
      data: {
        lifecycleCode: lifecycleCode
      }
    };
  };

  this.campaigns = {
    url: '/campaigns',
    method: 'GET'
  };

  this.campaign = function (id) {
    return {
      url: "/campaign/" + id,
      method: 'GET'
    };
  };

  this.editCampaign = function (id, data) {
    return {
      url: "/campaign/" + id,
      method: 'PUT',
      data: data
    };
  };

  this.campaignForm = function (id) {
    return {
      url: "/campaign/" + id + "/form",
      method: 'GET'
    };
  };

  this.campaignFileUrl = function (id) {
    return "/campaign/file/" + id;
  };

  this.campaignFile = function (id) {
    return {
      url: _this.campaignFileUrl(id),
      method: 'GET',
      responseType: 'blob'
    };
  };

  this.createRegForm = function (campaignId) {
    return {
      url: '/regForm',
      method: 'POST',
      params: {
        campaign: campaignId
      }
    };
  };

  this.editRegForm = function (id, submission) {
    return {
      url: "/regForm/" + id,
      method: 'PUT',
      data: submission
    };
  };

  this.regFormCard = function (id) {
    return {
      url: "/regForm/" + id,
      method: 'GET'
    };
  };

  this.regForms = function (campaignId, minimal, edit) {
    if (minimal === void 0) {
      minimal = false;
    }

    return {
      url: '/regForms',
      method: 'GET',
      params: {
        campaign: campaignId,
        minimal: minimal,
        edit: edit
      }
    };
  };

  this.regFormsByCampaignsForSelect = function (campaigns) {
    var campaignsQuery = campaigns.map(function (c) {
      return "campaign=" + c;
    }).join('&');
    return {
      url: "/select/regForms/grouped?" + campaignsQuery,
      method: 'GET'
    };
  };

  this.changeRegFormsPosition = function (regFormId, newPosition) {
    return {
      url: "/regForm/" + regFormId + "/position/" + newPosition,
      method: 'PUT'
    };
  };

  this.regForm = function (id) {
    return {
      url: "/regForm/" + id + "/form",
      method: 'GET'
    };
  };

  this.deleteRegForm = function (id) {
    return {
      url: "/regForm/" + id,
      method: 'DELETE'
    };
  };

  this.regFormFile = function (fileId) {
    return {
      url: "/regForm/file/" + fileId,
      method: 'GET',
      responseType: 'blob'
    };
  };

  this.templates = function (regFormId) {
    return {
      url: "/regForm/" + regFormId + "/templates",
      method: 'GET'
    };
  };

  this.template = function (id) {
    return {
      url: "/template/" + id,
      method: 'GET'
    };
  };

  this.createTemplate = function (regFormId, formData) {
    return {
      url: "/template",
      method: 'POST',
      params: {
        regForm: regFormId
      },
      data: formData
    };
  };

  this.saveTemplate = function (templateId, formData) {
    return {
      url: "/template/" + templateId,
      method: 'PUT',
      data: formData
    };
  };

  this.deleteTemplate = function (templateId) {
    return {
      url: "/template/" + templateId,
      method: 'DELETE'
    };
  };

  this.changeTemplatePosition = function (templateId, newPosition) {
    return {
      url: "/template/" + templateId + "/position/" + newPosition,
      method: 'PUT'
    };
  };

  this.downloadTemplateFile = function (templateId) {
    return {
      url: "/template/" + templateId + "/file",
      method: 'GET',
      responseType: 'blob'
    };
  };

  this.createRequest = function (regFormId) {
    return {
      url: "/request?regForm=" + regFormId,
      method: 'POST'
    };
  };

  this.getRequest = function (requestId) {
    return {
      url: "/request/" + requestId,
      method: 'GET'
    };
  };

  this.getDeadlines = function (requestId) {
    return {
      url: "/request/" + requestId + "/deadline",
      method: 'GET'
    };
  };

  this.updatePreScores = function (requestId, submission) {
    return {
      url: "/request/" + requestId + "/preScores",
      method: 'PUT',
      data: submission
    };
  };

  this.updatePreExpertise = function (requestId, submission) {
    return {
      url: "/request/" + requestId + "/preExpertise",
      method: 'PUT',
      data: submission
    };
  };

  this.updateExpertise = function (requestId, submission) {
    return {
      url: "/request/" + requestId + "/expertise",
      method: 'PUT',
      data: submission
    };
  };

  this.deleteRequest = function (requestId) {
    return {
      url: "/request/" + requestId,
      method: 'DELETE'
    };
  };

  this.loadRequestApprovalSheets = function (requestId) {
    return {
      url: "/request/" + requestId + "/approval-sheets",
      method: 'GET'
    };
  };

  this.getApprovalSheet = function (sheetId) {
    return {
      url: "/approval-sheet/" + sheetId,
      method: 'GET'
    };
  };

  this.changeApprovalSheetStatus = function (sheetId, status) {
    return {
      url: "/approval-sheet/" + sheetId + "/manage",
      method: 'POST',
      data: {
        decision: status
      }
    };
  };

  this.sendApprovalSheetResolution = function (sheetId, resolution, participantId) {
    return {
      url: "/approval-sheet/" + sheetId + "/sendResolution",
      method: 'POST',
      data: {
        participantId: participantId,
        resolution: resolution
      }
    };
  };

  this.saveApprovalSheetGroups = function (dto) {
    return {
      url: "/approval-sheet/" + dto.sheetId + "/editGroups",
      method: 'POST',
      data: dto.groups
    };
  };

  this.getAllActiveNonBlockedUsers = function () {
    return {
      url: "/select/users/v2",
      method: 'GET',
      params: {
        blocked: false,
        emailConfirmed: true
      }
    };
  };

  this.requestList = function (queryData) {
    return {
      url: '/requests',
      method: 'PUT',
      data: queryData
    };
  };

  this.registry = function (registryCode, queryData) {
    return {
      url: '/registry/table',
      method: 'PUT',
      params: {
        code: registryCode
      },
      data: queryData
    };
  };

  this.registryColumns = function (registryCode) {
    return {
      url: '/registry/columns',
      method: 'GET',
      params: {
        code: registryCode
      }
    };
  };

  this.registryRequestLogColumns = function (registryCode) {
    return {
      url: "/registry/" + registryCode + "/columns",
      method: 'GET'
    };
  };

  this.registryRequestLog = function (registryCode, entityId, queryData) {
    return {
      url: "/registry/" + registryCode + "/entity/" + entityId + "/table",
      method: 'PUT',
      data: queryData
    };
  };

  this.uploadRequestLog = function (tableQueryData, registryCode, entityId) {
    return {
      url: "/registry/" + registryCode + "/entity/" + entityId + "/export",
      method: 'PUT',
      data: tableQueryData,
      responseType: 'arraybuffer'
    };
  };

  this.requestListFilterData = function (data) {
    return {
      url: '/requests/filters',
      method: 'PUT',
      data: data
    };
  };

  this.requestListXls = function (queryData) {
    return {
      url: '/requestsXls',
      method: 'PUT',
      responseType: 'blob',
      data: queryData
    };
  };

  this.transitionRequest = function (requestId) {
    return {
      url: "/request/" + requestId + "/transitions",
      method: 'GET'
    };
  };

  this.transitionToNextLifeCycleStep = function (transitionId, requestId) {
    return {
      url: "/request/" + requestId + "/changeState?transition=" + transitionId,
      method: 'PUT'
    };
  };

  this.personsListFilterData = {
    url: '/persons?filter',
    method: 'GET'
  };

  this.requestPrintForms = function (formId) {
    return {
      url: "/request-form/" + formId + "/templates",
      method: 'GET'
    };
  };

  this.getPrintForm = function (templateId, formId) {
    return {
      url: "/pf-template/" + templateId + "/form/" + formId,
      method: 'GET'
    };
  };

  this.generatePrintForm = function (formId, templateId, submission) {
    return {
      method: 'POST',
      url: '/pf',
      params: {
        template: templateId,
        customForm: formId
      },
      data: submission
    };
  };

  this.downloadPrintFormFile = function (pfId) {
    return {
      url: "/pf/" + pfId,
      method: 'GET',
      responseType: 'blob'
    };
  };

  this.downloadAllPrintFormFiles = function (formId) {
    return {
      url: "/pf/" + formId + "/all",
      method: 'GET',
      responseType: 'blob'
    };
  };

  this.getActualCampaignList = {
    url: "/campaigns/active",
    method: 'GET'
  };
  this.getLifecycleList = {
    url: "/select/lifecycles?processCode=CampaignProcess",
    method: 'GET'
  };

  this.catalogItems = function (catalogCode, lang) {
    return {
      url: "/catalogItems",
      method: 'GET',
      params: {
        catalogCode: catalogCode,
        lang: lang
      }
    };
  };

  this.deleteCampaign = function (id) {
    return {
      url: "/campaign/" + id,
      method: 'DELETE'
    };
  };

  this.transitionCampaign = function (campaignId) {
    return {
      url: "/campaign/" + campaignId + "/transitions",
      method: 'GET'
    };
  };

  this.getFormForGeneralSettings = function (campaignId) {
    return {
      url: "/campaign/" + campaignId + "/general-settings-form",
      method: 'GET'
    };
  };

  this.transitionToNextLifeCycleStepCampaign = function (transitionId, campaignId) {
    return {
      url: "/campaign/" + campaignId + "/changeState?transition=" + transitionId,
      method: 'PUT'
    };
  };

  this.saveFormForGeneralSettings = function (campaignId, submission) {
    return {
      url: "/campaign/" + campaignId + "/general-settings-form",
      method: 'PUT',
      data: submission
    };
  };

  this.loginAnonymously = {
    url: "/login-anonymous",
    method: 'PUT'
  };

  this.requestFormSettings = function (regFormId) {
    return {
      url: '/request-form-settings',
      method: 'GET',
      params: {
        regForm: regFormId
      }
    };
  };

  this.createRequestFormSetting = function (regFormId, dto) {
    return {
      url: '/request-form-setting',
      method: 'POST',
      params: {
        regForm: regFormId
      },
      data: dto
    };
  };

  this.loadRequestFormSetting = function (id) {
    return {
      url: "/request-form-setting/" + id,
      method: 'GET'
    };
  };

  this.saveRequestFormSetting = function (id, dto) {
    return {
      url: "/request-form-setting/" + id,
      method: 'PUT',
      data: dto
    };
  };

  this.deleteRequestFormSetting = function (id) {
    return {
      url: "/request-form-setting/" + id,
      method: 'DELETE'
    };
  };

  this.changePositionRequestFormSetting = function (id, position) {
    return {
      url: "/request-form-setting/" + id + "/position/" + position,
      method: 'PUT'
    };
  };

  this.loadExecutors = function () {
    return {
      url: "/select/users/v2?role=Employee&role=SeniorEmployee",
      method: 'GET',
      params: {
        blocked: false
      }
    };
  };

  this.loadStates = function (id) {
    return {
      url: "/regForm/" + id + "/states",
      method: 'GET'
    };
  };

  this.loadPermissions = function () {
    return {
      url: "/select/permissions?entityCode=RequestCustomForm",
      method: 'GET'
    };
  };

  this.loadFormCode = function () {
    return {
      url: "/select/forms/search?code=RequestCustomForm_",
      method: 'GET'
    };
  };

  this.loadRequestForm = function (id) {
    return {
      url: "/request-form/" + id,
      method: 'GET'
    };
  };

  this.saveRequestForm = function (id, submission) {
    return {
      url: "/request-form/" + id,
      method: 'PUT',
      data: submission
    };
  };

  this.requestFormCheckEditable = function (requestFormId) {
    return {
      url: "/request-form/" + requestFormId + "/checkEditable",
      method: 'GET'
    };
  };

  this.fetchExecutorList = function (regFormId) {
    return {
      url: "/regForm/" + regFormId + "/executors",
      method: 'GET'
    };
  };

  this.deleteExecutor = function (regFormId, settingsExecId) {
    return {
      url: "/regForm/" + regFormId + "/executor/" + settingsExecId,
      method: 'DELETE'
    };
  };

  this.addExecutor = function (regFormId, settings) {
    return {
      method: 'POST',
      url: "/regForm/" + regFormId + "/executor",
      data: settings
    };
  };

  this.fetchUsers = function () {
    return {
      url: '/persons',
      method: 'GET'
    };
  };

  this.fetchExecutorsSettings = function (regFormId) {
    return {
      url: "regForm/" + regFormId + "/executors-settings",
      method: 'GET'
    };
  };

  this.getAllActiveEmployees = function () {
    return {
      url: "/select/users?role=Employee&role=SeniorEmployee",
      method: 'GET',
      params: {
        blocked: false
      }
    };
  };

  this.getAllEmployees = function () {
    return {
      url: "/select/users?role=Employee&role=SeniorEmployee",
      method: 'GET'
    };
  };

  this.setCurrentUserAsExecutor = function (requestId) {
    return {
      url: "/request/" + requestId + "/executor",
      method: 'GET'
    };
  };

  this.getExecutorSettings = function (requestId) {
    return {
      url: "/request/" + requestId + "/executorSetting",
      method: 'GET'
    };
  };

  this.editExecutorSettings = function (requestId, userId) {
    return {
      url: "/request/" + requestId + "/executorSetting",
      method: 'PUT',
      data: {
        userId: userId
      }
    };
  };

  this.listPreset = function (registryCode) {
    return {
      url: "presets",
      method: 'GET',
      params: {
        registryCode: registryCode
      }
    };
  };

  this.savePreset = function (preset) {
    return {
      url: "preset",
      method: "PUT",
      data: preset
    };
  };

  this.deletePreset = function (presetId) {
    return {
      url: "preset/" + presetId,
      method: 'DELETE'
    };
  };

  this.saveListPresets = function (presets) {
    return {
      url: '/presets',
      method: 'PUT',
      data: presets
    };
  };

  this.getLastPreset = function (registryCode) {
    return {
      url: '/lastPreset',
      method: 'GET',
      params: {
        registryCode: registryCode
      }
    };
  };

  this.saveLastPreset = function (registryCode, presetId) {
    return {
      url: '/lastPreset',
      method: 'PUT',
      params: {
        registryCode: registryCode,
        presetId: presetId
      }
    };
  };

  this.loadNotifications = function (queryData) {
    return {
      url: "/notifications/lk",
      method: 'PUT',
      data: queryData
    };
  };

  this.loadCountNotViewedMessages = function () {
    return {
      url: '/notifications/lk/countUnviewedMessage',
      method: 'GET'
    };
  };

  this.changeViewed = function (id, viewed) {
    return {
      url: "/notification/lk/changeViewed",
      method: 'PUT',
      params: {
        deliveredNotificationId: id,
        viewed: viewed
      }
    };
  };

  this.deleteNotification = function (id) {
    return {
      url: "/notification/lk",
      method: 'DELETE',
      params: {
        deliveredNotificationId: id
      }
    };
  };

  this.loadModulesList = function () {
    return {
      url: '/getRoutes',
      method: 'GET'
    };
  };

  this.upload = function (tableQueryData) {
    return {
      url: '/registry/export',
      method: 'PUT',
      data: tableQueryData,
      responseType: 'arraybuffer'
    };
  };

  this.loadTemplatePermissions = function (settingsId) {
    return {
      url: "/settings/" + settingsId + "/templatePermissions",
      method: 'GET'
    };
  };

  this.savedTemplatePermissions = function (settingsId, permissions) {
    return {
      url: "/settings/" + settingsId + "/templatePermissions",
      method: 'PUT',
      data: permissions
    };
  };

  this.checkEditablePf = function (customFormId) {
    return {
      url: "/request-form/" + customFormId + "/checkEditablePf",
      method: 'GET'
    };
  };

  this.checkIsPasswordRecoveryTokenValid = function (token) {
    return {
      url: "/checkPasswordResetToken?token=" + token,
      method: 'GET'
    };
  };

  this.getFileByte = function (printFormId) {
    return {
      url: "/pf/" + printFormId + "/toByte",
      method: 'GET',
      responseType: 'arraybuffer'
    };
  };

  this.uploadSignature = function (printFormId, signature) {
    return {
      url: "/pf/" + printFormId + "/sign",
      method: 'POST',
      data: {
        sign: signature
      }
    };
  };

  this.uploadSignatureFile = function (printFormId, signatureFile) {
    return {
      url: "/pf/" + printFormId + "/upload-sign",
      method: 'POST',
      data: signatureFile
    };
  };

  this.getSignatureInfo = function (printFormId) {
    return {
      url: "/pf/" + printFormId + "/sign-info",
      method: 'GET'
    };
  };

  this.downloadSignature = function (printFormId, isWithFile) {
    return {
      url: "/pf/" + printFormId + "/sign",
      method: 'GET',
      params: {
        attached: isWithFile
      }
    };
  };

  this.deleteSignature = function (printFormId) {
    return {
      url: "/pf/" + printFormId + "/sign",
      method: 'DELETE'
    };
  };

  this.getFormioFileByte = function (url) {
    return {
      url: url,
      method: 'GET',
      responseType: 'arraybuffer'
    };
  };

  this.uploadFormioSignature = function (url, signature) {
    return {
      url: url,
      method: 'POST',
      data: {
        sign: signature
      }
    };
  };

  this.uploadFormioSignatureFile = function (url, signatureFile) {
    return {
      url: url,
      method: 'POST',
      data: signatureFile
    };
  };

  this.getFormioSignatureInfo = function (url) {
    return {
      url: url,
      method: 'GET'
    };
  };

  this.downloadFormioSignature = function (url, isWithFile) {
    return {
      url: url,
      method: 'GET',
      params: {
        attached: isWithFile
      }
    };
  };

  this.deleteFormioSignature = function (url) {
    return {
      url: url,
      method: 'DELETE'
    };
  };

  this.runScript = function (script) {
    return {
      url: "/console/script",
      method: 'POST',
      responseType: 'blob',
      data: script
    };
  };
};

var apiConfigs = new ApiConfigs();

var Sort = /*#__PURE__*/function () {
  function Sort(defaultDirection) {
    this.direction = defaultDirection;
  }

  var _proto = Sort.prototype;

  _proto.changeDirection = function changeDirection() {
    this.direction = this.nextDirection;
  };

  _proto.off = function off() {
    this.direction = undefined;
  };

  _createClass(Sort, [{
    key: "isActive",
    get: function get() {
      return !!this.direction;
    }
  }, {
    key: "nextDirection",
    get: function get() {
      switch (this.direction) {
        case 'asc':
          return 'desc';

        case 'desc':
          return undefined;

        default:
          return 'asc';
      }
    }
  }]);

  return Sort;
}();

__decorate([observable], Sort.prototype, "direction", void 0);

__decorate([action.bound], Sort.prototype, "changeDirection", null);

__decorate([action.bound], Sort.prototype, "off", null);

__decorate([computed], Sort.prototype, "isActive", null);

__decorate([computed], Sort.prototype, "nextDirection", null);

class LikeFilter extends Filter {
  constructor(defaultValue = '') {
    super(defaultValue);
  }

  checkActive(value) {
    return !!value;
  }

  onChange(e) {
    this.value = e.target.value;
  }

  clear() {
    this.value = '';
  }

  get asJson() {
    return this.value;
  }

}

__decorate([action.bound], LikeFilter.prototype, "checkActive", null);

__decorate([action.bound], LikeFilter.prototype, "onChange", null);

__decorate([action.bound], LikeFilter.prototype, "clear", null);

class DateRangeFilter extends Filter {
  constructor(defaultValue = {
    from: null,
    to: null
  }) {
    super(defaultValue);
  }

  checkActive(value) {
    return !!value.from || !!value.to;
  }

  get asJson() {
    return {
      from: this.value.from ? formatISO(startOfDay(this.value.from)) : undefined,
      to: this.value.to ? formatISO(endOfDay(this.value.to)) : undefined
    };
  }

  onFromChange(date) {
    this.value.from = date;
  }

  onToChange(date) {
    this.value.to = date;
  }

  clear() {
    this.value = observable({
      from: null,
      to: null
    });
  }

}

__decorate([action.bound], DateRangeFilter.prototype, "onFromChange", null);

__decorate([action.bound], DateRangeFilter.prototype, "onToChange", null);

__decorate([action.bound], DateRangeFilter.prototype, "clear", null);

var PersonModel = /*#__PURE__*/function () {
  function PersonModel() {
    this.uuid = '';
    this.userId = '';
    this.lastName = '';
    this.firstName = '';
  }

  var _proto = PersonModel.prototype;

  _proto.load = function load(dto) {
    Object.assign(this, dto);
    return this;
  };

  _createClass(PersonModel, [{
    key: "lastNameWithInitials",
    get: function get() {
      var firstName = this.firstName,
          lastName = this.lastName,
          middleName = this.middleName;
      return lastName + " " + (firstName ? firstName[0] + '. ' : '') + (middleName ? middleName[0] + '.' : '');
    }
  }]);

  return PersonModel;
}();

__decorate([observable], PersonModel.prototype, "userId", void 0);

__decorate([observable], PersonModel.prototype, "lastName", void 0);

__decorate([observable], PersonModel.prototype, "firstName", void 0);

__decorate([observable], PersonModel.prototype, "middleName", void 0);

__decorate([computed], PersonModel.prototype, "lastNameWithInitials", null);

var UserNameModel = /*#__PURE__*/function () {
  function UserNameModel() {
    this.userId = '';
    this.name = '';
    return this;
  }

  var _proto = UserNameModel.prototype;

  _proto.load = function load(dto) {
    this.userId = dto.userId;
    var person = new PersonModel().load(dto.person);
    this.name = person.lastNameWithInitials;
    return this;
  };

  _createClass(UserNameModel, [{
    key: "asIdTitle",
    get: function get() {
      return {
        id: this.userId,
        title: this.name
      };
    }
  }]);

  return UserNameModel;
}();

__decorate([observable], UserNameModel.prototype, "userId", void 0);

__decorate([observable], UserNameModel.prototype, "name", void 0);

__decorate([action.bound], UserNameModel.prototype, "load", null);

__decorate([computed], UserNameModel.prototype, "asIdTitle", null);

var RequestRowModel = /*#__PURE__*/function () {
  function RequestRowModel() {
    this.id = '';
    this.number = '';
    this.authorUserId = '';
    this.authorName = '';
    this.campaignId = '';
    this.campaignTitle = '';
    this.regFormTitle = '';
    this.state = '';
    this.created = '';
    this.sent = '';
    this.executors = [];
  }

  var _proto = RequestRowModel.prototype;

  _proto.load = function load(row) {
    this.id = row.id;
    this.number = row.number;
    this.authorUserId = row.authorUserId;
    this.authorName = row.authorName;
    this.campaignId = row.campaignId;
    this.campaignTitle = row.campaignTitle;
    this.regFormTitle = row.regFormTitle;
    this.state = row.state;
    this.created = row.created;
    this.sent = row.sent;
    this.executors = row.executors;
  };

  _createClass(RequestRowModel, [{
    key: "executorsList",
    get: function get() {
      if (!this.executors) {
        return '';
      }

      var executorsList = this.executors.map(function (executor) {
        return executor.person.lastName + " " + executor.person.firstName;
      });
      return executorsList.join(', ');
    }
  }]);

  return RequestRowModel;
}();

__decorate([observable], RequestRowModel.prototype, "id", void 0);

__decorate([observable], RequestRowModel.prototype, "number", void 0);

__decorate([observable], RequestRowModel.prototype, "authorUserId", void 0);

__decorate([observable], RequestRowModel.prototype, "authorName", void 0);

__decorate([observable], RequestRowModel.prototype, "campaignId", void 0);

__decorate([observable], RequestRowModel.prototype, "campaignTitle", void 0);

__decorate([observable], RequestRowModel.prototype, "regFormTitle", void 0);

__decorate([observable], RequestRowModel.prototype, "state", void 0);

__decorate([observable], RequestRowModel.prototype, "created", void 0);

__decorate([observable], RequestRowModel.prototype, "sent", void 0);

__decorate([observable], RequestRowModel.prototype, "executors", void 0);

__decorate([computed], RequestRowModel.prototype, "executorsList", null);

__decorate([action.bound], RequestRowModel.prototype, "load", null);

var CampaignRequestListModel = /*#__PURE__*/function (_TableModel) {
  _inheritsLoose(CampaignRequestListModel, _TableModel);

  function CampaignRequestListModel(api) {
    var _this;

    var filter = {
      number: new LikeFilter(),
      author: new InSetFilter(),
      campaign: new InSetFilter(),
      regForm: new InSetFilter(),
      state: new InSetFilter(),
      created: new DateRangeFilter(),
      sent: new DateRangeFilter(),
      executors: new InSetFilter()
    };
    var sort = {
      number: new Sort('asc'),
      campaign: new Sort(),
      regForm: new Sort(),
      created: new Sort(),
      sent: new Sort()
    };
    _this = _TableModel.call(this, filter, sort) || this;
    _this.api = api;
    _this.campaignFilterData = [];
    _this.regFormFilterData = [];
    _this.stateFilterData = {};
    _this.personsFilterData = [];
    _this.employeeFilterData = [];

    _this.getPersonsFilterData();

    _this.getEmployeesFilterData();

    return _this;
  }

  var _proto = CampaignRequestListModel.prototype;

  _proto.getRowsData = function getRowsData(queryData) {
    var _this2 = this;

    return this.api.client(apiConfigs.requestList(queryData)).then(function (r) {
      return r.data;
    }).then(function (_ref) {
      var rows = _ref.rows,
          count = _ref.count;
      return {
        rows: rows.map(_this2.mapDtoToRow),
        count: count
      };
    });
  };

  _proto.getFilterData = function getFilterData(campaignId) {
    var _this3 = this;

    if (campaignId === void 0) {
      campaignId = [];
    }

    var data = {
      filter: campaignId ? {
        campaigns: campaignId
      } : {}
    };
    this.api.client(apiConfigs.requestListFilterData(data)).then(function (r) {
      return r.data;
    }).then(action(function (data) {
      _this3.campaignFilterData = data.campaigns;
      _this3.regFormFilterData = data.regForms;

      if (data.statesByProcess) {
        _this3.stateFilterData = data.statesByProcess;
      }
    }));
  };

  _proto.getPersonsFilterData = function getPersonsFilterData() {
    var _this4 = this;

    this.api.client(apiConfigs.personsListFilterData).then(function (r) {
      return r.data;
    }).then(action(function (data) {
      var author = new UserNameModel();
      _this4.personsFilterData = data.map(function (o) {
        author.load(o);
        return author.asIdTitle;
      });
    }));
  };

  _proto.getEmployeesFilterData = function getEmployeesFilterData() {
    var _this5 = this;

    this.api.client(apiConfigs.getAllEmployees()).then(function (r) {
      return r.data;
    }).then(function (employees) {
      var employeesIdTitle = employees.map(function (employee) {
        return {
          id: employee.userId,
          title: employee.person.lastName + " " + employee.person.firstName
        };
      });
      _this5.employeeFilterData = employeesIdTitle;
    });
  };

  _proto.mapDtoToRow = function mapDtoToRow(dto) {
    var author = new UserNameModel().load(dto.author);
    var rowModel = new RequestRowModel();
    var row = {
      id: dto.id,
      number: dto.number,
      authorName: author.name,
      authorUserId: author.userId,
      campaignId: dto.campaignId,
      campaignTitle: dto.campaignTitle,
      regFormTitle: dto.regFormTitle,
      created: dto.created,
      sent: dto.sent,
      state: dto.state,
      executors: dto.executors
    };
    rowModel.load(row);
    return rowModel;
  };

  return CampaignRequestListModel;
}(TableModel);

__decorate([observable], CampaignRequestListModel.prototype, "api", void 0);

__decorate([observable], CampaignRequestListModel.prototype, "campaignFilterData", void 0);

__decorate([observable], CampaignRequestListModel.prototype, "regFormFilterData", void 0);

__decorate([observable], CampaignRequestListModel.prototype, "stateFilterData", void 0);

__decorate([observable], CampaignRequestListModel.prototype, "personsFilterData", void 0);

__decorate([observable], CampaignRequestListModel.prototype, "employeeFilterData", void 0);

__decorate([action.bound], CampaignRequestListModel.prototype, "getRowsData", null);

__decorate([action.bound], CampaignRequestListModel.prototype, "getFilterData", null);

__decorate([action.bound], CampaignRequestListModel.prototype, "getPersonsFilterData", null);

__decorate([action.bound], CampaignRequestListModel.prototype, "getEmployeesFilterData", null);

__decorate([action.bound], CampaignRequestListModel.prototype, "mapDtoToRow", null);

var _path$4;

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function SvgClearFilter(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -2 24 24",
    width: 24,
    height: 24
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M18.19 8.79l-1.88 1.88c-.18.19-.44.3-.71.3-.26 0-.52-.11-.71-.3a.973.973 0 01-.29-.71c0-.26.1-.52.29-.71.05-.04.28-.27.7-.69L17 7v-.44-.78c0-.2-.08-.4-.22-.55a.83.83 0 00-.56-.23H9.66c-.55 0-1-.44-1-1 0-.55.45-1 1-1h6.56c.75.01 1.46.31 1.98.84.52.52.81 1.24.8 1.98v1c-.01.38-.1.74-.27 1.07v.1c-.2.38-.38.65-.54.8zM1.71.29c.12.12 1.63 1.64 16.97 17.03.19.19.3.45.3.71 0 .27-.11.53-.3.71-.18.19-.44.3-.71.3-.26 0-.52-.11-.71-.3l-4.51-4.52v2c0 .38-.21.72-.55.89l-3.56 1.78c-.14.08-.29.11-.45.11a.999.999 0 01-1-1v-3.85l-5.41-5.4a2.5 2.5 0 01-.54-.81v-.06C1.09 7.54 1 7.16 1 6.78v-1c0-.88.43-1.71 1.14-2.22.38.37 0-.01 0-.01v.01c-.23-.24-.76-.76-1.85-1.85C-.1 1.32-.1.69.29.29c.4-.39 1.03-.39 1.42 0zM3 7l1.41 1.56 4.52 4.51c.19.19.3.45.29.71v2.6c.94-.46 1.46-.72 1.56-.78v-1.82c0-.26.11-.52.29-.71.02-.02.12-.11.3-.29L3.59 5l-.09.06c-.3.11-.5.4-.5.72V7zM1.71.29c-.02-.02 0 0 0 0z"
  })));
}

var _path$5;

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

function SvgExport(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "31 25 20 20"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M47.998 44.999H33.999a3 3 0 01-3-3v-4a.999.999 0 112 0v4a1 1 0 001 1h13.999a1 1 0 001-1v-4a1 1 0 012.001 0v4a3 3 0 01-3.001 3zm-7-20a1 1 0 011.001 1v9.59l2.289-2.3a1.004 1.004 0 011.42 1.42l-4 4a1.004 1.004 0 01-.33.21.937.937 0 01-.759 0 .993.993 0 01-.33-.21l-4-4a1.003 1.003 0 111.419-1.42l2.29 2.3v-9.59a1 1 0 011-1z"
  })));
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    &:hover {\n        background-color: ", ";\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n        &:hover {\n            color: ", ";\n            background-color: ", ";\n        }\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n    transform: rotate(180deg);\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var ReversedKeyboardTabIconInj = styled(KeyboardTabIcon)(_templateObject$3());
var StyledIconButtonInj = withTheme(styled(IconButton)(_templateObject2$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.variables.palette.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.variables.palette.hoverInLists;
}));
var StyledPaginationItemInj = withTheme(styled(PaginationItem)(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.variables.palette.hoverInLists;
}));
var renderPaginationItem = function renderPaginationItem(item) {
  var disabled = item.disabled,
      onClick = item.onClick,
      type = item.type;

  var _di = di([ReversedKeyboardTabIconInj], renderPaginationItem),
      ReversedKeyboardTabIcon = _di[0];

  var _di2 = di([StyledIconButtonInj], renderPaginationItem),
      StyledIconButton = _di2[0];

  var _di3 = di([StyledPaginationItemInj], renderPaginationItem),
      StyledPaginationItem = _di3[0];

  switch (type) {
    case 'first':
      return React__default.createElement(StyledIconButton, {
        disabled: disabled,
        onClick: onClick
      }, React__default.createElement(ReversedKeyboardTabIcon, null));

    case 'last':
      return React__default.createElement(StyledIconButton, {
        disabled: disabled,
        onClick: onClick
      }, React__default.createElement(KeyboardTabIcon, null));

    default:
      return React__default.createElement(StyledPaginationItem, Object.assign({}, item));
  }
};

var TotTablePagination = function TotTablePagination(props) {
  var rowsPerPage = props.rowsPerPage,
      count = props.count,
      page = props.page,
      rowsPerPageOptions = props.rowsPerPageOptions,
      onChangePage = props.onChangePage,
      onChangeRowsPerPage = props.onChangeRowsPerPage,
      pagingInfoMessageId = props.pagingInfoMessageId,
      pagingInfoMessageIdIfNull = props.pagingInfoMessageIdIfNull;

  var _di = di([renderPaginationItem], TotTablePagination),
      renderPaginationItem$1 = _di[0];

  var pagesCount = Math.ceil(count / rowsPerPage);
  var from = page * rowsPerPage + 1;
  var to = (page + 1) * rowsPerPage;

  if (to > count) {
    to = count;
  }

  return React__default.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "space-between",
    alignItems: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    wrap: "nowrap"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "common.rowsPerPage"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TextField, {
    id: "filled-select-currency",
    select: true,
    size: "small",
    value: rowsPerPage,
    onChange: onChangeRowsPerPage,
    variant: "outlined"
  }, rowsPerPageOptions && rowsPerPageOptions.map(function (option) {
    return React__default.createElement(MenuItem, {
      key: option,
      value: option
    }, option);
  }))))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Pagination, {
    count: pagesCount,
    page: page + 1,
    onChange: onChangePage,
    color: "primary",
    showFirstButton: true,
    showLastButton: true,
    renderItem: renderPaginationItem$1
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, null, count ? React__default.createElement(FormattedMessage, {
    id: pagingInfoMessageId,
    values: {
      count: count,
      from: from,
      to: to
    }
  }) : React__default.createElement(FormattedMessage, {
    id: pagingInfoMessageIdIfNull
  }))));
};

var EllipsisBox = function EllipsisBox(props) {
  var text = props.text,
      _props$correctLength = props.correctLength,
      correctLength = _props$correctLength === void 0 ? 100 : _props$correctLength;

  if (text.length > correctLength) {
    return React__default.createElement(Tooltip, {
      title: text
    }, React__default.createElement(Box, null, text.substring(0, correctLength - 3) + '...'));
  } else {
    return React__default.createElement(React__default.Fragment, null, text);
  }
};

var renderLink = function renderLink(to, last, linkText) {
  return last ? React__default.createElement(Typography, {
    color: "textPrimary",
    key: to
  }, React__default.createElement(EllipsisBox, {
    text: linkText,
    correctLength: 35
  })) : linkText && React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: to,
    key: to
  }, React__default.createElement(EllipsisBox, {
    text: linkText,
    correctLength: 35
  }));
};
var BreadcrumbsComponent = function BreadcrumbsComponent(props) {
  var _props$objectId = props.objectId,
      objectId = _props$objectId === void 0 ? 'non-id' : _props$objectId,
      pageTitle = props.pageTitle,
      breadcrumbsSettings = props.breadcrumbsSettings;
  var mainRoutes = breadcrumbsSettings.mainRoutes,
      names = breadcrumbsSettings.names,
      routesWithParams = breadcrumbsSettings.routesWithParams;
  var location = useLocation();
  var intl = useIntl();

  var _useStore = useStore(),
      breadcrumbsStore = _useStore.breadcrumbsStore;

  var mainPageRoute = breadcrumbsStore.mainPageRoute;

  var renderLinks = function renderLinks() {
    var locationArray = location.pathname.split('/').filter(function (x) {
      return x;
    });
    var lastIndex = locationArray.length - 1;
    return locationArray.map(function (value, index) {
      var to = "/" + locationArray.slice(0, index + 1).join('/');
      var routeWithParams = Object.keys(routesWithParams).find(function (r) {
        return routesWithParams[r](objectId) === to;
      });
      var routeWithoutParams = Object.keys(mainRoutes).find(function (r) {
        return mainRoutes[r] === to;
      });

      if (index !== lastIndex) {
        var nextTo = "/" + locationArray.slice(0, index + 2).join('/');
        var nextRouteWithoutParams = Object.keys(mainRoutes).find(function (r) {
          return mainRoutes[r] === nextTo;
        });

        if (nextRouteWithoutParams) {
          return '';
        }
      }

      if (routeWithoutParams && names[routeWithoutParams]) {
        var linkText = intl.formatMessage({
          id: names[routeWithoutParams]
        });
        return renderLink(to, index === lastIndex, linkText);
      } else if (routeWithParams && names[routeWithParams]) {
        var _linkText = intl.formatMessage({
          id: names[routeWithParams]
        });

        return renderLink(to, index === lastIndex, _linkText);
      } else if ((routeWithParams || routeWithoutParams) && pageTitle) {
        var _linkText2 = pageTitle;
        return renderLink(to, index === lastIndex, _linkText2);
      } else {
        return '';
      }
    });
  };

  return React__default.createElement(Breadcrumbs, {
    separator: "<"
  }, React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: mainPageRoute
  }, React__default.createElement(FormattedMessage, {
    id: "breadcrumbs.mainPage"
  })), renderLinks());
};

var AuthorizationCheckAll = observer$1(function (props) {
  var queries = props.queries,
      children = props.children,
      pendingElement = props.pendingElement,
      errorElement = props.errorElement,
      or = props.or;

  var _useStore = useStore(),
      authorizationStore = _useStore.authorizationStore;

  var checkIsAllAllowed = useCallback(function () {
    return authorizationStore.checkAll(queries);
  }, [queries]);

  var _useState = useState(Promise.resolve([])),
      isAllAllowed = _useState[0],
      setIsAllAllowed = _useState[1];

  useEffect(function () {
    setIsAllAllowed(checkIsAllAllowed());
  }, [checkIsAllAllowed]);
  var renderChildrenOr = useCallback(function (isAllAllowed) {
    var allowed = isAllAllowed.some(function (_) {
      return _;
    });

    if (typeof children === 'function') {
      var render = children;
      return render(allowed);
    }

    if (allowed) {
      return children;
    }

    return React__default.createElement(React__default.Fragment, null);
  }, [children]);
  var renderChildrenAll = useCallback(function (isAllAllowed) {
    if (typeof children === 'function') {
      var render = children;
      return render(isAllAllowed);
    } else {
      throw new Error('AuthorizationCheckAll без установленной опции "or" в качестве children допускает только render-функцию `(isAllAllowed: boolean[]) => ReactNode`');
    }
  }, [children]);
  return fromPromise(isAllAllowed).case({
    pending: function pending() {
      return pendingElement || React__default.createElement(React__default.Fragment, null);
    },
    fulfilled: or ? renderChildrenOr : renderChildrenAll,
    rejected: function rejected() {
      return errorElement || React__default.createElement(React__default.Fragment, null);
    }
  });
});

const useStyles$2 = makeStyles(() => createStyles$1({
  typography: {
    fontWeight: 'bold'
  }
}));
const ExecutorEditDialog = observer$1(props => {
  const {
    onClose,
    open,
    requestRowModel,
    title,
    requestModel,
    setIsConfirm
  } = props;
  const [renderAutoCompleteInput$1] = di([renderAutoCompleteInput], ExecutorEditDialog);
  const {
    intlStore: intl,
    requestStore
  } = useStore();
  const classes = useStyles$2();
  const [employeesList, setEmployeesList] = useState([]);
  const [selectedExecutor, setSelectedExecutor] = useState(null);
  const [errorText, setErrorText] = useState('');
  const {
    id
  } = useParams();
  const requestId = requestRowModel ? requestRowModel.id : id;
  useEffect(() => {
    requestStore.getRequestExecutorList(requestId).then(setEmployeesList);
  }, [requestId, requestStore, setEmployeesList]);
  useEffect(() => {
    open && requestId && requestStore.getExecutorSettings(requestId).then(setSelectedExecutor);
  }, [requestStore, setSelectedExecutor, requestId, open]);

  const handleExecutorChange = (event, value) => {
    setSelectedExecutor(value);
    setErrorText('');
  };

  const handleClose = () => {
    onClose();
    setErrorText('');
    setSelectedExecutor(null);
  };

  const handleConfirm = () => {
    if (!selectedExecutor) {
      setErrorText(intl.formatMessage('validation.required'));
      return;
    }

    requestStore.editExecutorSettings(requestId, selectedExecutor === null || selectedExecutor === void 0 ? void 0 : selectedExecutor.userId).then(() => {
      requestModel && requestModel.updateExecutors();

      if (requestRowModel) {
        requestRowModel.executors = [selectedExecutor];
      }

      if (setIsConfirm) {
        setIsConfirm(true);
      }

      handleClose();
    });
  };

  const executorEditDialogTitle = title ? title : 'campaignRequest.dialog.editExecutorTitle';

  const getOptionSelected = (option, value) => {
    return option.userId === value.userId;
  };

  const getOptionLabel = option => {
    return `${option.person.lastName} ${option.person.firstName}`;
  };

  return React__default.createElement(Dialog, {
    open: open,
    onClose: onClose
  }, React__default.createElement(DialogTitle, null, React__default.createElement(FormattedMessage, {
    id: executorEditDialogTitle
  })), React__default.createElement(DialogContent, null, requestRowModel && React__default.createElement(Box, {
    pb: 4
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 3
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: classes.typography,
    variant: "body2"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.number"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, null, React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: generatePath(clientRoute.request, {
      id: requestRowModel.id
    })
  }, requestRowModel.number || React__default.createElement(FormattedMessage, {
    id: "campaignRequest.withoutNumber"
  }))))), React__default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: classes.typography,
    variant: "body2"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.campaign"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, null, React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: generatePath(clientRoute.campaign, {
      id: requestRowModel.campaignId
    })
  }, requestRowModel.campaignTitle)))), React__default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: classes.typography,
    variant: "body2"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.author"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, null, requestRowModel.authorName))))), React__default.createElement(Autocomplete, {
    key: selectedExecutor === null || selectedExecutor === void 0 ? void 0 : selectedExecutor.userId,
    onChange: handleExecutorChange,
    getOptionSelected: getOptionSelected,
    getOptionLabel: getOptionLabel,
    options: employeesList,
    defaultValue: selectedExecutor,
    loading: false,
    renderInput: renderAutoCompleteInput$1(intl.formatMessage('campaign.campaignRegFormExecutorResponsibleExecutor'), true, errorText)
  })), React__default.createElement(DialogActions, null, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 3
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: handleConfirm,
    size: "large",
    color: "primary",
    variant: "contained",
    fullWidth: true
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: handleClose,
    size: "large",
    color: "primary",
    fullWidth: true
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  }))))));
});

const useCampaignRequestListPageStyles = makeStyles(() => createStyles$1({
  tableBody: {
    overflowX: 'auto'
  }
}));
const CampaignRequestListPage = observer$1(() => {
  const [CampaignRequestListModel$1] = di([CampaignRequestListModel], CampaignRequestListPage);
  const [CampaignRequestListFilterPanel$1] = di([CampaignRequestListFilterPanel], CampaignRequestListPage);
  const [TotTablePagination$1] = di([TotTablePagination], CampaignRequestListPage);
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignRequestListPage);
  const [AuthorizationCheckAll$1] = di([AuthorizationCheckAll], CampaignRequestListPage);
  const [BreadcrumbsComponent$1] = di([BreadcrumbsComponent], CampaignRequestListPage);
  const [CampaignRequestCreateDialog$1] = di([CampaignRequestCreateDialog], CampaignRequestListPage);
  const [ExecutorEditDialog$1] = di([ExecutorEditDialog], CampaignRequestListPage);
  const [CampaignRequestActionsBtns$1] = di([CampaignRequestActionsBtns], CampaignRequestListPage);
  const location = useLocation();
  const {
    api,
    requestStore,
    authorizationStore,
    breadcrumbsStore
  } = useStore();
  const {
    breadCrumbsSettings
  } = breadcrumbsStore;
  const model = useMemo(() => {
    return new CampaignRequestListModel$1(api);
  }, [location.search, api]);
  const [requestRowModel, setRequestRowModel] = useState();
  const [isConfirm, setIsConfirm] = useState(false);
  const [isExecutorsAllowed, setIsExecutorsAllowed] = useState(false);
  const [open, setModalIsOpen, setModalIsClosed] = useModal();
  const [editExecutorDialogOpen, setEditExecutorDialogOpen, setEditExecutorDialogClosed] = useModal();
  const [editExecutorDialogTitle, setEditExecutorDialogTitle] = useState();
  const classes = useCampaignRequestListPageStyles();
  useEffect(() => {
    model.getFilterData(model.filtering.campaign.values);
    return () => model.dispose();
  }, [model]);
  useEffect(() => {
    authorizationStore.check({
      entityCode: entities.System,
      permCode: permissions.System.ViewCampReqExecutorColumn
    }).then(allowed => {
      setIsExecutorsAllowed(allowed);
    });
  }, [authorizationStore]);
  const onChangePage = useCallback((e, newPage) => {
    const root = document.getElementById('root');
    root.scrollTop = 0;
    model.onChangePage(e, newPage);
  }, [model]);
  const exportListXls = useCallback(() => {
    requestStore.exportListXls(model.queryData);
  }, [requestStore]);
  const handleEditExecutorDialogOpen = useCallback((campaignRow, title) => {
    setEditExecutorDialogOpen();
    setRequestRowModel(campaignRow);
    title && setEditExecutorDialogTitle(title);
  }, [setEditExecutorDialogOpen, setRequestRowModel, setEditExecutorDialogTitle]);
  const handleClickClearFilterButton = useCallback(() => {
    model.getFilterData();
    model.clearFilters();
  }, [model]);
  const {
    sorting,
    rows
  } = model;
  const [showCreateRequestButton] = useFeature('showCreateRequestButton');
  const queries = useMemo(() => {
    return rows.map(r => {
      const {
        id
      } = r;
      return [permissionsConfig.addActualAppointment(id), permissionsConfig.updateActualAppointment(id), permissionsConfig.editCampaignRequest(id), permissionsConfig.deleteCampaignRequest(id)];
    });
  }, [rows]);
  const renderRows = useCallback(() => {
    return rows.map((r, index) => {
      const {
        id
      } = r;
      return React__default.createElement(TableRow, {
        key: id,
        hover: true
      }, React__default.createElement(TableCell, null, React__default.createElement(Link$1, {
        component: NavLink,
        underline: "none",
        to: generatePath(clientRoute.request, {
          id
        })
      }, r.number || React__default.createElement(FormattedMessage, {
        id: "campaignRequest.withoutNumber"
      }))), React__default.createElement(TableCell, null, r.authorName), React__default.createElement(TableCell, null, React__default.createElement(Link$1, {
        component: NavLink,
        underline: "none",
        to: generatePath(clientRoute.campaign, {
          id: r.campaignId
        })
      }, r.campaignTitle)), React__default.createElement(TableCell, null, r.regFormTitle), React__default.createElement(TableCell, null, r.state), React__default.createElement(TableCell, null, React__default.createElement(FormattedDate, {
        value: r.created
      })), React__default.createElement(TableCell, null, r.sent && React__default.createElement(FormattedDate, {
        value: r.sent
      })), isExecutorsAllowed && React__default.createElement(TableCell, null, r.executorsList), React__default.createElement(AuthorizationCheckAll$1, {
        or: true,
        queries: queries[index]
      }, React__default.createElement(TableCell, null, React__default.createElement(CampaignRequestActionsBtns$1, {
        campaignRow: r,
        reloadData: model.reloadData,
        handleEditExecutorDialogOpen: handleEditExecutorDialogOpen,
        isConfirm: isConfirm,
        setIsConfirm: setIsConfirm
      }))));
    });
  }, [rows, isExecutorsAllowed, model, handleEditExecutorDialogOpen, queries, isConfirm]);
  return React__default.createElement(React__default.Fragment, null, open && React__default.createElement(CampaignRequestCreateDialog$1, {
    onClose: setModalIsClosed
  }), React__default.createElement(ExecutorEditDialog$1, {
    title: editExecutorDialogTitle,
    onClose: setEditExecutorDialogClosed,
    open: editExecutorDialogOpen,
    requestRowModel: requestRowModel,
    setIsConfirm: setIsConfirm
  }), React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 5.5,
    pb: 15
  }, React__default.createElement(Box, {
    pb: 5
  }, React__default.createElement(BreadcrumbsComponent$1, {
    breadcrumbsSettings: breadCrumbsSettings
  })), React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 10
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryTitle"
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 6,
    container: true,
    spacing: 2,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    variant: "text",
    color: "primary",
    startIcon: React__default.createElement(SvgIcon, null, React__default.createElement(SvgClearFilter, null)),
    onClick: handleClickClearFilterButton
  }, React__default.createElement(FormattedMessage, {
    id: "common.resetFilters"
  }))), React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    permCode: permissions.System.ExportCampRequestList
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    variant: "text",
    color: "primary",
    startIcon: React__default.createElement(SvgExport, null),
    onClick: exportListXls
  }, React__default.createElement(FormattedMessage, {
    id: "common.export"
  })))), showCreateRequestButton && React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    permCode: permissions.System.AddCampaignRequest
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "primary",
    variant: "contained",
    onClick: setModalIsOpen
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.createRequest"
  })))))), React__default.createElement(Grid, {
    item: true,
    xs: true
  }, React__default.createElement(CampaignRequestListFilterPanel$1, {
    isExecutorsAllowed: isExecutorsAllowed,
    model: model
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TableContainer, {
    component: Paper
  }, model.isLoading && React__default.createElement(LinearProgress, null), React__default.createElement(Table, null, React__default.createElement(TableHead, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, null, React__default.createElement(TableSortLabel, {
    active: sorting.number.isActive,
    direction: sorting.number.direction,
    onClick: model.changeSorting(sorting.number),
    IconComponent: ExpandMoreIcon
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.number"
  })))), React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.author"
  }))), React__default.createElement(TableCell, null, React__default.createElement(TableSortLabel, {
    active: sorting.campaign.isActive,
    direction: sorting.campaign.direction,
    onClick: model.changeSorting(sorting.campaign),
    IconComponent: ExpandMoreIcon
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.campaign"
  })))), React__default.createElement(TableCell, null, React__default.createElement(TableSortLabel, {
    active: sorting.regForm.isActive,
    direction: sorting.regForm.direction,
    onClick: model.changeSorting(sorting.regForm),
    IconComponent: ExpandMoreIcon
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.regForm"
  })))), React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.state"
  }))), React__default.createElement(TableCell, null, React__default.createElement(TableSortLabel, {
    active: sorting.created.isActive,
    direction: sorting.created.direction,
    onClick: model.changeSorting(sorting.created),
    IconComponent: ExpandMoreIcon
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.created"
  })))), React__default.createElement(TableCell, null, React__default.createElement(TableSortLabel, {
    active: sorting.sent.isActive,
    direction: sorting.sent.direction,
    onClick: model.changeSorting(sorting.sent),
    IconComponent: ExpandMoreIcon
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.sent"
  })))), isExecutorsAllowed && React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.registryColumns.executor"
  }))), React__default.createElement(TableCell, null))), React__default.createElement(TableBody, {
    className: classes.tableBody
  }, renderRows()), React__default.createElement(TableFooter, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, {
    colSpan: 12
  }, React__default.createElement(TotTablePagination$1, {
    count: model.rowsCount,
    page: model.pageNumber,
    onChangePage: onChangePage,
    onChangeRowsPerPage: model.onChangePageSize,
    rowsPerPage: model.pageSize,
    rowsPerPageOptions: model.pageSizeOptions,
    pagingInfoMessageId: "campaignRequest.registryPagingInfo",
    pagingInfoMessageIdIfNull: "campaignRequest.registryPagingInfoIfNull"
  })))))))))));
});

const RegFormFilter = props => {
  const {
    column,
    flatHeaders
  } = props;
  const {
    filterValue,
    setFilter,
    lang,
    columnType,
    filterField
  } = column;
  const [selectData, setSelectData] = useState([]);
  const filterType = 'select';
  const {
    campaignsStore
  } = useStore();
  const campaignFilterValue = useMemo(() => {
    var _flatHeaders$find, _flatHeaders$find$fil;

    return (_flatHeaders$find = flatHeaders.find(_ => _.id === 'campaign.title')) === null || _flatHeaders$find === void 0 ? void 0 : (_flatHeaders$find$fil = _flatHeaders$find.filterValue) === null || _flatHeaders$find$fil === void 0 ? void 0 : _flatHeaders$find$fil.value;
  }, [flatHeaders]);
  useEffect(() => {
    campaignsStore.regFormsByCampaignsForSelect(campaignFilterValue).then(data => setSelectData(data));
  }, [lang, setSelectData, campaignFilterValue]);
  const handleChange = useCallback((e, value) => {
    let newValue;

    if (value.length !== 0) {
      newValue = filterField ? {
        filterType,
        columnType,
        filterField,
        value: value
      } : {
        filterType,
        columnType,
        value: value
      };
    }

    setFilter(newValue);
  }, [setFilter]);
  return React__default.createElement(TTableSelectForFilter, {
    selectData: selectData,
    onChange: handleChange,
    values: !(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) ? [] : filterValue.value,
    label: column.shortHeader
  });
};

const useCampaignRequestTableStylesInj = makeStyles$1(() => createStyles$1({
  link: {
    display: 'inline'
  }
}));
const CampaignRequestTable = observer$1(props => {
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignRequestTable);
  const [useCampaignRequestTableStyles] = di([useCampaignRequestTableStylesInj], CampaignRequestTable);
  const [RegFormFilter$1] = di([RegFormFilter], CampaignRequestTable);
  const classes = useCampaignRequestTableStyles();
  const {
    setRowActions
  } = props;
  const {
    requestStore,
    presetStore,
    intlStore,
    catalogStore,
    userStore
  } = useStore();

  const saveListPresets = settings => presetStore.saveListPresets(settings);

  return React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    permCode: permissions.System.Administration
  }, allowed => React__default.createElement(TTable, {
    registryCode: "ics-requests",
    fetchData: requestStore.registry,
    fetchColumns: requestStore.registryColumns,
    presetsSetting: presetStore,
    fetchCatalog: catalogStore.getCatalog,
    fetchSelectDataByUrl: catalogStore.getSelectDataByUrl,
    upload: requestStore.upload,
    lang: intlStore.locale,
    cellFormatters: {
      'customData.number': function number(p) {
        return React__default.createElement(Link$1, {
          className: classes.link,
          component: NavLink,
          underline: "always",
          to: generatePath(clientRoute.request, {
            id: p.row.original.id
          })
        }, p.row.original.customData.number || React__default.createElement(FormattedMessage, {
          id: "campaignRequest.withoutNumber"
        }));
      },
      'customData.campaign.title': function campaignTitle(p) {
        return React__default.createElement(Link$1, {
          className: classes.link,
          component: NavLink,
          underline: "always",
          to: generatePath(clientRoute.campaign, {
            id: p.row.original.customData.campaign.id
          })
        }, p.row.original.customData.campaign.title);
      }
    },
    customFilters: {
      'regForm.title': RegFormFilter$1
    },
    saveListPresets: saveListPresets,
    fetchUserRoleList: userStore.userRoleList,
    rowActions: setRowActions,
    isAdmin: allowed
  }));
});

const useCampaignRequestLisPageNewStyles = makeStyles(() => createStyles$1({
  tableWrapper: {
    width: '100%'
  }
}));
const CampaignRequestListPageNew = observer$1(() => {
  const [BreadcrumbsComponent$1] = di([BreadcrumbsComponent], CampaignRequestListPageNew);
  const [ExecutorEditDialog$1] = di([ExecutorEditDialog], CampaignRequestListPageNew);
  const [CampaignRequestActionsBtns$1] = di([CampaignRequestActionsBtns], CampaignRequestListPageNew);
  const [CampaignRequestTable$1] = di([CampaignRequestTable], CampaignRequestListPageNew);
  const {
    requestStore,
    breadcrumbsStore
  } = useStore();
  const [requestRowModel, setRequestRowModel] = useState();
  const {
    breadCrumbsSettings
  } = breadcrumbsStore;
  const [editExecutorDialogOpen, setEditExecutorDialogOpen, setEditExecutorDialogClosed] = useModal();
  const [editExecutorDialogTitle, setEditExecutorDialogTitle] = useState();
  const [isConfirm, setIsConfirm] = useState(false);
  const classes = useCampaignRequestLisPageNewStyles();
  const handleEditExecutorDialogOpen = useCallback((campaignRow, title) => {
    setEditExecutorDialogOpen();
    setRequestRowModel(campaignRow);
    title && setEditExecutorDialogTitle(title);
  }, [setEditExecutorDialogOpen, setRequestRowModel, setEditExecutorDialogTitle]);
  const setRowActions = useMemo(() => (row, reloadData) => {
    const correctRowData = requestStore.mapDtoToRow(row);
    return React__default.createElement(CampaignRequestActionsBtns$1, {
      campaignRow: correctRowData,
      reloadData: reloadData,
      handleEditExecutorDialogOpen: handleEditExecutorDialogOpen,
      isConfirm: isConfirm,
      setIsConfirm: setIsConfirm
    });
  }, [isConfirm]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ExecutorEditDialog$1, {
    title: editExecutorDialogTitle,
    onClose: setEditExecutorDialogClosed,
    open: editExecutorDialogOpen,
    requestRowModel: requestRowModel,
    setIsConfirm: setIsConfirm
  }), React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 5.5,
    pb: 15
  }, React__default.createElement(Box, {
    pb: 5
  }, React__default.createElement(BreadcrumbsComponent$1, {
    breadcrumbsSettings: breadCrumbsSettings
  })), React__default.createElement(Grid, {
    container: true,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true,
    className: classes.tableWrapper
  }, React__default.createElement(CampaignRequestTable$1, {
    setRowActions: setRowActions
  }))))));
});

const CampaignCancelButton = props => {
  const {
    path
  } = props;
  return React__default.createElement(Button, {
    component: NavLink,
    to: path,
    color: "secondary",
    size: "small",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.discardChanges"
  }));
};

var ConfirmationDialog = function ConfirmationDialog(props) {
  var confirmText = props.confirmText,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      open = props.open,
      title = props.title,
      message = props.message,
      other = _objectWithoutPropertiesLoose(props, ["confirmText", "onConfirm", "onCancel", "open", "title", "message"]);

  var _useState = useState(false),
      isSending = _useState[0],
      setIsSending = _useState[1];

  var startIcon = isSending && React__default.createElement(StyledCircularProgress, null);

  var handleCancel = function handleCancel() {
    onCancel();
  };

  var stopIsSending = function stopIsSending() {
    setIsSending(false);
  };

  var handleOk = function handleOk() {
    setIsSending(true);
    onConfirm().finally(stopIsSending);
  };

  return React__default.createElement(Portal, null, React__default.createElement(Dialog$1, Object.assign({
    fullWidth: true,
    maxWidth: "xs",
    "aria-labelledby": "confirmation-dialog-title",
    open: open
  }, other), React__default.createElement(DialogTitle$1, {
    id: "confirmation-dialog-title"
  }, title), React__default.createElement(DialogContent$1, null, message), React__default.createElement(DialogActions$1, null, React__default.createElement(Button$1, {
    autoFocus: true,
    onClick: handleCancel,
    color: "primary"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })), React__default.createElement(Button$1, {
    onClick: handleOk,
    color: "secondary",
    variant: "contained",
    disabled: isSending,
    startIcon: startIcon
  }, confirmText || React__default.createElement(FormattedMessage, {
    id: 'common.confirm'
  })))));
};

function withConfirmDialog(WrappedComponent) {
  var ComponentWithConfirmDialog = observer$1(function (props) {
    var onConfirm = props.onConfirm,
        onOpen = props.onOpen,
        onClose = props.onClose,
        wrappedComponentProps = props.wrappedComponentProps,
        dialogProps = _objectWithoutPropertiesLoose(props, ["onConfirm", "onOpen", "onClose", "wrappedComponentProps"]);

    var _di = di([ConfirmationDialog], ComponentWithConfirmDialog),
        ConfirmationDialog$1 = _di[0];

    var _useState = useState(false),
        isOpen = _useState[0],
        setIsOpen = _useState[1];

    var openConfirmDialog = function openConfirmDialog() {
      setIsOpen(true);
      onOpen && onOpen();
    };

    var closeConfirmDialog = function closeConfirmDialog() {
      setIsOpen(false);
      onClose && onClose();
    };

    var handleConfirm = function handleConfirm() {
      try {
        return Promise.resolve(onConfirm()).then(function () {
          closeConfirmDialog();
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    return React__default.createElement(React__default.Fragment, null, React__default.createElement(WrappedComponent, Object.assign({
      openConfirmDialog: openConfirmDialog
    }, wrappedComponentProps)), React__default.createElement(ConfirmationDialog$1, Object.assign({
      open: isOpen,
      onConfirm: handleConfirm,
      onCancel: closeConfirmDialog,
      keepMounted: true
    }, dialogProps)));
  });
  return ComponentWithConfirmDialog;
}

const CancelButton = props => {
  const {
    onCancel
  } = props;
  return React__default.createElement(Button, {
    onClick: onCancel,
    color: "secondary",
    size: "small",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.discardChanges"
  }));
};

const CancelButtonButtonWithDialogInj = withConfirmDialog(({
  openConfirmDialog
}) => React__default.createElement(CancelButton, {
  onCancel: openConfirmDialog
}));
const CampaignCancelButtonWithDialog = props => {
  const {
    onConfirm
  } = props;
  const [CancelButtonButtonWithDialog] = di([CancelButtonButtonWithDialogInj], CampaignCancelButtonWithDialog);
  return React__default.createElement(CancelButtonButtonWithDialog, {
    id: "delete-request",
    title: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.dialog.title"
    }),
    message: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.dialog.closeMessage"
    }),
    onConfirm: onConfirm
  });
};

const CampaignEditButton = props => {
  const {
    onEdit
  } = props;
  return React__default.createElement(Button, {
    onClick: onEdit,
    color: "primary",
    size: "small",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.openEditMode"
  }));
};

const CampaignSaveButton = props => {
  const {
    onSubmit
  } = props;
  const [isLoading, startIcon, onSubmitHandler] = useAntiDoubleClick(onSubmit);
  return React__default.createElement(Button, {
    onClick: onSubmitHandler,
    color: "primary",
    size: "small",
    variant: "contained",
    disabled: isLoading,
    startIcon: startIcon
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.saveChanges"
  }));
};

const CampaignEditModeButtonsWithDialog = props => {
  const [CampaignSaveButton$1] = di([CampaignSaveButton], CampaignEditModeButtonsWithDialog);
  const [CampaignCancelButton$1] = di([CampaignCancelButton], CampaignEditModeButtonsWithDialog);
  const [CampaignCancelButtonWithDialog$1] = di([CampaignCancelButtonWithDialog], CampaignEditModeButtonsWithDialog);
  const history = useHistory();
  const {
    onSubmit,
    path,
    formIsChanged
  } = props;

  const confirm = () => {
    history.push({
      pathname: path,
      search: '?prompt=false'
    });
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    spacing: 3,
    alignItems: "center",
    justify: "center",
    container: true
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CampaignSaveButton$1, {
    onSubmit: onSubmit
  })), React__default.createElement(Grid, {
    item: true
  }, formIsChanged ? React__default.createElement(CampaignCancelButtonWithDialog$1, {
    onConfirm: confirm
  }) : React__default.createElement(CampaignCancelButton$1, {
    path: path
  }))));
};

const DeleteRequestButtonInj = withConfirmDialog(({
  openConfirmDialog
}) => {
  return React__default.createElement(Button, {
    onClick: openConfirmDialog,
    color: "secondary",
    size: "small",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.deleteRequest"
  }));
});
const CampaignViewModeButtons = props => {
  const {
    onEdit,
    deleteRequest,
    id,
    requestNumber,
    editCheckQueries,
    formId
  } = props;
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignViewModeButtons);
  const [AuthorizationCheckAll$1] = di([AuthorizationCheckAll], CampaignViewModeButtons);
  const [DeleteRequestButton] = di([DeleteRequestButtonInj], CampaignViewModeButtons);
  const [CampaignEditButton$1] = di([CampaignEditButton], CampaignViewModeButtons);
  const [isEditAllowed, setIsEditAllowed] = useState(false);
  const {
    requestStore
  } = useStore();
  useEffect(() => {
    if (!formId) {
      return;
    }

    requestStore.requestFormCheckEditable(formId).then(() => setIsEditAllowed(true)).catch(() => setIsEditAllowed(false));
  }, [requestStore, setIsEditAllowed, formId]);
  return React__default.createElement(Grid, {
    spacing: 3,
    alignItems: "center",
    justify: "center",
    container: true
  }, editCheckQueries && onEdit && React__default.createElement(AuthorizationCheckAll$1, {
    or: true,
    queries: editCheckQueries
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CampaignEditButton$1, {
    onEdit: onEdit
  }))), formId && isEditAllowed && onEdit && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CampaignEditButton$1, {
    onEdit: onEdit
  })), React__default.createElement(Route, {
    path: [clientRoute.request, clientRoute.requestForm],
    exact: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.CampaignRequest,
    entityId: id,
    permCode: permissions.CampaignRequest.Delete
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(DeleteRequestButton, {
    id: "delete-request",
    title: React__default.createElement(FormattedMessage, {
      id: "common.confirmDeletion"
    }),
    message: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.confirmDeletionInfoText",
      values: {
        number: requestNumber
      }
    }),
    onConfirm: deleteRequest
  })))));
};

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: transparent;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSticky = styled(Sticky)(_templateObject$4());
var triggerScrollTimeoutOnLoad = 1000;
var triggerScrollTimeout = 200;
var StickyWrapper = function StickyWrapper(props) {
  var root = document.getElementById('root');
  var location = useLocation();
  var children = props.children,
      mode = props.mode;

  var onRootClick = function onRootClick() {
    timeoutScrollHandler();
  };

  useEffect(function () {
    root.addEventListener('click', onRootClick);
    return function () {
      return root.removeEventListener('click', onRootClick);
    };
  }, [root]);
  var timeoutScrollHandler = useCallback(function () {
    root.dispatchEvent(new Event('scroll'));
  }, [root]);
  var timeoutScrollEvent = useCallback(function (timeout) {
    return setTimeout(timeoutScrollHandler, timeout);
  }, [timeoutScrollHandler]);
  useEffect(function () {
    timeoutScrollEvent(triggerScrollTimeoutOnLoad);
    return function () {
      return clearTimeout(timeoutScrollEvent(triggerScrollTimeoutOnLoad));
    };
  }, [timeoutScrollEvent]);
  useEffect(function () {
    timeoutScrollHandler();
    timeoutScrollEvent(triggerScrollTimeout);
    return function () {
      return clearTimeout(timeoutScrollEvent(triggerScrollTimeout));
    };
  }, [location, timeoutScrollHandler, timeoutScrollEvent]);
  return React__default.createElement(StyledSticky, {
    stickyStyle: {
      zIndex: 1
    },
    scrollElement: "#root",
    mode: mode
  }, children);
};

var ErrorDialog = function ErrorDialog(props) {
  var message = props.message,
      onClose = props.onClose,
      open = props.open;
  return React__default.createElement(Portal, null, React__default.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "xs",
    "aria-labelledby": "information-dialog",
    open: open
  }, React__default.createElement(DialogTitle, null, React__default.createElement(FormattedMessage, {
    id: "common.error"
  })), React__default.createElement(DialogContent, null, message || ''), React__default.createElement(DialogActions, null, React__default.createElement(Button, {
    onClick: onClose,
    color: "secondary",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: 'common.close'
  })))));
};

function getOrElse(value, component, elseComponent) {
  if (component === void 0) {
    component = value;
  }

  if (elseComponent === void 0) {
    elseComponent = '-';
  }

  return !!value ? component : elseComponent;
}

function ErrorMessage(error) {
  var _error$response;

  return getOrElse(error.response && error.response.data, (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data, React__default.createElement(FormattedMessage, {
    id: "common.errorText"
  }));
}

var LifeCycleTransitionConfirmationDialog = observer$1(function (props) {
  var transition = props.transition,
      isModalOpen = props.isModalOpen,
      setModalIsClosed = props.setModalIsClosed,
      lifeCycleTransition = props.lifeCycleTransition,
      handleErrorTransition = props.handleErrorTransition,
      handleSuccessTransition = props.handleSuccessTransition;

  var handleConfirm = function handleConfirm() {
    return lifeCycleTransition().then(handleSuccessTransition).catch(handleErrorTransition).finally(setModalIsClosed);
  };

  return React__default.createElement(ConfirmationDialog, {
    id: "confirm-transition",
    onCancel: setModalIsClosed,
    onConfirm: handleConfirm,
    message: React__default.createElement(FormattedMessage, {
      id: "common.lifeCycleConfirmText",
      values: {
        toState: transition.toStateTitle
      }
    }),
    open: isModalOpen,
    title: React__default.createElement(FormattedMessage, {
      id: "common.lifeCycleConfirmTitle"
    }),
    keepMounted: true,
    confirmText: transition.params.title
  });
});

var TransitionDialog = function TransitionDialog(props) {
  var isModalOpen = props.isModalOpen,
      setModalIsClosed = props.setModalIsClosed,
      validateFunction = props.validateFunction,
      transition = props.transition,
      errorMessage = props.errorMessage;

  var _useState = useState(false),
      isTransitionAllowed = _useState[0],
      setIsTransitionAllowed = _useState[1];

  var _transition$params = transition.params,
      dialogComponentCode = _transition$params.dialogComponentCode,
      validate = _transition$params.validate;
  useEffect(function () {
    if (validate) {
      validateFunction().then(function () {
        setIsTransitionAllowed(true);
      });
      return;
    }

    setIsTransitionAllowed(true);
  }, [validateFunction, setIsTransitionAllowed, validate]);

  if (isTransitionAllowed) {
    switch (dialogComponentCode) {
      default:
        return React__default.createElement(LifeCycleTransitionConfirmationDialog, Object.assign({}, props));
    }
  }

  return React__default.createElement(ErrorDialog, {
    message: errorMessage,
    open: isModalOpen,
    onClose: setModalIsClosed
  });
};

var renderTransitions = function renderTransitions(data, onClickModalOpen) {
  return data.map(function (transition) {
    return React__default.createElement(Grid, {
      item: true,
      key: transition.id
    }, React__default.createElement(Button, {
      onClick: onClickModalOpen(transition),
      color: transition.params.btnType,
      size: "medium",
      variant: "contained",
      type: "button"
    }, transition.title));
  });
};

var TotObjectTransitions = observer$1(function (props) {
  var lifeCycleTransition = props.lifeCycleTransition,
      objectId = props.objectId,
      updateObjectPage = props.updateObjectPage,
      getTransitions = props.getTransitions,
      _props$validateFuncti = props.validateFunction,
      validateFunction = _props$validateFuncti === void 0 ? function () {
    return Promise.resolve();
  } : _props$validateFuncti,
      errorMessage = props.errorMessage;

  var _di = di([TransitionDialog], TotObjectTransitions),
      TransitionDialog$1 = _di[0];

  var _di2 = di([ErrorMessage], TotObjectTransitions),
      ErrorMessage$1 = _di2[0];

  var _useState = useState(),
      transition = _useState[0],
      setTransition = _useState[1];

  var _useState2 = useState([]),
      data = _useState2[0],
      setData = _useState2[1];

  var _useStore = useStore(),
      intlStore = _useStore.intlStore;

  var _useModal = useModal(),
      isModalOpen = _useModal[0],
      setModalIsOpen = _useModal[1],
      setModalIsClosed = _useModal[2];

  var _useError = useError(),
      isError = _useError[0],
      errorText = _useError[1],
      enableError = _useError[2],
      resetError = _useError[3];

  var updateTransitions = function updateTransitions() {
    getTransitions(objectId).then(function (data) {
      setData(data);
    });
  };

  useEffect(function () {
    updateTransitions();
  }, [intlStore.locale]);

  var lifeCycleTransitionCallback = function lifeCycleTransitionCallback() {
    return lifeCycleTransition((transition === null || transition === void 0 ? void 0 : transition.id) || '', objectId, (transition === null || transition === void 0 ? void 0 : transition.params.validate) || false);
  };

  var handleSuccessTransition = function handleSuccessTransition() {
    updateObjectPage();
  };

  var handleErrorTransition = function handleErrorTransition(error) {
    var errorText = ErrorMessage$1(error);
    enableError(errorText);
  };

  var onClickModalOpen = function onClickModalOpen(transition) {
    return function () {
      setTransition(transition);
      setModalIsOpen();
    };
  };

  var closeModal = function closeModal() {
    setModalIsClosed();
    setTransition(undefined);
  };

  return React__default.createElement(React__default.Fragment, null, transition && React__default.createElement(TransitionDialog$1, {
    objectId: objectId,
    transition: transition,
    isModalOpen: isModalOpen,
    setModalIsClosed: closeModal,
    lifeCycleTransition: lifeCycleTransitionCallback,
    handleSuccessTransition: handleSuccessTransition,
    handleErrorTransition: handleErrorTransition,
    validateFunction: validateFunction,
    errorMessage: errorMessage
  }), React__default.createElement(ErrorDialog, {
    message: errorText,
    open: isError,
    onClose: resetError
  }), React__default.createElement(Grid, {
    container: true,
    direction: "row",
    spacing: 4
  }, renderTransitions(data, onClickModalOpen)));
});

const RequestActionsBar = withTheme(styled(Toolbar)`
        background-color: ${({
  theme
}) => theme.palette.primary.contrastText};
        color: ${({
  theme
}) => theme.variables.palette.textDark};
        border-top: ${({
  theme
}) => `1px solid ${theme.variables.palette.hoverInLists}`};
    `);
const RequestControlPanel = observer$1(props => {
  const {
    model,
    reloadModel,
    formIsChanged,
    errorMessage
  } = props;
  const {
    id,
    number,
    deleteRequest,
    transitionLifeCycle,
    goToRequestEditPageAndValidate,
    saveRequestForm,
    validateReadonlyPage
  } = model;
  const [StickyWrapper$1] = di([StickyWrapper], RequestControlPanel);
  const [CampaignViewModeButtons$1] = di([CampaignViewModeButtons], RequestControlPanel);
  const [CampaignEditModeButtonsWithDialog$1] = di([CampaignEditModeButtonsWithDialog], RequestControlPanel);
  const [TotObjectTransitions$1] = di([TotObjectTransitions], RequestControlPanel);
  const {
    requestStore
  } = useStore();
  return React__default.createElement(StickyWrapper$1, {
    mode: "bottom"
  }, React__default.createElement(RequestActionsBar, null, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Grid, {
    alignItems: "center",
    justify: "space-between",
    container: true
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    key: clientRoute.request,
    path: clientRoute.request,
    exact: true
  }, React__default.createElement(CampaignViewModeButtons$1, {
    deleteRequest: deleteRequest,
    requestNumber: number,
    id: id
  })), model.formsTabs.map(f => {
    const formId = f.id;
    return [React__default.createElement(Route, {
      key: f.id,
      path: generatePath(clientRoute.requestForm, {
        id,
        formId
      }),
      exact: true
    }, React__default.createElement(CampaignViewModeButtons$1, {
      onEdit: goToRequestEditPageAndValidate(generatePath(clientRoute.requestFormEdit, {
        id,
        formId
      })),
      deleteRequest: deleteRequest,
      requestNumber: number,
      id: id,
      formId: formId
    })), React__default.createElement(Route, {
      key: `${formId}edit`,
      path: generatePath(clientRoute.requestFormEdit, {
        id,
        formId
      }),
      exact: true
    }, React__default.createElement(CampaignEditModeButtonsWithDialog$1, {
      onSubmit: saveRequestForm(formId),
      path: generatePath(clientRoute.requestForm, {
        id,
        formId
      }),
      formIsChanged: formIsChanged
    }))];
  }).reduce((a, b) => a.concat(b), []))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    spacing: 3
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: [clientRoute.request, clientRoute.requestForm],
    exact: true
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TotObjectTransitions$1, {
    objectId: id,
    getTransitions: requestStore.getTransitionRequest,
    updateObjectPage: reloadModel,
    lifeCycleTransition: transitionLifeCycle,
    validateFunction: validateReadonlyPage,
    errorMessage: errorMessage
  }))))))))));
});

var _defs, _g, _path$6;

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

function SvgQuestionCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "5 0 20 20",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
    id: "question-circle_svg__a",
    width: 112,
    height: 130,
    x: -41,
    y: -46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("feOffset", {
    dy: 18,
    in: "SourceGraphic",
    result: "FeOffset1110Out"
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    in: "FeOffset1110Out",
    result: "FeGaussianBlur1111Out",
    stdDeviation: "14.4 14.4"
  })), /*#__PURE__*/createElement("mask", {
    id: "question-circle_svg__b",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M5 0h20v20H5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.289 13.29a1 1 0 011.709.71.99.99 0 01-.06.38.901.901 0 01-.539.54.945.945 0 01-.76 0 .902.902 0 01-.54-.54.845.845 0 01-.08-.38 1.355 1.355 0 010-.2.668.668 0 01.059-.18.772.772 0 01.09-.18c.037-.053.078-.103.121-.15zM14.999 0c5.522 0 10 4.476 10 10 0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10C5 4.476 9.476 0 15 0zm0 18a8 8 0 100-16.001 8 8 0 000 16zm0-13a3 3 0 011 5.82V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 000-2 1 1 0 00-.87.5 1 1 0 11-1.73-1 3 3 0 012.6-1.5z"
  })))), _g || (_g = /*#__PURE__*/createElement("g", {
    filter: "url(#question-circle_svg__a)"
  }, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M14.289 13.29a1 1 0 011.709.71.99.99 0 01-.06.38.901.901 0 01-.539.54.945.945 0 01-.76 0 .902.902 0 01-.54-.54.845.845 0 01-.08-.38 1.355 1.355 0 010-.2.668.668 0 01.059-.18.772.772 0 01.09-.18c.037-.053.078-.103.121-.15zM14.999 0c5.522 0 10 4.476 10 10 0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10C5 4.476 9.476 0 15 0zm0 18a8 8 0 100-16.001 8 8 0 000 16zm0-13a3 3 0 011 5.82V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 000-2 1 1 0 00-.87.5 1 1 0 11-1.73-1 3 3 0 012.6-1.5z",
    mask: "url(\"#b\")"
  }), /*#__PURE__*/createElement("path", {
    fillOpacity: 0.03,
    d: "M14.289 13.29a1 1 0 011.709.71.99.99 0 01-.06.38.901.901 0 01-.539.54.945.945 0 01-.76 0 .902.902 0 01-.54-.54.845.845 0 01-.08-.38 1.355 1.355 0 010-.2.668.668 0 01.059-.18.772.772 0 01.09-.18c.037-.053.078-.103.121-.15zM14.999 0c5.522 0 10 4.476 10 10 0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10C5 4.476 9.476 0 15 0zm0 18a8 8 0 100-16.001 8 8 0 000 16zm0-13a3 3 0 011 5.82V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 000-2 1 1 0 00-.87.5 1 1 0 11-1.73-1 3 3 0 012.6-1.5z"
  }))), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    d: "M14.289 13.29a1 1 0 011.709.71.99.99 0 01-.06.38.901.901 0 01-.539.54.945.945 0 01-.76 0 .902.902 0 01-.54-.54.845.845 0 01-.08-.38 1.355 1.355 0 010-.2.668.668 0 01.059-.18.772.772 0 01.09-.18c.037-.053.078-.103.121-.15zM14.999 0c5.522 0 10 4.476 10 10 0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10C5 4.476 9.476 0 15 0zm0 18a8 8 0 100-16.001 8 8 0 000 16zm0-13a3 3 0 011 5.82V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 000-2 1 1 0 00-.87.5 1 1 0 11-1.73-1 3 3 0 012.6-1.5z"
  })));
}

var useStyles$3 = makeStyles$1(function (theme) {
  return createStyles$1({
    container: {
      color: theme.variables.palette.lighterBlue,
      height: '100%'
    },
    link: {
      display: 'inline',
      color: theme.variables.palette.lighterBlue,
      cursor: 'pointer'
    }
  });
});
var ErrorPage = function ErrorPage(props) {
  var errorCode = props.errorCode,
      errorText = props.errorText;
  var classes = useStyles$3();
  var rootStore = useStore();
  var intl = rootStore.intlStore.intl;
  var history = useHistory();

  var _useFeature = useFeature('instructions'),
      instructions = _useFeature[0];

  var _useFeature2 = useFeature('customBackground'),
      config = _useFeature2[1];

  var hasBackgroundSrc = !!config.src;
  return React__default.createElement(Grid, {
    container: true,
    direction: "column",
    wrap: "nowrap",
    alignItems: "center",
    justify: "space-between",
    className: classes.container
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    xs: 8,
    spacing: 4
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, null, React__default.createElement(Box, {
    fontSize: "80px",
    fontWeight: 600,
    component: "span",
    lineHeight: "normal"
  }, errorCode))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, React__default.createElement(Box, {
    fontSize: hasBackgroundSrc ? '18px' : '24px',
    component: "span",
    lineHeight: "normal",
    mb: 2
  }, errorText))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    color: "primary",
    component: "div"
  }, React__default.createElement(Box, {
    lineHeight: "normal"
  }, React__default.createElement(FormattedMessage, {
    id: "notFoundPage.goTo"
  }), React__default.createElement(Link, {
    color: "inherit",
    to: clientRoute.root
  }, React__default.createElement(FormattedMessage, {
    id: "notFoundPage.main"
  })), React__default.createElement(React__default.Fragment, null, React__default.createElement(FormattedMessage, {
    id: "notFoundPage.orReturn"
  }), React__default.createElement("a", {
    className: classes.link,
    color: "inherit",
    onClick: history.goBack
  }, React__default.createElement(FormattedMessage, {
    id: "notFoundPage.back"
  }))))))), instructions && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    mb: "40px"
  }, React__default.createElement("a", {
    color: "inherit",
    className: classes.link,
    download: intl.formatMessage({
      id: 'common.instructionFileName'
    }),
    href: intl.formatMessage({
      id: 'common.instructionSrc'
    })
  }, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, React__default.createElement(SvgQuestionCircle, null), React__default.createElement(Box, {
    pl: "5px"
  }, React__default.createElement(FormattedMessage, {
    id: "common.downloadInstructions"
  })))))));
};

var DeadlineStatus;

(function (DeadlineStatus) {
  DeadlineStatus["VALID"] = "valid";
  DeadlineStatus["WARNING"] = "warning";
  DeadlineStatus["INVALID"] = "invalid";
  DeadlineStatus["ERROR"] = "error";
})(DeadlineStatus || (DeadlineStatus = {}));

var ErrorCodes;

(function (ErrorCodes) {
  ErrorCodes["notAllowed"] = "403";
  ErrorCodes["notFound"] = "404";
})(ErrorCodes || (ErrorCodes = {}));

var additionalPagesInj = function additionalPagesInj() {
  return [];
};
var appContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
};
var App = observer$1(function () {
  var _di = di([additionalPagesInj], App),
      additionalPages = _di[0];

  var _di2 = di([Footer], App),
      Footer$1 = _di2[0];

  var _di3 = di([TotBackgroundWithAvailableHeader], App),
      TotBackgroundWithAvailableHeader$1 = _di3[0];

  var _di4 = di([TotBackground], App),
      TotBackground$1 = _di4[0];

  var _di5 = di([SamlPages], App),
      SamlPages$1 = _di5[0];

  var _di6 = di([UserPages], App),
      UserPages$1 = _di6[0];

  var _di7 = di([StartPage], App),
      StartPage$1 = _di7[0];

  var _di8 = di([AuthorizationCheck], App),
      AuthorizationCheck$1 = _di8[0];

  var _di9 = di([ConsolePage], App),
      ConsolePage$1 = _di9[0];

  var _di10 = di([RegistrationPage], App),
      RegistrationPage$1 = _di10[0];

  var _di11 = di([RegistrationConfirmPage], App),
      RegistrationConfirmPage$1 = _di11[0];

  var _di12 = di([RecoveryPasswordPage], App),
      RecoveryPasswordPage$1 = _di12[0];

  var _di13 = di([NewPasswordPage], App),
      NewPasswordPage$1 = _di13[0];

  var _di14 = di([LoginDialog], App),
      LoginDialog$1 = _di14[0];

  var _di15 = di([Logout], App),
      Logout$1 = _di15[0];

  var _di16 = di([EsiaPages], App),
      EsiaPages$1 = _di16[0];

  var _di17 = di([CampaignRequestPages], App),
      CampaignRequestPages$1 = _di17[0];

  var _di18 = di([CampaignPages], App),
      CampaignPages$1 = _di18[0];

  var _di19 = di([AuthenticationInfoPage], App),
      AuthenticationInfoPage$1 = _di19[0];

  var _di20 = di([RequestLogPage], App),
      RequestLog = _di20[0];

  var _di21 = di([TotAppBar], App),
      TotAppBar$1 = _di21[0];

  var _di22 = di([NotificationComponent], App),
      NotificationComponent$1 = _di22[0];

  var _di23 = di([Authentication], App),
      Authentication$1 = _di23[0];

  var _di24 = di([AppContentContainer], App),
      AppContentContainer$1 = _di24[0];

  var _useStore = useStore(),
      personStore = _useStore.personStore,
      intl = _useStore.intlStore;

  var _useFeature = useFeature('startPage'),
      startPage = _useFeature[0];

  var _useFeature2 = useFeature('redirectToCampaignsAllUsers'),
      redirectToCampaignsAllUsers = _useFeature2[0];

  var _useFeature3 = useFeature('loginDialogWithoutAvailableHeader'),
      loginDialogWithoutAvailableHeader = _useFeature3[0];

  var additionalPagesArray = additionalPages();
  return React__default.createElement("div", {
    style: appContainerStyle
  }, React__default.createElement(TotAppBar$1, null), React__default.createElement(AppContentContainer$1, null, React__default.createElement(Switch, null, additionalPagesArray, React__default.createElement(Route, {
    path: clientRoute.requestLog
  }, React__default.createElement(Authentication$1, null, React__default.createElement(RequestLog, null))), React__default.createElement(Route, {
    path: clientRoute.campaigns
  }, React__default.createElement(CampaignPages$1, null)), React__default.createElement(Route, {
    path: clientRoute.requests
  }, React__default.createElement(CampaignRequestPages$1, null)), React__default.createElement(Route, {
    path: clientRoute.users
  }, React__default.createElement(UserPages$1, null)), React__default.createElement(Route, {
    path: clientRoute.console
  }, React__default.createElement(Authentication$1, null, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    permCode: permissions.System.Administration,
    isWithRedirect: true
  }, React__default.createElement(ConsolePage$1, null)))), React__default.createElement(Route, {
    path: clientRoute.esia
  }, React__default.createElement(EsiaPages$1, null)), React__default.createElement(Route, {
    path: clientRoute.saml
  }, React__default.createElement(SamlPages$1, null)), React__default.createElement(Route, {
    path: clientRoute.newPassword
  }, React__default.createElement(NewPasswordPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.recoveryPassword
  }, React__default.createElement(RecoveryPasswordPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.authenticationInfo
  }, React__default.createElement(AuthenticationInfoPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.registrationConfirm
  }, React__default.createElement(RegistrationConfirmPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.registration
  }, React__default.createElement(RegistrationPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.login
  }, loginDialogWithoutAvailableHeader ? React__default.createElement(TotBackground$1, null, React__default.createElement(LoginDialog$1, null)) : React__default.createElement(TotBackgroundWithAvailableHeader$1, null, React__default.createElement(LoginDialog$1, null))), React__default.createElement(Route, {
    path: clientRoute.logout
  }, React__default.createElement(Logout$1, null)), React__default.createElement(Route, {
    path: clientRoute.notFound
  }, React__default.createElement(ErrorPage, {
    errorCode: ErrorCodes.notFound,
    errorText: intl.formatMessage('notFoundPage.notExist')
  })), React__default.createElement(Route, {
    path: clientRoute.notAllowed
  }, React__default.createElement(ErrorPage, {
    errorCode: ErrorCodes.notAllowed,
    errorText: intl.formatMessage('common.actionNotAllowed')
  })), React__default.createElement(Route, {
    path: clientRoute.root,
    exact: true
  }, React__default.createElement(TotBackground$1, null, startPage && React__default.createElement(StartPage$1, null), !startPage && React__default.createElement(Authentication$1, {
    redirectUrl: clientRoute.login
  }, React__default.createElement(Redirect, {
    to: redirectToCampaignsAllUsers ? clientRoute.campaigns : personStore.redirectPath
  })))), React__default.createElement(Route, null, React__default.createElement(Redirect, {
    to: clientRoute.notFound
  }))), React__default.createElement(NotificationComponent$1, null)), React__default.createElement(Footer$1, null));
});

var validationErrorLink = function validationErrorLink(id) {
  return function () {
    var _di = di([AlertLink], App),
        AlertLink$1 = _di[0];

    var location = useLocation();

    for (var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++) {
      chunks[_key] = arguments[_key];
    }

    return React__default.createElement(AlertLink$1, {
      component: NavLink,
      to: generatePath(location.pathname + "/edit", {
        id: id
      }),
      style: {
        display: 'inline'
      }
    }, chunks);
  };
};

const StyledCircularProgress = withTheme(styled(CircularProgress)`
        width: ${({
  theme
}) => theme.variables.requestPrintForms.actionIconSize}px !important;
        height: ${({
  theme
}) => theme.variables.requestPrintForms.actionIconSize}px !important;
    `);
const ErrorIcon = withTheme(styled.div`
        color: ${({
  theme
}) => theme.palette.primary.contrastText};
        background-color: ${({
  theme
}) => theme.palette.error.main};
        border-radius: 50%;
        width: ${({
  theme
}) => theme.variables.requestPrintForms.actionIconSize}px;
        height: ${({
  theme
}) => theme.variables.requestPrintForms.actionIconSize}px;
        font-size: ${({
  theme
}) => theme.variables.requestPrintForms.actionIconFontSize}px !important;
        display: block;
        padding-left: ${({
  theme
}) => theme.spacing(0.25)}px;
        padding-top: ${({
  theme
}) => theme.spacing(0.25)}px;
        box-sizing: border-box;
    `);
const TableToolbar = withTheme(styled(Toolbar)`
        border-bottom: 1px solid ${({
  theme
}) => theme.variables.palette.hoverInLists};
        padding-left: ${({
  theme
}) => theme.spacing(6)}px !important;
        padding-right: ${({
  theme
}) => theme.spacing(6)}px !important;
        min-height: 128px;
    `);

const CampaignRequestPrintFormsSignature = observer$1(props => {
  var _printForm$pf, _printForm$pf2;

  const {
    printForm,
    isView = false,
    onSuccess
  } = props;
  const {
    intlStore,
    signatureStore
  } = useStore();
  const {
    getFileByte,
    uploadSignature,
    uploadSignatureFile,
    getSignatureInfo,
    downloadSignature,
    deleteSignature
  } = signatureStore;
  const printFormId = ((_printForm$pf = printForm.pf) === null || _printForm$pf === void 0 ? void 0 : _printForm$pf.id) || '';
  const filename = ((_printForm$pf2 = printForm.pf) === null || _printForm$pf2 === void 0 ? void 0 : _printForm$pf2.filename) || '';
  return React__default.createElement(DigitalSignature, {
    locale: intlStore.locale,
    isView: isView,
    fileTitle: printForm.templateTitle,
    fileTitleWithExtension: filename,
    signatureSetting: printForm.signatureSettings,
    signatureStatus: printForm.signatureStatus,
    fileDownloadComponent: React__default.createElement(FileDownload, {
      fileName: filename,
      title: filename,
      downloadFile: printForm.downloadPf,
      fontSize: "16px"
    }),
    getFileByte: getFileByte(printFormId),
    uploadSignature: uploadSignature(printFormId),
    uploadSignatureFile: uploadSignatureFile(printFormId),
    getSignatureInfo: getSignatureInfo(printFormId),
    downloadSignature: downloadSignature(printFormId),
    deleteSignature: deleteSignature(printFormId),
    onSuccess: onSuccess
  });
});

const taskStatus = {
  COMPLETED: React__default.createElement(FormattedMessage, {
    id: "campaignRequest.taskStatus.completed"
  }),
  NEW: React__default.createElement(FormattedMessage, {
    id: "campaignRequest.taskStatus.generating"
  }),
  ATTEMPT_FAILED: React__default.createElement(FormattedMessage, {
    id: "campaignRequest.taskStatus.generating"
  }),
  FAILED: React__default.createElement(FormattedMessage, {
    id: "campaignRequest.taskStatus.failed"
  })
};
const CampaignRequestPrintFormsRow = observer$1(props => {
  var _printForm$delayedTas;

  const [validationErrorLink$1] = di([validationErrorLink], CampaignRequestPrintFormsRow);
  const [ErrorDialog$1] = di([ErrorDialog], CampaignRequestPrintFormsRow);
  const [FileDownload$1] = di([FileDownload], CampaignRequestPrintFormsRow);
  const [StyledCircularProgress$1] = di([StyledCircularProgress], CampaignRequestPrintFormsRow);
  const [CampaignRequestPrintFormsSignature$1] = di([CampaignRequestPrintFormsSignature], CampaignRequestPrintFormsRow);
  const {
    printForm,
    handleGenerateAction
  } = props;
  const {
    templateId,
    templateTitle,
    pf,
    errorCode,
    isGenerating,
    dropErrorCode,
    required
  } = printForm;
  const {
    id: requestId
  } = useParams();
  const startIcon = isGenerating && React__default.createElement(StyledCircularProgress$1, null);
  const location = useLocation();
  const buttonTextCode = (pf === null || pf === void 0 ? void 0 : pf.id) ? 'campaignRequest.printFormsTable.updateAction' : 'campaignRequest.printFormsTable.generateAction';
  useEffect(() => {
    dropErrorCode();
  }, [location.pathname]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(TableRow, {
    key: templateId
  }, React__default.createElement(TableCell, null, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap",
    spacing: 2
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FileDownload$1, {
    fileName: pf === null || pf === void 0 ? void 0 : pf.filename,
    title: templateTitle,
    downloadFile: printForm.downloadPf,
    required: required
  })), printForm.pf && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CampaignRequestPrintFormsSignature$1, {
    printForm: printForm,
    onSuccess: printForm.updatePf
  })))), React__default.createElement(TableCell, null, printForm.docCategory || ''), React__default.createElement(TableCell, null, printForm.delayedTask && taskStatus[(_printForm$delayedTas = printForm.delayedTask) === null || _printForm$delayedTas === void 0 ? void 0 : _printForm$delayedTas.taskStatus]), React__default.createElement(TableCell, null, printForm.created && React__default.createElement(FormattedDate, {
    value: printForm.created
  })), React__default.createElement(TableCell, null, React__default.createElement(Button, {
    disabled: isGenerating,
    onClick: handleGenerateAction(printForm),
    color: "secondary",
    variant: "contained",
    startIcon: startIcon
  }, React__default.createElement(FormattedMessage, {
    id: buttonTextCode
  })))), React__default.createElement(ErrorDialog$1, {
    message: !!errorCode && React__default.createElement(FormattedMessage, {
      id: errorCode,
      values: {
        a: validationErrorLink$1(requestId)
      }
    }),
    open: !!errorCode,
    onClose: dropErrorCode
  }));
});

const CampaignRequestPrintFormsTable = observer$1(props => {
  const [CampaignRequestPrintFormsRow$1] = di([CampaignRequestPrintFormsRow], CampaignRequestPrintFormsTable);
  const {
    validateEditPage,
    printForms,
    validateReadonlyPage
  } = props;
  const location = useLocation();
  const isEditPage = location.pathname.includes('edit');

  const handleGenerateAction = printForm => () => {
    const validateFunction = isEditPage ? validateEditPage : validateReadonlyPage;
    printForm.generatePrintForm(validateFunction, isEditPage);
  };

  return React__default.createElement(TableContainer, null, React__default.createElement(Table, null, React__default.createElement(TableHead, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, {
    style: {
      width: '30%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.printFormsTable.fileColumnName"
  }))), React__default.createElement(TableCell, {
    style: {
      width: '30%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaign.documentCategory"
  }))), React__default.createElement(TableCell, {
    style: {
      width: '30%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.printFormsTable.taskStatus"
  }))), React__default.createElement(TableCell, {
    style: {
      width: '20%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.printFormsTable.dateColumnName"
  }))), React__default.createElement(TableCell, {
    style: {
      width: '20%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "common.actions"
  }))))), React__default.createElement(TableBody, null, printForms.map(printForm => {
    return React__default.createElement(CampaignRequestPrintFormsRow$1, {
      printForm: printForm,
      handleGenerateAction: handleGenerateAction
    });
  }))));
});

var _path$7;

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function SvgFile(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "currentColor"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M12.998 19.999H2.999a3 3 0 01-3.001-3v-14a3 3 0 013.001-3h6.049a.876.876 0 01.33.11.278.278 0 01.091 0c.102.048.196.112.279.19l6 6c.078.083.142.177.191.28v.09c.03.087.049.178.06.27v10.06a3 3 0 01-3.001 3zm-3-16.59v1.59a1 1 0 001 1h1.59l-2.59-2.59zm4 4.59h-3a3 3 0 01-3-3v-3H2.999a1 1 0 00-1.001 1v14a1 1 0 001.001 1h9.999a1 1 0 001-1v-9zm-3 8H4.999a1 1 0 110-2h5.999a1 1 0 110 2zm0-4H4.999a1 1 0 110-2h5.999a1 1 0 110 2zm-5-4h-.999a1 1 0 110-2h.999a1 1 0 110 2z"
  })));
}

var IconLink = React__default.forwardRef(function (props, ref) {
  var icon = props.icon,
      text = props.text,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'none' : _props$underline,
      _props$color = props.color,
      color = _props$color === void 0 ? 'textPrimary' : _props$color,
      _props$uppercase = props.uppercase,
      uppercase = _props$uppercase === void 0 ? false : _props$uppercase,
      restProps = _objectWithoutPropertiesLoose(props, ["icon", "text", "underline", "color", "uppercase"]);

  return React__default.createElement(Link$1, Object.assign({
    underline: underline,
    color: color
  }, restProps, uppercase && {
    style: {
      textTransform: 'uppercase'
    }
  }), React__default.createElement(SvgIcon, {
    viewBox: "-2 -2 24 24"
  }, icon), text);
});

const PfListTooltipFileInj = props => {
  const {
    downloadPf,
    file,
    templateTitle
  } = props;
  const [IconLink$1] = di([IconLink], PfListTooltipFileInj);
  return React__default.createElement(Tooltip, {
    title: React__default.createElement(FormattedMessage, {
      id: "common.downloadFile",
      values: {
        fileName: file.filename
      }
    })
  }, React__default.createElement(IconLink$1, {
    component: "button",
    onClick: downloadPf,
    icon: React__default.createElement(SvgFile, null),
    text: templateTitle
  }));
};
const CampaignRequestPrintFormsList = observer$1(props => {
  const {
    printForms
  } = props;
  const [PfListTooltipFile] = di([PfListTooltipFileInj], CampaignRequestPrintFormsList);
  const [CampaignRequestPrintFormsSignature$1] = di([CampaignRequestPrintFormsSignature], CampaignRequestPrintFormsList);

  const renderPfListRow = printForm => {
    const {
      templateId,
      templateTitle,
      pf
    } = printForm;
    return pf && React__default.createElement(Grid, {
      container: true,
      item: true,
      alignItems: "center",
      wrap: "nowrap",
      spacing: 2,
      key: templateId
    }, React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(PfListTooltipFile, {
      downloadPf: printForm.downloadPf,
      file: pf,
      templateTitle: templateTitle
    })), React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(CampaignRequestPrintFormsSignature$1, {
      printForm: printForm,
      isView: true
    })));
  };

  return React__default.createElement(Box, {
    p: 6
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 4
  }, printForms.map(renderPfListRow)));
});

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var UserModel = function UserModel() {
  this.id = '';
  this.email = '';
  this.blocked = false;
};

var CampaignRequestPfModel = /*#__PURE__*/function () {
  function CampaignRequestPfModel(rootStore, formId, formApi) {
    this.formId = '';
    this.templateId = '';
    this.templateTitle = '';
    this.signatureStatus = SignatureStatus.WITHOUT;
    this.signatureSettings = {
      signatureEnabled: false,
      signatureBrowserPlugin: false,
      signatureRequired: false,
      signatureUpload: false
    };
    this.required = false;
    this.isGenerating = false;
    this.errorCode = '';
    this.requestStore = rootStore.requestStore;
    this.formApi = formApi;
    this.formId = formId;
  }

  var _proto = CampaignRequestPfModel.prototype;

  _proto.load = function load(dto) {
    var _restDto$delayedTask;

    var author = dto.author,
        restDto = _objectWithoutPropertiesLoose(dto, ["author"]);

    Object.assign(this, restDto);
    var taskStatus = (_restDto$delayedTask = restDto.delayedTask) === null || _restDto$delayedTask === void 0 ? void 0 : _restDto$delayedTask.taskStatus;
    this.isGenerating = taskStatus === 'NEW' || taskStatus === 'ATTEMPT_FAILED';

    if (author) {
      var authorModel = new UserNameModel().load(author);
      this.authorId = authorModel.userId;
      this.authorName = authorModel.name;
    }

    return this;
  };

  _proto.generatePrintForm = function generatePrintForm(validateFunction, isEditPage) {
    var _this = this;

    this.isGenerating = true;
    validateFunction(function () {
      return Promise.resolve();
    }, true).then(function () {
      _this.successValidate();
    }).catch(function () {
      _this.setValidateErrorCode(isEditPage);

      _this.stopIsGenerating();
    });
  };

  _proto.successValidate = function successValidate() {
    var _this$formApi,
        _this2 = this;

    var submission = (_this$formApi = this.formApi) === null || _this$formApi === void 0 ? void 0 : _this$formApi.getSubmission();
    this.delayedTask = {
      taskStatus: 'NEW'
    };
    this.requestStore.generatePrintForm(this.formId, this.templateId, submission).then(function () {
      _this2.dropErrorCode();
    }).catch(function () {
      _this2.setGenerateErrorCode();
    });
  };

  _proto.updatePf = function updatePf() {
    var _this3 = this;

    this.requestStore.getPrintForm(this.templateId, this.formId).then(function (dto) {
      _this3.load(dto);
    });
  };

  _proto.downloadPf = function downloadPf() {
    this.pf && this.requestStore.downloadPrintFormFile(this.pf);
  };

  _proto.setGenerateErrorCode = function setGenerateErrorCode() {
    this.errorCode = 'campaignRequest.printFormsTable.generationError';
    this.delayedTask = {
      taskStatus: 'FAILED'
    };
  };

  _proto.setValidateErrorCode = function setValidateErrorCode(isEditPage) {
    this.errorCode = isEditPage ? 'campaignRequest.printFormsTable.cannotGenerateError' : 'campaignRequest.printFormsTable.cannotGenerateErrorWithLink';
  };

  _proto.dropErrorCode = function dropErrorCode() {
    this.errorCode = '';
  };

  _proto.stopIsGenerating = function stopIsGenerating() {
    this.isGenerating = false;
  };

  return CampaignRequestPfModel;
}();

__decorate([observable], CampaignRequestPfModel.prototype, "templateId", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "templateTitle", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "authorId", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "docCategory", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "authorName", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "created", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "pf", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "delayedTask", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "formApi", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "signatureStatus", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "signatureSettings", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "required", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "requestStore", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "isGenerating", void 0);

__decorate([observable], CampaignRequestPfModel.prototype, "errorCode", void 0);

__decorate([action.bound], CampaignRequestPfModel.prototype, "load", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "generatePrintForm", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "successValidate", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "updatePf", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "downloadPf", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "setGenerateErrorCode", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "setValidateErrorCode", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "dropErrorCode", null);

__decorate([action.bound], CampaignRequestPfModel.prototype, "stopIsGenerating", null);

var CampaignRequestPfListModel = /*#__PURE__*/function () {
  function CampaignRequestPfListModel(rootStore, formId, formApi) {
    this.formId = '';
    this.printForms = [];
    this.errorDownloadFiles = '';
    this.isFilesLoading = false;
    this.formId = formId;
    this.rootStore = rootStore;
    this.requestStore = rootStore.requestStore;
    this.intlStore = rootStore.intlStore;
    this.formApi = formApi;
  }

  var _proto = CampaignRequestPfListModel.prototype;

  _proto.load = function load(dto) {
    var _this = this;

    this.printForms = dto.map(function (dto) {
      return new CampaignRequestPfModel(_this.rootStore, _this.formId, _this.formApi).load(dto);
    });
  };

  _proto.downloadAllPf = function downloadAllPf(requestNumber) {
    try {
      var _this3 = this;

      function _temp3() {
        _this3.isFilesLoading = false;
      }

      var _temp4 = _catch(function () {
        _this3.isFilesLoading = true;
        return Promise.resolve(_this3.requestStore.downloadAllPrintFormFiles(_this3.formId)).then(function (_ref) {
          var data = _ref.data;
          var fileName = _this3.intlStore.formatMessage('campaignRequest.allFiles', {
            title: requestNumber
          }) + ".zip";
          downloadFile(data, fileName);
        });
      }, function (error) {
        var _error$response;

        if (error.request.responseType === 'blob' && ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) instanceof Blob) {
          var reader = new FileReader();

          reader.onload = function () {
            error.response && (error.response.data = reader.result);

            _this3.setErrorText(error);
          };

          reader.readAsText(error.response.data);
        } else {
          _this3.setErrorText(error);
        }
      });

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setErrorText = function setErrorText(error) {
    var errorText = ErrorMessage(error);
    this.errorDownloadFiles = errorText;
  };

  _createClass(CampaignRequestPfListModel, [{
    key: "isFilesGenerating",
    get: function get() {
      return this.printForms.some(function (_ref2) {
        var delayedTask = _ref2.delayedTask;
        return (delayedTask === null || delayedTask === void 0 ? void 0 : delayedTask.taskStatus) === 'NEW' || (delayedTask === null || delayedTask === void 0 ? void 0 : delayedTask.taskStatus) === 'ATTEMPT_FAILED';
      });
    }
  }, {
    key: "generatedPF",
    get: function get() {
      return this.printForms.filter(function (form) {
        return !!form.pf;
      });
    }
  }]);

  return CampaignRequestPfListModel;
}();

__decorate([observable], CampaignRequestPfListModel.prototype, "printForms", void 0);

__decorate([observable], CampaignRequestPfListModel.prototype, "errorDownloadFiles", void 0);

__decorate([observable], CampaignRequestPfListModel.prototype, "isFilesLoading", void 0);

__decorate([observable], CampaignRequestPfListModel.prototype, "rootStore", void 0);

__decorate([observable], CampaignRequestPfListModel.prototype, "requestStore", void 0);

__decorate([observable], CampaignRequestPfListModel.prototype, "intlStore", void 0);

__decorate([observable], CampaignRequestPfListModel.prototype, "formApi", void 0);

__decorate([computed], CampaignRequestPfListModel.prototype, "isFilesGenerating", null);

__decorate([action.bound], CampaignRequestPfListModel.prototype, "load", null);

__decorate([computed], CampaignRequestPfListModel.prototype, "generatedPF", null);

__decorate([asyncAction, action.bound], CampaignRequestPfListModel.prototype, "downloadAllPf", null);

__decorate([action.bound], CampaignRequestPfListModel.prototype, "setErrorText", null);

const StyledProgress = withTheme(styled(CircularProgress)`
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -${({
  theme
}) => theme.spacing(3)}px;
    margin-left: -${({
  theme
}) => theme.spacing(3)}px;
`);
const CampaignRequestPrintForms = observer$1(props => {
  const [CampaignRequestPrintFormsList$1] = di([CampaignRequestPrintFormsList], CampaignRequestPrintForms);
  const [CampaignRequestPrintFormsTable$1] = di([CampaignRequestPrintFormsTable], CampaignRequestPrintForms);
  const [ErrorDialog$1] = di([ErrorDialog], CampaignRequestPrintForms);
  const [TableToolbar$1] = di([TableToolbar], CampaignRequestPrintForms);
  const {
    isShown,
    validateEditPage,
    validateReadonlyPage,
    formApi,
    requestNumber,
    canGenerate
  } = props;
  const {
    formId
  } = useParams();
  const rootStore = useStore();
  const [model] = useState(new CampaignRequestPfListModel(rootStore, formId, formApi));
  const [isLoading, setIsLoading] = useState(true);
  const {
    requestStore,
    env
  } = rootStore;
  const [errorDownloadFiles, setErrorDownloadFiles] = useState('');
  const [isFilesGenerating, setIsFilesGenerating] = useState(false);
  const [intervalId, setIntervalId] = useState();
  const {
    pfDelay
  } = env;
  const fetchPrintForms = useCallback(() => {
    return requestStore.loadPrintForms(formId).then(model.load).finally(() => {
      setIsLoading(false);
    });
  }, [requestStore, formId]);
  useEffect(() => {
    fetchPrintForms();
  }, [fetchPrintForms]);
  useEffect(() => {
    setIsFilesGenerating(model.isFilesGenerating);
  }, [model.isFilesGenerating, model.printForms, setIsFilesGenerating]);
  useEffect(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }

    if (isFilesGenerating) {
      const updateDelayedTasksInterval = setInterval(fetchPrintForms, pfDelay);
      setIntervalId(updateDelayedTasksInterval);
      return () => clearInterval(updateDelayedTasksInterval);
    }
  }, [fetchPrintForms, isFilesGenerating, pfDelay]);

  if (!isShown) {
    return React__default.createElement(React__default.Fragment, null);
  }

  let shouldRenderPrintForms = model.printForms.length > 0;
  let generatedPrintForms = [];

  if (!canGenerate) {
    generatedPrintForms = model.generatedPF;
    shouldRenderPrintForms = generatedPrintForms.length > 0;
  }

  if (isLoading) {
    return React__default.createElement(Box, {
      mb: 8,
      mt: 6
    }, React__default.createElement(Grid, {
      container: true,
      direction: "column",
      justify: "center",
      alignItems: "center",
      spacing: 6
    }, React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(FormattedMessage, {
      id: "campaignRequest.printFormsTable.loading"
    })), React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(CircularProgress, null))));
  }

  return React__default.createElement(React__default.Fragment, null, shouldRenderPrintForms && React__default.createElement(Box, {
    mt: 5,
    mb: 5
  }, React__default.createElement(Paper, {
    elevation: 1
  }, React__default.createElement(TableToolbar$1, null, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h3"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.printFormsTable.title"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    disabled: model.isFilesLoading,
    color: "primary",
    variant: "contained",
    onClick: () => model.downloadAllPf(requestNumber),
    style: {
      position: 'relative'
    }
  }, model.isFilesLoading && React__default.createElement(StyledProgress, {
    size: 24
  }), React__default.createElement(FormattedMessage, {
    id: "campaignRequest.printFormsTable.downloadAllButton"
  }))))), canGenerate ? React__default.createElement(CampaignRequestPrintFormsTable$1, {
    formApi: formApi,
    validateEditPage: validateEditPage,
    validateReadonlyPage: validateReadonlyPage,
    printForms: model.printForms
  }) : React__default.createElement(CampaignRequestPrintFormsList$1, {
    printForms: generatedPrintForms
  })), React__default.createElement(ErrorDialog$1, {
    message: errorDownloadFiles,
    open: !!errorDownloadFiles,
    onClose: () => setErrorDownloadFiles('')
  })));
});

const CampaignRequestForm = observer$1(props => {
  const {
    requestModel,
    setFormIsChanged,
    requestNumber
  } = props;
  const {
    onFormReady,
    onFormChange,
    currentTab: model,
    isFormReady,
    formApi,
    validateEditPage,
    validateReadonlyPage
  } = requestModel;
  const [CampaignRequestPrintForms$1] = di([CampaignRequestPrintForms], CampaignRequestForm);
  const {
    requestStore
  } = useStore();
  const {
    locale
  } = useIntl();
  const {
    formId
  } = useParams();
  const [canGenerate, setCanGenerate] = useState(false);
  useEffect(() => {
    requestModel.setCurrentTab(formId);
    requestStore.checkEditablePf(formId).then(() => setCanGenerate(true)).catch(() => setCanGenerate(false));
    return () => {
      requestModel.currentTab = null;
      clearTimeout(requestModel.onFormReadyTimeOut);
      clearTimeout(requestModel.onFormChangeTimeOut);
    };
  }, [requestStore, formId, requestModel]);

  if (!model) {
    return React__default.createElement(React__default.Fragment, null);
  }

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Route, {
    path: clientRoute.requestFormEdit,
    exact: true
  }, React__default.createElement(Form, {
    locale: locale,
    form: model.formModel,
    onFormReady: onFormReady(formId),
    onFormChange: onFormChange,
    setFormIsChanged: setFormIsChanged
  })), React__default.createElement(Route, {
    path: clientRoute.requestForm,
    exact: true
  }, React__default.createElement(FormView, {
    locale: locale,
    form: model.formModel,
    onFormReady: onFormReady(formId),
    className: "print-form"
  }), React__default.createElement(CampaignRequestPrintForms$1, {
    isShown: isFormReady,
    formApi: formApi,
    canGenerate: canGenerate,
    validateEditPage: validateEditPage,
    validateReadonlyPage: validateReadonlyPage,
    requestNumber: requestNumber
  })));
});

const RequestDeadlineBoxInj = withTheme(styled(Box)`
        background-color: ${({
  backgroundColor
}) => `${backgroundColor}`};
        border-radius: 4px;
        padding: ${({
  theme
}) => `${theme.spacing(2.25)}px ${theme.spacing(4.25)}px ${theme.spacing(2.5)}px ${theme.spacing(4)}px`};
        display: inline-block;
    `);
const RequestDeadline = props => {
  const [RequestDeadlineBox] = di([RequestDeadlineBoxInj], RequestDeadline);
  const theme = useTheme();
  const {
    deadline,
    title,
    withBlock
  } = props;
  let color;

  if (deadline) {
    switch (deadline.status) {
      case DeadlineStatus.WARNING:
        {
          color = theme.palette.warning.main;
          break;
        }

      case DeadlineStatus.INVALID:
        {
          color = theme.palette.error.main;
          break;
        }

      case DeadlineStatus.ERROR:
        {
          color = theme.palette.error.main;
          break;
        }

      default:
        color = theme === null || theme === void 0 ? void 0 : theme.variables.palette.mainMiddleLight;
    }
  }

  return React__default.createElement(React__default.Fragment, null, deadline && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestDeadlineBox, {
    backgroundColor: color
  }, deadline.date ? React__default.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 'bold'
    }
  }, title, ": ", React__default.createElement(FormattedDate, {
    value: deadline.date
  }), withBlock && deadline.delay && React__default.createElement(Tooltip, {
    title: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.deadlines.notRelevantTooltip"
    })
  }, React__default.createElement("span", null, "(", React__default.createElement(FormattedMessage, {
    id: "campaignRequest.deadlines.notRelevant"
  }), ")"))) : React__default.createElement(React__default.Fragment, null, deadline.status === DeadlineStatus.ERROR && React__default.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 'bold'
    }
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.deadlines.error"
  }))))));
};

const RequestStateBoxInj = withTheme(styled(Box)`
        background-color: rgba(53, 167, 255, 0.09);
        border-radius: 4px;
        padding: ${({
  theme
}) => `${theme.spacing(3.25)}px ${theme.spacing(4.25)}px ${theme.spacing(3.25)}px ${theme.spacing(4)}px`};
        display: inline-block;
    `);
const RequestHeaderButtonWithDialogInj = withConfirmDialog(({
  openConfirmDialog
}) => React__default.createElement(Button, {
  onClick: openConfirmDialog,
  color: "secondary",
  size: "small",
  variant: "contained"
}, React__default.createElement(FormattedMessage, {
  id: "campaignRequest.takeToWork"
})));

const queries = id => {
  return [{
    entityCode: entities.CampaignRequest,
    entityId: id,
    permCode: permissions.CampaignRequest.UpdateActualAppointment
  }, {
    entityCode: entities.CampaignRequest,
    entityId: id,
    permCode: permissions.CampaignRequest.AddActualAppointment
  }];
};

const AdditionalTitleLinkInj = props => React__default.createElement(React__default.Fragment, null);
const RequestHeader = observer$1(props => {
  const [AdditionalTitleLink] = di([AdditionalTitleLinkInj], RequestHeader);
  const [AuthorizationCheck$1] = di([AuthorizationCheck], RequestHeader);
  const [RequestHeaderButtonWithDialog] = di([RequestHeaderButtonWithDialogInj], RequestHeader);
  const [RequestStateBox] = di([RequestStateBoxInj], RequestHeader);
  const [RequestDeadline$1] = di([RequestDeadline], RequestHeader);
  const [CampaignEditButton$1] = di([CampaignEditButton], RequestHeader);
  const [TotObjectHeader$1] = di([TotObjectHeader], RequestHeader);
  const {
    requestModel,
    onModalOpen,
    reloadIncrement
  } = props;
  const theme = useTheme();
  const {
    requestStore,
    intlStore: intl,
    authorizationStore,
    history
  } = useStore();
  const {
    number,
    campaign,
    regFormTitle,
    state,
    id,
    currentTab,
    deadlines
  } = requestModel;
  const {
    stateDeadline,
    entityDeadline
  } = deadlines;
  const [checkedPermissions, setCheckedPermissions] = useState([]);
  const [updateActualAppointment, addActualAppointment] = checkedPermissions;
  const currentTabExecutor = currentTab === null || currentTab === void 0 ? void 0 : currentTab.tabExecutor;
  const tabExecutor = useMemo(() => {
    if (currentTabExecutor) {
      return currentTabExecutor;
    } else if (requestModel.executorsList) {
      return requestModel.executorsList;
    }

    return '';
  }, [currentTabExecutor, requestModel.executorsList]);
  useEffect(() => {
    authorizationStore.checkAll(queries(id)).then(setCheckedPermissions);
  }, [authorizationStore, setCheckedPermissions, id, currentTabExecutor, requestModel.executors]);

  const handleConfirm = () => {
    requestStore.setCurrentUserAsExecutor(id).then(() => {
      requestModel.updateExecutors();
      reloadIncrement();
    });
  };

  return React__default.createElement(TotObjectHeader$1, null, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 10,
    alignItems: "center"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.RequestN",
    values: {
      number
    }
  }))), React__default.createElement(AdditionalTitleLink, {
    requestId: id
  }), React__default.createElement(Grid, {
    item: true
  }, campaign.id && React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: generatePath(clientRoute.campaign, {
      id: campaign.id
    })
  }, React__default.createElement(Typography, {
    variant: "h3"
  }, campaign.title))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    color: theme === null || theme === void 0 ? void 0 : theme.variables.palette.textMain
  }, React__default.createElement(Typography, {
    variant: "body2"
  }, regFormTitle))), React__default.createElement(RequestDeadline$1, {
    deadline: entityDeadline,
    title: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.deadlines.entity"
    }),
    withBlock: true
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column",
    wrap: "nowrap",
    justify: "center",
    style: {
      height: '100%'
    }
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, null, React__default.createElement(Typography, {
    variant: "body2"
  }, React__default.createElement(FormattedMessage, {
    id: "common.State"
  })))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestStateBox, null, React__default.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 'bold'
    }
  }, state))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    entityId: id,
    permCode: permissions.System.ViewLogsRegistry
  }, React__default.createElement(Tooltip, {
    title: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.requestLog"
    })
  }, React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: generatePath(clientRoute.requestLog, {
      id
    })
  }, React__default.createElement(AssignmentIcon, null))))))), React__default.createElement(RequestDeadline$1, {
    deadline: stateDeadline,
    title: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.deadlines.state"
    })
  }), React__default.createElement(Grid, {
    item: true
  }, tabExecutor && React__default.createElement(Grid, {
    container: true,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "body2",
    noWrap: true
  }, React__default.createElement(FormattedMessage, {
    id: "common.responsibleExecutor"
  }))), React__default.createElement(Grid, {
    item: true,
    container: true,
    wrap: "nowrap",
    alignItems: "center",
    spacing: 1
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "body2"
  }, tabExecutor)), !addActualAppointment && updateActualAppointment && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CampaignEditButton$1, {
    onEdit: () => onModalOpen('campaignRequest.dialog.changeExecutorTitle')
  }))))), React__default.createElement(Grid, {
    item: true,
    container: true,
    wrap: "nowrap",
    spacing: 1
  }, addActualAppointment && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestHeaderButtonWithDialog, {
    title: intl.formatMessage('campaignRequest.dialog.executorsTitle'),
    message: intl.formatMessage('campaignRequest.dialog.executorsMessage'),
    id: "takeToWork",
    onConfirm: handleConfirm
  })), addActualAppointment && updateActualAppointment && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: () => onModalOpen(),
    color: "secondary",
    size: "small",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.chooseExecutor"
  })))))))));
});

const CampaignRequestRoutes = observer$1(props => {
  const {
    requestModel,
    setFormIsChanged,
    requestNumber,
    reloadModelForModuleTab
  } = props;
  const {
    id
  } = useParams();
  const [CampaignRequestForm$1] = di([CampaignRequestForm], CampaignRequestRoutes);
  const location = useLocation();
  const history = useHistory();
  const {
    approvalStore,
    intlStore,
    personStore
  } = useStore();
  const {
    loadApprovalSheets,
    sheets,
    isSheetsLoading,
    hasApprovalTab,
    changeApprovalSheetStatus,
    updateApprovalSheet,
    sendApprovalSheetResolution,
    saveApprovalSheetGroups,
    getAllUsers
  } = approvalStore;
  useEffect(() => {
    loadApprovalSheets(id);
  }, [loadApprovalSheets, id]);
  useEffect(() => {
    if (location.pathname === generatePath(clientRoute.request, {
      id
    }) && requestModel.firstFormId) {
      history.replace(generatePath(clientRoute.requestForm, {
        id,
        formId: requestModel.firstFormId
      }));
    }

    return () => {
      requestModel.resetFirstFormId();
    };
  }, [location.pathname, requestModel.firstFormId, history, id]);
  const firstFormRedirect = requestModel.firstFormId && React__default.createElement(Redirect, {
    to: generatePath(clientRoute.requestForm, {
      id,
      formId: requestModel.firstFormId
    })
  });

  const getApprovalTabOrRedirect = () => hasApprovalTab ? React__default.createElement(AuthorizationCheck, {
    entityCode: entities.System,
    permCode: permissions.System.Administration
  }, allowed => React__default.createElement(ApprovalTab, {
    sheets: sheets === null || sheets === void 0 ? void 0 : sheets.toJS(),
    locale: intlStore.locale,
    currentUserId: personStore.user.id,
    isAdmin: allowed,
    updateApprovalSheet: updateApprovalSheet,
    saveApprovalSheetGroups: saveApprovalSheetGroups,
    changeApprovalSheetStatus: changeApprovalSheetStatus(reloadModelForModuleTab),
    sendApprovalSheetResolution: sendApprovalSheetResolution(reloadModelForModuleTab),
    getAllUsers: getAllUsers
  })) : firstFormRedirect || null;

  return React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.requestEdit,
    key: clientRoute.requestEdit,
    exact: true
  }, requestModel.firstFormId && React__default.createElement(Redirect, {
    to: generatePath(clientRoute.requestFormEdit, {
      id,
      formId: requestModel.firstFormId
    })
  })), React__default.createElement(Route, {
    path: clientRoute.requestForm,
    key: clientRoute.requestForm
  }, requestNumber && React__default.createElement(CampaignRequestForm$1, {
    key: requestModel.firstFormId + id,
    requestModel: requestModel,
    setFormIsChanged: setFormIsChanged,
    requestNumber: requestNumber
  })), React__default.createElement(Route, {
    path: clientRoute.requestApprovalSheets,
    key: clientRoute.requestApprovalSheets
  }, isSheetsLoading ? React__default.createElement(Box, {
    px: 5
  }, React__default.createElement(StyledCircularProgress, null)) : getApprovalTabOrRedirect()));
});

var RoutedTabs = observer$1(function (props) {
  var settings = props.settings,
      tabsProps = props.tabsProps,
      children = props.children,
      customTabsActions = props.customTabsActions;
  var location = useLocation();
  var pathname = location.pathname;
  var tabsActions = useMemo(function () {
    return React__default.createRef();
  }, []);
  var updateIndicator = debounce$1(function () {
    var _tabsActions$current;

    (_tabsActions$current = tabsActions.current) === null || _tabsActions$current === void 0 ? void 0 : _tabsActions$current.updateIndicator();
  }, 50);

  var renderChildren = function renderChildren() {
    if (typeof children === 'function') {
      var render = children;
      return render(updateIndicator);
    }

    return children;
  };

  var match = useMemo(function () {
    return settings.find(function (s) {
      return !!matchPath(pathname, s);
    });
  }, [settings, pathname]);
  var selected = useMemo(function () {
    return match === undefined ? false : match.tab;
  }, [match]);
  return React__default.createElement(Tabs, Object.assign({
    value: selected,
    action: customTabsActions || tabsActions
  }, tabsProps), renderChildren());
});

const transitionDefault = '250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';

const CampaignRequestStyledTab = withTheme$1(styled(Tab)`
    background-color: ${({
  theme
}) => `${theme.variables.palette.tab.backgroundColor} !important`};
    color: ${({
  theme
}) => `${theme.variables.palette.tab.color} !important`};
    margin-right: 12px !important;
    min-height: 36px !important;
    border-radius: 4px !important;
    font-size: 13px !important;
    font-weight: 700 !important;
    opacity: 1 !important;
    padding: 7px 12px 7px !important;
    transition: ${transitionDefault};
    min-width: 150px !important;

    &:hover,
    &.MuiTab-textColorInherit.Mui-selected {
        background-color: ${({
  theme
}) => `${theme.variables.palette.tab.hoverBackgroundColor} !important`};
        color: ${({
  theme
}) => `${theme.variables.palette.tab.hoverColor} !important`};
        transition: ${transitionDefault};
    }

    & > .MuiTab-wrapper {
        display: block;

        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        & > svg {
            margin-bottom: 0 !important;
            margin-right: 10px !important;
        }
    }
`);
const useTabStylesInj = makeStyles(() => ({
  scroller: {
    display: 'flex',
    alignItems: 'center'
  }
}));
const tabsProps = {
  TabIndicatorProps: {
    style: {
      display: 'none'
    }
  },
  variant: 'scrollable',
  scrollButtons: 'auto'
};
const CampaignRequestTabs = observer$1(props => {
  const {
    model,
    tabsActions
  } = props;
  const {
    id
  } = model;
  const [RoutedTabs$1] = di([RoutedTabs], CampaignRequestTabs);
  const [StyledTab] = di([CampaignRequestStyledTab], CampaignRequestTabs);
  const [useTabStyles] = di([useTabStylesInj], CampaignRequestTabs);
  const classes = useTabStyles();
  const settings = model.formsTabs.map((f, index) => {
    const formId = f.id;
    return [{
      tab: index,
      path: generatePath(clientRoute.requestForm, {
        id,
        formId
      }),
      exact: true
    }, {
      tab: index,
      path: generatePath(clientRoute.requestFormEdit, {
        id,
        formId
      }),
      exact: true
    }];
  }).reduce((a, b) => a.concat(b), []);
  const settingsLength = settings.length;
  const approvalListPath = generatePath(clientRoute.requestApprovalSheets, {
    id
  });
  const {
    approvalStore,
    intlStore
  } = useStore();
  const {
    hasApprovalTab
  } = approvalStore;

  if (hasApprovalTab) {
    settings.push({
      tab: settingsLength,
      path: approvalListPath,
      exact: true
    });
  }

  const approvalTabLabel = React__default.createElement(ApprovalTabLabel, {
    locale: intlStore.locale
  });
  return React__default.createElement(RoutedTabs$1, {
    customTabsActions: tabsActions,
    tabsProps: { ...tabsProps,
      classes
    },
    settings: settings
  }, model.formsTabs.map((formInfo, index) => {
    const formId = formInfo.id;
    const formTitle = formInfo.title;
    return React__default.createElement(StyledTab, {
      key: formId,
      value: index,
      title: formTitle,
      label: formTitle,
      component: NavLink,
      to: generatePath(clientRoute.requestForm, {
        id,
        formId
      })
    });
  }), hasApprovalTab && React__default.createElement(StyledTab, {
    key: "approvalTab",
    value: settingsLength,
    label: approvalTabLabel,
    component: NavLink,
    to: approvalListPath
  }));
});

var DateUtils = /*#__PURE__*/function () {
  function DateUtils() {}

  DateUtils.isValidDate = function isValidDate(date) {
    return !isNaN(date.getTime());
  };

  return DateUtils;
}();

var PaginationModel = /*#__PURE__*/function () {
  function PaginationModel() {
    this.paginationData = [];
    this.currentPage = 0;
    this.pageSize = 0;
  }

  var _proto = PaginationModel.prototype;

  _proto.setCurrentPage = function setCurrentPage(currentPage) {
    this.currentPage = currentPage;
  };

  _proto.setPageSize = function setPageSize(pageSize) {
    this.pageSize = pageSize;
  };

  _createClass(PaginationModel, [{
    key: "pagesCount",
    get: function get() {
      return Math.ceil(this.paginationData.length / this.pageSize);
    }
  }, {
    key: "renderItems",
    get: function get() {
      var renderItems = [];
      var lengthItems = this.paginationData.length;

      if (this.currentPage !== 0) {
        var from = (this.currentPage - 1) * this.pageSize;
        var to = from + this.pageSize;

        for (var i = from; i < to && i < lengthItems; i++) {
          renderItems.push(this.paginationData[i]);
        }
      } else {
        for (var _i = 0; _i < this.pageSize && _i < lengthItems; _i++) {
          renderItems.push(this.paginationData[_i]);
        }
      }

      return renderItems;
    }
  }]);

  return PaginationModel;
}();

__decorate([observable], PaginationModel.prototype, "paginationData", void 0);

__decorate([observable], PaginationModel.prototype, "currentPage", void 0);

__decorate([observable], PaginationModel.prototype, "pageSize", void 0);

__decorate([computed], PaginationModel.prototype, "pagesCount", null);

__decorate([computed], PaginationModel.prototype, "renderItems", null);

__decorate([action.bound], PaginationModel.prototype, "setCurrentPage", null);

__decorate([action.bound], PaginationModel.prototype, "setPageSize", null);

var CampaignListModel = /*#__PURE__*/function (_PaginationModel) {
  _inheritsLoose(CampaignListModel, _PaginationModel);

  function CampaignListModel(api, apiUrl) {
    var _this;

    _this = _PaginationModel.call(this) || this;
    _this.apiUrl = apiUrl;
    _this.api = api;

    _this.setPageSize(8);

    _this.getPaginationData();

    return _this;
  }

  var _proto = CampaignListModel.prototype;

  _proto.getPaginationData = function getPaginationData() {
    var _this2 = this;

    this.api.client(apiConfigs.campaigns).then(function (r) {
      return r.data;
    }).then(function (data) {
      return data.map(_this2.mapDTO);
    }).then(function (data) {
      return _this2.paginationData = data;
    });
  };

  _proto.mapDTO = function mapDTO(c) {
    var to = new Date(c.to || '');
    var from = new Date(c.from || '');
    return {
      id: c.id,
      title: c.title,
      requestCount: c.requestCount,
      avatarUrl: c.avatarId && this.apiUrl && "" + this.apiUrl + apiConfigs.campaignFileUrl(c.avatarId),
      to: c.to && DateUtils.isValidDate(to) ? to : undefined,
      from: c.from && DateUtils.isValidDate(from) ? from : undefined
    };
  };

  return CampaignListModel;
}(PaginationModel);

__decorate([observable], CampaignListModel.prototype, "apiUrl", void 0);

__decorate([observable], CampaignListModel.prototype, "api", void 0);

__decorate([action.bound], CampaignListModel.prototype, "getPaginationData", null);

__decorate([action.bound], CampaignListModel.prototype, "mapDTO", null);

var CatalogCodes = {
  documentCategory: 'DocumentCategory',
  fileFormat: 'FileFormat'
};
var CatalogStore = /*#__PURE__*/function () {
  function CatalogStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
    this.intlStore = rootStore.intlStore;
  }

  var _proto = CatalogStore.prototype;

  _proto.getSelectData = function getSelectData(requestConfig) {
    return this.api.client(requestConfig).then(function (r) {
      return r.data;
    }).then(function (data) {
      return data.map(function (_ref) {
        var code = _ref.code,
            title = _ref.title;
        return {
          id: code,
          title: title
        };
      });
    });
  };

  _proto.getCatalog = function getCatalog(catalogCode, lang) {
    return this.api.client(apiConfigs.catalogItems(catalogCode, lang)).then(function (r) {
      return r.data;
    }).then(function (arr) {
      return arr.map(function (item) {
        return {
          code: item.code + "@" + item.catalogCode,
          title: item.title
        };
      });
    });
  };

  _proto.getSelectDataByUrl = function getSelectDataByUrl(url) {
    return this.api.client({
      url: url,
      method: 'GET'
    }).then(function (r) {
      return r.data;
    });
  };

  return CatalogStore;
}();

__decorate([observable], CatalogStore.prototype, "rootStore", void 0);

__decorate([observable], CatalogStore.prototype, "api", void 0);

__decorate([observable], CatalogStore.prototype, "intlStore", void 0);

__decorate([action.bound], CatalogStore.prototype, "getSelectData", null);

__decorate([action.bound], CatalogStore.prototype, "getCatalog", null);

__decorate([action.bound], CatalogStore.prototype, "getSelectDataByUrl", null);

var getCatalogStore = function getCatalogStore() {
  var _di = di([CatalogStore], getCatalogStore),
      _CatalogStore = _di[0];

  return _CatalogStore;
};

var CampaignPfTemplateModel = /*#__PURE__*/function () {
  function CampaignPfTemplateModel(campaignId, settingsId, regFormsCatalog, rootStore) {
    this.titleMaxLength = 100;
    this.id = '';
    this.title = '';
    this.description = '';
    this.settingsId = '';
    this.required = false;
    this.signatureSettings = {
      signatureEnabled: false,
      signatureRequired: false,
      signatureBrowserPlugin: false,
      signatureUpload: false
    };
    this.acceptedFiles = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    this.regFormsCatalog = [];
    this.docCategories = [];
    this.docCategory = '';
    this.fileFormats = [];
    this.resultFileFormat = '';
    this.validationStarted = false;
    this.errorForm = false;
    this.errorFormCode = '';
    this.isRejectedFile = false;
    this.intl = rootStore.intlStore;
    this.catalogStore = rootStore.catalogStore;
    this.regFormsCatalog = regFormsCatalog;
    this.campaignId = campaignId;
    this.settingsId = settingsId;
  }

  var _proto = CampaignPfTemplateModel.prototype;

  _proto.getDocCategories = function getDocCategories() {
    var _this = this;

    return this.catalogStore.getSelectData(apiConfigs.catalogItems(CatalogCodes.documentCategory, this.intl.locale)).then(function (r) {
      _this.docCategories = r;
    });
  };

  _proto.getFileFormats = function getFileFormats() {
    var _this2 = this;

    this.catalogStore.getSelectData(apiConfigs.catalogItems(CatalogCodes.fileFormat, this.intl.locale)).then(function (r) {
      return _this2.fileFormats = r;
    });
  };

  _proto.enableErrorForm = function enableErrorForm(errorFormCode) {
    this.errorForm = true;
    this.errorFormCode = errorFormCode;
  };

  _proto.disableErrorForm = function disableErrorForm() {
    this.errorForm = false;
    this.errorFormCode = '';
  };

  _proto.load = function load(dto) {
    Object.assign(this, dto);
    return this;
  };

  _proto.onChangeDocumentCategory = function onChangeDocumentCategory(e, value) {
    this.docCategory = value ? value : '';
  };

  _proto.onChangeFileFormat = function onChangeFileFormat(e, value) {
    this.resultFileFormat = value ? value : '';
  };

  _proto.onChangeSignatureSettings = function onChangeSignatureSettings(e, fieldKey) {
    this.signatureSettings[fieldKey] = e.target.checked;
  };

  _proto.setCorrectSignatureSettings = function setCorrectSignatureSettings() {
    var _this3 = this;

    var signatureFields = Object.keys(this.signatureSettings);

    if (!this.signatureSettings.signatureEnabled) {
      signatureFields.forEach(function (signatureField) {
        _this3.signatureSettings[signatureField] = false;
      });
    }
  };

  _proto.onChangeRequired = function onChangeRequired() {
    this.required = !this.required;
  };

  _proto.onChangeFile = function onChangeFile(_ref) {
    var file = _ref[0];

    if (!file) {
      return;
    }

    this.fileDTO = undefined;
    this.fileForUpload = file;
    this.isRejectedFile = false;
  };

  _proto.onRejectedFile = function onRejectedFile() {
    this.isRejectedFile = true;
  };

  _proto.onDeleteFile = function onDeleteFile() {
    this.fileDTO = undefined;
    this.fileForUpload = undefined;
  };

  _createClass(CampaignPfTemplateModel, [{
    key: "templateFileName",
    get: function get() {
      var _this$fileForUpload, _this$fileDTO;

      return ((_this$fileForUpload = this.fileForUpload) === null || _this$fileForUpload === void 0 ? void 0 : _this$fileForUpload.name) || ((_this$fileDTO = this.fileDTO) === null || _this$fileDTO === void 0 ? void 0 : _this$fileDTO.filename);
    }
  }, {
    key: "dropzoneInitialFiles",
    get: function get() {
      if (this.templateFileName) {
        return [this.templateFileName];
      }

      return undefined;
    }
  }, {
    key: "formData",
    get: function get() {
      var data = new FormData();
      var _this$signatureSettin = this.signatureSettings,
          signatureEnabled = _this$signatureSettin.signatureEnabled,
          signatureUpload = _this$signatureSettin.signatureUpload,
          signatureRequired = _this$signatureSettin.signatureRequired,
          signatureBrowserPlugin = _this$signatureSettin.signatureBrowserPlugin;
      data.append('title', this.title);
      data.append('description', this.description);
      data.append('docCategory', this.docCategory);
      data.append('fileFormat', this.resultFileFormat);
      data.append('required', this.required.toString());
      data.append('settings', this.settingsId);
      data.append('signatureEnabled', signatureEnabled.toString());
      data.append('signatureUpload', signatureUpload.toString());
      data.append('signatureRequired', signatureRequired.toString());
      data.append('signatureBrowserPlugin', signatureBrowserPlugin.toString());

      if (this.fileForUpload) {
        data.append('file', this.fileForUpload);
      }

      return data;
    }
  }, {
    key: "errorTitle",
    get: function get() {
      if (this.validationStarted && !this.title) {
        return this.intl.formatMessage('validation.required');
      }

      if (this.title.length > this.titleMaxLength) {
        return this.intl.formatMessage('validation.maxLength', {
          length: this.titleMaxLength
        });
      }

      return '';
    }
  }, {
    key: "errorFileFormat",
    get: function get() {
      if (this.validationStarted && !this.resultFileFormat) {
        return this.intl.formatMessage('validation.required');
      }

      return '';
    }
  }, {
    key: "errorFile",
    get: function get() {
      if (this.validationStarted && !(!!this.fileForUpload || !!this.fileDTO)) {
        return this.intl.formatMessage('validation.required');
      } else if (this.isRejectedFile) {
        return this.intl.formatMessage('validation.dropzoneError');
      }

      return '';
    }
  }, {
    key: "errorSignatureMethod",
    get: function get() {
      if (this.validationStarted && this.signatureSettings.signatureEnabled && !this.signatureSettings.signatureUpload && !this.signatureSettings.signatureBrowserPlugin) {
        return this.intl.formatMessage('validation.withoutSignatureMethod');
      }

      return '';
    }
  }, {
    key: "isValid",
    get: function get() {
      return !this.errorTitle && !this.errorFile && !this.errorFileFormat && !this.errorSignatureMethod;
    }
  }]);

  return CampaignPfTemplateModel;
}();

__decorate([observable], CampaignPfTemplateModel.prototype, "intl", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "catalogStore", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "id", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "title", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "description", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "settingsId", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "required", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "signatureSettings", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "fileForUpload", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "fileDTO", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "regFormsCatalog", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "docCategories", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "docCategory", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "fileFormats", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "resultFileFormat", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "validationStarted", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "errorForm", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "errorFormCode", void 0);

__decorate([observable], CampaignPfTemplateModel.prototype, "isRejectedFile", void 0);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "getDocCategories", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "getFileFormats", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "enableErrorForm", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "disableErrorForm", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "load", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "onChangeDocumentCategory", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "onChangeFileFormat", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "onChangeSignatureSettings", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "setCorrectSignatureSettings", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "onChangeRequired", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "onChangeFile", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "onRejectedFile", null);

__decorate([action.bound], CampaignPfTemplateModel.prototype, "onDeleteFile", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "templateFileName", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "dropzoneInitialFiles", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "formData", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "errorTitle", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "errorFileFormat", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "errorFile", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "errorSignatureMethod", null);

__decorate([computed], CampaignPfTemplateModel.prototype, "isValid", null);

var reorderList = function reorderList(list, startIndex, endIndex) {
  var reorderedList = Array.from(list);

  var _reorderedList$splice = reorderedList.splice(startIndex, 1),
      removed = _reorderedList$splice[0];

  reorderedList.splice(endIndex, 0, removed);
  return reorderedList;
};

var CampaignPfTemplateListModel = /*#__PURE__*/function () {
  function CampaignPfTemplateListModel(campaignId, regFormId, rootStore) {
    this.campaignId = '';
    this.regFormId = '';
    this.templatesTabs = [];
    this.regFormsCatalog = [];
    this.campaignId = campaignId;
    this.regFormId = regFormId;
    this.store = rootStore.campaignsStore;
    this.intl = rootStore.intlStore;
    this.notificationStore = rootStore.notificationStore;
    this.rootStore = rootStore;
  }

  var _proto = CampaignPfTemplateListModel.prototype;

  _proto.loadData = function loadData() {
    var _this = this;

    this.store.loadRegForms(this.campaignId, true).then(function (regForms) {
      _this.regFormsCatalog = regForms;
    });
    this.store.loadTemplates(this.regFormId).then(function (templates) {
      _this.templatesTabs = templates.map(_this.mapDTO);
    });
  };

  _proto.newTemplate = function newTemplate(settingsId) {
    return new CampaignPfTemplateModel(this.campaignId, settingsId, this.regFormsCatalog, this.rootStore);
  };

  _proto.getTemplate = function getTemplate(id, settingsId) {
    var model = this.newTemplate(settingsId);
    this.store.loadTemplate(id).then(model.load);
    return model;
  };

  _proto.createTemplate = function createTemplate(template, settingsId) {
    var _this2 = this;

    template.setCorrectSignatureSettings();
    return this.store.createTemplate(this.regFormId, template).then(function (id) {
      template.id = id;

      var currentTab = _this2.templatesTabs.find(function (templateTab) {
        return templateTab.settingsId === settingsId;
      });

      if (currentTab) {
        currentTab.templates.push(template);
      }
    });
  };

  _proto.saveTemplate = function saveTemplate(template, settingsId) {
    var _this3 = this;

    return this.store.saveTemplate(template).then(function () {
      var currentTab = _this3.templatesTabs.find(function (templateTab) {
        return templateTab.settingsId === settingsId;
      });

      if (currentTab) {
        var oldIndex = currentTab.templates.findIndex(function (t) {
          return t.id === template.id;
        });
        currentTab.templates[oldIndex] = template;
      }
    });
  };

  _proto.deleteTemplate = function deleteTemplate(template) {
    var _this4 = this;

    return this.store.deleteTemplate(template.id).then(function () {
      var currentTab = _this4.templatesTabs.find(function (templateTab) {
        return templateTab.settingsId === template.settingsId;
      });

      if (currentTab) {
        currentTab.templates = currentTab.templates.filter(function (item) {
          return item.id !== template.id;
        });
      }
    }).catch(function (err) {
      _this4.notificationStore.onError(err.response.data);
    });
  };

  _proto.changeTemplatePosition = function changeTemplatePosition(id, newPosition) {
    this.store.changeTemplatePosition(id, newPosition);
  };

  _proto.reorderTemplatesList = function reorderTemplatesList(startIndex, endIndex, settingsId) {
    var currentTab = this.templatesTabs.find(function (templateTab) {
      return templateTab.settingsId === settingsId;
    });

    if (currentTab) {
      var reordered = reorderList(currentTab.templates, startIndex, endIndex);
      currentTab.templates = reordered;
    }
  };

  _proto.downloadTemplateFile = function downloadTemplateFile(template) {
    if (template.fileForUpload) {
      var file = template.fileForUpload;
      file.arrayBuffer().then(function (buff) {
        downloadFile(buff, file.name, file.type);
      });
      return;
    }

    if (template.fileDTO) {
      this.store.downloadTemplateFile(template.fileDTO);
    }
  };

  _proto.mapDTO = function mapDTO(templateTabDTO) {
    var _this5 = this;

    var settingsId = templateTabDTO.settingsId;
    return {
      settingsId: settingsId,
      settingsTitle: templateTabDTO.settingsTitle,
      templates: templateTabDTO.pfs.map(function (dto) {
        return _this5.newTemplate(settingsId).load(dto);
      })
    };
  };

  return CampaignPfTemplateListModel;
}();

__decorate([observable], CampaignPfTemplateListModel.prototype, "store", void 0);

__decorate([observable], CampaignPfTemplateListModel.prototype, "intl", void 0);

__decorate([observable], CampaignPfTemplateListModel.prototype, "notificationStore", void 0);

__decorate([observable], CampaignPfTemplateListModel.prototype, "rootStore", void 0);

__decorate([observable], CampaignPfTemplateListModel.prototype, "templatesTabs", void 0);

__decorate([observable], CampaignPfTemplateListModel.prototype, "regFormsCatalog", void 0);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "loadData", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "newTemplate", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "getTemplate", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "createTemplate", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "saveTemplate", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "deleteTemplate", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "changeTemplatePosition", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "reorderTemplatesList", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "downloadTemplateFile", null);

__decorate([action.bound], CampaignPfTemplateListModel.prototype, "mapDTO", null);

var CampaingPfTemplateTabModel = /*#__PURE__*/function () {
  function CampaingPfTemplateTabModel(intl) {
    this.permissions = [];
    this.permission = {
      code: '',
      title: ''
    };
    this.states = [];
    this.editPermission = false;
    this.accessPermissionsValidationStarted = false;
    this.validationStarted = false;
    this.statesList = [];
    this.permissionsList = [];
    this.intl = intl;
  }

  var _proto = CampaingPfTemplateTabModel.prototype;

  _proto.addAccessPermission = function addAccessPermission() {
    this.accessPermissionsValidationStarted = true;

    if (!this.isAccessPermissionsValid) {
      return;
    }

    this.permissions.push({
      permission: this.permission,
      states: this.states,
      edit: this.editPermission
    });
    this.permission = {
      code: '',
      title: ''
    };
    this.states = [];
    this.editPermission = false;
    this.accessPermissionsValidationStarted = false;
  };

  _proto.deleteAccessPermission = function deleteAccessPermission(index) {
    this.permissions.splice(index, 1);
  };

  _proto.handleUpdatePermission = function handleUpdatePermission(index, updatedPermission) {
    this.permissions[index] = updatedPermission;
  };

  _proto.onChangePermission = function onChangePermission(e, value) {
    this.permission = value != null ? value : {
      code: '',
      title: ''
    };
  };

  _proto.onChangeStates = function onChangeStates(e, value) {
    this.states = value != null ? value : [];
  };

  _proto.onChangeEditPermission = function onChangeEditPermission() {
    this.editPermission = !this.editPermission;
  };

  _createClass(CampaingPfTemplateTabModel, [{
    key: "isAccessPermissionsValid",
    get: function get() {
      return !!this.permission.code;
    }
  }, {
    key: "isValid",
    get: function get() {
      if (this.isAccessPermissionsValid && !this.permissions.length) {
        return false;
      }

      return !!this.permissions.length;
    }
  }, {
    key: "requiredMessage",
    get: function get() {
      return this.intl.formatMessage('validation.required');
    }
  }, {
    key: "permissionMessage",
    get: function get() {
      var accessPermissionsValidationStarted = this.accessPermissionsValidationStarted,
          permission = this.permission,
          requiredMessage = this.requiredMessage,
          validationStarted = this.validationStarted;

      if (accessPermissionsValidationStarted && !permission.code) {
        return requiredMessage;
      }

      if (validationStarted && !this.permissions.length) {
        return requiredMessage;
      }

      return '';
    }
  }]);

  return CampaingPfTemplateTabModel;
}();

__decorate([observable], CampaingPfTemplateTabModel.prototype, "intl", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "permissions", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "permission", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "states", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "editPermission", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "accessPermissionsValidationStarted", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "validationStarted", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "statesList", void 0);

__decorate([observable], CampaingPfTemplateTabModel.prototype, "permissionsList", void 0);

__decorate([action.bound], CampaingPfTemplateTabModel.prototype, "addAccessPermission", null);

__decorate([action.bound], CampaingPfTemplateTabModel.prototype, "deleteAccessPermission", null);

__decorate([action.bound], CampaingPfTemplateTabModel.prototype, "handleUpdatePermission", null);

__decorate([action.bound], CampaingPfTemplateTabModel.prototype, "onChangePermission", null);

__decorate([action.bound], CampaingPfTemplateTabModel.prototype, "onChangeStates", null);

__decorate([action.bound], CampaingPfTemplateTabModel.prototype, "onChangeEditPermission", null);

__decorate([computed], CampaingPfTemplateTabModel.prototype, "isAccessPermissionsValid", null);

__decorate([computed], CampaingPfTemplateTabModel.prototype, "isValid", null);

__decorate([computed], CampaingPfTemplateTabModel.prototype, "requiredMessage", null);

__decorate([computed], CampaingPfTemplateTabModel.prototype, "permissionMessage", null);

var NotificationModel = /*#__PURE__*/function () {
  function NotificationModel() {
    this.id = v4();
    this.title = '';
    this.severity = 'success';
    this.isOpen = true;
  }

  var _proto = NotificationModel.prototype;

  _proto.closeNotification = function closeNotification() {
    this.isOpen = false;
  };

  _proto.load = function load(dto) {
    this.severity = dto.severity;
    this.title = dto.title;
  };

  return NotificationModel;
}();

__decorate([observable], NotificationModel.prototype, "id", void 0);

__decorate([observable], NotificationModel.prototype, "title", void 0);

__decorate([observable], NotificationModel.prototype, "severity", void 0);

__decorate([observable], NotificationModel.prototype, "isOpen", void 0);

__decorate([action.bound], NotificationModel.prototype, "closeNotification", null);

__decorate([action.bound], NotificationModel.prototype, "load", null);

var NotificationListModel = /*#__PURE__*/function () {
  function NotificationListModel() {
    this.notifications = [];
  }

  var _proto = NotificationListModel.prototype;

  _proto.pushNotification = function pushNotification(title, severity) {
    var _this = this;

    var notification = new NotificationModel();
    var messageDetails = {
      title: title,
      severity: severity
    };

    if (this.notifications.length >= 3) {
      this.clearNotifications();
      setTimeout(function () {
        _this.notifications = [];
        notification.load(messageDetails);

        _this.notifications.unshift(notification);
      }, 300);
    } else {
      notification.load(messageDetails);
      this.notifications.unshift(notification);
    }

    this.removeAfterTimeout(notification);
  };

  _proto.removeAfterTimeout = function removeAfterTimeout(notification) {
    setTimeout(function () {
      notification.closeNotification();
    }, 3000);
  };

  _proto.clearNotifications = function clearNotifications() {
    this.notifications.forEach(function (m) {
      m.closeNotification();
    });
  };

  _proto.deleteNotification = function deleteNotification(id) {
    var _this2 = this;

    var notification = this.notifications.find(function (n) {
      return n.id === id;
    });
    var indexNotification = this.notifications.findIndex(function (m) {
      return m.id === id;
    });
    notification === null || notification === void 0 ? void 0 : notification.closeNotification();
    setTimeout(function () {
      _this2.notifications.splice(indexNotification, 1);
    }, 300);
  };

  return NotificationListModel;
}();

__decorate([observable], NotificationListModel.prototype, "notifications", void 0);

__decorate([action.bound], NotificationListModel.prototype, "pushNotification", null);

__decorate([action.bound], NotificationListModel.prototype, "removeAfterTimeout", null);

__decorate([action.bound], NotificationListModel.prototype, "clearNotifications", null);

__decorate([action.bound], NotificationListModel.prototype, "deleteNotification", null);

var getAdditionalCampaignRegFormTabsRoutes = function getAdditionalCampaignRegFormTabsRoutes() {
  var _di = di([getAdditionalCampaignRegFormTabsRoutesInj], CampaignSettingsPage),
      getAdditionalCampaignRegFormTabsRoutes = _di[0];

  var paths = [];
  getAdditionalCampaignRegFormTabsRoutes().forEach(function (route) {
    paths.push(route.path);
    route.additionalTabLinks.forEach(function (additionalRoute) {
      paths.push(additionalRoute);
    });
  });
  return paths;
};

var BootstrapPanelUtils = /*#__PURE__*/function () {
  function BootstrapPanelUtils() {}

  BootstrapPanelUtils.openPanelById = function openPanelById(id) {
    var _document$querySelect, _document$querySelect2, _document$querySelect3;

    var parentPanelId = (_document$querySelect = document.querySelector("#" + id)) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.parentElement) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.parentElement) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.getAttribute('id');

    if (parentPanelId) {
      var parentPanelBody = document.querySelector("#" + parentPanelId + " > *:nth-child(2)");

      if (parentPanelBody && parentPanelBody.getAttribute('hidden')) {
        this.openPanelById(parentPanelId);
      }
    }

    var panelBody = document.querySelector("#" + id + " > *:nth-child(2)");

    if (panelBody && panelBody.getAttribute('hidden')) {
      var panelTitle = document.querySelector("#" + id + " > *:nth-child(1)");

      if (panelTitle && typeof panelTitle.click === 'function') {
        panelTitle.click();
      }
    }
  };

  return BootstrapPanelUtils;
}();

var ElementPositionUtils = /*#__PURE__*/function () {
  function ElementPositionUtils() {}

  ElementPositionUtils.isFullElementInView = function isFullElementInView(element, prevElementHeight, nextElementHeight) {
    if (prevElementHeight === void 0) {
      prevElementHeight = 0;
    }

    if (nextElementHeight === void 0) {
      nextElementHeight = 0;
    }

    if (element !== null) {
      var scrollTop = ElementPositionUtils.getScrollTop();
      var pageTop = scrollTop + prevElementHeight;
      var pageBottom = pageTop + window.innerHeight - nextElementHeight;
      var elementTop = element.getBoundingClientRect().top + scrollTop;
      var elementBottom = elementTop + element.offsetHeight;
      return elementTop > pageTop && elementBottom < pageBottom;
    } else {
      return false;
    }
  };

  ElementPositionUtils.isPartOfElementInView = function isPartOfElementInView(element, prevElementHeight, nextElementHeight) {
    if (prevElementHeight === void 0) {
      prevElementHeight = 0;
    }

    if (nextElementHeight === void 0) {
      nextElementHeight = 0;
    }

    if (element !== null) {
      var scrollTop = ElementPositionUtils.getScrollTop();
      var pageTop = scrollTop + prevElementHeight;
      var pageBottom = pageTop + window.innerHeight - nextElementHeight;
      var elementTop = element.getBoundingClientRect().top + scrollTop;
      var elementBottom = elementTop + element.offsetHeight;
      return elementTop < pageBottom && elementBottom > pageTop;
    } else {
      return false;
    }
  };

  ElementPositionUtils.isTopOfElementInView = function isTopOfElementInView(element, prevElementHeight) {
    if (prevElementHeight === void 0) {
      prevElementHeight = 0;
    }

    if (element !== null) {
      var scrollTop = ElementPositionUtils.getScrollTop();
      var pageTop = scrollTop + prevElementHeight;
      var elementTop = element.getBoundingClientRect().top + scrollTop;
      return elementTop > pageTop;
    } else {
      return false;
    }
  };

  ElementPositionUtils.getElementOffsetHeightWithMargin = function getElementOffsetHeightWithMargin(element) {
    if (element !== null) {
      var styles = window.getComputedStyle(element);
      var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
      return Math.round(element.offsetHeight + margin);
    } else {
      return 0;
    }
  };

  ElementPositionUtils.getScrollTop = function getScrollTop() {
    return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
  };

  return ElementPositionUtils;
}();

var rootElement = document.getElementById('root');

var ScrollUtils = /*#__PURE__*/function () {
  function ScrollUtils() {}

  ScrollUtils.scrollToElementById = function scrollToElementById(id, headerHeight) {
    var element = document.querySelector('#' + id);

    if (element && rootElement) {
      var elementBoundingRect = element.getBoundingClientRect();
      rootElement.scrollBy({
        top: elementBoundingRect.top - headerHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  return ScrollUtils;
}();

var codeTitleToIdTitle = function codeTitleToIdTitle(codeTitleList) {
  return codeTitleList.map(function (_ref) {
    var code = _ref.code,
        title = _ref.title;
    return {
      id: code,
      title: title
    };
  });
};

function handleAxiosErrorByResponseStatus(actions) {
  return function (error) {
    var _error$response;

    var status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;

    if (status) {
      var action = actions[status];

      if (action) {
        action();
      }
    }

    return Promise.reject(error);
  };
}

var getEmailFromText = function getEmailFromText(text) {
  var pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
  var mail = text.match(pattern) || [];
  return mail[0];
};

var getPhoneNumberFromText = function getPhoneNumberFromText(text) {
  return text.replace(/[^\d\+]/g, '');
};

var isEmail = function isEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};

var fileNameRegex = /filename[^;=\n]*=['"].*?(\2|[^;\n'"]*)/;
var getFileName = function getFileName(contentDisposition) {
  var filenameMatches = fileNameRegex.exec(contentDisposition);
  return filenameMatches ? filenameMatches[1] : '';
};

var RegFormListModel = /*#__PURE__*/function () {
  function RegFormListModel(api, campaignId) {
    this.regFormsData = [];
    this.api = api;
    this.getRegFormsData(campaignId);
  }

  var _proto = RegFormListModel.prototype;

  _proto.getRegFormsData = function getRegFormsData(campaignId) {
    var _this = this;

    this.api.client(apiConfigs.regForms(campaignId, false)).then(function (r) {
      return r.data;
    }).then(function (data) {
      return data.map(_this.mapDTO);
    }).then(function (data) {
      return _this.regFormsData = data;
    });
  };

  _proto.mapDTO = function mapDTO(dto) {
    var regStart = new Date(dto.regStart);
    var regEnd = new Date(dto.regEnd);
    return {
      id: dto.id,
      title: dto.title,
      procedureTitle: dto.procedureTitle,
      regStart: DateUtils.isValidDate(regStart) ? regStart : undefined,
      regEnd: DateUtils.isValidDate(regEnd) ? regEnd : undefined,
      allowAfterDeadline: dto.allowAfterDeadline,
      fileInstruction: dto.fileInstruction
    };
  };

  return RegFormListModel;
}();

__decorate([observable], RegFormListModel.prototype, "regFormsData", void 0);

__decorate([action.bound], RegFormListModel.prototype, "getRegFormsData", null);

__decorate([action.bound], RegFormListModel.prototype, "mapDTO", null);

var UserListModel = /*#__PURE__*/function (_TableModel) {
  _inheritsLoose(UserListModel, _TableModel);

  function UserListModel(userStore) {
    var _this;

    _this = _TableModel.call(this, {
      name: new LikeFilter(),
      login: new LikeFilter()
    }, {}) || this;
    _this.userStore = userStore;
    _this.pageSize = 10;
    return _this;
  }

  var _proto = UserListModel.prototype;

  _proto.getRowsData = function getRowsData(queryData) {
    return this.userStore.loadList(queryData);
  };

  _proto.blockUser = function blockUser(id) {
    var _this2 = this;

    return function () {
      return _this2.userStore.blockUser(id).then(_this2.reloadData);
    };
  };

  _proto.unblockUser = function unblockUser(id) {
    var _this3 = this;

    return function () {
      return _this3.userStore.unblockUser(id).then(_this3.reloadData);
    };
  };

  _proto.deleteUser = function deleteUser(id) {
    var _this4 = this;

    return function () {
      return _this4.userStore.deleteUser(id).then(_this4.reloadData);
    };
  };

  return UserListModel;
}(TableModel);

__decorate([observable], UserListModel.prototype, "userStore", void 0);

__decorate([action.bound], UserListModel.prototype, "getRowsData", null);

__decorate([action.bound], UserListModel.prototype, "blockUser", null);

__decorate([action.bound], UserListModel.prototype, "unblockUser", null);

__decorate([action.bound], UserListModel.prototype, "deleteUser", null);

var UserPersonModel = /*#__PURE__*/function () {
  function UserPersonModel(id) {
    this.login = '';
    this.lang = '';
    this.roles = observable.array();
    this.id = id;
    this.personForm = new FormModel(this.id);
  }

  var _proto = UserPersonModel.prototype;

  _proto.load = function load(dto) {
    this.login = dto.login;
    this.lang = dto.lang;
    this.roles.replace(dto.roles);
    this.personForm.load(dto.formInfo);
    return this;
  };

  return UserPersonModel;
}();

__decorate([observable], UserPersonModel.prototype, "id", void 0);

__decorate([observable], UserPersonModel.prototype, "login", void 0);

__decorate([observable], UserPersonModel.prototype, "lang", void 0);

__decorate([observable], UserPersonModel.prototype, "roles", void 0);

__decorate([observable], UserPersonModel.prototype, "personForm", void 0);

__decorate([action.bound], UserPersonModel.prototype, "load", null);

var CampaignInfoModel = /*#__PURE__*/function () {
  function CampaignInfoModel(apiUrl) {
    this.id = '';
    this.title = '';
    this.annotation = '';
    this.files = observable.array();
    this.apiUrl = apiUrl;
  }

  var _proto = CampaignInfoModel.prototype;

  _proto.load = function load(dto) {
    this.id = dto.id;
    this.title = dto.title;
    this.avatarId = dto.avatarId;
    this.annotation = dto.annotation || '';
    this.files = observable.array(dto.files.map(function (i) {
      var id = i.id,
          dto = _objectWithoutPropertiesLoose(i, ["id"]);

      return _extends({
        fileId: id
      }, dto);
    }));

    if (dto.from) {
      var from = new Date(dto.from);

      if (DateUtils.isValidDate(from)) {
        this.from = from;
      }
    }

    if (dto.to) {
      var to = new Date(dto.to);

      if (DateUtils.isValidDate(to)) {
        this.to = to;
      }
    }
  };

  _createClass(CampaignInfoModel, [{
    key: "isCollectionCompleted",
    get: function get() {
      return this.to && isAfter(new Date(), this.to);
    }
  }, {
    key: "avatarUrl",
    get: function get() {
      if (this.apiUrl && this.avatarId) {
        return "" + this.apiUrl + apiConfigs.campaignFileUrl(this.avatarId);
      }

      return undefined;
    }
  }, {
    key: "campaignNotStarted",
    get: function get() {
      if (this.from) {
        var now = new Date();
        return this.from > now;
      }

      return true;
    }
  }]);

  return CampaignInfoModel;
}();

__decorate([observable], CampaignInfoModel.prototype, "id", void 0);

__decorate([observable], CampaignInfoModel.prototype, "title", void 0);

__decorate([observable], CampaignInfoModel.prototype, "from", void 0);

__decorate([observable], CampaignInfoModel.prototype, "to", void 0);

__decorate([observable], CampaignInfoModel.prototype, "annotation", void 0);

__decorate([observable], CampaignInfoModel.prototype, "files", void 0);

__decorate([observable], CampaignInfoModel.prototype, "avatarId", void 0);

__decorate([computed], CampaignInfoModel.prototype, "isCollectionCompleted", null);

__decorate([action.bound], CampaignInfoModel.prototype, "load", null);

__decorate([computed], CampaignInfoModel.prototype, "avatarUrl", null);

__decorate([computed], CampaignInfoModel.prototype, "campaignNotStarted", null);

var CampaignRegFormInfoModel = /*#__PURE__*/function () {
  function CampaignRegFormInfoModel(id) {
    this.title = '';
    this.campaignId = '';
    this.requestFormCode = '';
    this.id = id;
  }

  var _proto = CampaignRegFormInfoModel.prototype;

  _proto.load = function load(dto) {
    this.title = dto.title;
    this.campaignId = dto.campaignId;
    this.requestFormCode = dto.requestFormCode;
    this.procedureTitle = dto.procedureTitle;
    this.reEnrollmentForm = dto.reEnrollmentForm;
    this.allowAfterDeadline = dto.allowAfterDeadline;

    if (dto.registrationStart) {
      var registrationStart = new Date(dto.registrationStart);

      if (DateUtils.isValidDate(registrationStart)) {
        this.registrationStart = registrationStart;
      }
    }

    if (dto.registrationEnd) {
      var registrationEnd = new Date(dto.registrationEnd);

      if (DateUtils.isValidDate(registrationEnd)) {
        this.registrationEnd = registrationEnd;
      }
    }
  };

  return CampaignRegFormInfoModel;
}();

__decorate([observable], CampaignRegFormInfoModel.prototype, "id", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "title", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "campaignId", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "requestFormCode", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "procedureTitle", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "registrationStart", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "registrationEnd", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "reEnrollmentForm", void 0);

__decorate([observable], CampaignRegFormInfoModel.prototype, "allowAfterDeadline", void 0);

__decorate([action.bound], CampaignRegFormInfoModel.prototype, "load", null);

var LoginModel = /*#__PURE__*/function () {
  function LoginModel(api, intlStore, personStore) {
    this.email = '';
    this.password = '';
    this.rememberMe = false;
    this.validationStarted = false;
    this.api = api;
    this.intl = intlStore;
    this.personStore = personStore;
  }

  var _proto = LoginModel.prototype;

  _proto.login = function login(event) {
    try {
      var _this2 = this;

      event.preventDefault();
      _this2.validationStarted = true;

      var _temp3 = function () {
        if (_this2.isValid) {
          var _temp4 = _catch(function () {
            return Promise.resolve(_this2.api.client(apiConfigs.login(_this2.asJson))).then(function () {
              return Promise.resolve(_this2.api.authVerify()).then(function () {
                return Promise.resolve(_this2.personStore.getInfo()).then(function () {
                  _this2.loginStatus = 'success';
                });
              });
            });
          }, function (e) {
            var status = e.response.status;
            _this2.loginStatus = 'failed';
            _this2.loginStatusCode = status;
          });

          if (_temp4 && _temp4.then) return _temp4.then(function () {});
        }
      }();

      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.onChangeEmail = function onChangeEmail(event) {
    this.email = event.target.value;
  };

  _proto.onChangePassword = function onChangePassword(event) {
    this.password = event.target.value;
  };

  _proto.onChangeRememberMe = function onChangeRememberMe(event, checked) {
    this.rememberMe = checked;
  };

  _createClass(LoginModel, [{
    key: "asJson",
    get: function get() {
      return {
        email: this.email,
        password: this.password,
        rememberMe: this.rememberMe
      };
    }
  }, {
    key: "loginFailedMessage",
    get: function get() {
      switch (this.loginStatusCode) {
        case 401:
          return this.intl.formatMessage('authentication.loginFailed');

        case 403:
          return this.intl.formatMessage('authentication.userBlocked');

        case 404:
          return this.intl.formatMessage('authentication.emailNotExist');

        case 405:
          return this.intl.formatMessage('authentication.emailNotConfirmed');
      }

      return '';
    }
  }, {
    key: "loginSucceed",
    get: function get() {
      return this.loginStatus === 'success';
    }
  }, {
    key: "errorEmail",
    get: function get() {
      if (this.validationStarted && !this.email) {
        return this.intl.formatMessage('validation.required');
      }

      return '';
    }
  }, {
    key: "errorPassword",
    get: function get() {
      if (this.validationStarted && !this.password) {
        return this.intl.formatMessage('validation.required');
      }

      return '';
    }
  }, {
    key: "isValid",
    get: function get() {
      return !this.errorEmail && !this.errorPassword;
    }
  }]);

  return LoginModel;
}();

__decorate([observable], LoginModel.prototype, "api", void 0);

__decorate([observable], LoginModel.prototype, "intl", void 0);

__decorate([observable], LoginModel.prototype, "personStore", void 0);

__decorate([observable], LoginModel.prototype, "email", void 0);

__decorate([observable], LoginModel.prototype, "password", void 0);

__decorate([observable], LoginModel.prototype, "rememberMe", void 0);

__decorate([observable], LoginModel.prototype, "validationStarted", void 0);

__decorate([observable], LoginModel.prototype, "loginStatus", void 0);

__decorate([observable], LoginModel.prototype, "loginStatusCode", void 0);

__decorate([asyncAction, action.bound], LoginModel.prototype, "login", null);

__decorate([action.bound], LoginModel.prototype, "onChangeEmail", null);

__decorate([action.bound], LoginModel.prototype, "onChangePassword", null);

__decorate([action.bound], LoginModel.prototype, "onChangeRememberMe", null);

__decorate([computed], LoginModel.prototype, "asJson", null);

__decorate([computed], LoginModel.prototype, "loginFailedMessage", null);

__decorate([computed], LoginModel.prototype, "loginSucceed", null);

__decorate([computed], LoginModel.prototype, "errorEmail", null);

__decorate([computed], LoginModel.prototype, "errorPassword", null);

__decorate([computed], LoginModel.prototype, "isValid", null);

var fileContentType = 'application/octet-stream';

var consoleEditorClass = 'language-scala';
var consoleErrorClass = 'result-error';
var tabSize = 4;

var ConsoleModel = /*#__PURE__*/function () {
  function ConsoleModel(rootStore) {
    this.code = '';
    this.result = '';
    this.error = '';
    this.rootStore = rootStore;
    this.consoleStore = rootStore.consoleStore;
  }

  var _proto = ConsoleModel.prototype;

  _proto.runScript = function runScript() {
    var _this = this;

    this.clearResult();
    return this.consoleStore.runScript(this.code).then(function (result) {
      var blob = result.blob,
          isFile = result.isFile,
          fileName = result.fileName;

      if (isFile) {
        downloadFile(blob, fileName);
        return;
      }

      blob.text().then(function (text) {
        _this.setResult(text);
      });
    }).catch(function (error) {
      var errorBlob = error.response.data;
      errorBlob.text().then(function (errors) {
        var errorsParse = JSON.parse(errors);

        _this.setError(JSON.stringify(errorsParse, null, tabSize));
      });
    });
  };

  _proto.copyResult = function copyResult() {
    navigator.clipboard.writeText(this.error || this.result);
  };

  _proto.clearResult = function clearResult() {
    this.result = '';
    this.error = '';
  };

  _proto.setCode = function setCode(code) {
    this.code = code;
  };

  _proto.setResult = function setResult(result) {
    this.result = result;
  };

  _proto.setError = function setError(error) {
    this.error = error;
  };

  return ConsoleModel;
}();

__decorate([observable], ConsoleModel.prototype, "rootStore", void 0);

__decorate([observable], ConsoleModel.prototype, "consoleStore", void 0);

__decorate([observable], ConsoleModel.prototype, "code", void 0);

__decorate([observable], ConsoleModel.prototype, "result", void 0);

__decorate([observable], ConsoleModel.prototype, "error", void 0);

__decorate([action.bound], ConsoleModel.prototype, "runScript", null);

__decorate([action.bound], ConsoleModel.prototype, "copyResult", null);

__decorate([action.bound], ConsoleModel.prototype, "clearResult", null);

__decorate([action.bound], ConsoleModel.prototype, "setCode", null);

__decorate([action.bound], ConsoleModel.prototype, "setResult", null);

__decorate([action.bound], ConsoleModel.prototype, "setError", null);

var NewPasswordModel = /*#__PURE__*/function () {
  function NewPasswordModel(api, intlStore) {
    this.newPassword = '';
    this.repeatPassword = '';
    this.validationStarted = false;
    this.api = api;
    this.intl = intlStore;
  }

  var _proto = NewPasswordModel.prototype;

  _proto.onChangeNewPassword = function onChangeNewPassword(event) {
    this.newPassword = event.target.value;
  };

  _proto.onChangeRepeatPassword = function onChangeRepeatPassword(event) {
    this.repeatPassword = event.target.value;
  };

  _proto.updatePassword = function updatePassword(event) {
    try {
      var _this2 = this;

      event.preventDefault();
      _this2.validationStarted = true;

      var _temp3 = function () {
        if (_this2.isValid) {
          var _temp4 = _catch(function () {
            return Promise.resolve(_this2.api.client(apiConfigs.resetPassword(_this2.asJson))).then(function () {
              _this2.status = 'success';
            });
          }, function () {
            _this2.status = 'failed';
          });

          if (_temp4 && _temp4.then) return _temp4.then(function () {});
        }
      }();

      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.validateToken = function validateToken() {
    try {
      var _this4 = this;

      var _temp7 = function () {
        if (_this4.token) {
          var _temp8 = _catch(function () {
            return Promise.resolve(_this4.api.client(apiConfigs.checkIsPasswordRecoveryTokenValid(_this4.token))).then(function () {
              _this4.isTokenValid = true;
            });
          }, function () {
            _this4.isTokenValid = false;
          });

          if (_temp8 && _temp8.then) return _temp8.then(function () {});
        }
      }();

      return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(NewPasswordModel, [{
    key: "asJson",
    get: function get() {
      return {
        token: this.token,
        newPassword: this.newPassword
      };
    }
  }, {
    key: "newPasswordModel",
    get: function get() {
      return {
        errorPassword: this.errorNewPassword,
        onChangePassword: this.onChangeNewPassword
      };
    }
  }, {
    key: "repeatPasswordModel",
    get: function get() {
      return {
        errorPassword: this.errorRepeatPassword,
        onChangePassword: this.onChangeRepeatPassword
      };
    }
  }, {
    key: "changedSucceed",
    get: function get() {
      return this.status === 'success';
    }
  }, {
    key: "errorNewPassword",
    get: function get() {
      var minLength = 8;

      if (this.validationStarted && this.newPassword.length < minLength) {
        return this.intl.formatMessage('validation.minLength', {
          length: minLength
        });
      }

      return '';
    }
  }, {
    key: "errorRepeatPassword",
    get: function get() {
      if (this.validationStarted) {
        if (this.newPassword !== this.repeatPassword) {
          return this.intl.formatMessage('authentication.passwordsMustMatch');
        }

        if (!this.repeatPassword) {
          return this.intl.formatMessage('validation.required');
        }
      }

      return '';
    }
  }, {
    key: "failedMessage",
    get: function get() {
      if (this.status === 'failed') {
        return this.intl.formatMessage('authentication.linkInvalidOrExpired');
      }

      return '';
    }
  }, {
    key: "isValid",
    get: function get() {
      return !this.errorNewPassword && !this.errorRepeatPassword;
    }
  }]);

  return NewPasswordModel;
}();

__decorate([observable], NewPasswordModel.prototype, "api", void 0);

__decorate([observable], NewPasswordModel.prototype, "intl", void 0);

__decorate([observable], NewPasswordModel.prototype, "token", void 0);

__decorate([observable], NewPasswordModel.prototype, "newPassword", void 0);

__decorate([observable], NewPasswordModel.prototype, "repeatPassword", void 0);

__decorate([observable], NewPasswordModel.prototype, "validationStarted", void 0);

__decorate([observable], NewPasswordModel.prototype, "status", void 0);

__decorate([observable], NewPasswordModel.prototype, "isTokenValid", void 0);

__decorate([action.bound], NewPasswordModel.prototype, "onChangeNewPassword", null);

__decorate([action.bound], NewPasswordModel.prototype, "onChangeRepeatPassword", null);

__decorate([asyncAction, action.bound], NewPasswordModel.prototype, "updatePassword", null);

__decorate([asyncAction, action.bound], NewPasswordModel.prototype, "validateToken", null);

__decorate([computed], NewPasswordModel.prototype, "asJson", null);

__decorate([computed], NewPasswordModel.prototype, "newPasswordModel", null);

__decorate([computed], NewPasswordModel.prototype, "repeatPasswordModel", null);

__decorate([computed], NewPasswordModel.prototype, "changedSucceed", null);

__decorate([computed], NewPasswordModel.prototype, "errorNewPassword", null);

__decorate([computed], NewPasswordModel.prototype, "errorRepeatPassword", null);

__decorate([computed], NewPasswordModel.prototype, "failedMessage", null);

__decorate([computed], NewPasswordModel.prototype, "isValid", null);

var RecoveryPasswordModel = /*#__PURE__*/function () {
  function RecoveryPasswordModel(api, intlStore) {
    this.email = '';
    this.validationStarted = false;
    this.api = api;
    this.intl = intlStore;
  }

  var _proto = RecoveryPasswordModel.prototype;

  _proto.sendToken = function sendToken(event) {
    try {
      var _this2 = this;

      event.preventDefault();
      _this2.status = undefined;
      _this2.validationStarted = true;

      var _temp3 = function () {
        if (_this2.isValid) {
          var _temp4 = _catch(function () {
            return Promise.resolve(_this2.api.client(apiConfigs.forgotPassword(_this2.asJson))).then(function () {
              _this2.status = 'success';
            });
          }, function () {
            _this2.status = 'failed';
          });

          if (_temp4 && _temp4.then) return _temp4.then(function () {});
        }
      }();

      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.onChangeEmail = function onChangeEmail(event) {
    this.email = event.target.value;
  };

  _createClass(RecoveryPasswordModel, [{
    key: "asJson",
    get: function get() {
      return {
        email: this.email,
        lang: this.intl.locale
      };
    }
  }, {
    key: "sentSucceed",
    get: function get() {
      return this.status === 'success';
    }
  }, {
    key: "errorEmail",
    get: function get() {
      if (this.validationStarted) {
        if (!this.email) {
          return this.intl.formatMessage('validation.required');
        }

        if (this.status === 'failed') {
          return this.intl.formatMessage('authentication.recoveryPasswordFailed');
        }
      }

      return '';
    }
  }, {
    key: "isValid",
    get: function get() {
      return !this.errorEmail;
    }
  }]);

  return RecoveryPasswordModel;
}();

__decorate([observable], RecoveryPasswordModel.prototype, "api", void 0);

__decorate([observable], RecoveryPasswordModel.prototype, "intl", void 0);

__decorate([observable], RecoveryPasswordModel.prototype, "email", void 0);

__decorate([observable], RecoveryPasswordModel.prototype, "validationStarted", void 0);

__decorate([observable], RecoveryPasswordModel.prototype, "status", void 0);

__decorate([asyncAction, action.bound], RecoveryPasswordModel.prototype, "sendToken", null);

__decorate([action.bound], RecoveryPasswordModel.prototype, "onChangeEmail", null);

__decorate([computed], RecoveryPasswordModel.prototype, "asJson", null);

__decorate([computed], RecoveryPasswordModel.prototype, "sentSucceed", null);

__decorate([computed], RecoveryPasswordModel.prototype, "errorEmail", null);

__decorate([computed], RecoveryPasswordModel.prototype, "isValid", null);

var RegistrationConfirmModel = /*#__PURE__*/function () {
  function RegistrationConfirmModel(api, intlStore) {
    this.api = api;
    this.intl = intlStore;
  }

  var _proto = RegistrationConfirmModel.prototype;

  _proto.confirmEmail = function confirmEmail(token) {
    try {
      var _this2 = this;

      var _temp2 = _catch(function () {
        _this2.status = 'pending';
        var confirmEmailDTO = {
          token: token,
          lang: _this2.intl.locale
        };
        return Promise.resolve(_this2.api.client(apiConfigs.confirmEmail(confirmEmailDTO))).then(function () {
          _this2.status = 'success';
        });
      }, function (e) {
        if (e.response) {
          if (e.response.status === 410) {
            _this2.status = 'expired';
          }

          if (e.response.status === 404) {
            _this2.status = 'not-found';
          }
        }
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return RegistrationConfirmModel;
}();

__decorate([observable], RegistrationConfirmModel.prototype, "api", void 0);

__decorate([observable], RegistrationConfirmModel.prototype, "intl", void 0);

__decorate([observable], RegistrationConfirmModel.prototype, "status", void 0);

__decorate([action.bound], RegistrationConfirmModel.prototype, "confirmEmail", null);

var RegistrationModel = /*#__PURE__*/function () {
  function RegistrationModel(api, intlStore) {
    this.email = '';
    this.password = '';
    this.firstName = '';
    this.lastName = '';
    this.termsIsAccepted = false;
    this.validationStarted = false;
    this.emailAlreadyRegisteredError = 'Email already registered';
    this.confirmTokenStillNotExpiredError = 'Confirm token still not expired';
    this.api = api;
    this.intl = intlStore;
  }

  var _proto = RegistrationModel.prototype;

  _proto.register = function register(event) {
    try {
      var _this2 = this;

      event.preventDefault();
      _this2.validationStarted = true;

      var _temp3 = function () {
        if (_this2.isValid) {
          var _temp4 = _catch(function () {
            return Promise.resolve(_this2.api.client(apiConfigs.register(_this2.asJson))).then(function () {
              _this2.registerStatus = 'success';
            });
          }, function (e) {
            if (e.response && e.response.status === 409) {
              _this2.registerStatus = e.response.data;
            } else {
              _this2.registerStatus = 'failed';
            }
          });

          if (_temp4 && _temp4.then) return _temp4.then(function () {});
        }
      }();

      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.onChangeEmail = function onChangeEmail(event) {
    this.email = event.target.value;

    if (this.isRegisterConflict()) {
      this.registerStatus = undefined;
    }
  };

  _proto.onChangePassword = function onChangePassword(event) {
    this.password = event.target.value;
  };

  _proto.onChangeFirstName = function onChangeFirstName(event) {
    this.firstName = event.target.value;
  };

  _proto.onChangeMiddleName = function onChangeMiddleName(event) {
    this.middleName = event.target.value;
  };

  _proto.onChangeTermsIsAccepted = function onChangeTermsIsAccepted(event, checked) {
    this.termsIsAccepted = checked;
  };

  _proto.onChangeLastName = function onChangeLastName(event) {
    this.lastName = event.target.value;
  };

  _proto.isRegisterConflict = function isRegisterConflict() {
    return this.registerStatus === this.emailAlreadyRegisteredError || this.registerStatus === this.confirmTokenStillNotExpiredError;
  };

  _createClass(RegistrationModel, [{
    key: "asJson",
    get: function get() {
      return {
        email: this.email,
        password: this.password,
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName,
        lang: this.intl.locale
      };
    }
  }, {
    key: "registerSucceed",
    get: function get() {
      return this.registerStatus === 'success';
    }
  }, {
    key: "errorEmail",
    get: function get() {
      if (this.validationStarted) {
        if (!this.email) {
          return this.intl.formatMessage('validation.required');
        }

        if (this.registerStatus === this.emailAlreadyRegisteredError) {
          return this.intl.formatMessage('authentication.emailAlreadyExists');
        }

        if (this.registerStatus === this.confirmTokenStillNotExpiredError) {
          return this.intl.formatMessage('authentication.confirmingEmailReminder');
        }

        if (!isEmail(this.email)) {
          return this.intl.formatMessage('validation.isEmail');
        }
      }

      return '';
    }
  }, {
    key: "errorPassword",
    get: function get() {
      var minLength = 8;

      if (this.validationStarted && this.password.length < minLength) {
        return this.intl.formatMessage('validation.minLength', {
          length: minLength
        });
      }

      return '';
    }
  }, {
    key: "errorFirstName",
    get: function get() {
      if (this.validationStarted && !this.firstName) {
        return this.intl.formatMessage('validation.required');
      }

      return '';
    }
  }, {
    key: "errorLastName",
    get: function get() {
      if (this.validationStarted && !this.lastName) {
        return this.intl.formatMessage('validation.required');
      }

      return '';
    }
  }, {
    key: "isValid",
    get: function get() {
      return !this.errorEmail && !this.errorPassword && !this.errorFirstName && !this.errorLastName;
    }
  }]);

  return RegistrationModel;
}();

__decorate([observable], RegistrationModel.prototype, "api", void 0);

__decorate([observable], RegistrationModel.prototype, "intl", void 0);

__decorate([observable], RegistrationModel.prototype, "email", void 0);

__decorate([observable], RegistrationModel.prototype, "password", void 0);

__decorate([observable], RegistrationModel.prototype, "firstName", void 0);

__decorate([observable], RegistrationModel.prototype, "middleName", void 0);

__decorate([observable], RegistrationModel.prototype, "lastName", void 0);

__decorate([observable], RegistrationModel.prototype, "termsIsAccepted", void 0);

__decorate([observable], RegistrationModel.prototype, "validationStarted", void 0);

__decorate([observable], RegistrationModel.prototype, "registerStatus", void 0);

__decorate([asyncAction, action.bound], RegistrationModel.prototype, "register", null);

__decorate([action.bound], RegistrationModel.prototype, "onChangeEmail", null);

__decorate([action.bound], RegistrationModel.prototype, "onChangePassword", null);

__decorate([action.bound], RegistrationModel.prototype, "onChangeFirstName", null);

__decorate([action.bound], RegistrationModel.prototype, "onChangeMiddleName", null);

__decorate([action.bound], RegistrationModel.prototype, "onChangeTermsIsAccepted", null);

__decorate([action.bound], RegistrationModel.prototype, "onChangeLastName", null);

__decorate([computed], RegistrationModel.prototype, "asJson", null);

__decorate([computed], RegistrationModel.prototype, "registerSucceed", null);

__decorate([computed], RegistrationModel.prototype, "errorEmail", null);

__decorate([computed], RegistrationModel.prototype, "errorPassword", null);

__decorate([computed], RegistrationModel.prototype, "errorFirstName", null);

__decorate([computed], RegistrationModel.prototype, "errorLastName", null);

__decorate([computed], RegistrationModel.prototype, "isValid", null);

var RequestFormModel = /*#__PURE__*/function () {
  function RequestFormModel(id) {
    this.formModel = new FormModel(this.id);
    this.tabExecutor = '';
    this.id = id;
    this.formModel = new FormModel(this.id);
  }

  var _proto = RequestFormModel.prototype;

  _proto.load = function load(dto) {
    this.formModel.load(dto.formInfo);
    this.tabExecutor = dto.tabExecutor;
  };

  return RequestFormModel;
}();

__decorate([observable], RequestFormModel.prototype, "id", void 0);

__decorate([observable], RequestFormModel.prototype, "formModel", void 0);

__decorate([observable], RequestFormModel.prototype, "tabExecutor", void 0);

__decorate([action.bound], RequestFormModel.prototype, "load", null);

var bannedSymbols = /[\/\\:*?<>|]/g;

var RequestFormSettingModel = /*#__PURE__*/function () {
  function RequestFormSettingModel(id, campaignsStore, intl) {
    this.title = '';
    this.identifier = '';
    this.formCode = '';
    this.fileSize = '';
    this.executorId = '';
    this.permissions = [];
    this.permission = {
      code: '',
      title: ''
    };
    this.states = [];
    this.editPermission = false;
    this.formCodeList = [];
    this.statesList = [];
    this.permissionsList = [];
    this.executorsList = [];
    this.formValidationStarted = false;
    this.accessPermissionsValidationStarted = false;
    this.id = id;
    this.campaignsStore = campaignsStore;
    this.intl = intl;
  }

  var _proto = RequestFormSettingModel.prototype;

  _proto.load = function load(dto) {
    this.title = dto.title;
    this.identifier = dto.identifier;
    this.formCode = dto.formCode;
    this.fileSize = dto.fileSize && dto.fileSize.toString() || '';
    this.permissions = dto.permissions;
    this.executorId = dto.executorId || '';
  };

  _proto.loadData = function loadData(rfId) {
    try {
      var _this2 = this;

      return Promise.resolve(_this2.campaignsStore.loadFormCode()).then(function (formCodeList) {
        return Promise.resolve(_this2.campaignsStore.loadPermissions()).then(function (_this$campaignsStore$) {
          _this2.permissionsList = _this$campaignsStore$;
          return Promise.resolve(_this2.campaignsStore.loadExecutors()).then(function (_this$campaignsStore$2) {
            _this2.executorsList = _this$campaignsStore$2;
            _this2.formCodeList = codeTitleToIdTitle(formCodeList);
            return Promise.resolve(_this2.campaignsStore.loadStates(rfId)).then(function (_this$campaignsStore$3) {
              _this2.statesList = _this$campaignsStore$3;
            });
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.addAccessPermission = function addAccessPermission() {
    this.accessPermissionsValidationStarted = true;

    if (!this.isAccessPermissionsValid) {
      return;
    }

    this.permissions.push({
      permission: this.permission,
      states: this.states,
      edit: this.editPermission
    });
    this.permission = {
      code: '',
      title: ''
    };
    this.states = [];
    this.editPermission = false;
    this.accessPermissionsValidationStarted = false;
  };

  _proto.deleteAccessPermission = function deleteAccessPermission(index) {
    this.permissions.splice(index, 1);
  };

  _proto.handleUpdatePermission = function handleUpdatePermission(index, updatedPermission) {
    this.permissions[index] = updatedPermission;
  };

  _proto.onChangeTitle = function onChangeTitle(e) {
    var _e$target$value;

    this.title = (_e$target$value = e.target.value) != null ? _e$target$value : '';
  };

  _proto.onChangeIdentifier = function onChangeIdentifier(e) {
    var _e$target$value2;

    this.identifier = (_e$target$value2 = e.target.value) != null ? _e$target$value2 : '';
  };

  _proto.onChangeFileSize = function onChangeFileSize(e) {
    var _e$target$value3;

    this.fileSize = (_e$target$value3 = e.target.value) != null ? _e$target$value3 : '';
  };

  _proto.onChangeExecutor = function onChangeExecutor(e, value) {
    this.executorId = value != null ? value : '';
  };

  _proto.onChangeFormCode = function onChangeFormCode(e, value) {
    this.formCode = value != null ? value : '';
  };

  _proto.onChangePermission = function onChangePermission(e, value) {
    this.permission = value != null ? value : {
      code: '',
      title: ''
    };
  };

  _proto.onChangeStates = function onChangeStates(e, value) {
    this.states = value != null ? value : [];
  };

  _proto.onChangeEditPermission = function onChangeEditPermission() {
    this.editPermission = !this.editPermission;
  };

  _createClass(RequestFormSettingModel, [{
    key: "requestFormTabSettingsData",
    get: function get() {
      var title = this.title,
          identifier = this.identifier,
          formCode = this.formCode,
          executorId = this.executorId,
          fileSize = this.fileSize,
          permissions = this.permissions;
      var data = {
        title: title,
        identifier: identifier,
        formCode: formCode,
        permissions: permissions
      };

      if (!!executorId) {
        data.executorId = executorId;
      }

      if (!!fileSize) {
        data.fileSize = +fileSize;
      }

      return data;
    }
  }, {
    key: "requiredMessage",
    get: function get() {
      return this.intl.formatMessage('validation.required');
    }
  }, {
    key: "isValid",
    get: function get() {
      var title = this.title,
          fileSize = this.fileSize,
          identifier = this.identifier,
          formCode = this.formCode;
      return !!title && !identifier.match(bannedSymbols) && !!identifier && !!formCode && (!fileSize || !isNaN(+fileSize)) && !!this.permissions.length;
    }
  }, {
    key: "titleMessage",
    get: function get() {
      var formValidationStarted = this.formValidationStarted,
          title = this.title,
          requiredMessage = this.requiredMessage;

      if (formValidationStarted && !title) {
        return requiredMessage;
      }

      return '';
    }
  }, {
    key: "identifierMessage",
    get: function get() {
      var formValidationStarted = this.formValidationStarted,
          identifier = this.identifier,
          requiredMessage = this.requiredMessage,
          intl = this.intl;

      if (formValidationStarted && !identifier) {
        return requiredMessage;
      }

      if (formValidationStarted && !!identifier.match(bannedSymbols)) {
        return intl.formatMessage('validation.bannedSymbols', {
          symbols: '/ \\ : * ? < > |'
        });
      }

      return '';
    }
  }, {
    key: "formCodeMessage",
    get: function get() {
      var formValidationStarted = this.formValidationStarted,
          formCode = this.formCode,
          requiredMessage = this.requiredMessage;

      if (formValidationStarted && !formCode) {
        return requiredMessage;
      }

      return '';
    }
  }, {
    key: "fileSizeMessage",
    get: function get() {
      var formValidationStarted = this.formValidationStarted,
          fileSize = this.fileSize,
          requiredMessage = this.requiredMessage;

      if (formValidationStarted && fileSize && isNaN(+fileSize)) {
        return requiredMessage;
      }

      return '';
    }
  }, {
    key: "isAccessPermissionsValid",
    get: function get() {
      return !!this.permission.code;
    }
  }, {
    key: "permissionMessage",
    get: function get() {
      var accessPermissionsValidationStarted = this.accessPermissionsValidationStarted,
          formValidationStarted = this.formValidationStarted,
          permission = this.permission,
          requiredMessage = this.requiredMessage;

      if (accessPermissionsValidationStarted && !permission.code) {
        return requiredMessage;
      }

      if (formValidationStarted && !permission.code && !this.permissions.length) {
        return requiredMessage;
      }

      return '';
    }
  }]);

  return RequestFormSettingModel;
}();

__decorate([observable], RequestFormSettingModel.prototype, "campaignsStore", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "intl", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "id", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "title", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "identifier", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "formCode", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "fileSize", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "executorId", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "permissions", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "permission", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "states", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "editPermission", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "formCodeList", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "statesList", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "permissionsList", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "executorsList", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "formValidationStarted", void 0);

__decorate([observable], RequestFormSettingModel.prototype, "accessPermissionsValidationStarted", void 0);

__decorate([computed], RequestFormSettingModel.prototype, "requestFormTabSettingsData", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "load", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "loadData", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "addAccessPermission", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "deleteAccessPermission", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "handleUpdatePermission", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangeTitle", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangeIdentifier", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangeFileSize", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangeExecutor", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangeFormCode", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangePermission", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangeStates", null);

__decorate([action.bound], RequestFormSettingModel.prototype, "onChangeEditPermission", null);

__decorate([computed], RequestFormSettingModel.prototype, "requiredMessage", null);

__decorate([computed], RequestFormSettingModel.prototype, "isValid", null);

__decorate([computed], RequestFormSettingModel.prototype, "titleMessage", null);

__decorate([computed], RequestFormSettingModel.prototype, "identifierMessage", null);

__decorate([computed], RequestFormSettingModel.prototype, "formCodeMessage", null);

__decorate([computed], RequestFormSettingModel.prototype, "fileSizeMessage", null);

__decorate([computed], RequestFormSettingModel.prototype, "isAccessPermissionsValid", null);

__decorate([computed], RequestFormSettingModel.prototype, "permissionMessage", null);

var RequestModel = /*#__PURE__*/function () {
  function RequestModel(id, rootStore) {
    var _this = this;

    this.number = '';
    this.regFormTitle = '';
    this.campaign = {
      id: '',
      title: ''
    };
    this.state = '';
    this.formsTabs = [];
    this.firstTabName = '';
    this.executors = [];
    this.firstFormId = '';
    this.isFormReady = false;
    this.formErrors = [];
    this.deadlines = {};
    this.showValidation = false;
    this.formName = 'request';

    this.saveRequestForm = function (formId) {
      var formApi = _this.formApi,
          id = _this.id,
          requestStore = _this.requestStore,
          goToRequestPage = _this.goToRequestPage;
      return function () {
        if (formApi && formId) {
          return formApi.submit(false).then(function () {
            return requestStore.saveRequestForm(formId, formApi.getSubmission());
          }).then(function () {
            goToRequestPage(generatePath(clientRoute.requestForm, {
              id: id,
              formId: formId
            }));
          }).catch(function (error) {
            _this.notificationStore.onError(error.response.data);

            formApi.setSubmissionFromStartSubmission();
          });
        }

        return Promise.reject();
      };
    };

    this.formioSidebarStore = rootStore.formioSidebarStore;
    this.requestStore = rootStore.requestStore;
    this.history = rootStore.history;
    this.notificationStore = rootStore.notificationStore;
    this.id = id;
    this.intlStore = rootStore.intlStore;
    this.formioSignatureStore = rootStore.formioSignatureStore;
  }

  var _proto = RequestModel.prototype;

  _proto.resetFirstFormId = function resetFirstFormId() {
    this.firstFormId = '';
  };

  _proto.load = function load(dto) {
    var firstTab = dto.customTabs[0];
    this.regFormTitle = dto.regFormTitle;
    this.campaign = dto.campaign;
    this.number = dto.number;
    this.state = dto.state;
    this.formsTabs = dto.customTabs;
    this.executors = dto.executors;
    this.firstFormId = firstTab && firstTab.id;
    this.loadDeadlines();
  };

  _proto.onFormChange = function onFormChange(form) {
    var _this2 = this;

    this.onFormChangeTimeOut = window.setTimeout(function () {
      _this2.formioSidebarStore.updateItemsVisibility(_this2.formName, form);
    }, 100);
  };

  _proto.saveForFormioCryptoButton = function saveForFormioCryptoButton(formId) {
    var _this3 = this;

    return function () {
      var formApi = _this3.formApi,
          requestStore = _this3.requestStore;

      if (formApi && formId) {
        formApi.submit(false).then(function () {
          return requestStore.saveRequestForm(formId, formApi.getSubmission());
        }).catch(function (error) {
          _this3.notificationStore.onError(error.response.data);
        });
      }
    };
  };

  _proto.onFormReady = function onFormReady(formId) {
    var _this4 = this;

    return function (form) {
      _this4.formApi = form;
      _this4.isFormReady = true;

      _this4.formioSignatureStore.setOnSuccessForFormioInstance(_this4.saveForFormioCryptoButton(formId));

      _this4.onFormReadyTimeOut = window.setTimeout(function () {
        _this4.validateAfterReadonly();

        _this4.formioSidebarStore.initSidebarItems(_this4.formName, form.form);
      }, 80);
    };
  };

  _proto.updateCurrentTab = function updateCurrentTab() {
    var _this$currentTab;

    if (!this.currentTab) {
      return;
    }

    var tab = this.requestStore.getRequestFormModel((_this$currentTab = this.currentTab) === null || _this$currentTab === void 0 ? void 0 : _this$currentTab.id);
    this.currentTab.tabExecutor = tab.tabExecutor;
  };

  _proto.setCurrentTab = function setCurrentTab(formId) {
    var _this5 = this;

    this.requestStore.getRequestFormModel(formId).then(function (model) {
      _this5.currentTab = model;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this5.history.push(generatePath(clientRoute.request, {
          id: _this5.id
        }));
      },
      404: function _() {
        return _this5.history.push(clientRoute.notFound);
      }
    }));
  };

  _proto.updateExecutors = function updateExecutors() {
    var _this6 = this;

    this.requestStore.getRequestDTO(this.id).then(function (data) {
      _this6.executors = data.executors;
      _this6.formsTabs = data.customTabs;

      _this6.updateCurrentTab();
    });
  };

  _proto.validateEditPage = function validateEditPage(onSuccess) {
    var _this7 = this;

    if (this.formApi) {
      return this.formApi.submit(true).finally(function () {
        if (!_this7.formErrors.length) {
          _this7.formioSidebarStore.updateSidebarErrors(_this7.formName);

          return onSuccess ? onSuccess() : Promise.resolve();
        }

        _this7.formioSidebarStore.updateSidebarErrors(_this7.formName, _this7.formErrors);

        console.log('validation errors:', _this7.formErrors);
        return Promise.reject(_this7.formErrors);
      });
    } else {
      return Promise.reject(['formApi is undefined']);
    }
  };

  _proto.validateAfterReadonly = function validateAfterReadonly() {
    var _this8 = this;

    if (this.showValidation) {
      this.validateEditPage().finally(function () {
        _this8.showValidation = false;
        _this8.formErrors = [];
      });
    }
  };

  _proto.validateReadonlyPage = function validateReadonlyPage$1(onSuccess, withoutSignatureValidate) {
    var _this9 = this;

    var setShowValidation = function setShowValidation(isShowValidation) {
      _this9.showValidation = isShowValidation;
    };

    var setFormErrors = function setFormErrors(errors) {
      _this9.formErrors = errors;
    };

    return validateReadonlyPage({
      setFormErrors: setFormErrors,
      setShowValidation: setShowValidation,
      onSuccess: onSuccess,
      formApi: this.formApi,
      formioSidebarStore: this.formioSidebarStore,
      formName: this.formName,
      withoutSignatureValidate: withoutSignatureValidate
    });
  };

  _proto.goToRequestPage = function goToRequestPage(path) {
    var redirectPath = path || generatePath(clientRoute.request, {
      id: this.id
    });
    this.isFormReady = false;
    this.history.push({
      pathname: redirectPath,
      search: '?prompt=false'
    });
  };

  _proto.deleteRequest = function deleteRequest() {
    var _this10 = this;

    var id = this.id,
        requestStore = this.requestStore,
        campaign = this.campaign,
        history = this.history;
    return requestStore.deleteRequest(id).then(function () {
      _this10.isFormReady = false;
      history.push(generatePath(clientRoute.campaign, {
        id: campaign.id
      }));
    });
  };

  _proto.transitionLifeCycle = function transitionLifeCycle(transitionId, requestId) {
    return this.requestStore.transitionToNextLifeCycleStep(transitionId, requestId);
  };

  _proto.goToRequestEditPageAndValidate = function goToRequestEditPageAndValidate(path) {
    var _this11 = this;

    return function () {
      _this11.isFormReady = false;

      _this11.history.push(path);
    };
  };

  _proto.loadDeadlines = function loadDeadlines() {
    var _this12 = this;

    this.requestStore.getDeadlinesDTO(this.id).then(function (deadlinesDTO) {
      var _deadlinesDTO$entityD, _deadlinesDTO$stateDe;

      var entityDeadlineDate = (_deadlinesDTO$entityD = deadlinesDTO.entityDeadline) === null || _deadlinesDTO$entityD === void 0 ? void 0 : _deadlinesDTO$entityD.date;
      var stateDeadlineDate = (_deadlinesDTO$stateDe = deadlinesDTO.stateDeadline) === null || _deadlinesDTO$stateDe === void 0 ? void 0 : _deadlinesDTO$stateDe.date;

      if (entityDeadlineDate) {
        deadlinesDTO.entityDeadline.date = new Date(entityDeadlineDate);
      }

      if (stateDeadlineDate) {
        deadlinesDTO.stateDeadline.date = new Date(stateDeadlineDate);
      }

      _this12.deadlines = deadlinesDTO;
    });
  };

  _createClass(RequestModel, [{
    key: "executorsList",
    get: function get() {
      if (!this.executors) {
        return '';
      }

      var executorsList = this.executors.map(function (executor) {
        return executor.person.lastName + " " + executor.person.firstName + " " + (executor.person.middleName || '');
      });
      return executorsList.join(', ');
    }
  }, {
    key: "locale",
    get: function get() {
      return this.intlStore.locale;
    }
  }]);

  return RequestModel;
}();

__decorate([observable], RequestModel.prototype, "formioSidebarStore", void 0);

__decorate([observable], RequestModel.prototype, "requestStore", void 0);

__decorate([observable], RequestModel.prototype, "history", void 0);

__decorate([observable], RequestModel.prototype, "notificationStore", void 0);

__decorate([observable], RequestModel.prototype, "intlStore", void 0);

__decorate([observable], RequestModel.prototype, "formioSignatureStore", void 0);

__decorate([observable], RequestModel.prototype, "id", void 0);

__decorate([observable], RequestModel.prototype, "number", void 0);

__decorate([observable], RequestModel.prototype, "regFormTitle", void 0);

__decorate([observable], RequestModel.prototype, "campaign", void 0);

__decorate([observable], RequestModel.prototype, "state", void 0);

__decorate([observable], RequestModel.prototype, "formsTabs", void 0);

__decorate([observable], RequestModel.prototype, "firstTabName", void 0);

__decorate([observable], RequestModel.prototype, "executors", void 0);

__decorate([observable], RequestModel.prototype, "firstFormId", void 0);

__decorate([observable], RequestModel.prototype, "currentTab", void 0);

__decorate([observable], RequestModel.prototype, "formApi", void 0);

__decorate([observable], RequestModel.prototype, "isFormReady", void 0);

__decorate([observable], RequestModel.prototype, "formErrors", void 0);

__decorate([observable], RequestModel.prototype, "deadlines", void 0);

__decorate([observable], RequestModel.prototype, "showValidation", void 0);

__decorate([observable], RequestModel.prototype, "onFormChangeTimeOut", void 0);

__decorate([observable], RequestModel.prototype, "onFormReadyTimeOut", void 0);

__decorate([computed], RequestModel.prototype, "executorsList", null);

__decorate([action.bound], RequestModel.prototype, "resetFirstFormId", null);

__decorate([action.bound], RequestModel.prototype, "load", null);

__decorate([action.bound], RequestModel.prototype, "onFormChange", null);

__decorate([computed], RequestModel.prototype, "locale", null);

__decorate([action.bound], RequestModel.prototype, "saveForFormioCryptoButton", null);

__decorate([action.bound], RequestModel.prototype, "onFormReady", null);

__decorate([action.bound], RequestModel.prototype, "updateCurrentTab", null);

__decorate([action.bound], RequestModel.prototype, "setCurrentTab", null);

__decorate([action.bound], RequestModel.prototype, "updateExecutors", null);

__decorate([action.bound], RequestModel.prototype, "validateEditPage", null);

__decorate([action.bound], RequestModel.prototype, "validateAfterReadonly", null);

__decorate([action.bound], RequestModel.prototype, "validateReadonlyPage", null);

__decorate([action.bound], RequestModel.prototype, "goToRequestPage", null);

__decorate([action.bound], RequestModel.prototype, "deleteRequest", null);

__decorate([action.bound], RequestModel.prototype, "transitionLifeCycle", null);

__decorate([action.bound], RequestModel.prototype, "goToRequestEditPageAndValidate", null);

__decorate([action.bound], RequestModel.prototype, "loadDeadlines", null);

const useCampaignRequestPageStylesInj = makeStyles(theme => {
  const sidebarWidth = (theme === null || theme === void 0 ? void 0 : theme.variables.sidebar.widthXl) || 0;
  const collapseIconWidth = theme.variables.sidebar.collapseIconWidth;
  const gridItemPadding = theme ? theme.spacing(5) * 2 : 0;
  const formWidth = `calc(100% - ${sidebarWidth + gridItemPadding}px)`;
  return createStyles$1({
    wrapper: {
      flexGrow: 1,
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.variables.palette.mainContrastDarker,
      overflow: 'hidden'
    },
    container: {
      margin: '0 auto',
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    containerLg: {
      maxWidth: theme.breakpoints.width('lg')
    },
    containerFullWidth: {
      maxWidth: '100%'
    },
    sidebarGridWrapper: {
      paddingTop: `${theme.variables.requestPanel.tabsHeight}px !important`
    },
    form: {
      width: formWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    fullWidthForm: {
      width: `calc(100% - ${collapseIconWidth + gridItemPadding}px)`,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    approvalContainer: {
      width: '100%'
    },
    approvalBoxContainer: {
      width: '100%',
      boxSizing: 'border-box'
    },
    approvalBox: {
      width: '100%',
      paddingBottom: 0,
      marginBottom: theme.spacing(5)
    }
  });
});
const CampaignRequestPage = observer$1(() => {
  const [CampaignRequestRoutes$1] = di([CampaignRequestRoutes], CampaignRequestPage);
  const [PageContentContainer$1] = di([PageContentContainer], CampaignRequestPage);
  const [RouteLeavingGuard$1] = di([RouteLeavingGuard], CampaignRequestPage);
  const [RequestHeader$1] = di([RequestHeader], CampaignRequestPage);
  const [Sidebar$1] = di([Sidebar], CampaignRequestPage);
  const [validationErrorLink$1] = di([validationErrorLink], CampaignRequestPage);
  const [CampaignRequestTabs$1] = di([CampaignRequestTabs], CampaignRequestPage);
  const [RequestControlPanel$1] = di([RequestControlPanel], CampaignRequestPage);
  const [ExecutorEditDialog$1] = di([ExecutorEditDialog], CampaignRequestPage);
  const [useCampaignRequestPageStyles] = di([useCampaignRequestPageStylesInj], CampaignRequestPage);
  const [RequestModel$1] = di([RequestModel], CampaignRequestPage);
  const {
    id
  } = useParams();
  const classes = useCampaignRequestPageStyles();
  const [reloadKey, reloadIncrement] = useReload();
  const [formIsChanged, setFormIsChanged] = useState(false);
  const [open, setModalIsOpen, setModalIsClosed] = useModal();
  const [sidebarOpen, setSidebarOpen] = React__default.useState(true);
  const rootStore = useStore();
  const {
    intlStore,
    history,
    requestStore,
    formioSidebarStore,
    approvalStore
  } = rootStore;
  const {
    locale
  } = intlStore;
  const [requestModel, setRequestModel] = useState(() => new RequestModel$1(id, rootStore));
  const {
    items
  } = formioSidebarStore;
  const sidebarItems = items[requestModel.formName];
  const [editExecutorDialogTitle, setEditExecutorDialogTitle] = useState();
  const location = useLocation();
  const pathList = location.pathname.split('/');
  const isApprovalPage = pathList[pathList.length - 1] === 'approval';
  const isFullWidth = !sidebarOpen || isApprovalPage;
  const tabsActions = useMemo(() => {
    return React__default.createRef();
  }, []);
  useEffect(() => {
    setFormIsChanged(false);
  }, [locale]);
  useEffect(() => {
    const newRequestModel = new RequestModel$1(id, rootStore);
    requestStore.getRequestDTO(id).then(newRequestModel.load).then(() => {
      if (!newRequestModel.formsTabs.length && !approvalStore.hasApprovalTab) {
        history.replace(clientRoute.notAllowed);
      }
    });
    setRequestModel(newRequestModel);
  }, [requestStore, id, setRequestModel, rootStore, approvalStore, history]);
  const reloadModel = useCallback(() => {
    const newRequestModel = new RequestModel$1(id, rootStore);
    requestStore.getRequestDTO(id).then(newRequestModel.load);
    newRequestModel.updateCurrentTab();
    setRequestModel(newRequestModel);
    reloadIncrement();
  }, [requestStore, id, reloadIncrement, rootStore]);
  const reloadModelForModuleTab = useCallback(() => {
    requestStore.getRequestDTO(id).then(requestModel.load);
  }, [requestStore, id, requestModel]);
  const errorMessage = useMemo(() => {
    return React__default.createElement(FormattedMessage, {
      id: "campaignRequest.readonlyRequestValidationMsg",
      values: {
        a: validationErrorLink$1(id)
      }
    });
  }, [validationErrorLink$1, id]);

  const shouldBlockNavigation = location => {
    return formIsChanged && !location.search.includes('prompt=false');
  };

  const leaveMessage = React__default.createElement(React__default.Fragment, null, React__default.createElement("p", null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.dialog.leaveMessage"
  })), React__default.createElement("p", null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.dialog.tooltipMessage"
  })));

  const toggleSidebar = () => {
    setSidebarOpen(open => !open);
    setTimeout(() => {
      var _tabsActions$current;

      return (_tabsActions$current = tabsActions.current) === null || _tabsActions$current === void 0 ? void 0 : _tabsActions$current.updateScrollButtons();
    }, 200);
  };

  const handleEditExecutorDialogOpen = useCallback(title => {
    setModalIsOpen();
    title && setEditExecutorDialogTitle(title);
  }, [setModalIsOpen, setEditExecutorDialogTitle]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(RouteLeavingGuard$1, {
    key: location.pathname,
    when: formIsChanged,
    navigate: path => history.push(path),
    title: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.dialog.title"
    }),
    message: leaveMessage,
    shouldBlockNavigation: shouldBlockNavigation
  }), React__default.createElement(ExecutorEditDialog$1, {
    title: editExecutorDialogTitle,
    onClose: setModalIsClosed,
    open: open,
    requestModel: requestModel
  }), React__default.createElement(PageContentContainer$1, {
    container: true,
    direction: "column",
    wrap: "nowrap"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestHeader$1, {
    key: reloadKey,
    reloadIncrement: reloadIncrement,
    requestModel: requestModel,
    onModalOpen: handleEditExecutorDialogOpen
  })), React__default.createElement(Grid, {
    item: true,
    className: classNames(classes.wrapper, {
      [classes.approvalContainer]: isApprovalPage
    })
  }, React__default.createElement(Box, {
    pt: 10,
    pl: 5,
    pr: 5,
    className: classNames(classes.container, {
      [classes.containerLg]: sidebarOpen,
      [classes.containerFullWidth]: isFullWidth,
      [classes.approvalBoxContainer]: isApprovalPage
    })
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 7,
    wrap: "nowrap",
    className: classNames({
      [classes.approvalContainer]: isApprovalPage
    })
  }, React__default.createElement(Grid, {
    item: true,
    className: classNames({
      [classes.form]: sidebarOpen,
      [classes.fullWidthForm]: isFullWidth,
      [classes.approvalContainer]: isApprovalPage
    })
  }, React__default.createElement(Box, {
    pb: 9,
    className: classNames({
      [classes.approvalBox]: isApprovalPage
    })
  }, React__default.createElement(Box, {
    pb: 5
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, React__default.createElement(CampaignRequestTabs$1, {
    model: requestModel,
    tabsActions: tabsActions
  })))), React__default.createElement(Box, {
    width: "100%"
  }, React__default.createElement(CampaignRequestRoutes$1, {
    key: reloadKey + id + requestModel.firstFormId,
    locale: locale,
    requestModel: requestModel,
    setFormIsChanged: setFormIsChanged,
    requestNumber: requestModel.number,
    reloadModelForModuleTab: reloadModelForModuleTab
  })))), React__default.createElement(Route, {
    path: [clientRoute.requestForm, clientRoute.requestFormEdit]
  }, React__default.createElement(Grid, {
    item: true,
    className: classes.sidebarGridWrapper
  }, React__default.createElement(Sidebar$1, {
    open: sidebarOpen,
    toggleSidebar: toggleSidebar,
    sidebarItems: sidebarItems
  })))))), !isApprovalPage && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestControlPanel$1, {
    model: requestModel,
    key: reloadKey + id + requestModel.firstFormId,
    reloadModel: reloadModel,
    errorMessage: errorMessage,
    formIsChanged: formIsChanged
  }))));
});

const CardLabel = withTheme$1(({
  theme,
  children
}) => {
  return React__default.createElement(Box, {
    color: theme === null || theme === void 0 ? void 0 : theme.variables.palette.main
  }, React__default.createElement(Typography, {
    variant: "body1",
    component: "span"
  }, children));
});
const CardValue = ({
  children
}) => {
  return React__default.createElement(Typography, {
    variant: "body2",
    component: "span"
  }, children);
};
const CardTitle = styled(Typography)`
    font-size: 15px;
    line-height: 22px;
    font-weight: bold;
    word-break: break-word;
`;

var _path$8;

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

function SvgDoneOutlinedIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-18c-4.419 0-8 3.582-8 8a8 8 0 1016 0 8 8 0 00-8-8zm-.87 11.21a1 1 0 01-1.41 0l-2.351-2.36A1.001 1.001 0 116.78 9.44l1.65 1.65 4.29-4.3a1 1 0 111.41 1.42l-5 5z"
  })));
}

const RegFormCard = observer$1(props => {
  const {
    titleRegForm,
    description,
    registrationStartDate,
    registrationEndDate,
    afterDeadline,
    fileInstructions,
    onDownloadFile,
    onCreate,
    index
  } = props;
  const [EllipsisBox$1] = di([EllipsisBox], RegFormCard);
  const [CardLabel$1] = di([CardLabel], RegFormCard);
  const [CardTitle$1] = di([CardTitle], RegFormCard);
  const [CardValue$1] = di([CardValue], RegFormCard);
  const [FileListComponent$1] = di([FileListComponent], RegFormCard);
  const theme = useTheme$1();
  const [isSending, endIcon, createHandler] = useAntiDoubleClick(onCreate);
  const backgroundColor = useMemo(() => {
    return index % 2 === 0 ? {
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.variables.palette.hoverInLists
    } : {};
  }, [index, theme]);
  const files = useMemo(() => {
    return fileInstructions.map(i => {
      const {
        id,
        ...dto
      } = i;
      return {
        fileId: id,
        ...dto
      };
    });
  }, [fileInstructions]);
  return React__default.createElement(Grid, {
    container: true,
    alignItems: "flex-start",
    style: backgroundColor
  }, React__default.createElement(Grid, {
    item: true,
    xs: 2
  }, React__default.createElement(Box, {
    pt: 10,
    pl: 10,
    pr: 5
  }, React__default.createElement(CardTitle$1, {
    variant: "h2"
  }, React__default.createElement(EllipsisBox$1, {
    text: titleRegForm
  })))), React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, React__default.createElement(Box, {
    pt: 10,
    pb: 10
  }, React__default.createElement(Box, {
    pb: 6
  }, React__default.createElement(CardValue$1, null, getOrElse(description))), React__default.createElement(Grid, {
    container: true,
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CardLabel$1, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.regFormCard.registrationStartDate"
  })), React__default.createElement(CardValue$1, null, getOrElse(registrationStartDate, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormattedDate, {
    value: registrationStartDate
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormattedTime, {
    value: registrationStartDate
  }))), '-'))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CardLabel$1, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.regFormCard.registrationEndDate"
  })), React__default.createElement(CardValue$1, null, getOrElse(registrationEndDate, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormattedDate, {
    value: registrationEndDate
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormattedTime, {
    value: registrationEndDate
  }))), '-'))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CardLabel$1, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.regFormCard.afterDeadline"
  })), React__default.createElement(CardValue$1, null, getOrElse(afterDeadline, React__default.createElement(FormattedMessage, {
    id: "common.yes"
  }), React__default.createElement(FormattedMessage, {
    id: "common.no"
  }))))), React__default.createElement(Box, {
    pt: 6
  }, React__default.createElement(CardLabel$1, null, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.regFormCard.instruction"
  })), React__default.createElement(FileListComponent$1, {
    files: files,
    downloadFile: onDownloadFile,
    noDataText: React__default.createElement(CardValue$1, null, React__default.createElement(FormattedMessage, {
      id: "common.noData"
    }))
  })))), React__default.createElement(Grid, {
    item: true,
    xs: 2,
    container: true,
    justify: "flex-end"
  }, React__default.createElement(Box, {
    pt: 6,
    pr: 6
  }, React__default.createElement(Button, {
    variant: "text",
    color: "primary",
    startIcon: React__default.createElement(SvgDoneOutlinedIcon, null),
    onClick: createHandler,
    disabled: isSending,
    endIcon: endIcon
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.createRequest"
  })))));
});

const RegFormSelect = observer$1(props => {
  const {
    regFormListModel,
    createRequest
  } = props;
  const [RegFormCard$1] = di([RegFormCard], RegFormSelect);
  const [BreadcrumbsComponent$1] = di([BreadcrumbsComponent], RegFormSelect);
  const {
    campaignsStore,
    breadcrumbsStore
  } = useStore();
  const {
    campaignId
  } = useParams();
  const {
    breadCrumbsSettings
  } = breadcrumbsStore;

  const renderRegFormItems = () => {
    return regFormListModel.regFormsData.map((regForm, index) => {
      return React__default.createElement(RegFormCard$1, {
        key: regForm.id,
        index: index,
        afterDeadline: regForm.allowAfterDeadline,
        description: regForm.procedureTitle,
        registrationEndDate: regForm.regEnd,
        registrationStartDate: regForm.regStart,
        titleRegForm: regForm.title,
        fileInstructions: regForm.fileInstruction,
        onCreate: createRequest(regForm.id),
        onDownloadFile: campaignsStore.downloadRegFormFile
      });
    });
  };

  const regFormsCount = regFormListModel.regFormsData.length;
  return React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 5.5,
    pb: 5.5
  }, React__default.createElement(Box, {
    pb: 5
  }, React__default.createElement(BreadcrumbsComponent$1, {
    breadcrumbsSettings: breadCrumbsSettings,
    objectId: campaignId
  })), React__default.createElement(Box, {
    pb: 7,
    width: "100%"
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "campaignRequest.regFormsPageTitle"
  }))), !regFormsCount ? React__default.createElement(Box, {
    pt: 5
  }, React__default.createElement(Typography, {
    variant: "body2"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.noRegForms"
  }))) : React__default.createElement(Box, null, renderRegFormItems())));
});

const RegFormSelectPage = observer$1(() => {
  const [RegFormSelect$1] = di([RegFormSelect], RegFormSelectPage);
  const {
    requestStore,
    api,
    notificationStore
  } = useStore();
  const {
    campaignId
  } = useParams();
  const [regFormListModel, setRegFormListModel] = useState();
  const history = useHistory();
  useEffect(() => {
    const model = new RegFormListModel(api, campaignId);
    setRegFormListModel(model);
  }, [api, campaignId]);

  const createRequest = regFormId => {
    return () => {
      return requestStore.createRequest(regFormId).then(id => {
        history.push(generatePath(clientRoute.requestEdit, {
          campaignId,
          regFormId,
          id
        }));
      }).catch(error => {
        notificationStore.onError(error.response.data);
      });
    };
  };

  if (!regFormListModel) {
    return React__default.createElement(React__default.Fragment, null);
  }

  return React__default.createElement(RegFormSelect$1, {
    regFormListModel: regFormListModel,
    createRequest: createRequest
  });
});

var Authentication = observer$1(function (props) {
  var children = props.children,
      _props$redirectUrl = props.redirectUrl,
      redirectUrl = _props$redirectUrl === void 0 ? clientRoute.login : _props$redirectUrl;

  var _useStore = useStore(),
      api = _useStore.api;

  var location = useLocation();
  var backUrl = location.search.indexOf('backUrl') !== -1 ? location.search : "?backUrl=" + location.pathname + location.search;
  useEffect(function () {
    api.authVerify().then(function (r) {
      return r;
    });
  }, [api]);

  var renderComponent = function renderComponent(status) {
    switch (status) {
      case 'ok':
        return children;

      case 'unauthorized':
        return React__default.createElement(Redirect, {
          to: {
            pathname: redirectUrl,
            search: backUrl
          }
        });

      default:
        return React__default.createElement(Backdrop, {
          open: true
        }, React__default.createElement(CircularProgress, null));
    }
  };

  return renderComponent(api.authStatus);
});

var CampaignRequestPages = function CampaignRequestPages() {
  var _di = di([CampaignRequestListPageNew], CampaignRequestPages),
      CampaignRequestListPageNew$1 = _di[0];

  var _di2 = di([CampaignRequestPage], CampaignRequestPages),
      CampaignRequestPage$1 = _di2[0];

  var _di3 = di([CampaignRequestListPage], CampaignRequestPages),
      CampaignRequestListPage$1 = _di3[0];

  var _di4 = di([Authentication], CampaignRequestPages),
      Authentication$1 = _di4[0];

  return React__default.createElement(Authentication$1, null, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.requestsNew
  }, React__default.createElement(CampaignRequestListPageNew$1, null)), React__default.createElement(Route, {
    path: clientRoute.request
  }, React__default.createElement(CampaignRequestPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.requests
  }, React__default.createElement(CampaignRequestListPage$1, null))));
};

const CampaignCreateDialog = observer$1(props => {
  const {
    onClose,
    createCampaign
  } = props;
  const [renderAutoCompleteInput$1] = di([renderAutoCompleteInput], CampaignCreateDialog);
  const [activeLifecycleList, setActiveLifecycleList] = useState([]);
  const [isLoadingActiveCampaigns, setIsLoadingActiveCampaigns] = useState(true);
  const [activeLifecycle, setActiveLifecycle] = useState('');
  const [validationStarted, setValidationStarted] = useState(false);
  const {
    campaignsStore,
    intlStore: intl
  } = useStore();
  useEffect(() => {
    campaignsStore.getLifecycleList().then(lifecycleList => {
      setIsLoadingActiveCampaigns(false);
      setActiveLifecycleList(lifecycleList);
    });
  }, [campaignsStore, setIsLoadingActiveCampaigns, setActiveLifecycleList]);
  const error = useMemo(() => {
    if (validationStarted && !activeLifecycle) {
      return intl.formatMessage('validation.required');
    }

    return '';
  }, [activeLifecycle, intl, validationStarted]);

  const onChangeLifecycle = (e, value) => {
    setValidationStarted(true);
    setActiveLifecycle(value ? value.code : '');
  };

  const onSubmit = event => {
    event.preventDefault();
    createCampaign(activeLifecycle);
  };

  return React__default.createElement(Dialog, {
    maxWidth: "xs",
    fullWidth: true,
    open: true,
    scroll: "body"
  }, React__default.createElement(Box, {
    pt: 4,
    pr: 4
  }, React__default.createElement(Grid, {
    container: true,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    onClick: onClose
  }, React__default.createElement(Close, null))))), React__default.createElement(Box, {
    pl: 12,
    pr: 12,
    pb: 12
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h5"
  }, React__default.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.newCampaign"
  }))))), React__default.createElement(Box, {
    pt: 8
  }, React__default.createElement("form", {
    noValidate: true,
    onSubmit: onSubmit
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column",
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Autocomplete, {
    onChange: onChangeLifecycle,
    getOptionSelected: (option, value) => option.code === value.code,
    getOptionLabel: option => option.title,
    options: activeLifecycleList,
    loading: isLoadingActiveCampaigns,
    renderInput: renderAutoCompleteInput$1(intl.formatMessage('campaign.lifecycle'), true, error)
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 3
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    disabled: !activeLifecycle,
    color: "primary",
    fullWidth: true,
    size: "large",
    variant: "contained",
    type: "submit"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.createCampaign"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: onClose,
    fullWidth: true,
    size: "large",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  }))))))))));
});

const CreateCampaignPage = observer$1(() => {
  const classes = useFormStyles();
  const {
    campaignsStore,
    notificationStore
  } = useStore();
  const {
    id
  } = useParams();
  const history = useHistory();
  const {
    locale
  } = useIntl();
  const [formApi, setFormApi] = useState();
  const [campaignFormModel] = useState(new FormModel(id));
  useEffect(() => {
    campaignsStore.loadCampaignForm(id).then(campaignFormModel.load);
  }, [campaignsStore, id, campaignFormModel]);

  const onFormReady = form => {
    setFormApi(form);
  };

  const onSubmit = () => {
    if (formApi && formApi.validate()) {
      formApi.submit(false).then(() => {
        return campaignsStore.saveCampaignForm(id, formApi.getSubmission());
      }).then(() => {
        history.push(generatePath(clientRoute.campaign, {
          id
        }));
      }).catch(error => {
        notificationStore.onError(error.response.data);
      });
    }
  };

  return React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 5.5,
    pb: 5.5
  }, React__default.createElement(Box, {
    pb: 5.5
  }, React__default.createElement(Typography, {
    variant: "h3"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.titleCreateCampaignPage"
  }))), React__default.createElement(Box, {
    pb: 5.5
  }, React__default.createElement(Form, {
    locale: locale,
    className: classes.formWithNoOffset,
    form: campaignFormModel,
    onFormReady: onFormReady
  })), React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true,
    style: {
      width: '40%'
    }
  }, React__default.createElement(Box, {
    pr: 5
  }, React__default.createElement(Button, {
    fullWidth: true,
    size: "large",
    color: "secondary",
    variant: "contained",
    onClick: onSubmit
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  })))), React__default.createElement(Grid, {
    item: true,
    style: {
      width: '40%'
    }
  }, React__default.createElement(Button, {
    fullWidth: true,
    size: "large",
    component: NavLink,
    variant: "text",
    to: clientRoute.campaigns,
    color: "primary"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  }))))));
});

var _path$9;

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

function SvgRequestsCount(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 22
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.999 16.189v2.81a3 3 0 01-3 3h-4a3 3 0 01-3-3v-3a4.545 4.545 0 00-1.14-2.87 8.07 8.07 0 01-1.72-6.65 8 8 0 016.27-6.32 8.003 8.003 0 016.68 1.66v-.02A8.001 8.001 0 0114.219 13a5.164 5.164 0 00-1.22 3.189zm-8 2.81a1 1 0 001 1h4a1 1 0 001-1v-1h-6v1zm6.792-15.652a5.998 5.998 0 00-5.002-1.228 5.998 5.998 0 00-3.39 9.72 6.503 6.503 0 011.6 4.16h2V13a1 1 0 112 0v2.999h2a7.117 7.117 0 011.67-4.239 5.902 5.902 0 001.33-3.761 5.998 5.998 0 00-2.208-4.652z"
  })));
}

const CardCampaignLink = withTheme$1(styled(React__default.forwardRef((props, ref) => {
  const {
    isDarkBackground,
    ...otherProps
  } = props;
  return React__default.createElement(Link$1, Object.assign({}, otherProps, {
    ref: ref
  }));
}))`
    font-size: 15px !important;
    font-weight: bold;
    text-decoration: none !important;
    color: ${({
  theme,
  isDarkBackground
}) => `${isDarkBackground ? theme.variables.palette.mainContrast : theme.variables.palette.textDark}`} !important;

    &:focus {
        outline: 1px solid ${({
  theme
}) => `${theme.variables.palette.accent}`};
    }
    &:hover {
        color: ${({
  theme,
  isDarkBackground
}) => `${isDarkBackground ? theme.variables.palette.campaignList.darkBackgroundHoverTextCard : theme.variables.palette.main}`} !important;
    }
`);
const CampaignRequestsButton = withTheme$1(styled(props => {
  const {
    requests,
    isDarkBackground,
    ...otherProps
  } = props;
  return React__default.createElement(IconButton, Object.assign({}, otherProps, {
    disabled: true
  }));
})`
    background-color: transparent !important;
    color: ${({
  theme,
  requests
}) => `${requests ? theme.variables.palette.accentDark : theme.variables.palette.mainMiddleLight}`} !important;
    &:hover {
        color: ${({
  theme,
  isDarkBackground
}) => `${isDarkBackground ? theme.variables.palette.mainContrast : theme.variables.palette.accentContrast}`} !important;
    }
`);
const NotAccentText = withTheme$1(styled(Typography)`
    font-size: 10px !important;
    text-transform: uppercase;
    font-weight: 700 !important;
    color: ${({
  theme
}) => `${theme.variables.palette.mainLight}`};
`);
const AccentText = withTheme$1(styled(Typography)`
    font-size: 13px !important;
    text-transform: uppercase;
    font-weight: 700 !important;
    color: ${({
  theme
}) => `${theme.variables.palette.red}`};
`);
const CampaignCardContent = withTheme$1(styled(props => {
  const {
    isImage,
    ...otherProps
  } = props;
  return React__default.createElement(CardContent, Object.assign({}, otherProps));
})`
    position: relative;
    padding: 0 !important;
    &:after {
      content: '';
      width: 100%;
      height: ${({
  isImage
}) => isImage ? '204px' : '0'};
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(28, 29, 31, 0.6);
    },
`);
const CampaignCardWrapper = withTheme$1(styled(props => {
  const {
    isImage,
    showCreateRequestButton,
    ...otherProps
  } = props;
  return React__default.createElement(Card, Object.assign({}, otherProps));
})`
    position: relative;
    width: 284px;
    ${({
  theme,
  isImage
}) => isImage ? '' : `background-color: ${theme === null || theme === void 0 ? void 0 : theme.variables.palette.campaignList.backgroundCard};`}
    height: ${({
  showCreateRequestButton
}) => showCreateRequestButton ? '320px' : '272px'};
`);

const TitleWrapper = props => {
  const {
    isImage,
    children
  } = props;
  const styleTitleWrapper = isImage ? {
    zIndex: 1,
    position: 'absolute',
    top: 0
  } : {
    position: 'static'
  };
  return React__default.createElement(Box, Object.assign({}, styleTitleWrapper, {
    padding: "24px",
    height: "204px",
    boxSizing: "border-box"
  }), children);
};

const CampaignCard = props => {
  const [AccentText$1] = di([AccentText], CampaignCard);
  const [CampaignCardContent$1] = di([CampaignCardContent], CampaignCard);
  const [CampaignCardWrapper$1] = di([CampaignCardWrapper], CampaignCard);
  const [CampaignRequestsButton$1] = di([CampaignRequestsButton], CampaignCard);
  const [CardCampaignLink$1] = di([CardCampaignLink], CampaignCard);
  const [NotAccentText$1] = di([NotAccentText], CampaignCard);
  const [EllipsisBox$1] = di([EllipsisBox], CampaignCard);
  const [TitleWrapper$1] = di([TitleWrapper], CampaignCard);
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignCard);
  const {
    id,
    avatarUrl,
    requestCount,
    title,
    to
  } = props.campaign;
  const theme = useTheme();
  const {
    campaignsStore
  } = useStore();
  const {
    createRequest
  } = campaignsStore;

  const createFunc = () => {
    return createRequest(id);
  };

  const [isSending, endIcon, createHandler] = useAntiDoubleClick(createFunc);
  const isCollectionCompleted = useMemo(() => {
    if (!to) {
      return false;
    }

    return isAfter(new Date(), to);
  }, [to]);
  const [showCreateRequestButton] = useFeature('showCreateRequestButton');
  const [showRequestsLamp] = useFeature('showRequestsLamp');
  const [showCampaignPeriod] = useFeature('showCampaignPeriod');
  const isImage = !!avatarUrl;
  return React__default.createElement(CampaignCardWrapper$1, {
    isImage: isImage,
    showCreateRequestButton: showCreateRequestButton
  }, React__default.createElement(CampaignCardContent$1, {
    isImage: isImage
  }, isImage && React__default.createElement(CardMedia, {
    component: "img",
    height: "204",
    image: avatarUrl,
    title: title,
    alt: title
  }), React__default.createElement(TitleWrapper$1, {
    isImage: isImage
  }, React__default.createElement(Tooltip, {
    title: title
  }, React__default.createElement(CardCampaignLink$1, {
    component: NavLink,
    to: generatePath(clientRoute.campaign, {
      id
    }),
    isDarkBackground: isImage
  }, React__default.createElement(EllipsisBox$1, {
    text: title
  }))))), React__default.createElement(CardActions, null, React__default.createElement(Grid, {
    container: true,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    pb: 3
  }, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "space-between"
  }, showCampaignPeriod && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, null, isCollectionCompleted ? React__default.createElement(AccentText$1, null, React__default.createElement(FormattedMessage, {
    id: "campaign.collectionCompleted"
  })) : React__default.createElement(React__default.Fragment, null, React__default.createElement(NotAccentText$1, null, React__default.createElement(FormattedMessage, {
    id: "campaign.campaignPeriod"
  }), "\u00A0", React__default.createElement(FormattedMessage, {
    id: "common.to"
  }), "\u00A0"), React__default.createElement(Box, {
    fontWeight: "700"
  }, React__default.createElement(FormattedDate, {
    value: to
  }))))), showRequestsLamp && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "center",
    wrap: "nowrap"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CampaignRequestsButton$1, {
    requests: requestCount
  }, React__default.createElement(SvgRequestsCount, null))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    color: theme === null || theme === void 0 ? void 0 : theme.variables.palette.campaignList.accentContrast
  }, requestCount))))))), showCreateRequestButton && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.Campaign,
    permCode: permissions.Campaign.AddCampRequest,
    entityId: id
  }, allowed => React__default.createElement(Tooltip, {
    title: !allowed && !isCollectionCompleted ? React__default.createElement(FormattedMessage, {
      id: "campaign.createRequestError"
    }) : ''
  }, React__default.createElement("div", null, React__default.createElement(Button, {
    disabled: !allowed || isSending,
    fullWidth: true,
    color: "primary",
    size: "small",
    variant: "contained",
    onClick: createHandler,
    endIcon: endIcon
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.createRequest"
  })))))))));
};

var _path$a;

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

function SvgAddIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "-2 -2 15 15"
  }, props), _path$a || (_path$a = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8.996 5.999H5.997v2.999a1 1 0 11-1.999 0V5.999H.997a1 1 0 010-2.001h3.001v-3a1 1 0 111.999 0v3h2.999a1 1 0 110 2.001z"
  })));
}

function useModal() {
  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var setModalIsOpen = function setModalIsOpen() {
    setOpen(true);
  };

  var setModalIsClosed = function setModalIsClosed() {
    setOpen(false);
  };

  return [open, setModalIsOpen, setModalIsClosed];
}

const CampaignListPage = observer$1(() => {
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignListPage);
  const [CampaignCard$1] = di([CampaignCard], CampaignListPage);
  const [BreadcrumbsComponent$1] = di([BreadcrumbsComponent], CampaignListPage);
  const [CampaignCreateDialog$1] = di([CampaignCreateDialog], CampaignListPage);
  const {
    campaignsStore,
    api,
    env,
    breadcrumbsStore
  } = useStore();
  const [campaignListModel] = useState(new CampaignListModel(api, env.apiUrl));
  const [open, setModalIsOpen, setModalIsClosed] = useModal();
  const history = useHistory();
  const pagesCount = campaignListModel.pagesCount;
  const {
    breadCrumbsSettings
  } = breadcrumbsStore;

  const createCampaign = function (lifecycleCode) {
    try {
      return Promise.resolve(campaignsStore.createCampaign(lifecycleCode)).then(function (id) {
        history.push(generatePath(clientRoute.createCampaign, {
          id
        }));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const changePage = (event, page) => {
    campaignListModel.setCurrentPage(page);
  };

  const renderCampaignList = () => {
    return campaignListModel.renderItems.map(campaign => {
      return React__default.createElement(Grid, {
        key: campaign.id,
        item: true
      }, React__default.createElement(CampaignCard$1, {
        campaign: campaign
      }));
    });
  };

  return React__default.createElement(React__default.Fragment, null, open && React__default.createElement(CampaignCreateDialog$1, {
    createCampaign: createCampaign,
    onClose: setModalIsClosed
  }), React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 5.5,
    pb: 5.5
  }, React__default.createElement(Box, {
    pb: 5
  }, React__default.createElement(BreadcrumbsComponent$1, {
    breadcrumbsSettings: breadCrumbsSettings
  })), React__default.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    pr: 6.2
  }, React__default.createElement(Typography, {
    variant: "h3"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.titleCampaignListPage"
  })))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    permCode: permissions.System.AddCampaign
  }, React__default.createElement(Button, {
    startIcon: React__default.createElement(SvgIcon, null, React__default.createElement(SvgAddIcon, null)),
    size: "small",
    variant: "text",
    color: "primary",
    onClick: setModalIsOpen
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.create"
  })))))), React__default.createElement(Box, {
    pb: 12
  }, campaignListModel.paginationData.length === 0 ? React__default.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.noCategoriesText"
  })) : React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 10
  }, renderCampaignList())), pagesCount > 1 && React__default.createElement(Box, {
    pb: 12
  }, React__default.createElement(Pagination$1, {
    count: pagesCount,
    hidePrevButton: true,
    hideNextButton: true,
    size: "large",
    color: "secondary",
    onChange: changePage
  }))));
});

var FileComponent = function FileComponent(props) {
  var file = props.file,
      onDownloadFile = props.onDownloadFile;

  var _di = di([IconLink], FileComponent),
      IconLink$1 = _di[0];

  var theme = useTheme$1();

  var _useState = useState(false),
      isLoadingFile = _useState[0],
      setIsLoadingFile = _useState[1];

  var _useState2 = useState(false),
      isCompletedLoading = _useState2[0],
      setIsCompletedLoading = _useState2[1];

  var _useState3 = useState(false),
      isError = _useState3[0],
      setIsError = _useState3[1];

  var onDownloadFileClick = function onDownloadFileClick() {
    setIsLoadingFile(true);
    setIsCompletedLoading(false);
    setIsError(false);
    onDownloadFile(file).then(function () {
      setIsCompletedLoading(true);
    }).catch(function () {
      setIsError(true);
    }).finally(function () {
      setIsLoadingFile(false);
    });
  };

  return React__default.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    pr: 4
  }, React__default.createElement(IconLink$1, {
    component: "button",
    onClick: onDownloadFileClick,
    icon: React__default.createElement(SvgFile, null),
    text: file.filename
  }))), React__default.createElement(Grid, {
    item: true
  }, isLoadingFile && React__default.createElement(CircularProgress, {
    size: 15
  }), isCompletedLoading && React__default.createElement(DoneIcon, {
    style: {
      color: theme === null || theme === void 0 ? void 0 : theme.variables.palette.green,
      fontSize: '17px'
    }
  }), isError && React__default.createElement(ErrorOutlineIcon, {
    style: {
      color: theme === null || theme === void 0 ? void 0 : theme.variables.palette.red,
      fontSize: '20px'
    }
  })));
};

var FileListComponent = observer$1(function (props) {
  var files = props.files,
      downloadFile = props.downloadFile,
      noDataText = props.noDataText;

  var _di = di([FileComponent], FileListComponent),
      FileComponent$1 = _di[0];

  return React__default.createElement(List, {
    disablePadding: true
  }, files && files.length > 0 ? files.map(function (f) {
    return React__default.createElement(ListItem, {
      key: f.fileId,
      disableGutters: true
    }, React__default.createElement(FileComponent$1, {
      file: f,
      onDownloadFile: downloadFile
    }));
  }) : noDataText);
});

var _path$b;

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

function SvgFiles(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/createElement("path", {
    d: "M14.999 18h-1v.999a3 3 0 01-3 3H2.998a3 3 0 01-2.999-3v-12a3 3 0 012.999-3h1.001v-1a3 3 0 013-3h4.059c.093.01.183.031.27.06h.091c.103.048.197.112.28.19l6 6c.077.083.142.178.189.28v.09a.865.865 0 01.11.33v8.05A3 3 0 0114.999 18zm-11-3.001v-9H2.998a1 1 0 00-1 1v12a1 1 0 001 1h8.001a1 1 0 001-1V18h-5a3 3 0 01-3-3.001zm8-11.59v1.59a1 1 0 001 1h1.59l-2.59-2.59zm4 4.59h-3a3 3 0 01-3-3v-3h-3a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1v-7z"
  })));
}

var _path$c;

function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$d.apply(this, arguments);
}

function SvgSetting(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement("path", {
    d: "M19.319 12.439l-1.89.63.89 1.78c.189.385.113.847-.19 1.15l-2.13 2.13a1 1 0 01-1.13.19l-1.78-.89-.63 1.89a1 1 0 01-.95.68h-3a.999.999 0 01-.95-.68l-.63-1.89-1.78.89a1 1 0 01-1.151-.19l-2.13-2.13a1.003 1.003 0 01-.19-1.14l.891-1.78-1.89-.63a.999.999 0 01-.68-.95v-3a1 1 0 01.68-.94l1.89-.63-.891-1.78a1.005 1.005 0 01.19-1.15l2.13-2.13a1 1 0 011.14-.19l1.781.89.63-1.89a1 1 0 01.95-.68h2.999c.428.004.804.276.941.68l.63 1.89 1.78-.89a1.002 1.002 0 011.15.19l2.13 2.13a1 1 0 01.19 1.14l-.89 1.781 1.89.629c.408.138.681.52.679.95v3a.998.998 0 01-.679.94zm-1.32-3.25l-1.2-.4a2.004 2.004 0 01-1.217-1.13 2.005 2.005 0 01.057-1.66l.6-1.11-1.1-1.1-1.14.57a1.998 1.998 0 01-2.82-1.16l-.4-1.2h-1.56l-.4 1.2a2.001 2.001 0 01-2.82 1.16l-1.11-.57-1.1 1.1.57 1.11c.269.521.296 1.136.073 1.679-.224.542-.675.96-1.233 1.141l-1.2.4v1.56l1.2.4a2.002 2.002 0 011.16 2.82l-.6 1.11 1.1 1.101 1.14-.571a2.002 2.002 0 012.82 1.16l.4 1.2h1.59l.4-1.2c.183-.55.595-.994 1.13-1.217a2.005 2.005 0 011.66.057l1.11.6 1.1-1.1-.57-1.14a2 2 0 011.16-2.82l1.2-.4v-1.59zm-8 4.81a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z"
  })));
}

const CampaignHeadWithBackground = styled(({
  backgroundColor,
  ...props
}) => React__default.createElement(Box, Object.assign({}, props)))`
    position: relative;
    background-color: ${props => props.bgcolor};
`;
const AvatarGridItem = styled(Grid)`
    position: absolute;
    right: 0;
    width: 100%;
    height: 100%;
`;
const AvatarCardMedia = styled(CardMedia)`
    height: 100%;
`;

const queries$1 = id => {
  return [{
    entityCode: entities.System,
    permCode: permissions.System.ViewCampRequestList
  }, {
    entityCode: entities.Campaign,
    entityId: id,
    permCode: permissions.Campaign.Edit
  }];
};

const AdditionalCampaignSectionsInj = props => React__default.createElement(React__default.Fragment, null);
const CampaignPage = observer$1(() => {
  const [IconLink$1] = di([IconLink], CampaignPage);
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignPage);
  const [FileListComponent$1] = di([FileListComponent], CampaignPage);
  const [AdditionalCampaignSections] = di([AdditionalCampaignSectionsInj], CampaignPage);
  const {
    campaignsStore,
    env,
    authorizationStore
  } = useStore();
  const {
    downloadFile,
    createRequest
  } = campaignsStore;
  const [showCampaignPeriod] = useFeature('showCampaignPeriod');
  const [model, setModel] = useState(new CampaignInfoModel(env.apiUrl));
  const theme = useTheme$1();
  const {
    id
  } = useParams();
  const [sidebarItemsPermissions, setSidebarItemsPermissions] = useState([]);
  const [viewCampRequestList, campaignEdit] = sidebarItemsPermissions;

  const createFunc = () => {
    return createRequest(id);
  };

  const [isSending, endIcon, createHandler] = useAntiDoubleClick(createFunc);
  useEffect(() => {
    setModel(campaignsStore.getCampaignInfoModel(id));
  }, [campaignsStore, id]);
  useEffect(() => {
    authorizationStore.checkAll(queries$1(id)).then(setSidebarItemsPermissions);
  }, [authorizationStore, id, setSidebarItemsPermissions]);
  const {
    from,
    title,
    to,
    isCollectionCompleted,
    avatarUrl,
    campaignNotStarted,
    files
  } = model;
  const isSidebarVisible = useMemo(() => {
    return viewCampRequestList || campaignEdit;
  }, [viewCampRequestList, campaignEdit]);

  const renderCampaignPeriod = () => {
    if (from && to && !isCollectionCompleted) {
      return React__default.createElement(Typography, {
        variant: "body2",
        display: "inline"
      }, React__default.createElement(FormattedMessage, {
        id: "campaign.campaignPeriod"
      }), "\u00A0", campaignNotStarted && React__default.createElement(React__default.Fragment, null, React__default.createElement(FormattedMessage, {
        id: "common.from"
      }), "\u00A0", React__default.createElement(Typography, {
        variant: "body2",
        component: "span"
      }, React__default.createElement(FormattedDate, {
        value: from
      })), "\u00A0"), React__default.createElement(FormattedMessage, {
        id: "common.to"
      }), "\u00A0", React__default.createElement(Typography, {
        variant: "body2",
        component: "span"
      }, React__default.createElement(FormattedDate, {
        value: to
      })));
    } else if (isCollectionCompleted) {
      return React__default.createElement(Typography, {
        variant: "body2",
        component: "span",
        color: "error",
        style: {
          textTransform: 'uppercase'
        }
      }, React__default.createElement(FormattedMessage, {
        id: "campaign.collectionCompleted"
      }));
    }

    return null;
  };

  const renderAnnotation = () => {
    const {
      annotation
    } = model;

    if (annotation) {
      return React__default.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(annotation)
        }
      });
    }

    return React__default.createElement(Typography, {
      variant: "caption"
    }, React__default.createElement(FormattedMessage, {
      id: "common.noData"
    }));
  };

  return React__default.createElement(Box, {
    width: "100%"
  }, React__default.createElement(CampaignHeadWithBackground, {
    bgcolor: theme === null || theme === void 0 ? void 0 : theme.variables.palette.card.header.main
  }, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Grid, {
    container: true
  }, React__default.createElement(Grid, {
    item: true,
    xs: 7
  }, React__default.createElement(Box, {
    pb: 6,
    pt: 6,
    color: theme === null || theme === void 0 ? void 0 : theme.variables.palette.card.header.color
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 5,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, title)), showCampaignPeriod && React__default.createElement(Grid, {
    item: true
  }, renderCampaignPeriod()), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.Campaign,
    permCode: permissions.Campaign.AddCampRequest,
    entityId: id
  }, React__default.createElement(Button, {
    color: "primary",
    size: "large",
    variant: "contained",
    type: "submit",
    disabled: isSending,
    onClick: createHandler,
    endIcon: endIcon
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.createRequest"
  }))))))), React__default.createElement(AvatarGridItem, {
    item: true,
    xs: 5
  }, avatarUrl && React__default.createElement(AvatarCardMedia, {
    image: avatarUrl
  }))))), React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 20,
    pb: 20
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, isSidebarVisible && React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, React__default.createElement(Typography, {
    variant: "h3"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.sections"
  })), React__default.createElement(Box, {
    mt: 5,
    fontWeight: "bold"
  }, React__default.createElement(List, null, viewCampRequestList && React__default.createElement(ListItem, {
    disableGutters: true
  }, React__default.createElement(IconLink$1, {
    uppercase: true,
    component: NavLink,
    to: clientRoute.filteringWithCampaign(id),
    icon: React__default.createElement(SvgFiles, null),
    text: React__default.createElement(FormattedMessage, {
      id: "campaign.campaignRequests"
    })
  })), campaignEdit && React__default.createElement(ListItem, {
    disableGutters: true
  }, React__default.createElement(IconLink$1, {
    uppercase: true,
    component: NavLink,
    to: generatePath(clientRoute.campaignSettings, {
      id
    }),
    icon: React__default.createElement(SvgSetting, null),
    text: React__default.createElement(FormattedMessage, {
      id: "campaign.campaignSettings"
    })
  })), React__default.createElement(AdditionalCampaignSections, {
    campaignId: id
  })))), React__default.createElement(Grid, {
    item: true,
    xs: isSidebarVisible ? 9 : 12
  }, React__default.createElement(Typography, {
    variant: "h3"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.description"
  })), React__default.createElement(Box, {
    mt: 5,
    mb: 9
  }, renderAnnotation()), React__default.createElement(Typography, {
    variant: "h3"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.files"
  })), React__default.createElement(Box, {
    mt: 5
  }, React__default.createElement(FileListComponent$1, {
    files: files,
    downloadFile: downloadFile,
    noDataText: React__default.createElement(Typography, {
      variant: "caption"
    }, React__default.createElement(FormattedMessage, {
      id: "common.noData"
    }))
  })))))));
});

const CampaignForm = observer$1(() => {
  const {
    id
  } = useParams();
  const [form, setForm] = useState();
  const [model] = useState(new FormModel(id));
  const {
    campaignsStore,
    notificationStore
  } = useStore();
  const history = useHistory();
  const location = useLocation();
  const {
    locale
  } = useIntl();
  useEffect(() => {
    campaignsStore.loadCampaignForm(id).then(model.load);
  }, [campaignsStore, id, model, location.pathname]);

  const onFormReady = form => {
    setForm(form);
  };

  const onSubmit = () => {
    if (form && form.validate()) {
      form.submit(false).then(() => {
        return campaignsStore.saveCampaignForm(id, form.getSubmission());
      }).then(() => {
        history.push(generatePath(clientRoute.campaignSettings, {
          id
        }));
      }).catch(err => {
        notificationStore.onError(err.response.data);
      });
    }
  };

  return React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.campaignSettings,
    exact: true,
    key: clientRoute.campaignSettings
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.campaignDescription"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    variant: "text",
    color: "primary",
    size: "small",
    startIcon: React__default.createElement(Edit, null),
    component: NavLink,
    to: generatePath(clientRoute.campaignSettingsEdit, {
      id
    })
  }, React__default.createElement(FormattedMessage, {
    id: "common.edit"
  })))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Form, {
    locale: locale,
    form: model,
    readOnly: true,
    onFormReady: onFormReady
  })))), React__default.createElement(Route, {
    path: clientRoute.campaignSettingsEdit,
    key: clientRoute.campaignSettingsEdit
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.campaignDescriptionEdit"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Form, {
    locale: locale,
    form: model,
    onFormReady: onFormReady
  })), React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "secondary",
    variant: "contained",
    onClick: onSubmit
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    component: NavLink,
    variant: "text",
    to: generatePath(clientRoute.campaignSettings, {
      id
    })
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })))))));
});

const CampaignGeneralSettings = observer$1(() => {
  const {
    campaignsStore
  } = useStore();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [model] = useState(() => campaignsStore.getFormForGeneralSettings(id));
  const [form, setForm] = useState();
  const {
    notificationStore
  } = useStore();
  const intl = useIntl();
  const {
    locale
  } = intl;
  const classes = useFormStyles();

  const onFormReady = form => {
    setForm(form);
  };

  const onSubmit = () => {
    if (form && form.validate()) {
      form.submit(false).then(() => {
        return campaignsStore.saveFormForGeneralSettings(id, form.getSubmission());
      }).then(() => {
        history.push(generatePath(clientRoute.generalSettings, {
          id
        }));
        notificationStore.onSuccess(intl.formatMessage({
          id: 'notifications.success'
        }));
      }).catch(error => {
        notificationStore.onError(error.response.data);
      });
    }
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Form, {
    locale: locale,
    className: classes.formWithNoOffset,
    form: model,
    onFormReady: onFormReady
  }), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "secondary",
    variant: "contained",
    onClick: onSubmit
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  }))));
});

const CampaignManagement = observer$1(() => {
  const [ConfirmationDialog$1] = di([ConfirmationDialog], CampaignManagement);
  const [ErrorDialog$1] = di([ErrorDialog], CampaignManagement);
  const [ErrorMessage$1] = di([ErrorMessage], CampaignManagement);
  const [TotObjectTransitions$1] = di([TotObjectTransitions], CampaignManagement);
  const [open, setModalIsOpen, setModalIsClosed] = useModal();
  const history = useHistory();
  const {
    id
  } = useParams();
  const rootStore = useStore();
  const {
    campaignsStore
  } = rootStore;
  const [isError, errorText, enableError, resetError] = useError();
  const [model] = useState(new CampaignInfoModel(rootStore.env.apiUrl));
  useEffect(() => {
    campaignsStore.loadCampaignInfo(id).then(model.load);
  }, [campaignsStore, id, model]);

  const handleErrorDeletion = error => {
    const errorText = ErrorMessage$1(error);
    enableError(errorText);
  };

  const onConfirmDelete = function () {
    try {
      function _temp2() {
        setModalIsClosed();
      }

      const _temp = _catch(function () {
        return Promise.resolve(campaignsStore.deleteCampaign(id)).then(function () {
          history.push(clientRoute.campaigns);
        });
      }, function (error) {
        handleErrorDeletion(error);
      });

      return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const onDeleteLinkClick = () => {
    setModalIsOpen();
  };

  const lifeCycleTransition = function (transitionId, requestId) {
    try {
      return Promise.resolve(campaignsStore.transitionToNextLifeCycleStepCampaign(transitionId, requestId)).then(function () {
        campaignsStore.loadCampaignInfo(id).then(model.load);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const [reloadKey, reloadIncrement] = useReload();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ErrorDialog$1, {
    message: errorText,
    open: isError,
    onClose: resetError
  }), React__default.createElement(Container, {
    maxWidth: "lg",
    key: reloadKey
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.campaignTitle",
    values: {
      campaignName: model.title
    }
  }))), React__default.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center",
    spacing: 10
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TotObjectTransitions$1, {
    objectId: id,
    getTransitions: campaignsStore.getTransitionCampaign,
    updateObjectPage: reloadIncrement,
    lifeCycleTransition: lifeCycleTransition
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    variant: "text",
    color: "primary",
    startIcon: React__default.createElement(Delete, null),
    onClick: onDeleteLinkClick
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.deleteCampaign"
  })), React__default.createElement(ConfirmationDialog$1, {
    id: "delete-request",
    keepMounted: true,
    open: open,
    onConfirm: onConfirmDelete,
    onCancel: setModalIsClosed,
    title: React__default.createElement(FormattedMessage, {
      id: "common.confirmDeletion"
    }),
    message: React__default.createElement(FormattedMessage, {
      id: "campaign.campaignManagementDelete",
      values: {
        campaignName: model.title
      }
    })
  }))))));
});

const useDigitalSignatureCheckboxStylesInj = makeStyles$1(() => ({
  checkbox: {
    padding: '5px'
  }
}));
const DigitalSignaturePfFormFieldsCheckbox = observer$1(props => {
  const [useDigitalSignatureCheckboxStyles] = di([useDigitalSignatureCheckboxStylesInj], DigitalSignaturePfFormFieldsCheckbox);
  const {
    fieldName,
    signatureSettings,
    onChange
  } = props;
  const classes = useDigitalSignatureCheckboxStyles();
  return React__default.createElement(FormControlLabel, {
    control: React__default.createElement(Checkbox, {
      className: classes.checkbox,
      checked: signatureSettings[fieldName],
      onChange: event => onChange(event, fieldName)
    }),
    label: React__default.createElement(FormattedMessage, {
      id: `digitalSignature.form.${fieldName}`
    })
  });
});

const DigitalSignaturePfFormFields = observer$1(props => {
  const [DigitalSignaturePfFormFieldsCheckbox$1] = di([DigitalSignaturePfFormFieldsCheckbox], DigitalSignaturePfFormFields);
  const {
    signatureSettings,
    onChangeSignatureSettings,
    validateMethodError
  } = props;
  return React__default.createElement(Grid, {
    container: true,
    direction: "column"
  }, React__default.createElement(Box, {
    mx: "12px"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(DigitalSignaturePfFormFieldsCheckbox$1, {
    signatureSettings: signatureSettings,
    onChange: onChangeSignatureSettings,
    fieldName: 'signatureEnabled'
  })), signatureSettings.signatureEnabled && React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(DigitalSignaturePfFormFieldsCheckbox$1, {
    signatureSettings: signatureSettings,
    onChange: onChangeSignatureSettings,
    fieldName: 'signatureRequired'
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "body2"
  }, React__default.createElement(Box, {
    fontWeight: "600",
    margin: "6px",
    component: "span"
  }, React__default.createElement(FormattedMessage, {
    id: "digitalSignature.form.signatureVariants"
  })))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(DigitalSignaturePfFormFieldsCheckbox$1, {
    signatureSettings: signatureSettings,
    onChange: onChangeSignatureSettings,
    fieldName: 'signatureBrowserPlugin'
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(DigitalSignaturePfFormFieldsCheckbox$1, {
    signatureSettings: signatureSettings,
    onChange: onChangeSignatureSettings,
    fieldName: 'signatureUpload'
  })), validateMethodError && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    mx: "14px",
    mb: "10px"
  }, React__default.createElement(FormHelperText, {
    error: true
  }, validateMethodError))))));
});

const errorFormMessages = {
  notUniqueTemplateName: React__default.createElement(FormattedMessage, {
    id: "campaign.templateFormErrors.notUniqueTemplateName"
  })
};
const codeErrors = {
  notUniqueTemplateName: 'notUniqueTemplateName'
};
const useStyles$4 = makeStyles$1(() => ({
  tooltip: {
    maxWidth: '592px'
  },
  checkbox: {
    padding: '0 5px'
  },
  checkboxContainer: {
    padding: '5px 12px !important'
  }
}));
const CampaignPfTemplateFormDialog = observer$1(props => {
  const {
    saveModel,
    title,
    listModel
  } = props;
  const classes = useStyles$4();
  const [Select$1] = di([Select], CampaignPfTemplateFormDialog);
  const [TotDropzoneArea$1] = di([TotDropzoneArea], CampaignPfTemplateFormDialog);
  const [DigitalSignaturePfFormFields$1] = di([DigitalSignaturePfFormFields], CampaignPfTemplateFormDialog);
  const history = useHistory();
  const {
    id: campaignId,
    rfId,
    templateId,
    settingsId
  } = useParams();
  const rootStore = useStore();
  const {
    intlStore: intl,
    campaignsStore
  } = rootStore;
  const [titleValidationError, setTitleValidationError] = useState('');
  const model = useMemo(() => {
    return new CampaignPfTemplateModel(campaignId, settingsId, listModel.regFormsCatalog, rootStore);
  }, [campaignId, settingsId, listModel.regFormsCatalog, rootStore]);
  useEffect(() => {
    model.getFileFormats();
    model.getDocCategories().then(() => {
      if (!templateId) {
        return;
      }

      campaignsStore.loadTemplate(templateId).then(template => {
        model.load(template);
      });
    });
  }, [templateId, campaignsStore, model]);

  const handleClose = () => {
    history.push(generatePath(clientRoute.campaignRegFormTemplates, {
      id: campaignId,
      rfId
    }));
  };

  const handleSave = () => {
    model.validationStarted = true;

    if (model.isValid) {
      saveModel(model, settingsId).then(handleClose).catch(e => {
        const message = e.response.data;

        if (message.includes(model.title)) {
          model.enableErrorForm(codeErrors.notUniqueTemplateName);
        }
      });
    }
  };

  const renderErrorMessage = () => {
    switch (model.errorFormCode) {
      case codeErrors.notUniqueTemplateName:
        return errorFormMessages[codeErrors.notUniqueTemplateName];

      default:
        return React__default.createElement(FormattedMessage, {
          id: "common.defaultErrorMessage"
        });
    }
  };

  const onTitleChange = event => {
    const title = event.target.value;
    const clearTitle = title.replace(bannedSymbols, '');
    model.title = clearTitle;

    if (title !== clearTitle) {
      setTitleValidationError(intl.formatMessage('validation.bannedSymbols', {
        symbols: '/ \\ : * ? < > |'
      }));
    } else {
      setTitleValidationError('');
    }
  };

  return React__default.createElement(Portal, null, React__default.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "sm",
    open: true,
    scroll: "body"
  }, React__default.createElement(DialogTitle$1, null, title), React__default.createElement(DialogContent$1, {
    dividers: true
  }, model.errorForm && React__default.createElement(Box, {
    pb: 5
  }, React__default.createElement(Alert$1, {
    variant: "filled",
    severity: "error"
  }, renderErrorMessage())), React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Tooltip, {
    open: !!titleValidationError,
    placement: "top-start",
    classes: {
      tooltip: classes.tooltip
    },
    title: titleValidationError
  }, React__default.createElement(TextField, {
    variant: "outlined",
    required: true,
    error: !!model.errorTitle,
    helperText: model.errorTitle,
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.templateForm.title"
    }),
    value: model.title,
    onChange: onTitleChange,
    onBlur: () => setTitleValidationError(''),
    fullWidth: true
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TextField, {
    variant: "outlined",
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.templateForm.description"
    }),
    value: model.description,
    onChange: e => model.description = e.target.value,
    fullWidth: true
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Select$1, {
    multiple: false,
    values: model.docCategory,
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.documentCategory"
    }),
    selectData: model.docCategories,
    onChange: model.onChangeDocumentCategory,
    textFieldProps: {
      variant: 'outlined',
      required: false
    },
    autoCompleteProps: {
      fullWidth: true,
      size: 'medium',
      disableClearable: true,
      freeSolo: false
    }
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Autocomplete, {
    popupIcon: React__default.createElement(ExpandMoreIcon, null),
    fullWidth: true,
    size: "medium",
    disableClearable: true,
    freeSolo: false,
    options: model.fileFormats.map(item => item.title),
    onChange: model.onChangeFileFormat,
    getOptionLabel: option => option,
    noOptionsText: React__default.createElement(FormattedMessage, {
      id: "campaignRequest.resultsOption"
    }),
    value: model.resultFileFormat,
    renderInput: params => React__default.createElement(TextField, Object.assign({}, params, {
      variant: "outlined",
      required: true,
      label: React__default.createElement(FormattedMessage, {
        id: "campaign.fileFormat"
      }),
      error: !!model.errorFileFormat,
      helperText: model.errorFileFormat
    }))
  })), React__default.createElement(Grid, {
    item: true,
    className: classes.checkboxContainer
  }, React__default.createElement(FormControlLabel, {
    control: React__default.createElement(Checkbox, {
      color: "primary",
      className: classes.checkbox,
      checked: model.required,
      onChange: model.onChangeRequired
    }),
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.templateForm.templateIsRequired"
    })
  })), React__default.createElement(DigitalSignaturePfFormFields$1, {
    validateMethodError: model.errorSignatureMethod,
    signatureSettings: model.signatureSettings,
    onChangeSignatureSettings: model.onChangeSignatureSettings
  }), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormControl, {
    fullWidth: true,
    required: true,
    error: !!model.errorFile,
    variant: "outlined"
  }, React__default.createElement(InputLabel, {
    shrink: true
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.templateForm.file"
  })), React__default.createElement(TotDropzoneArea$1, {
    showAlerts: false,
    useChipsForPreview: true,
    showPreviewsInDropzone: false,
    filesLimit: 1,
    acceptedFiles: model.acceptedFiles,
    dropzoneText: intl.formatMessage('common.dropzoneText'),
    onDrop: model.onChangeFile,
    onChange: model.onChangeFile,
    onDropRejected: model.onRejectedFile,
    alertSnackbarProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      }
    }
  }), model.templateFileName && React__default.createElement(Box, {
    pt: 1
  }, React__default.createElement(Chip, {
    label: model.templateFileName,
    onDelete: model.onDeleteFile
  })), React__default.createElement(FormHelperText, null, model.errorFile))))), React__default.createElement(DialogActions$1, null, React__default.createElement(Button$1, {
    onClick: handleSave,
    color: "primary",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  })), React__default.createElement(Button$1, {
    onClick: handleClose,
    variant: "text"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })))));
});

const useAccessPermissionStyles = makeStyles$1(() => createStyles$1({
  editPermission: {
    padding: 0
  }
}));
const renderOptionCampaignRegForm = (option, {
  selected
}) => {
  const [SelectCheckbox$1] = di([SelectCheckbox], renderOptionCampaignRegForm);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(SelectCheckbox$1, Object.assign({}, checkboxProps$1, {
    checked: selected
  })), option.title);
};
const noOptionsText = React__default.createElement(FormattedMessage, {
  id: "common.noData"
});
const editMessage = React__default.createElement(FormattedMessage, {
  id: "campaign.tabSettingForm.edit"
});
const roleMessage = React__default.createElement(FormattedMessage, {
  id: "campaign.tabSettingFormTable.role"
});
const statusMessage = React__default.createElement(FormattedMessage, {
  id: "campaign.tabSettingFormTable.status"
});
const chipProps = {
  deleteIcon: React__default.createElement(SvgDeleteChipIcon, null),
  size: 'small'
};

const EditPermissionDialog = observer$1(props => {
  const {
    model,
    currentPermission,
    closeDialog,
    open,
    checkboxLabel = editMessage
  } = props;
  const [renderAutoCompleteInput$1] = di([renderAutoCompleteInput], EditPermissionDialog);
  const [useAccessPermissionStyles$1] = di([useAccessPermissionStyles], EditPermissionDialog);
  const [renderOptionCampaignRegForm$1] = di([renderOptionCampaignRegForm], EditPermissionDialog);
  const currentRow = useMemo(() => model.permissions[currentPermission], [model, currentPermission]);
  const [newPermission, setNewPermission] = useState(currentRow.permission);
  const [newStates, setNewStates] = useState(currentRow.states);
  const [newEditPermission, setNewEditPermission] = useState(currentRow.edit);
  const intl = useIntl();
  const updatedPermission = useMemo(() => ({
    permission: newPermission,
    states: newStates,
    edit: newEditPermission
  }), [newPermission, newStates, newEditPermission]);
  const classes = useAccessPermissionStyles$1();
  const onChangeNewPermission = useCallback((e, value) => {
    value && setNewPermission(value);
  }, [setNewPermission]);
  const onChangeNewStates = useCallback((e, value) => {
    value && setNewStates(value);
  }, [setNewStates]);
  const onChangeNewEditPermission = useCallback(() => {
    setNewEditPermission(prevValue => !prevValue);
  }, [setNewPermission]);
  const submit = useCallback(() => {
    model.handleUpdatePermission(currentPermission, updatedPermission);
    closeDialog();
  }, [model, currentPermission, updatedPermission, closeDialog]);
  return React__default.createElement(Dialog, {
    maxWidth: "sm",
    fullWidth: true,
    open: open,
    scroll: "body"
  }, React__default.createElement(Box, {
    pt: 4,
    pr: 4
  }, React__default.createElement(Grid, {
    container: true,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    onClick: closeDialog
  }, React__default.createElement(Close, null))))), React__default.createElement(Box, {
    pl: 12,
    pr: 12,
    pb: 12
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 4,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, React__default.createElement(Autocomplete, Object.assign({}, AutocompleteProps, {
    value: newPermission,
    onChange: onChangeNewPermission,
    popupIcon: React__default.createElement(ExpandMoreIcon, null),
    noOptionsText: noOptionsText,
    ChipProps: chipProps,
    getOptionSelected: (option, value) => option.code === value.code,
    getOptionLabel: option => option.title,
    options: model.permissionsList,
    renderInput: renderAutoCompleteInput$1(roleMessage, true, model.permissionMessage, textFieldProps)
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, React__default.createElement(Autocomplete, Object.assign({}, AutocompleteProps, {
    multiple: true,
    disableCloseOnSelect: true,
    value: newStates.slice(),
    onChange: onChangeNewStates,
    popupIcon: React__default.createElement(ExpandMoreIcon, null),
    noOptionsText: noOptionsText,
    ChipProps: chipProps,
    getOptionSelected: (option, value) => option.code === value.code,
    getOptionLabel: option => option.title,
    options: model.statesList,
    renderInput: renderAutoCompleteInput$1(statusMessage, false, '', { ...textFieldProps,
      placeholder: newStates.length ? '' : intl.formatMessage({
        id: 'common.all'
      })
    }),
    renderOption: renderOptionCampaignRegForm$1
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, React__default.createElement(FormControlLabel, {
    control: React__default.createElement(Checkbox, {
      color: "primary",
      className: classes.editPermission,
      checked: newEditPermission,
      onChange: onChangeNewEditPermission
    }),
    label: checkboxLabel
  }))), React__default.createElement(Box, {
    pt: 4,
    pr: 4
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    justify: "center",
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "primary",
    fullWidth: true,
    variant: "contained",
    onClick: submit
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: closeDialog,
    fullWidth: true,
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })))))));
});

const RequestFormPermissionSettingsTable = observer$1(props => {
  const [renderAutoCompleteInput$1] = di([renderAutoCompleteInput], RequestFormPermissionSettingsTable);
  const [useAccessPermissionStyles$1] = di([useAccessPermissionStyles], RequestFormPermissionSettingsTable);
  const [renderOptionCampaignRegForm$1] = di([renderOptionCampaignRegForm], RequestFormPermissionSettingsTable);
  const {
    intlStore: intl
  } = useStore();
  const {
    model,
    handleEditPermissionDialogOpen,
    checkboxLabel = editMessage
  } = props;
  const {
    states
  } = model;
  const classes = useAccessPermissionStyles$1();

  const renderStates = states => {
    const {
      length
    } = states;

    if (!length) {
      return intl.formatMessage('campaign.tabSettingFormTable.allStatuses');
    }

    return states.map((state, index) => {
      return `${state.title}${index !== length - 1 ? ', ' : ''}`;
    });
  };

  return React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 4
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 4,
    wrap: "nowrap",
    alignItems: "flex-start"
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 4,
    alignItems: "flex-start"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(Autocomplete, Object.assign({}, AutocompleteProps, {
    value: model.permission,
    onChange: model.onChangePermission,
    popupIcon: React__default.createElement(ExpandMoreIcon, null),
    noOptionsText: noOptionsText,
    ChipProps: chipProps,
    getOptionSelected: (option, value) => option.code === value.code,
    getOptionLabel: option => option.title,
    options: model.permissionsList,
    renderInput: renderAutoCompleteInput$1(roleMessage, true, model.permissionMessage, textFieldProps)
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(Autocomplete, Object.assign({}, AutocompleteProps, {
    multiple: true,
    disableCloseOnSelect: true,
    value: states.slice(),
    onChange: model.onChangeStates,
    popupIcon: React__default.createElement(ExpandMoreIcon, null),
    noOptionsText: noOptionsText,
    ChipProps: chipProps,
    getOptionSelected: (option, value) => option.code === value.code,
    getOptionLabel: option => option.title,
    options: model.statesList,
    renderInput: renderAutoCompleteInput$1(statusMessage, false, '', { ...textFieldProps,
      placeholder: states.length ? '' : intl.formatMessage('common.all')
    }),
    renderOption: renderOptionCampaignRegForm$1
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, React__default.createElement(FormControlLabel, {
    control: React__default.createElement(Checkbox, {
      color: "primary",
      className: classes.editPermission,
      checked: model.editPermission,
      onChange: model.onChangeEditPermission
    }),
    label: checkboxLabel
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "secondary",
    variant: "contained",
    onClick: model.addAccessPermission
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.campaignRegFormExecutorAdd"
  })))), !!model.permissions.length && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TableContainer, {
    component: Paper
  }, React__default.createElement(Table, null, React__default.createElement(TableHead, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaign.tabSettingFormTable.role"
  }))), React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaign.tabSettingFormTable.status"
  }))), React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaign.tabSettingFormTable.access"
  }))), React__default.createElement(TableCell, null))), React__default.createElement(TableBody, null, model.permissions.map((item, index) => React__default.createElement(TableRow, {
    hover: true,
    key: index
  }, React__default.createElement(TableCell, null, item.permission.title), React__default.createElement(TableCell, null, renderStates(item.states)), React__default.createElement(TableCell, null, item.edit && React__default.createElement(Box, null, checkboxLabel), React__default.createElement(Box, null, React__default.createElement(FormattedMessage, {
    id: "campaign.tabSettingForm.view"
  }))), React__default.createElement(TableCell, null, React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    wrap: "nowrap"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    size: "small",
    onClick: () => handleEditPermissionDialogOpen(index)
  }, React__default.createElement(Edit, null))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    size: "small",
    onClick: () => model.deleteAccessPermission(index)
  }, React__default.createElement(Delete, null))))))))))));
});

const RequestFormTabsSettingDialog = observer$1(props => {
  const {
    updateSetting,
    createSetting
  } = props;
  const [Select$1] = di([Select], RequestFormTabsSettingDialog);
  const [RequestFormTabSettingTable] = di([RequestFormPermissionSettingsTable], RequestFormTabsSettingDialog);
  const [EditPermissionDialog$1] = di([EditPermissionDialog], RequestFormTabsSettingDialog);
  const {
    campaignsStore,
    notificationStore,
    intlStore: intl
  } = useStore();
  const {
    id,
    settingId,
    rfId
  } = useParams();
  const history = useHistory();
  const [settings] = useState(new RequestFormSettingModel(settingId, campaignsStore, intl));
  const [currentPermission, setCurrentPermission] = useState();
  const [editPermissionDialogOpen, setEditPermissionDialogOpen, setEditPermissionDialogClosed] = useModal();
  useEffect(() => {
    settings.loadData(rfId).finally(() => campaignsStore.getRequestFormSetting(settings, settingId));
  }, [campaignsStore, settings, settingId, rfId]);
  const closeDialog = useCallback(function () {
    try {
      history.push(generatePath(clientRoute.campaignRegFormTabsSettings, {
        id,
        rfId
      }));
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }, [id, rfId, history]);
  const submit = useCallback(() => {
    settings.formValidationStarted = true;

    if (!settings.isValid) {
      return;
    }

    updateSetting && updateSetting(settingId, settings.requestFormTabSettingsData).then(closeDialog).catch(err => {
      notificationStore.onError(err.response.data);
    });
    createSetting && createSetting(settings.requestFormTabSettingsData).then(closeDialog).catch(err => {
      notificationStore.onError(err.response.data);
    });
    settings.formValidationStarted = false;
  }, [closeDialog, settingId, updateSetting, settings, notificationStore, createSetting]);
  const handleEditPermissionDialogOpen = useCallback(index => {
    setCurrentPermission(index);
    setEditPermissionDialogOpen();
  }, [setCurrentPermission, setEditPermissionDialogOpen]);
  return React__default.createElement(React__default.Fragment, null, currentPermission !== undefined && editPermissionDialogOpen && React__default.createElement(EditPermissionDialog$1, {
    open: editPermissionDialogOpen,
    closeDialog: setEditPermissionDialogClosed,
    currentPermission: currentPermission,
    model: settings
  }), React__default.createElement(Dialog, {
    maxWidth: "md",
    fullWidth: true,
    open: true,
    scroll: "body"
  }, React__default.createElement(Box, {
    pt: 4,
    pr: 4
  }, React__default.createElement(Grid, {
    container: true,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    onClick: closeDialog
  }, React__default.createElement(Close, null))))), React__default.createElement(Box, {
    pl: 12,
    pr: 12,
    pb: 12
  }, React__default.createElement(Grid, {
    container: true,
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h5"
  }, React__default.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.requestFormSetting"
  }))))), React__default.createElement(Box, {
    pt: 8
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column",
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 4,
    direction: "column",
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TextField, Object.assign({}, textFieldProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.tabSettingForm.title"
    }),
    value: settings.title,
    onChange: settings.onChangeTitle,
    required: true,
    error: !!settings.titleMessage,
    helperText: settings.titleMessage
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TextField, Object.assign({}, textFieldProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.tabSettingForm.identifier"
    }),
    value: settings.identifier,
    onChange: settings.onChangeIdentifier,
    required: true,
    error: !!settings.identifierMessage,
    helperText: settings.identifierMessage
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Select$1, {
    multiple: false,
    values: settings.formCode,
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.tabSettingForm.formCode"
    }),
    selectData: settings.formCodeList,
    onChange: settings.onChangeFormCode,
    textFieldProps: { ...textFieldProps,
      required: true,
      error: !!settings.formCodeMessage,
      helperText: settings.formCodeMessage
    },
    autoCompleteProps: { ...AutocompleteProps
    }
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TextField, Object.assign({}, textFieldProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.tabSettingForm.fileSize"
    }),
    value: settings.fileSize,
    onChange: settings.onChangeFileSize,
    error: !!settings.fileSizeMessage,
    helperText: settings.fileSizeMessage
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Select$1, {
    multiple: false,
    values: settings.executorId,
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.tabSettingForm.executor"
    }),
    selectData: settings.executorsList,
    onChange: settings.onChangeExecutor,
    textFieldProps: { ...textFieldProps
    },
    autoCompleteProps: { ...AutocompleteProps
    }
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestFormTabSettingTable, {
    model: settings,
    handleEditPermissionDialogOpen: handleEditPermissionDialogOpen
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "primary",
    fullWidth: true,
    size: "large",
    variant: "contained",
    onClick: submit
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: closeDialog,
    fullWidth: true,
    size: "large",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  }))))))));
});

const TemplatePermissionSettingsDialog = observer$1(() => {
  const history = useHistory();
  const {
    intlStore: intl,
    campaignsStore
  } = useStore();
  const {
    id: campaignId,
    rfId,
    settingsId
  } = useParams();
  const [EditPermissionDialog$1] = di([EditPermissionDialog], TemplatePermissionSettingsDialog);
  const [RequestFormPermissionSettingsTable$1] = di([RequestFormPermissionSettingsTable], TemplatePermissionSettingsDialog);
  const templateTab = useMemo(() => new CampaingPfTemplateTabModel(intl), [intl]);
  const [currentPermission, setCurrentPermission] = useState();
  const [editPermissionDialogOpen, setEditPermissionDialogOpen, setEditPermissionDialogClosed] = useModal();
  const handleEditPermissionDialogOpen = useCallback(index => {
    setCurrentPermission(index);
    setEditPermissionDialogOpen();
  }, [setCurrentPermission, setEditPermissionDialogOpen]);

  const handleClose = () => {
    history.push(generatePath(clientRoute.campaignRegFormTemplates, {
      id: campaignId,
      rfId
    }));
  };

  const handleSave = () => {
    templateTab.validationStarted = true;

    if (!templateTab.isValid) {
      return;
    }

    campaignsStore.saveTemplatePermissions(settingsId, templateTab.permissions).then(handleClose).finally(() => templateTab.validationStarted = false);
  };

  const checkboxLabel = React__default.createElement(FormattedMessage, {
    id: "campaign.generate"
  });
  useEffect(() => {
    campaignsStore.loadTemplatePermissions(settingsId).then(permissions => {
      templateTab.permissions = permissions;
    });
    campaignsStore.loadStates(rfId).then(states => {
      templateTab.statesList = states;
    });
    campaignsStore.loadPermissions().then(permissions => {
      templateTab.permissionsList = permissions;
    });
  }, [campaignsStore, templateTab]);
  return React__default.createElement(React__default.Fragment, null, currentPermission !== undefined && editPermissionDialogOpen && React__default.createElement(EditPermissionDialog$1, {
    open: editPermissionDialogOpen,
    closeDialog: setEditPermissionDialogClosed,
    currentPermission: currentPermission,
    model: templateTab,
    checkboxLabel: checkboxLabel
  }), React__default.createElement(Dialog, {
    maxWidth: "md",
    fullWidth: true,
    open: true,
    scroll: "body"
  }, React__default.createElement(DialogTitle$1, null, React__default.createElement(FormattedMessage, {
    id: "campaign.accessSetting"
  })), React__default.createElement(DialogContent, {
    dividers: true
  }, React__default.createElement(RequestFormPermissionSettingsTable$1, {
    model: templateTab,
    handleEditPermissionDialogOpen: handleEditPermissionDialogOpen,
    checkboxLabel: checkboxLabel
  })), React__default.createElement(DialogActions$1, null, React__default.createElement(Button, {
    onClick: handleSave,
    color: "primary",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  })), React__default.createElement(Button, {
    onClick: handleClose,
    variant: "text"
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })))));
});

const AddPfTemplateButton = props => {
  const {
    campaignId,
    rfId,
    settingsId
  } = props;
  return React__default.createElement(Button, {
    component: NavLink,
    to: generatePath(clientRoute.campaignRegFormTemplatesCreate, {
      id: campaignId,
      rfId,
      settingsId
    }),
    variant: "text",
    color: "primary",
    size: "small",
    startIcon: React__default.createElement(AddIcon, null)
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.addTemplate"
  }));
};

var _path$d;

function _extends$e() {
  _extends$e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$e.apply(this, arguments);
}

function SvgMove(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "31 25 20 20"
  }, props), _path$d || (_path$d = /*#__PURE__*/createElement("path", {
    d: "M50.71 35.709l-2.5 2.5a.999.999 0 01-1.42 0 .997.997 0 010-1.42l.8-.79H42v5.59l.79-.8a1.004 1.004 0 011.42 1.42l-2.5 2.5a1.014 1.014 0 01-.33.21.94.94 0 01-.76 0 1.004 1.004 0 01-.33-.21l-2.5-2.5a1.004 1.004 0 011.42-1.42l.79.8v-5.59h-5.59l.8.79a1.004 1.004 0 01-1.42 1.42l-2.5-2.5a.998.998 0 01-.21-.33.94.94 0 010-.76.998.998 0 01.21-.33l2.5-2.5a1.004 1.004 0 011.42 1.42l-.8.79H40v-5.59l-.79.8a1.004 1.004 0 01-1.42-1.42l2.5-2.5c.095-.091.207-.162.33-.21a.991.991 0 01.76 0c.122.048.235.119.33.21l2.5 2.5a1 1 0 010 1.42 1.003 1.003 0 01-1.42 0l-.79-.8v5.59h5.59l-.8-.79a1.004 1.004 0 011.42-1.42l2.5 2.5c.091.095.162.208.21.33a1 1 0 010 .76 1.014 1.014 0 01-.21.33z"
  })));
}

const CampaignSettingsDeleteButton = withConfirmDialog(({
  openConfirmDialog
}) => React__default.createElement(IconButton, {
  size: "small",
  onClick: openConfirmDialog
}, React__default.createElement(Delete, null)));

const CampaignPfTemplateCard = observer$1(props => {
  const [CampaignSettingsDeleteButton$1] = di([CampaignSettingsDeleteButton], CampaignPfTemplateCard);
  const [FileDownload$1] = di([FileDownload], CampaignPfTemplateCard);
  const {
    model,
    listModel,
    provided
  } = props;
  const {
    id: campaignId,
    rfId
  } = useParams();
  const {
    id,
    title,
    description,
    templateFileName: fileName,
    required
  } = model;

  const handleDownloadTemplateFile = () => {
    listModel.downloadTemplateFile(model);
  };

  const handleDeleteTemplate = () => {
    return listModel.deleteTemplate(model);
  };

  return React__default.createElement(Card, {
    variant: "outlined"
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "space-between",
    alignItems: "center"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 10
  }, React__default.createElement(CardContent, null, React__default.createElement(Box, {
    mb: 2,
    fontWeight: "fontWeightBold"
  }, React__default.createElement(FileDownload$1, {
    fileName: fileName,
    title: title,
    downloadFile: handleDownloadTemplateFile,
    required: required
  })), description && React__default.createElement(Box, {
    mb: 1
  }, React__default.createElement(Typography, {
    component: "p",
    variant: "subtitle2"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.description"
  }), React__default.createElement(Typography, {
    component: "span"
  }, description))))), React__default.createElement(Grid, {
    item: true,
    xs: 2,
    container: true,
    justify: "center"
  }, React__default.createElement(CardActions, null, React__default.createElement(React__default.Fragment, null, React__default.createElement(IconButton, Object.assign({}, provided), React__default.createElement(SvgIcon, {
    viewBox: "0 0 20 20"
  }, React__default.createElement(SvgMove, null))), React__default.createElement(IconButton, {
    component: NavLink,
    to: generatePath(clientRoute.campaignRegFormTemplatesEdit, {
      id: campaignId,
      rfId,
      templateId: id,
      settingsId: model.settingsId
    }),
    size: "small"
  }, React__default.createElement(Edit, null))), React__default.createElement(CampaignSettingsDeleteButton$1, {
    id: "confirm-delete-pf-template",
    title: React__default.createElement(FormattedMessage, {
      id: "common.confirmDeletion"
    }),
    message: React__default.createElement(FormattedMessage, {
      id: "campaign.confirmDeletionTemplateInfoText",
      values: {
        title
      }
    }),
    onConfirm: handleDeleteTemplate
  })))));
});

const CampaignPfTemplateTab = observer$1(() => {
  const [CampaignPfTemplateFormDialog$1] = di([CampaignPfTemplateFormDialog], CampaignPfTemplateTab);
  const [TemplatePermissionSettingsDialog$1] = di([TemplatePermissionSettingsDialog], CampaignPfTemplateTab);
  const [AddPfTemplateButton$1] = di([AddPfTemplateButton], CampaignPfTemplateTab);
  const [CampaignPfTemplateCard$1] = di([CampaignPfTemplateCard], CampaignPfTemplateTab);
  const {
    id: campaignId,
    rfId
  } = useParams();
  const rootStore = useStore();
  const [model] = useState(new CampaignPfTemplateListModel(campaignId, rfId, rootStore));
  const {
    changeTemplatePosition,
    reorderTemplatesList
  } = model;
  useEffect(() => {
    model.loadData();
  }, [model]);

  const onDragEnd = (result, settingsId) => {
    if (!result.destination) {
      return;
    }

    changeTemplatePosition(result.draggableId, result.destination.index + 1);
    reorderTemplatesList(result.source.index, result.destination.index, settingsId);
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.campaignRegFormTemplatesCreate
  }, React__default.createElement(CampaignPfTemplateFormDialog$1, {
    title: React__default.createElement(FormattedMessage, {
      id: "campaign.addTemplate"
    }),
    listModel: model,
    saveModel: model.createTemplate
  })), React__default.createElement(Route, {
    path: clientRoute.campaignRegFormTemplatesEdit
  }, React__default.createElement(CampaignPfTemplateFormDialog$1, {
    title: React__default.createElement(FormattedMessage, {
      id: "campaign.editTemplate"
    }),
    listModel: model,
    saveModel: model.saveTemplate
  })), React__default.createElement(Route, {
    path: clientRoute.campaignRegFormTemplatesPermissionSettings
  }, React__default.createElement(TemplatePermissionSettingsDialog$1, null))), React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, model.templatesTabs.map(templateTab => {
    return React__default.createElement(Grid, {
      container: true,
      item: true,
      direction: "column",
      spacing: 3
    }, React__default.createElement(Grid, {
      container: true,
      item: true,
      alignItems: "center",
      justify: "space-between"
    }, React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(Typography, {
      variant: "subtitle1",
      component: "h3"
    }, templateTab.settingsTitle)), React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(Grid, {
      container: true,
      alignItems: "center"
    }, React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(AddPfTemplateButton$1, {
      campaignId: campaignId,
      rfId: rfId,
      settingsId: templateTab.settingsId
    })), React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(Button, {
      component: NavLink,
      to: generatePath(clientRoute.campaignRegFormTemplatesPermissionSettings, {
        id: campaignId,
        rfId,
        settingsId: templateTab.settingsId
      }),
      variant: "text",
      color: "primary",
      size: "small"
    }, React__default.createElement(FormattedMessage, {
      id: "campaign.editPermission"
    })))))), React__default.createElement(DragDropContext, {
      onDragEnd: result => onDragEnd(result, templateTab.settingsId)
    }, React__default.createElement(Droppable, {
      droppableId: 'droppable',
      key: templateTab.templates.length
    }, droppableProvided => React__default.createElement(Grid, Object.assign({
      container: true,
      item: true,
      direction: "column",
      spacing: 3
    }, droppableProvided.droppableProps, {
      ref: droppableProvided.innerRef
    }), templateTab.templates.length ? React__default.createElement(React__default.Fragment, null, templateTab.templates.map((template, index) => {
      return React__default.createElement(Draggable, {
        draggableId: template.id,
        index: index,
        key: template.id
      }, provided => React__default.createElement(Grid, Object.assign({
        item: true
      }, provided.draggableProps, {
        ref: provided.innerRef
      }), React__default.createElement(CampaignPfTemplateCard$1, {
        model: template,
        listModel: model,
        provided: provided.dragHandleProps
      })));
    }), droppableProvided.placeholder) : React__default.createElement(Typography, {
      variant: "subtitle2",
      component: "p"
    }, React__default.createElement(Box, {
      p: "10px 30px",
      fontWeight: "400"
    }, React__default.createElement(FormattedMessage, {
      id: "campaign.noTemplates"
    })))))));
  })));
});

const CampaignRegFormCard = props => {
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignRegFormCard);
  const {
    model,
    onFormReady,
    onDeleteLinkClick
  } = props;
  const {
    id,
    rfId
  } = useParams();
  const classes = useFormStyles();
  const {
    locale
  } = useIntl();
  return React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    justify: "flex-end",
    spacing: 5
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.CampaignRegForm,
    entityId: rfId,
    permCode: permissions.CampaignRegForm.Edit
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    variant: "text",
    color: "primary",
    startIcon: React__default.createElement(Edit, null),
    component: NavLink,
    to: generatePath(clientRoute.campaignRegFormEdit, {
      id,
      rfId
    })
  }, React__default.createElement(FormattedMessage, {
    id: "common.edit"
  })))), React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.CampaignRegForm,
    entityId: rfId,
    permCode: permissions.CampaignRegForm.Delete
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    "aria-haspopup": "true",
    "aria-controls": "confirm-delete-rf",
    variant: "text",
    color: "primary",
    startIcon: React__default.createElement(Delete, null),
    onClick: onDeleteLinkClick
  }, React__default.createElement(FormattedMessage, {
    id: "common.delete"
  }))))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Form, {
    locale: locale,
    className: classes.formWithNoOffset,
    form: model,
    readOnly: true,
    onFormReady: onFormReady
  })));
};

const useDraggableRequestFormTabsSettingsTableRowStyle = makeStyles(() => {
  return {
    settingTitleCell: {
      width: '30%'
    },
    formTitleCell: {
      width: '58%'
    },
    actionButtons: {
      width: '96px',
      minWidth: '96px'
    }
  };
});
const renderDraggableRequestFormTabsSettingsTableRow = (setting, id, rfId, deleteSetting, intl, services) => {
  const {
    id: settingId,
    title: settingTitle
  } = setting;
  return function DraggableRequestFormTabsSettingsTableRow(provided) {
    const classes = useDraggableRequestFormTabsSettingsTableRowStyle();
    return React__default.createElement(TableRow, Object.assign({
      hover: true,
      ref: provided.innerRef
    }, provided.draggableProps), React__default.createElement(TableCell, {
      className: classes.settingTitleCell
    }, settingTitle), React__default.createElement(TableCell, {
      className: classes.formTitleCell
    }, setting.formInfo ? React__default.createElement(Link$1, {
      target: "_blank",
      href: services.formVersionLink(setting.formInfo.id)
    }, setting.formInfo.title || setting.formInfo.id) : '-'), React__default.createElement(TableCell, {
      className: classes.actionButtons,
      align: "right"
    }, React__default.createElement(IconButton, Object.assign({}, provided.dragHandleProps), React__default.createElement(SvgIcon, {
      viewBox: "0 0 20 20"
    }, React__default.createElement(SvgMove, null))), React__default.createElement(IconButton, {
      component: NavLink,
      to: generatePath(clientRoute.campaignRequestFormTabSetting, {
        id,
        rfId,
        settingId
      }),
      size: "small"
    }, React__default.createElement(Edit, null)), React__default.createElement(CampaignSettingsDeleteButton, {
      id: "confirm-delete",
      title: intl.formatMessage({
        id: 'common.confirmDeletion'
      }),
      message: intl.formatMessage({
        id: 'campaign.confirmDeletionRequestFormSettingInfoText'
      }, {
        title: settingTitle
      }),
      onConfirm: deleteSetting(settingId)
    })));
  };
};

const RequestFormTabsSettingsDroppableTableBody = observer$1(props => {
  const [renderDraggableRequestFormTabsSettingsTableRow$1] = di([renderDraggableRequestFormTabsSettingsTableRow], RequestFormTabsSettingsDroppableTableBody);
  const {
    droppableProvided,
    settings,
    deleteSetting
  } = props;
  const {
    id,
    rfId
  } = useParams();
  const intl = useIntl();
  const rootStore = useStore();
  const draggableRows = settings.map((setting, index) => {
    const {
      id: settingId
    } = setting;
    const draggableRow = renderDraggableRequestFormTabsSettingsTableRow$1(setting, id, rfId, deleteSetting, intl, rootStore.services);
    return React__default.createElement(Draggable, {
      draggableId: settingId,
      index: index,
      key: settingId
    }, draggableRow);
  });
  return React__default.createElement(TableBody, Object.assign({}, droppableProvided.droppableProps, {
    ref: droppableProvided.innerRef
  }), draggableRows, droppableProvided.placeholder);
});

const renderDroppableRequestFormTabsSettingsTableBodyInj = (settings, deleteSetting) => {
  return function DroppableRequestFormTabsSettingsTableBody(droppableProvided) {
    return React__default.createElement(RequestFormTabsSettingsDroppableTableBody, {
      settings: settings,
      deleteSetting: deleteSetting,
      droppableProvided: droppableProvided
    });
  };
};
const RequestFormTabsSettingsTable = observer$1(props => {
  const [renderDroppableRequestFormTabsSettingsTableBody] = di([renderDroppableRequestFormTabsSettingsTableBodyInj], RequestFormTabsSettingsTable);
  const {
    setSettings,
    settings
  } = props;
  const {
    campaignsStore
  } = useStore();

  const setReordered = (sourceIndex, destinationIndex) => {
    const reordered = reorderList(settings, sourceIndex, destinationIndex);
    setSettings(reordered);
  };

  const onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const destinationIndex = result.destination.index;
    const settingsBefore = JSON.parse(JSON.stringify(settings));
    campaignsStore.changePositionRequestFormSetting(result.draggableId, destinationIndex + 1).catch(() => {
      setSettings(settingsBefore);
    });
    setReordered(result.source.index, destinationIndex);
  };

  const deleteSetting = useCallback(settingId => function () {
    try {
      return Promise.resolve(campaignsStore.deleteRequestFormSetting(settingId).then(data => {
        if (data) {
          setSettings(prevState => prevState.filter(setting => setting.id !== settingId));
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  }, [campaignsStore]);
  const droppableTableBody = renderDroppableRequestFormTabsSettingsTableBody(settings, deleteSetting);
  return React__default.createElement(TableContainer, {
    component: Paper
  }, React__default.createElement(Table, null, React__default.createElement(TableHead, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaign.requestFormSettings.title"
  }))), React__default.createElement(TableCell, null, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "campaign.requestFormSettings.formTitle"
  }))), React__default.createElement(TableCell, null))), React__default.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, React__default.createElement(Droppable, {
    droppableId: "droppable"
  }, droppableTableBody))));
});

const RequestFromTabsSettingsHeader = observer$1(() => {
  const {
    id,
    rfId
  } = useParams();
  const history = useHistory();
  const goToSettingDialog = useCallback(function () {
    try {
      history.push(generatePath(clientRoute.campaignRequestFormTabSettingCreate, {
        id,
        rfId,
        settingId: '-'
      }));
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }, [id, rfId, history]);
  return React__default.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(Typography, {
    variant: "h6"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.requestFormSettingsTitle"
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 6,
    container: true,
    spacing: 2,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "primary",
    variant: "contained",
    onClick: goToSettingDialog
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.createRequestFormSettings"
  })))));
});

const RequestFormTabsSettings = observer$1(() => {
  const [RequestFormTabsSettingDialog$1] = di([RequestFormTabsSettingDialog], RequestFormTabsSettings);
  const [RequestFormTabsSettingsTable$1] = di([RequestFormTabsSettingsTable], RequestFormTabsSettings);
  const [RequestFromTabsSettingsHeader$1] = di([RequestFromTabsSettingsHeader], RequestFormTabsSettings);
  const {
    campaignsStore
  } = useStore();
  const {
    id,
    rfId
  } = useParams();
  const [settings, setSettings] = useState([]);
  useEffect(() => {
    campaignsStore.requestFormSettings(rfId).then(setSettings);
  }, [id, rfId, campaignsStore]);
  const createSetting = useCallback(function (dto) {
    try {
      return Promise.resolve(campaignsStore.createRequestFormSetting(rfId, dto)).then(function () {
        return Promise.resolve(campaignsStore.requestFormSettings(rfId).then(setSettings)).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [id, rfId, campaignsStore]);
  const updateSetting = useCallback(function (settingId, dto) {
    try {
      return Promise.resolve(campaignsStore.saveRequestFormSetting(settingId, dto)).then(function (response) {
        return Promise.resolve(campaignsStore.requestFormSettings(rfId).then(setSettings)).then(function () {
          return response;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [rfId, campaignsStore]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.campaignRequestFormTabSetting
  }, React__default.createElement(RequestFormTabsSettingDialog$1, {
    updateSetting: updateSetting
  })), React__default.createElement(Route, {
    path: clientRoute.campaignRequestFormTabSettingCreate
  }, React__default.createElement(RequestFormTabsSettingDialog$1, {
    createSetting: createSetting
  }))), React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestFromTabsSettingsHeader$1, null)), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RequestFormTabsSettingsTable$1, {
    setSettings: setSettings,
    settings: settings
  }))));
});

const AdditionalCampaignRegFormPagesInj = () => React__default.createElement(React__default.Fragment, null);
const getAdditionalCampaignRegFormTabsRoutesInj = () => [];
const CampaignRegFormTabs = observer$1(props => {
  const {
    model,
    onFormReady,
    onDeleteLinkClick
  } = props;
  const [RoutedTabs$1] = di([RoutedTabs], CampaignRegFormTabs);
  const [CampaignPfTemplateTab$1] = di([CampaignPfTemplateTab], CampaignRegFormTabs);
  const [CampaignRegFormCard$1] = di([CampaignRegFormCard], CampaignRegFormTabs);
  const [RequestFormTabsSettings$1] = di([RequestFormTabsSettings], CampaignRegFormTabs);
  const [AdditionalCampaignRegFormPages] = di([AdditionalCampaignRegFormPagesInj], CampaignRegFormTabs);
  const [getAdditionalCampaignRegFormTabsRoutes] = di([getAdditionalCampaignRegFormTabsRoutesInj], CampaignRegFormTabs);
  const {
    id,
    rfId
  } = useParams();
  const campaignRegFormTabs = [{
    title: React__default.createElement(FormattedMessage, {
      id: "campaign.regFormInfo"
    }),
    path: clientRoute.campaignRegForm
  }, {
    title: React__default.createElement(FormattedMessage, {
      id: "campaign.tabsSettings"
    }),
    path: clientRoute.campaignRegFormTabsSettings
  }, {
    title: React__default.createElement(FormattedMessage, {
      id: "campaign.pfTemplates"
    }),
    path: clientRoute.campaignRegFormTemplates
  }, ...getAdditionalCampaignRegFormTabsRoutes()];
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(RoutedTabs$1, {
    tabsProps: {
      indicatorColor: 'primary'
    },
    settings: campaignRegFormTabs.map((t, index) => ({
      tab: index,
      path: t.path
    }))
  }, campaignRegFormTabs.map((p, index) => React__default.createElement(Tab, {
    key: index,
    tabIndex: index,
    value: index,
    component: NavLink,
    to: generatePath(p.path, {
      id,
      rfId
    }),
    label: p.title
  })))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.campaignRegForm,
    exact: true
  }, React__default.createElement(CampaignRegFormCard$1, {
    model: model,
    onFormReady: onFormReady,
    onDeleteLinkClick: onDeleteLinkClick
  })), React__default.createElement(Route, {
    path: [clientRoute.campaignRegFormTabsSettings, clientRoute.campaignRequestFormTabSetting, clientRoute.campaignRequestFormTabSettingCreate],
    exact: true
  }, React__default.createElement(RequestFormTabsSettings$1, null)), React__default.createElement(Route, {
    path: [clientRoute.campaignRegFormTemplates, clientRoute.campaignRegFormTemplatesCreate, clientRoute.campaignRegFormTemplatesEdit, clientRoute.campaignRegFormTemplatesPermissionSettings],
    exact: true
  }, React__default.createElement(CampaignPfTemplateTab$1, null)), React__default.createElement(AdditionalCampaignRegFormPages, null)))));
});

const useCampaignRegFormsListStylesInj = makeStyles$1(() => createStyles$1({
  link: {
    width: '100%'
  },
  icon: {
    padding: '12px'
  }
}));
const CampaignRegFormsList = observer$1(() => {
  const [AppRouterLink$1] = di([AppRouterLink], CampaignRegFormsList);
  const [useCampaignRegFormsListStyles] = di([useCampaignRegFormsListStylesInj], CampaignRegFormsList);
  const {
    id: campaignId
  } = useParams();
  const {
    campaignsStore
  } = useStore();
  const {
    changeRegFormsPosition
  } = campaignsStore;
  const history = useHistory();
  const classes = useCampaignRegFormsListStyles();
  const [regForms, setRegForms] = useState([]);
  const loadRegForms = useCallback(function () {
    try {
      return Promise.resolve(campaignsStore.loadRegForms(campaignId, true, true)).then(function (regForms) {
        setRegForms(regForms);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [campaignsStore, setRegForms, campaignId]);
  useEffect(() => {
    loadRegForms();
  }, [loadRegForms]);

  const createRegForm = function () {
    try {
      return Promise.resolve(campaignsStore.createRegForm(campaignId)).then(function (rfId) {
        history.push(generatePath(clientRoute.campaignRegFormCreate, {
          id: campaignId,
          rfId
        }));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const onDragEnd = useCallback(result => {
    if (!result.destination) {
      return;
    }

    const startIndex = result.source.index;
    const endIndex = result.destination.index;
    changeRegFormsPosition(result.draggableId, endIndex + 1);
    setRegForms(reorderList(regForms, startIndex, endIndex));
  }, [changeRegFormsPosition, setRegForms, reorderList, regForms]);
  return React__default.createElement(Box, {
    width: "100%"
  }, React__default.createElement(Box, {
    pb: 5,
    width: "100%"
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.campaignRegForms"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    variant: "text",
    color: "primary",
    size: "small",
    startIcon: React__default.createElement(AddIcon, null),
    onClick: createRegForm
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.addCampaignRegFormButton"
  }))))), React__default.createElement(Box, {
    ml: -4,
    mr: -4,
    width: "100%"
  }, React__default.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, React__default.createElement(Droppable, {
    droppableId: 'droppable'
  }, droppableProvided => React__default.createElement(List, Object.assign({
    ref: droppableProvided.innerRef,
    disablePadding: true
  }, droppableProvided.droppableProps), regForms.map((rf, index) => {
    const id = rf.id;
    return React__default.createElement(Draggable, {
      draggableId: id,
      index: index,
      key: id
    }, provided => React__default.createElement(ListItem, Object.assign({
      key: id,
      button: true,
      ref: provided.innerRef
    }, provided.draggableProps), React__default.createElement(AppRouterLink$1, {
      className: classes.link,
      underline: 'none',
      to: generatePath(clientRoute.campaignRegForm, {
        id: campaignId,
        rfId: id
      })
    }, React__default.createElement(ListItemText, {
      primary: rf.title
    }), React__default.createElement(IconButton, Object.assign({}, provided.dragHandleProps), React__default.createElement(SvgIcon, {
      className: classes.icon,
      viewBox: "0 0 20 20"
    }, React__default.createElement(SvgMove, null))))));
  }), droppableProvided.placeholder)))));
});

const CampaignRegForm = observer$1(() => {
  const [ConfirmationDialog$1] = di([ConfirmationDialog], CampaignRegForm);
  const [ErrorDialog$1] = di([ErrorDialog], CampaignRegForm);
  const [ErrorMessage$1] = di([ErrorMessage], CampaignRegForm);
  const [CampaignRegFormTabs$1] = di([CampaignRegFormTabs], CampaignRegForm);
  const classes = useFormStyles();
  const history = useHistory();
  const {
    id,
    rfId
  } = useParams();
  const [open, setModalIsOpen, setModalIsClosed] = useModal();
  const {
    campaignsStore,
    intlStore,
    notificationStore
  } = useStore();
  const {
    locale
  } = intlStore;
  const [form, setForm] = useState();
  const model = useMemo(() => new FormModel(rfId), []);
  const {
    form: formFromModel,
    getLangSubmission
  } = model;
  useEffect(() => {
    campaignsStore.loadRegForm(rfId).then(model.load);
  }, [campaignsStore, rfId, model]);

  const onFormReady = form => {
    setForm(form);
  };

  const onSubmit = () => {
    if (form && form.validate()) {
      form.submit(false).then(() => {
        return campaignsStore.saveRegForm(rfId, form.getSubmission());
      }).then(() => {
        history.push(generatePath(clientRoute.campaignRegForm, {
          id,
          rfId
        }));
      }).then(() => {
        campaignsStore.loadRegForm(rfId).then(model.load);
      }).catch(error => {
        notificationStore.onError(error.response.data);
        form.setSubmissionFromStartSubmission();
      });
    }
  };

  const onDeleteLinkClick = () => {
    setModalIsOpen();
  };

  const [isError, errorText, enableError, resetError] = useError();

  const handleErrorDeletion = error => {
    const errorText = ErrorMessage$1(error);
    enableError(errorText);
  };

  const onConfirmDelete = function () {
    try {
      function _temp2() {
        setModalIsClosed();
      }

      const _temp = _catch(function () {
        return Promise.resolve(campaignsStore.deleteRegForm(rfId)).then(function () {
          history.push(generatePath(clientRoute.campaignRegForms, {
            id,
            rfId
          }));
        });
      }, function (error) {
        handleErrorDeletion(error);
      });

      return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const titleSubmission = useMemo(() => {
    const submission = getLangSubmission(locale);
    return formFromModel && submission && submission.data && submission.data.title;
  }, [formFromModel, getLangSubmission, locale]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ErrorDialog$1, {
    message: errorText,
    open: isError,
    onClose: resetError
  }), React__default.createElement(ConfirmationDialog$1, {
    id: "confirm-delete-rf",
    keepMounted: true,
    open: open,
    onConfirm: onConfirmDelete,
    onCancel: setModalIsClosed,
    title: React__default.createElement(FormattedMessage, {
      id: "campaign.deleteCampaignRegForm"
    }),
    message: React__default.createElement(FormattedMessage, {
      id: "campaign.confirmDeleteCampaignRegForm",
      values: {
        formTitle: titleSubmission
      }
    })
  }), React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: [clientRoute.campaignRegForm, clientRoute.campaignRegFormExecutors, clientRoute.campaignRegFormTabsSettings, clientRoute.campaignRequestFormTabSetting, clientRoute.campaignRequestFormTabSettingCreate, clientRoute.campaignRegFormTemplates, clientRoute.campaignRegFormTemplatesCreate, clientRoute.campaignRegFormTemplatesEdit, clientRoute.campaignRegFormTemplatesPermissionSettings, ...getAdditionalCampaignRegFormTabsRoutes()],
    exact: true
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, titleSubmission))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(CampaignRegFormTabs$1, {
    model: model,
    onFormReady: onFormReady,
    onDeleteLinkClick: onDeleteLinkClick
  })))), React__default.createElement(Route, {
    path: [clientRoute.campaignRegFormCreate, clientRoute.campaignRegFormEdit],
    exact: true,
    key: clientRoute.campaignRegFormEdit
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.campaignRegFormCreate
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.newCampaignRegForm"
  })), React__default.createElement(Route, {
    path: clientRoute.campaignRegFormEdit
  }, React__default.createElement(FormattedMessage, {
    id: "campaign.editCampaignRegForm",
    values: {
      formTitle: titleSubmission
    }
  }))))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Form, {
    locale: locale,
    className: classes.formWithNoOffset,
    form: model,
    onFormReady: onFormReady
  }), React__default.createElement(Grid, {
    container: true,
    spacing: 5
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "secondary",
    variant: "contained",
    onClick: onSubmit
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.campaignRegFormCreate
  }, React__default.createElement(Button, {
    component: NavLink,
    variant: "text",
    to: generatePath(clientRoute.campaignRegForms, {
      id
    })
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  }))), React__default.createElement(Route, {
    path: clientRoute.campaignRegFormEdit
  }, React__default.createElement(Button, {
    component: NavLink,
    variant: "text",
    to: generatePath(clientRoute.campaignRegForm, {
      id,
      rfId
    })
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })))))))))));
});

const AdditionalCampaignSettingTabsInj = props => React__default.createElement(React__default.Fragment, null);
const getAdditionalCampaignSettingTabsRoutesInj = () => [];
const CampaignSettingTabs = () => {
  const [RoutedTabs$1] = di([RoutedTabs], CampaignSettingTabs);
  const [AdditionalCampaignSettingTabs] = di([AdditionalCampaignSettingTabsInj], CampaignSettingTabs);
  const [getAdditionalCampaignSettingTabsRoutes] = di([getAdditionalCampaignSettingTabsRoutesInj], CampaignSettingTabs);
  const {
    id
  } = useParams();
  return React__default.createElement(RoutedTabs$1, {
    tabsProps: {
      orientation: 'vertical',
      indicatorColor: 'primary'
    },
    settings: [{
      tab: 0,
      path: [clientRoute.campaignSettings, clientRoute.campaignSettingsEdit],
      exact: true
    }, {
      tab: 1,
      path: clientRoute.campaignRegForms
    }, {
      tab: 2,
      path: clientRoute.campaignManagement
    }, {
      tab: 3,
      path: clientRoute.generalSettings
    }, ...getAdditionalCampaignSettingTabsRoutes()]
  }, updateIndicator => [React__default.createElement(Tab, {
    key: "description",
    value: 0,
    component: NavLink,
    to: generatePath(clientRoute.campaignSettings, {
      id
    }),
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.campaignDescription"
    })
  }), React__default.createElement(Tab, {
    key: "regForms",
    value: 1,
    component: NavLink,
    to: generatePath(clientRoute.campaignRegForms, {
      id
    }),
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.campaignRegForms"
    })
  }), React__default.createElement(Tab, {
    key: "management",
    value: 2,
    component: NavLink,
    to: generatePath(clientRoute.campaignManagement, {
      id
    }),
    style: {
      whiteSpace: 'nowrap'
    },
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.campaignManagement"
    })
  }), React__default.createElement(Tab, {
    key: "access",
    value: 3,
    component: NavLink,
    to: generatePath(clientRoute.generalSettings, {
      id
    }),
    style: {
      whiteSpace: 'nowrap'
    },
    label: React__default.createElement(FormattedMessage, {
      id: "campaign.generalSettings"
    })
  }), React__default.createElement(AdditionalCampaignSettingTabs, {
    id: id
  })]);
};

const AdditionalCampaignSettingsPagesInj = () => React__default.createElement(React__default.Fragment, null);
const CampaignSettingsPage = () => {
  const [CampaignForm$1] = di([CampaignForm], CampaignSettingsPage);
  const [CampaignSettingTabs$1] = di([CampaignSettingTabs], CampaignSettingsPage);
  const [CampaignRegFormsList$1] = di([CampaignRegFormsList], CampaignSettingsPage);
  const [CampaignRegForm$1] = di([CampaignRegForm], CampaignSettingsPage);
  const [AuthorizationCheck$1] = di([AuthorizationCheck], CampaignSettingsPage);
  const [BreadcrumbsComponent$1] = di([BreadcrumbsComponent], CampaignSettingsPage);
  const [CampaignManagement$1] = di([CampaignManagement], CampaignSettingsPage);
  const [CampaignGeneralSettings$1] = di([CampaignGeneralSettings], CampaignSettingsPage);
  const [AdditionalCampaignSettingsPages] = di([AdditionalCampaignSettingsPagesInj], CampaignSettingsPage);
  const {
    id
  } = useParams();
  const {
    breadcrumbsStore
  } = useStore();
  const {
    breadCrumbsSettings
  } = breadcrumbsStore;
  return React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.Campaign,
    entityId: id,
    permCode: permissions.Campaign.Edit
  }, allowed => {
    if (!allowed) {
      return React__default.createElement(Redirect, {
        to: clientRoute.notAllowed
      });
    }

    return React__default.createElement(Container, {
      maxWidth: "lg"
    }, React__default.createElement(Box, {
      pt: 5.5,
      pb: 20
    }, React__default.createElement(Box, {
      pl: 3,
      pb: 5
    }, React__default.createElement(BreadcrumbsComponent$1, {
      objectId: id,
      breadcrumbsSettings: breadCrumbsSettings
    })), React__default.createElement(Grid, {
      container: true,
      spacing: 5
    }, React__default.createElement(Grid, {
      item: true,
      xs: 3
    }, React__default.createElement(CampaignSettingTabs$1, null)), React__default.createElement(Grid, {
      item: true,
      xs: 9
    }, React__default.createElement(Container, {
      maxWidth: "md"
    }, React__default.createElement(Switch, null, React__default.createElement(Route, {
      path: [clientRoute.campaignSettings, clientRoute.campaignSettingsEdit],
      exact: true
    }, React__default.createElement(CampaignForm$1, null)), React__default.createElement(Route, {
      path: clientRoute.campaignRegForms,
      exact: true
    }, React__default.createElement(CampaignRegFormsList$1, null)), React__default.createElement(Route, {
      path: [clientRoute.campaignManagement],
      exact: true
    }, React__default.createElement(CampaignManagement$1, null)), React__default.createElement(Route, {
      path: clientRoute.generalSettings,
      exact: true
    }, React__default.createElement(CampaignGeneralSettings$1, null)), React__default.createElement(Route, {
      path: [clientRoute.campaignRegForm, clientRoute.campaignRegFormExecutors, clientRoute.campaignRegFormTabsSettings, clientRoute.campaignRequestFormTabSetting, clientRoute.campaignRequestFormTabSettingCreate, clientRoute.campaignRegFormTemplates, clientRoute.campaignRegFormTemplatesCreate, clientRoute.campaignRegFormTemplatesEdit, clientRoute.campaignRegFormTemplatesPermissionSettings, clientRoute.campaignRegFormCreate, clientRoute.campaignRegFormEdit, ...getAdditionalCampaignRegFormTabsRoutes()]
    }, React__default.createElement(CampaignRegForm$1, null)), React__default.createElement(AdditionalCampaignSettingsPages, null)))))));
  });
};

var AdditionalCampaignPagesInj = function AdditionalCampaignPagesInj() {
  return null;
};
var CampaignPages = function CampaignPages() {
  var _di = di([RegFormSelectPage], CampaignPages),
      RegFormSelectPage$1 = _di[0];

  var _di2 = di([CampaignPage], CampaignPages),
      CampaignPage$1 = _di2[0];

  var _di3 = di([CampaignListPage], CampaignPages),
      CampaignListPage$1 = _di3[0];

  var _di4 = di([CampaignSettingsPage], CampaignPages),
      CampaignSettingsPage$1 = _di4[0];

  var _di5 = di([CreateCampaignPage], CampaignPages),
      CreateCampaignPage$1 = _di5[0];

  var _di6 = di([Authentication], CampaignPages),
      Authentication$1 = _di6[0];

  var _di7 = di([AdditionalCampaignPagesInj], CampaignPages),
      AdditionalCampaignPages = _di7[0];

  return React__default.createElement(Authentication$1, null, React__default.createElement(Switch, null, AdditionalCampaignPages(), React__default.createElement(Route, {
    path: clientRoute.regFormSelect
  }, React__default.createElement(RegFormSelectPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.campaignSettings
  }, React__default.createElement(CampaignSettingsPage$1, null)), React__default.createElement(Route, {
    exact: true,
    path: clientRoute.campaign
  }, React__default.createElement(CampaignPage$1, null)), React__default.createElement(Route, {
    exact: true,
    path: clientRoute.createCampaign
  }, React__default.createElement(CreateCampaignPage$1, null)), React__default.createElement(Route, {
    exact: true,
    route: clientRoute.campaigns
  }, React__default.createElement(CampaignListPage$1, null))));
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n        text-transform: uppercase;\n    "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var UpperLink = withTheme(styled(Link$1)(_templateObject$5()));

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n        display: flex;\n        align-items: center;\n        font-family: 'PT Sans', sans-serif;\n        font-size: 15px;\n        font-weight: bold;\n        line-height: 1.2;\n        letter-spacing: 1.5px;\n        min-height: 42px;\n    "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var StartPageHeaderLink = withTheme(styled(UpperLink)(_templateObject$6()));

var StartPageLoginLink = function StartPageLoginLink(props) {
  var handleToggle = props.handleToggle,
      anchorRef = props.anchorRef;

  var _di = di([StartPageHeaderLink], StartPageLoginLink),
      StartPageHeaderLink$1 = _di[0];

  return React__default.createElement(StartPageHeaderLink$1, {
    ref: anchorRef,
    component: Button,
    onClick: handleToggle,
    color: "secondary",
    underline: "none"
  }, React__default.createElement(Grid, {
    container: true,
    item: true,
    alignItems: "center"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.headerLinks.login"
  }), React__default.createElement(Box, {
    ml: 1,
    style: {
      lineHeight: 1
    }
  }, React__default.createElement(ExitToAppIcon, null))));
};

var StartAuthHeaderLink = observer$1(function (props) {
  var _di = di([StartPageHeaderLink], StartAuthHeaderLink),
      StartPageHeaderLink$1 = _di[0];

  var _di2 = di([StartPageLoginLink], StartAuthHeaderLink),
      StartPageLoginLink$1 = _di2[0];

  var anchorRef = props.anchorRef,
      handleToggle = props.handleToggle;

  var _useStore = useStore(),
      api = _useStore.api,
      personStore = _useStore.personStore;

  useEffect(function () {
    personStore.getInfo().then(api.authVerify);
  }, [personStore, api]);

  switch (api.authStatus) {
    case 'ok':
      return React__default.createElement(StartPageHeaderLink$1, {
        component: Link,
        to: clientRoute.campaigns,
        color: "secondary",
        underline: "none"
      }, personStore.person.lastNameWithInitials);

    default:
      return React__default.createElement(StartPageLoginLink$1, {
        handleToggle: handleToggle,
        anchorRef: anchorRef
      });
  }
});

var checkRadioBox = {
  checkRadioBoxPadding: 33,
  checkRadioBoxFontSize: 13,
  checkRadioBoxIconSize: {
    width: 18,
    height: 18
  },
  checkRadioBoxIconPosition: {
    left: -33,
    top: 'calc(50% - 9px)'
  },
  radioBorderRadius: '50%',
  checkedRadioIconPosition: {
    left: -29,
    top: 'calc(50% - 5px)'
  },
  checkedRadioIconSize: {
    width: 10,
    height: 10
  },
  checkboxBorderRadius: 3
};

var boxSize = 30;
var checkbox = {
  boxSize: boxSize
};

var formControl = {
  borderRadius: 4,
  padding: '6px 18px',
  minHeight: 48,
  fontWeight: 500,
  fontSize: 15,
  lineHeight: 22,
  border: function border(color, width) {
    return "0px 0px 0px " + width + "px " + color;
  }
};

var formioDateTime = {
  formControl: {
    borderRadius: '4px !important'
  },
  inputGroupAddon: {
    width: '40px',
    height: '40px',
    top: 'calc(50% - 20px)',
    right: '10px'
  }
};

var inputHeight = 60;
var inputIconTransition = 'border-color ease-in-out .15s, color ease-in-out .15s';
var input = {
  height: inputHeight,
  iconTransition: inputIconTransition
};

var select = {
  selectItem: {
    fontSize: 13,
    padding: '9px 0 9px 18px !important'
  },
  selectDropdown: {
    borderRadius: 4,
    boxShadow: '0px 6px 32px 0 rgba(0, 0, 0, 0.09)'
  },
  selectChipMultiple: {
    height: 24,
    fontSize: 11,
    lineHeight: 22,
    borderRadius: 4,
    transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  selectChoicesList: {
    paddingTop: 6
  }
};

var sizes = {
  small: 30,
  medium: 36,
  large: 48
};
var button = {
  sizes: sizes
};

var height = 66;
var footer = {
  height: height
};

var height$1 = 96;
var tabsHeight = 68;
var requestPanel = {
  height: height$1,
  tabsHeight: tabsHeight
};

var actionIconSize = 20;
var actionIconFontSize = 13;
var requestPrintForms = {
  actionIconSize: actionIconSize,
  actionIconFontSize: actionIconFontSize
};

var width = 312;
var widthXl = 321;
var offsetVertical = 14;
var errorSize = 24;
var collapseIconWidth = 36;
var sidebar = {
  width: width,
  widthXl: widthXl,
  offsetVertical: offsetVertical,
  errorSize: errorSize,
  collapseIconWidth: collapseIconWidth
};

const spacing = 4;

var createAppThemeOptions = function createAppThemeOptions(overrides) {
  var palette = overrides.palette,
      fonts = overrides.fonts,
      icons = overrides.icons;
  return {
    breakpoints: createBreakpoints({
      keys: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
      values: {
        xs: 0,
        sm: 640,
        md: 960,
        lg: 1280,
        xl: 1536,
        xxl: 1920
      }
    }),
    palette: {
      primary: {
        light: palette.mainLight,
        main: palette.main,
        dark: palette.mainDark,
        contrastText: palette.mainContrast
      },
      secondary: {
        main: palette.accent,
        dark: palette.accentDark,
        contrastText: palette.accentContrast
      },
      action: {
        hover: palette.hover
      }
    },
    typography: {
      fontFamily: fonts.mainFont,
      fontSize: 13,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 700
    },
    shadows: ['none', "0px 6px 32px 0 rgba(0, 0, 0, 0.09)", "0px 3px 1px -2px " + palette.textDark + "33,0px 2px 2px 0px " + palette.textDark + "24,0px 1px 5px 0px " + palette.textDark + "1f", "0px 3px 3px -2px " + palette.textDark + "33,0px 3px 4px 0px " + palette.textDark + "24,0px 1px 8px 0px " + palette.textDark + "1f", "0px 2px 4px -1px " + palette.textDark + "33,0px 4px 5px 0px " + palette.textDark + "24,0px 1px 10px 0px " + palette.textDark + "1f", "0px 3px 5px -1px " + palette.textDark + "33,0px 5px 8px 0px " + palette.textDark + "24,0px 1px 14px 0px " + palette.textDark + "1f", "0px 3px 5px -1px " + palette.textDark + "33,0px 6px 10px 0px " + palette.textDark + "24,0px 1px 18px 0px " + palette.textDark + "1f", "0px 4px 5px -2px " + palette.textDark + "33,0px 7px 10px 1px " + palette.textDark + "24,0px 2px 16px 1px " + palette.textDark + "1f", "0px 5px 5px -3px " + palette.textDark + "33,0px 8px 10px 1px " + palette.textDark + "24,0px 3px 14px 2px " + palette.textDark + "1f", "0px 5px 6px -3px " + palette.textDark + "33,0px 9px 12px 1px " + palette.textDark + "24,0px 3px 16px 2px " + palette.textDark + "1f", "0px 6px 6px -3px " + palette.textDark + "33,0px 10px 14px 1px " + palette.textDark + "24,0px 4px 18px 3px " + palette.textDark + "1f", "0px 6px 7px -4px " + palette.textDark + "33,0px 11px 15px 1px " + palette.textDark + "24,0px 4px 20px 3px " + palette.textDark + "1f", "0px 7px 8px -4px " + palette.textDark + "33,0px 12px 17px 2px " + palette.textDark + "24,0px 5px 22px 4px " + palette.textDark + "1f", "0px 7px 8px -4px " + palette.textDark + "33,0px 13px 19px 2px " + palette.textDark + "24,0px 5px 24px 4px " + palette.textDark + "1f", "0px 7px 9px -4px " + palette.textDark + "33,0px 14px 21px 2px " + palette.textDark + "24,0px 5px 26px 4px " + palette.textDark + "1f", "0px 8px 9px -5px " + palette.textDark + "33,0px 15px 22px 2px " + palette.textDark + "24,0px 6px 28px 5px " + palette.textDark + "1f", "0px 8px 10px -5px " + palette.textDark + "33,0px 16px 24px 2px " + palette.textDark + "24,0px 6px 30px 5px " + palette.textDark + "1f", "0px 8px 11px -5px " + palette.textDark + "33,0px 17px 26px 2px " + palette.textDark + "24,0px 6px 32px 5px " + palette.textDark + "1f", "0px 9px 11px -5px " + palette.textDark + "33,0px 18px 28px 2px " + palette.textDark + "24,0px 7px 34px 6px " + palette.textDark + "1f", "0px 9px 12px -6px " + palette.textDark + "33,0px 19px 29px 2px " + palette.textDark + "24,0px 7px 36px 6px " + palette.textDark + "1f", "0px 10px 13px -6px " + palette.textDark + "33,0px 20px 31px 3px " + palette.textDark + "24,0px 8px 38px 7px " + palette.textDark + "1f", "0px 10px 13px -6px " + palette.textDark + "33,0px 21px 33px 3px " + palette.textDark + "24,0px 8px 40px 7px " + palette.textDark + "1f", "0px 10px 14px -6px " + palette.textDark + "33,0px 22px 35px 3px " + palette.textDark + "24,0px 8px 42px 7px " + palette.textDark + "1f", "0px 11px 14px -7px " + palette.textDark + "33,0px 23px 36px 3px " + palette.textDark + "24,0px 9px 44px 8px " + palette.textDark + "1f", "0px 11px 15px -7px " + palette.textDark + "33,0px 24px 38px 3px " + palette.textDark + "24,0px 9px 46px 8px " + palette.textDark + "1f"],
    overrides: {
      MuiAppBar: {
        colorDefault: {
          backgroundColor: palette.appBar.mainContrast,
          color: palette.mainLight
        }
      },
      MuiButton: {
        root: {
          fontSize: '13px',
          fontWeight: 'bold',
          lineHeight: '1.25',
          letterSpacing: '0.2px',
          height: button.sizes.medium + "px",
          padding: '0 10px',
          transition: "background-color " + transitionDefault + ",\n                                 box-shadow " + transitionDefault + ",\n                                 border " + transitionDefault + ",\n                                 color " + transitionDefault,
          textTransform: 'none'
        },
        contained: {
          boxShadow: 'none',
          backgroundColor: 'transparent',
          color: palette.textDark,
          '&:hover': {
            boxShadow: 'none !important',
            backgroundColor: palette.main,
            color: palette.mainContrast
          },
          '&.Mui-disabled': {
            background: palette.button.disabled
          }
        },
        containedPrimary: {
          boxShadow: 'none',
          background: palette.accentBackgroundGradient,
          color: palette.button.accentContrast,
          '& [class^=MuiButton-startIcon]': {
            color: palette.textDark
          },
          '&.Mui-disabled [class^=MuiButton-startIcon]': {
            color: 'rgba(0, 0, 0, 0.26)'
          },
          '&:hover': {
            boxShadow: 'none',
            background: 'none',
            backgroundColor: palette.main,
            color: palette.mainContrast,
            '& [class^=MuiButton-startIcon]': {
              color: palette.mainContrast
            },
            '&:focus': {
              color: palette.mainContrast
            }
          },
          '&:focus': {
            color: palette.accentContrastBackgroundGradient
          }
        },
        containedSecondary: {
          boxShadow: 'none',
          backgroundColor: palette.main,
          color: palette.mainContrast,
          '& [class^=MuiButton-startIcon]': {
            color: palette.mainContrast
          },
          '&:hover': {
            boxShadow: 'none',
            background: "" + palette.accentBackgroundGradient,
            color: palette.button.accentContrast,
            '& [class^=MuiButton-startIcon]': {
              color: palette.button.accentContrast
            }
          }
        },
        containedSizeLarge: {
          height: button.sizes.large + "px",
          padding: '0 44px',
          fontSize: '14px',
          fontWeight: 'bold',
          lineHeight: '1.14',
          letterSpacing: '0.84px'
        },
        containedSizeSmall: {
          padding: '6px 16px'
        },
        text: {
          lineHeight: 1.25,
          letterSpacing: '1.04px',
          padding: '8px 10px',
          '&:hover': {
            background: "" + palette.accentBackgroundGradient,
            color: palette.accentContrastBackgroundGradient
          }
        },
        textPrimary: {
          color: palette.main,
          '& [class^=MuiButton-startIcon]': {
            color: palette.main
          },
          '&:hover': {
            background: palette.accentBackgroundGradient,
            color: palette.button.textHover
          },
          '&:hover [class^=MuiButton-startIcon]': {
            color: palette.button.accentContrast
          }
        },
        textSecondary: {
          color: palette.mainLight,
          '&:hover': {
            color: palette.hover,
            background: 'transparent',
            backgroundColor: 'transparent'
          },
          '&:hover [class^=MuiButton-startIcon]': {
            color: palette.hover
          },
          '&.active': {
            color: palette.hover
          },
          '&.active [class^=MuiButton-startIcon]': {
            color: palette.hover
          }
        },
        textSizeSmall: {
          padding: '6px 13px',
          fontSize: 'inherit'
        },
        textSizeLarge: {
          height: '48px',
          padding: '6px 13px',
          fontSize: 'inherit'
        },
        startIcon: {
          marginLeft: 0,
          color: palette.mainLight,
          transition: "color " + transitionDefault,
          '&:hover': {
            color: palette.textDark
          }
        },
        label: {
          whiteSpace: 'nowrap'
        }
      },
      MuiRadio: {
        root: {
          padding: 0
        },
        colorSecondary: {
          '&.Mui-checked': {
            color: palette.main
          }
        }
      },
      MuiIconButton: {
        root: {
          width: button.sizes.medium + "px",
          height: button.sizes.medium + "px",
          padding: 0,
          color: palette.main,
          '&.active': {
            color: palette.textDark
          },
          '&:hover': {
            backgroundColor: palette.main,
            color: palette.mainContrast
          },
          '&.active:hover': {
            color: palette.mainContrast
          },
          '@media (hover: none)': {
            '&:hover': {
              backgroundColor: palette.main + " !important"
            }
          }
        },
        sizeSmall: {
          width: button.sizes.small + "px",
          height: button.sizes.small + "px",
          padding: 0
        },
        colorPrimary: {
          color: palette.main,
          '&:hover': {
            background: "" + palette.accentBackgroundGradient,
            color: palette.accentContrast
          }
        },
        colorSecondary: {
          color: palette.mainLight + " !important",
          '&:hover': {
            color: palette.hover + " !important",
            backgroundColor: 'transparent !important'
          },
          '&.active': {
            color: palette.hover + " !important"
          }
        }
      },
      MuiLink: {
        root: _extends({}, fonts.mainFontAttrs, {
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover': {
            color: palette.textDark
          },
          '&.active': {
            color: palette.textDark
          },
          '&.MuiTypography-colorPrimary': {
            color: palette.textDark,
            '&:hover': {
              color: palette.main
            }
          },
          '&.MuiTypography-colorSecondary': {
            color: palette.main,
            '&:hover': {
              color: palette.hover
            }
          },
          '&.MuiTypography-colorTextPrimary': {
            color: palette.main,
            '&:hover': {
              color: palette.textDark
            },
            '&.active': {
              color: palette.textDark
            }
          },
          '& .MuiSvgIcon-root': {
            paddingRight: '12px'
          }
        })
      },
      MuiTypography: {
        h1: {
          fontSize: '24px',
          fontWeight: 600,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.5,
          letterSpacing: 'normal'
        },
        h2: {
          fontSize: '3rem',
          fontWeight: 600
        },
        h3: {
          fontSize: '18px',
          fontWeight: 'bold',
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.56,
          letterSpacing: '0.36px'
        },
        body1: _extends({}, fonts.mainFontAttrs),
        body2: {
          fontSize: '15px',
          fontWeight: 'normal',
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.47,
          letterSpacing: '0.3px'
        }
      },
      MuiInputLabel: {
        root: {
          backgroundColor: palette.mainContrast,
          paddingRight: spacing + "px"
        },
        shrink: {
          textTransform: 'uppercase',
          letterSpacing: '0.4px'
        }
      },
      MuiPaper: {
        rounded: {
          borderRadius: '8px'
        }
      },
      MuiCheckbox: {
        colorPrimary: {
          '&:hover': {
            background: 'transparent'
          }
        }
      },
      MuiFormControlLabel: {
        root: {
          '&:hover .MuiIconButton-label': {
            color: palette.textDark
          }
        }
      },
      MuiListItem: {
        root: {
          outline: 'none',
          '&.Mui-selected': {
            color: palette.textDark
          },
          '&.Mui-selected:hover': {
            backgroundColor: palette.hoverInLists
          }
        },
        button: {
          color: palette.main,
          '&:hover': {
            color: palette.textDark,
            backgroundColor: palette.hoverInLists
          }
        }
      },
      MuiTabs: {
        indicator: {
          height: '3px'
        },
        root: {
          '&.MuiTabs-vertical .MuiTabs-indicator': {
            width: '3px'
          }
        },
        flexContainer: {
          '&.MuiTabs-flexContainerVertical .MuiTab-wrapper': {
            alignItems: 'flex-start'
          },
          '&.MuiTabs-flexContainerVertical .MuiTab-root': {
            minHeight: 'auto'
          }
        }
      },
      MuiDialogActions: {
        spacing: {
          padding: '16px 24px'
        }
      },
      MuiTableRow: {
        root: {
          '&:nth-child(even)': {
            backgroundColor: palette.table.row.even
          },
          '&:nth-child(odd)': {
            backgroundColor: palette.table.row.odd
          },
          '&.MuiTableRow-head': {
            backgroundColor: palette.mainContrast
          },
          '&.MuiTableRow-footer': {
            backgroundColor: palette.mainContrast
          },
          '&.MuiTableRow-hover': {
            '&:hover': {
              backgroundColor: palette.hoverInLists
            }
          }
        }
      },
      MuiTableCell: {
        root: {
          padding: 4 * spacing + "px",
          borderBottomWidth: 0,
          paddingTop: 3 * spacing + "px",
          paddingBottom: 3 * spacing + "px",
          paddingLeft: 1.5 * spacing + "px",
          paddingRight: 1.5 * spacing + "px",
          '&:first-child': {
            paddingLeft: 6 * spacing + "px"
          },
          '&:last-child': {
            paddingRight: 6 * spacing + "px"
          },
          verticalAlign: 'top'
        },
        body: {
          color: palette.textMain
        },
        head: {
          backgroundColor: 'white',
          color: palette.textDark,
          fontWeight: 600
        }
      },
      MuiTableSortLabel: {
        icon: {
          fontSize: 'x-large'
        }
      },
      MuiTooltip: {
        tooltip: {
          backgroundColor: palette.tooltip.backgroundColor,
          fontSize: 12
        }
      },
      MuiExpansionPanelSummary: {
        root: {
          paddingLeft: 6 * spacing + "px",
          paddingRight: 0
        },
        expandIcon: {
          marginRight: 6 * spacing + "px",
          '&:hover': {
            backgroundColor: palette.main
          }
        }
      },
      MuiExpansionPanelDetails: {
        root: {
          paddingLeft: 6 * spacing + "px",
          paddingRight: 6 * spacing + "px",
          paddingBottom: 6 * spacing + "px"
        }
      },
      MuiPickersToolbar: {
        toolbar: {
          height: '80px'
        }
      },
      MuiPickersToolbarButton: {
        toolbarBtn: {
          backgroundColor: 'transparent',
          '&.MuiButton-text': {
            color: palette.mainContrast
          },
          '&:hover': {
            backgroundColor: 'transparent',
            backgroundImage: 'none'
          },
          '& .MuiPickersToolbarText-toolbarTxt': {
            transition: transitionDefault
          },
          '& .MuiPickersToolbarText-toolbarTxt:hover': {
            color: palette.mainContrast,
            transition: transitionDefault
          },
          '& .MuiPickersToolbarText-toolbarBtnSelected': {
            color: palette.mainContrast
          }
        }
      },
      MuiAutocomplete: {
        listbox: {
          maxHeight: '180px'
        },
        tag: {
          borderRadius: '4px',
          backgroundColor: palette.hoverInLists,
          '&:hover': {
            backgroundColor: palette.main,
            color: palette.mainContrast,
            '& .MuiChip-deleteIcon': {
              color: palette.mainContrast
            }
          },
          '& .MuiChip-deleteIcon': {
            color: palette.main,
            flexShrink: 0
          }
        },
        clearIndicator: {
          height: '24px',
          width: '24px'
        },
        option: {
          padding: "0 " + 4 * spacing + "px !important",
          '&[data-focus="true"]': {
            backgroundColor: palette.hoverInLists
          },
          '&[area-selected="true"]': {
            backgroundColor: palette.hoverInLists
          },
          '&:hover': {
            backgroundColor: palette.hoverInLists
          },
          '&:hover .MuiCheckbox-colorPrimary': {
            color: palette.textDark
          },
          '& .MuiCheckbox-colorPrimary.Mui-checked': {
            color: palette.main
          }
        },
        popupIndicator: {
          width: '24px',
          height: '24px'
        }
      },
      MuiInputBase: {
        input: {
          '&[type="password"]::-ms-reveal': {
            display: 'none'
          }
        }
      },
      MuiCardActions: {
        root: {
          padding: 4 * spacing + "px " + 6 * spacing + "px"
        }
      },
      MuiPaginationItem: {
        root: {
          color: palette.main,
          '&:hover': {
            color: palette.campaignList.buttonPaginationTextHover
          }
        },
        textSecondary: {
          '&:hover': {
            background: palette.accentBackgroundGradient
          },
          '&.Mui-selected': {
            color: palette.textDark,
            backgroundColor: palette.campaignList.selectedPaginationButton,
            '&:hover': {
              background: palette.campaignList.selectedPaginationButtonBackgroundHover + "!important"
            }
          }
        }
      }
    },
    spacing: spacing,
    variables: {
      palette: palette,
      fonts: fonts,
      icons: icons,
      sass: {},
      button: button,
      requestPanel: requestPanel,
      footer: footer,
      sidebar: sidebar,
      alertLink: {
        color: palette.mainDark,
        hoverColor: palette.mainLight
      },
      requestPrintForms: requestPrintForms,
      formio: {
        input: input,
        checkbox: checkbox,
        checkRadioBox: checkRadioBox,
        formControl: formControl,
        formioDateTime: formioDateTime,
        select: select,
        dateTime: {
          addonPadding: (inputHeight - icons.calendarIcon.width) / 2
        }
      }
    }
  };
};

var mainFont = '"Roboto", sans-serif';

var createLandingThemeOptions = function createLandingThemeOptions(overrides) {
  var palette = overrides.palette,
      fonts = overrides.fonts;
  return {
    typography: {
      fontFamily: mainFont,
      fontSize: 18,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700
    },
    overrides: {
      MuiLink: {
        root: {
          color: palette.main,
          '&:hover': {
            color: palette.textDark
          }
        }
      },
      MuiTypography: {
        colorPrimary: {
          color: palette.background.textMain,
          fontWeight: 'bold',
          textTransform: 'uppercase'
        },
        colorSecondary: {
          color: palette.mainContrast + " !important",
          '&:hover': {
            color: palette.hover + " !important"
          }
        }
      }
    },
    variables: {
      palette: palette,
      fonts: _extends({}, fonts, {
        mainFont: mainFont
      })
    }
  };
};

var sassVars = {
  arrowLeftIconHeight: '10px',
  arrowLeftIconWidth: '7px',
  backgroundContrastColor: 'rgb(244, 67, 54)',
  backgroundDarkColor: 'rgb(51, 51, 51)',
  backgroundLightColor: 'rgb(245, 245, 245)',
  backgroundMainColor: 'rgb(255, 255, 255)',
  borderColor: 'rgb(204, 211, 219)',
  btnBackgroundColor: 'rgb(244, 67, 54)',
  btnBorder: '2px solid rgb(244, 67, 54)',
  btnBorderColor: 'rgb(244, 67, 54)',
  btnBorderRadius: '4px',
  btnBorderRadiusLg: '30px',
  btnBorderRadiusXs: '18px',
  btnBorderStyle: 'solid',
  btnBorderWidth: '2px',
  btnBoxShadow: 'none',
  btnColor: 'rgb(255, 255, 255)',
  btnDefaultBackgroundColor: 'rgb(255, 255, 255)',
  btnDefaultBorderColor: 'rgb(244, 67, 54)',
  btnDefaultColor: 'rgb(244, 67, 54)',
  btnDefaultHoverBackgroundColor: 'rgb(51, 51, 51)',
  btnDefaultHoverBorderColor: 'rgb(51, 51, 51)',
  btnDefaultHoverColor: 'rgb(255, 255, 255)',
  btnDisabledBackgroundColor: 'rgb(226, 226, 226)',
  btnDisabledBorderColor: 'rgb(227, 227, 227)',
  btnDisabledColor: 'rgb(153, 153, 153)',
  btnDisabledIconColor: 'rgb(153, 153, 153)',
  btnFocusBoxShadow: 'none',
  btnFontFamily: "'Open Sans', sans-serif",
  btnFontSize: '16px',
  btnFontSizeLg: '16px',
  btnFontSizeXs: '13px',
  btnFontWeight: 700,
  btnHeight: '36px',
  btnHoverBackgroundColor: 'rgb(51, 51, 51)',
  btnHoverBorderColor: 'rgb(51, 51, 51)',
  btnHoverColor: 'rgb(255, 255, 255)',
  btnLetterSpacing: '1.3px',
  btnLetterSpacingLg: '1.92px',
  btnLineHeight: '24px',
  btnLinkBackgroundColor: 'rgba(0, 0, 0, 0)',
  btnLinkBorder: '1px solid rgb(255, 255, 255)',
  btnLinkBorderRadius: '4px',
  btnLinkBoxShadowBlurredBlurRadius: '7px',
  btnLinkBoxShadowBlurredColor: 'rgb(51, 51, 51)',
  btnLinkBoxShadowBlurredOffset: 0,
  btnLinkBoxShadowBlurredSpreadRadius: '4px',
  btnLinkBoxShadowOutlineBlurRadius: 0,
  btnLinkBoxShadowOutlineColor: 'rgb(51, 51, 51)',
  btnLinkBoxShadowOutlineOffset: 0,
  btnLinkBoxShadowOutlineSpreadRadius: '4px',
  btnLinkBoxShadowOverlayBlurRadius: 0,
  btnLinkBoxShadowOverlayColor: 'rgb(255, 255, 255)',
  btnLinkBoxShadowOverlayOffset: 0,
  btnLinkBoxShadowOverlaySpreadRadius: '3px',
  btnLinkColor: 'rgb(244, 67, 54)',
  btnLinkDisabledBackgroundColor: 'rgba(0, 0, 0, 0)',
  btnLinkDisabledColor: 'rgb(153, 153, 153)',
  btnLinkFontFamily: "'Open Sans', sans-serif",
  btnLinkFontSize: '18px',
  btnLinkFontWeight: 400,
  btnLinkHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
  btnLinkHoverBorder: 'none',
  btnLinkHoverColor: 'rgb(0, 0, 0)',
  btnLinkHoverOutline: 'none',
  btnLinkHoverTextDecoration: 'none',
  btnLinkLetterSpacing: '0.36px',
  btnLinkLineHeight: '28px',
  btnLinkMargin: '12px 0',
  btnLinkPadding: 0,
  btnLinkTextTransform: 'none',
  btnPaddingHorizontal: '25px',
  btnPaddingHorizontalLg: '25px',
  btnPaddingHorizontalXs: '25px',
  btnPaddingVertical: '10px',
  btnPaddingVerticalLg: '16px',
  btnPaddingVerticalXs: '4px',
  btnSlideBorder: '2px solid rgb(244, 67, 54)',
  btnSlideBorderRadius: '30px',
  btnSlideColor: 'rgb(244, 67, 54)',
  btnSlideDisabledHoverBackgroundColor: 'rgb(255, 255, 255)',
  btnSlideDisabledHoverTextDisplay: 'none',
  btnSlideDisabledHoverTransition: 'none',
  btnSlideDisabledHoverWidth: '60px',
  btnSlideFontSize: '16px',
  btnSlideFontWeight: 700,
  btnSlideHeight: '60px',
  btnSlideHoverBackgroundColor: 'rgb(51, 51, 51)',
  btnSlideHoverBorderColor: 'rgb(51, 51, 51)',
  btnSlideHoverColor: 'rgb(255, 255, 255)',
  btnSlideHoverIconMarginRight: '19px',
  btnSlideHoverIconTransition: 'color 0.1s 0.1s linear',
  btnSlideHoverTextOpacity: 1,
  btnSlideHoverTextPaddingRight: '4px',
  btnSlideHoverTextTransition: 'color 0.1s 0.1s linear opacity 0.1s 0.1s linear max-width 0.1s 0.1s linear',
  btnSlideHoverTransition: 'max-width 1s 0.1s linear background-color 0.1s linear border-color 0.1s linear',
  btnSlideHoverWidth: '100%',
  btnSlideIconColor: 'rgb(244, 67, 54)',
  btnSlideIconSize: '18px',
  btnSlideLetterSpacing: '1.92px',
  btnSlidePadding: '0 19px',
  btnSlideTextOpacity: 0,
  btnSlideWidth: '60px',
  btnTextTransform: 'uppercase',
  checkboxBoxBackgroundColor: 'rgb(255, 255, 255)',
  checkboxBoxBorder: '2px solid rgb(204, 211, 219)',
  checkboxBoxBorderColor: 'rgb(204, 211, 219)',
  checkboxBoxBorderRadius: '4px',
  checkboxBoxOffsetRight: '15px',
  checkboxBoxSize: '30px',
  checkboxCheckedBoxBackgroundColor: 'rgb(204, 211, 219)',
  checkboxCheckedBoxBorderColor: 'rgb(204, 211, 219)',
  checkboxCheckedIconColor: 'rgb(244, 67, 54)',
  checkboxCheckedLabelColor: 'rgb(0, 0, 0)',
  checkboxHoverBoxBorderColor: 'rgb(0, 0, 0)',
  checkboxHoverIconColor: 'rgb(0, 0, 0)',
  checkboxHoverLabelColor: 'rgb(0, 0, 0)',
  checkboxLabelColor: 'rgb(102, 102, 102)',
  checkboxLabelFontSize: '18px',
  checkboxLabelFontWeight: 400,
  checkboxLabelLineHeight: '30px',
  checkboxLabelPaddingLeft: '45px',
  checkboxRadioBoxDisabledBackgroundColor: 'rgb(226, 226, 226)',
  checkboxRadioBoxDisabledBorderColor: 'rgb(204, 204, 204)',
  checkboxRadioBoxDisabledColor: 'rgb(153, 153, 153)',
  checkboxRadioBoxDisabledIconColor: 'rgb(153, 153, 153)',
  colorBlack: 'rgb(0, 0, 0)',
  colorBlackShaft: 'rgb(51, 51, 51)',
  colorGold: 'rgb(157, 132, 32)',
  colorGoldLight: 'rgb(200, 150, 62)',
  colorGreen: 'rgb(0, 100, 4)',
  colorGreyDove: 'rgb(102, 102, 102)',
  colorGreyDusty: 'rgb(153, 153, 153)',
  colorGreyLight: 'rgb(226, 226, 226)',
  colorGreySeashell: 'rgb(241, 241, 241)',
  colorGreySilver: 'rgb(204, 204, 204)',
  colorGreyWild: 'rgb(227, 227, 227)',
  colorGreyWildSand: 'rgb(245, 245, 245)',
  colorRed: 'rgb(244, 67, 54)',
  colorWhite: 'rgb(255, 255, 255)',
  commentsListBtnToolbarMarginBottom: '15px',
  commentsListMarginBottom: '82px',
  commentsListMinHeight: '120px !important',
  datepickerAddonWidth: '60px',
  datepickerArrowAfterSize: '5px',
  datepickerArrowBeforeSize: '8px',
  datepickerBaseMargin: '6px',
  datepickerBaseSize: '30px',
  datepickerBorderStyle: 'solid',
  datepickerBoxShadow: 'none',
  datepickerContainerBorder: '2px solid rgb(0, 0, 0)',
  datepickerContainerBorderColor: 'rgb(0, 0, 0)',
  datepickerContainerBorderWidth: '2px',
  datepickerContainerPadding: '16px',
  datepickerDayBorderRadius: '3px',
  datepickerDayHoverBackgroundColor: 'rgb(51, 51, 51)',
  datepickerDayHoverBorderColor: 'rgb(51, 51, 51)',
  datepickerDayHoverColor: 'rgb(255, 255, 255)',
  datepickerDaySelectedBackgroundColor: 'rgb(244, 67, 54)',
  datepickerDaySelectedBorderColor: 'rgb(244, 67, 54)',
  datepickerDaySelectedColor: 'rgb(255, 255, 255)',
  datepickerDayTodayBackgroundColor: 'rgb(204, 211, 219)',
  datepickerDayTodayBorderColor: 'rgb(204, 211, 219)',
  datepickerDayTodayColor: 'rgb(244, 67, 54)',
  datepickerDisabledBackgroundColor: 'rgb(226, 226, 226)',
  datepickerDisabledBorderColor: 'rgb(204, 204, 204)',
  datepickerDisabledColor: 'rgb(153, 153, 153)',
  datepickerDisabledIconColor: 'rgb(153, 153, 153)',
  datepickerFontSize: '15px',
  datepickerInputArrowsWidth: '14px',
  datepickerInputBorderWidth: '0 0 1px',
  datepickerInputHourPadding: '16px',
  datepickerInputMinuteMargin: '8px',
  datepickerInputPaddingHoriz: '8px',
  datepickerInputPaddingHorizMin: '2px',
  datepickerInputWidth: '62px',
  datepickerLineHeight: '22px',
  datepickerMonthDropdownOffsetLeft: '4px',
  datepickerMonthDropdownPaddingLeft: '4px',
  datepickerMonthSwitchPaddingHorizLess: '11px',
  datepickerMonthSwitchPaddingHorizMore: '12px',
  datepickerMonthSwitchPaddingVertical: '10px',
  datepickerSmallMargin: '4px',
  datepickerTimeBorderTop: '1px solid rgb(204, 211, 219)',
  datepickerTimeBorderTopColor: 'rgb(204, 211, 219)',
  datepickerTimeBorderTopWidth: '1px',
  datepickerTimeHeight: '38px',
  datepickerTimePaddingTop: '15px',
  datepickerWeekdayColor: 'rgb(153, 153, 153)',
  datepickerWeekdayFontFamily: "'Open Sans', sans-serif",
  datepickerWeekdayFontSize: '10px',
  datepickerWeekdayFontWeight: 400,
  datepickerWeekdayLetterSpacing: '0.4px',
  datepickerWeekdayLineHeight: '18px',
  datepickerWeekdayTextTransform: 'uppercase',
  disabledBackgroundColor: 'rgb(226, 226, 226)',
  disabledBorderColor: 'rgb(204, 204, 204)',
  disabledColor: 'rgb(153, 153, 153)',
  errorColor: 'rgb(244, 67, 54)',
  fileDragBorderColor: 'rgb(0, 0, 0)',
  fileDragBorderStyle: 'dashed',
  fileHasErrorDescriptionMarginTop: '19px',
  fileInputDisabledBackgroundColor: 'rgb(226, 226, 226)',
  fileInputDisabledBorderColor: 'rgb(204, 204, 204)',
  fileInputDisabledColor: 'rgb(153, 153, 153)',
  fileInputDisabledIconColor: 'rgb(153, 153, 153)',
  fileInputHeight: '60px',
  fileInputSelectorBorder: "'none', '!important'",
  fileInputSelectorBorderRadius: '4px',
  fileInputSelectorIconColor: 'rgb(244, 67, 54)',
  fileInputSelectorIconContent: '',
  fileInputSelectorIconMarginRight: '15px !important',
  fileInputSelectorIconSize: '20px !important',
  fileInputSelectorLetterSpacing: '0.3px',
  fileInputSelectorLineHeight: '22px',
  fileInputSelectorLinkMarginLeft: '5px',
  fileInputSelectorPadding: '15px',
  fileInputSelectorTextColor: 'rgb(153, 153, 153)',
  fileInputSelectorTextSize: '15px',
  fileInputSelectorTransition: 'border-color ease-in-out 0.15s',
  fileListBlockFileDisabledLinkBasis: '100%',
  fileListBlockFileDisabledLinkSizeAlign: 'right',
  fileListBlockFileDisabledRemoveBasis: '0%',
  fileListBlockFileLinkBasis: '96%',
  fileListBlockFileLinkExtBasis: '17%',
  fileListBlockFileLinkNameBasis: '64%',
  fileListBlockFileLinkSizeBasis: '17%',
  fileListBlockFileRemoveBasis: '4%',
  fileListBlockFileRemoveIconSize: '18px',
  fileListIconColor: 'rgb(204, 204, 204)',
  fileListItemBorderBottomColor: 'rgb(204, 211, 219)',
  fileListItemBorderBottomStyle: 'solid',
  fileListItemBorderBottomWidth: '1px',
  fileListItemFontSize: '15px',
  fileListLinkColor: 'rgb(153, 153, 153)',
  fileListNameColor: 'rgb(102, 102, 102)',
  fileListTransition: 'color ease-in-out 0.15s',
  fileProgressBackgroundColor: 'rgb(241, 241, 241)',
  fileProgressBarBackgroundColor: 'rgb(244, 67, 54)',
  fileProgressBarBoxShadow: 'none',
  fileProgressBlockBackgroundColor: 'rgb(255, 255, 255)',
  fileProgressColor: 'rgb(255, 255, 255)',
  fileProgressErrorBackgroundColor: 'rgb(244, 67, 54)',
  fileProgressFontSize: '13px',
  fileProgressHeight: '15px',
  fileProgressInfoBackgroundColor: 'rgb(204, 204, 204)',
  fileProgressLineHeight: '15px',
  fileProgressLinesBackground: "'url(\"../../../../resources/images/scss-icons/progress-bg.svg\")', 'repeat-x'",
  fileProgressLinesHeight: '100%',
  fileProgressLinesWidth: '200%',
  fileProgressMarginBottom: 0,
  fileProgressPaddingLeft: '5px',
  fileProgressRadius: '3px',
  fileProgressWidth: '100%',
  focusColor: 'rgb(0, 0, 0)',
  fontFamilyAccent: "'Open Sans', sans-serif",
  fontFamilyGlyphIcons: 'glyphicons-theme',
  fontFamilyHeadings: "'Open Sans', sans-serif",
  fontFamilyMain: "'Open Sans', sans-serif",
  fontFamilyOpenSans: "'Open Sans', sans-serif",
  fontFamilySecondary: "'Open Sans', sans-serif",
  fontFamilySmallMain: "'Open Sans', sans-serif",
  fontSizeMain: '18px',
  fontSizeMainXs: '14px',
  fontSizeSecondary: '10px',
  fontSizeSecondarySm: '12px',
  fontSizeSmallMain: '15px',
  fontSizeSmallMainXs: '13px',
  fontWeightAccent: 700,
  fontWeightBold: 700,
  fontWeightHeadings: 700,
  fontWeightMain: 400,
  fontWeightRegular: 400,
  fontWeightSecondary: 400,
  fontWeightSmallMain: 400,
  footerHeight: '65px',
  formElementBorderRadius: '4px',
  formElementBorderWidth: '2px',
  formElementLabelColor: 'rgb(102, 102, 102)',
  formElementLabelFontFamily: "'Open Sans', sans-serif",
  formElementLabelFontSize: '15px',
  formElementLabelFontWeight: 400,
  formElementLabelLetterSpacing: '0.3px',
  formElementLabelLineHeight: '22px',
  formElementLabelMarginBottom: '8px',
  formElementLabelRequiredColor: 'rgb(244, 67, 54)',
  formGroupMarginBottom: '24px',
  formGroupMarginTop: '2px',
  formGroupOffsetMagicConst: '7px',
  formGroupOffsetVertical: '24px',
  formGroupOffsetVerticalFact: '31px',
  formioBtnWidth: '140px',
  formioDatagridBorder: '1px dotted rgb(204, 204, 204)',
  formioDatagridBtnAddRowMarginRight: '59px',
  formioDatagridCellPadding: '15px',
  formioDatagridMargin: 0,
  formioDatagridPaddingHorizontal: '24px',
  formioDatagridRemoveColPaddingLeft: '7px',
  formioDatagridRemoveColPaddingRight: '31px',
  formioDatagridRemoveColPaddingTop: '27px',
  formioDatagridRemoveColPaddingVert: '12px',
  formioDatagridTfootPaddingBottom: '23px',
  formioDatagridThPaddingTop: '18px',
  formioEditgridActionsBtnMarginBottom: '21px',
  formioEditgridBorder: '1px dotted rgb(204, 204, 204)',
  formioEditgridBtnAddRowMarginRight: '24px',
  formioEditgridBtnAddRowMarginVertical: '23px',
  formioEditgridBtnCancelBackgroundColor: 'rgb(255, 255, 255)',
  formioEditgridBtnCancelBorderColor: 'rgb(244, 67, 54)',
  formioEditgridBtnCancelColor: 'rgb(244, 67, 54)',
  formioEditgridBtnCancelHoverBackgroundColor: 'rgb(51, 51, 51)',
  formioEditgridBtnCancelHoverBorderColor: 'rgb(51, 51, 51)',
  formioEditgridBtnCancelHoverColor: 'rgb(255, 255, 255)',
  formioEditgridBtnRowActionMarginRight: '12px',
  formioEditgridFormGroupMarginBottom: '25px',
  formioEditgridFormGroupMarginTop: '16px',
  formioEditgridFormGroupOffsetVertical: '36px',
  formioEditgridHeaderColor: 'rgb(102, 102, 102)',
  formioEditgridHeaderFontFamily: "'Open Sans', sans-serif",
  formioEditgridHeaderFontSize: '10px',
  formioEditgridHeaderFontWeight: 400,
  formioEditgridHeaderLetterSpacing: '0.4px',
  formioEditgridHeaderLineHeight: '18px',
  formioEditgridHeaderPaddingTop: 0,
  formioEditgridHeaderTextTransform: 'uppercase',
  formioEditgridItemBorderBottomWidth: '1px',
  formioEditgridItemBorderWidth: '0 0 1px 0',
  formioEditgridItemColor: 'rgb(102, 102, 102)',
  formioEditgridItemFontSize: '15px',
  formioEditgridItemLastChildBorderBottomWidth: 0,
  formioEditgridItemLastChildBtnMarginBottom: 0,
  formioEditgridItemLastChildPaddingBottom: 0,
  formioEditgridItemLetterSpacing: '0.3px',
  formioEditgridItemLineHeight: '22px',
  formioEditgridItemMargin: 0,
  formioEditgridItemPadding: '15px 0 14px',
  formioEditgridItemPaddingBottom: '14px',
  formioEditgridItemPaddingVertical: '15px',
  formioEditgridMargin: 0,
  formioEditgridPadding: '19px 24px 23px',
  formioEditgridPaddingHorizontal: '24px',
  formioEditgridPaddingTop: '19px',
  formioFieldsetBodyPadding: '15px 24px 18px',
  formioFieldsetBodyPaddingBottom: '18px',
  formioFieldsetBodyPaddingHorizontal: '24px',
  formioFieldsetBodyPaddingTop: '15px',
  formioFieldsetBorder: '1px dotted rgb(204, 204, 204)',
  formioFieldsetFormGroupMarginBottom: '6px',
  formioFormMinHeight: '200px !important',
  formioGridMagicConst: '5px',
  formioLoaderBorderColor: 'rgb(244, 67, 54) !important',
  formioLoaderWrapper: 'rgba(0, 0, 0, 0) !important',
  formioModalOverlayBackground: 'rgba(0, 0, 0, 0.5)',
  formioSubgroupBorder: '1px dotted rgb(204, 204, 204)',
  formioSubgroupBorderColor: 'rgb(204, 204, 204)',
  formioSubgroupBorderStyle: 'dotted',
  formioSubgroupBorderWidth: '1px',
  formioSubgroupPaddingHorizontal: '24px',
  formioSubgroupPaddingVertical: '23px',
  formioSubgroupRowActionBtnContainerPaddingHorizontal: '7px',
  formioSubgroupRowActionBtnContainerPaddingVertical: '12px',
  formioSubgroupRowActionBtnContainerWidth: '50px',
  formioSubgroupRowActionBtnHeight: '36px',
  formioSubgroupRowActionBtnIconFontFamily: 'glyphicons-theme',
  formioSubgroupRowActionBtnIconFontSize: '18px',
  formioSubgroupRowActionBtnIconLineHeight: 1,
  formioSubgroupRowActionBtnLetterSpacing: 0,
  formioSubgroupRowActionBtnLineHeight: 0,
  formioSubgroupRowActionBtnMarginRight: '12px',
  formioSubgroupRowActionBtnPadding: '9px',
  formioSubgroupRowActionBtnWidth: '36px',
  formioSubgroupRowEditBtnBackgroundColor: 'rgba(0, 0, 0, 0)',
  formioSubgroupRowEditBtnBorder: 'none',
  formioSubgroupRowEditBtnColor: 'rgb(204, 204, 204)',
  formioSubgroupRowEditBtnHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
  formioSubgroupRowEditBtnHoverBorder: 'none',
  formioSubgroupRowEditBtnHoverColor: 'rgb(0, 0, 0)',
  formioSubgroupRowEditBtnIconContent: '',
  formioSubgroupRowPadding: '15px',
  formioSubgroupRowRemoveBtnBackgroundColor: 'rgba(0, 0, 0, 0)',
  formioSubgroupRowRemoveBtnBorder: 'none',
  formioSubgroupRowRemoveBtnColor: 'rgb(204, 204, 204)',
  formioSubgroupRowRemoveBtnHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
  formioSubgroupRowRemoveBtnHoverBorder: 'none',
  formioSubgroupRowRemoveBtnHoverColor: 'rgb(0, 0, 0)',
  formioSubgroupRowRemoveBtnIconContent: '',
  formioTextfieldMultipleButtonAddRowMarginTop: '6px',
  formioTextfieldMultipleButtonRemoveRowSize: '36px',
  formioTextfieldMultipleColumnHeight: '60px',
  formioTextfieldMultipleFormControlMarginBottom: '12px',
  formioTextfieldMultipleRemoveColumnPaddingHorizontal: '7px',
  formioTextfieldMultipleRemoveColumnPaddingVertical: '12px',
  formioTextfieldMultipleRemoveColumnWidth: '50px',
  gridGutterWidth: '48px',
  gridGutterWidthHalf: '24px',
  hoverColor: 'rgb(0, 0, 0)',
  hoverColorLight: 'rgb(51, 51, 51)',
  inputAddonIconColor: 'rgb(102, 102, 102)',
  inputAddonTextColor: 'rgb(0, 0, 0)',
  inputAddonTextFontSize: '18px',
  inputAddonTextLineHeight: '28px',
  inputBackgroundColor: 'rgb(241, 241, 241)',
  inputBorder: 'solid rgb(204, 204, 204)',
  inputBorderColor: 'rgb(204, 204, 204)',
  inputBorderRadius: '4px 4px 0 0',
  inputBorderRadiusSize: '4px',
  inputBorderStyle: 'solid',
  inputBorderWidth: '0 0 2px 0',
  inputDisabledBackgroundColor: 'rgb(226, 226, 226)',
  inputDisabledBorderColor: 'rgb(204, 204, 204)',
  inputDisabledColor: 'rgb(153, 153, 153)',
  inputDisabledIconColor: 'rgb(153, 153, 153)',
  inputErrorBorderColor: 'rgb(244, 67, 54)',
  inputErrorHelpBlockColor: 'rgb(244, 67, 54)',
  inputErrorHelpBlockOffsetTop: '1px',
  inputFocusBorderColor: 'rgb(102, 102, 102)',
  inputFocusBoxShadow: 'none',
  inputFocusIconColor: 'rgb(102, 102, 102)',
  inputFontFamily: "'Open Sans', sans-serif",
  inputFontSize: '18px',
  inputFontSizeXs: '14px',
  inputFontWeight: 400,
  inputHeight: '60px',
  inputHelpBlockColor: 'rgb(102, 102, 102)',
  inputHelpBlockFontFamily: "'Open Sans', sans-serif",
  inputHelpBlockFontSize: '10px',
  inputHelpBlockFontSizeSm: '12px',
  inputHelpBlockFontWeight: 400,
  inputHelpBlockLineHeight: '18px',
  inputHelpBlockTextTransform: 'uppercase',
  inputHoverBorderColor: 'rgb(0, 0, 0)',
  inputHoverIconColor: 'rgb(0, 0, 0)',
  inputIconTransition: 'border-color ease-in-out 0.15s color ease-in-out 0.15s',
  inputLineHeight: '28px',
  inputLineHeightXs: '20px',
  inputMdHeight: '48px',
  inputMdPadding: '9px 15px',
  inputMdPaddingHorizontal: '15px',
  inputMdPaddingVertical: '9px',
  inputPaddingHorizontal: '25px',
  inputPaddingVertical: '15px',
  inputPlaceholderColor: 'rgb(102, 102, 102)',
  inputTextColor: 'rgb(0, 0, 0)',
  inputTransition: 'border-color ease-in-out 0.15s',
  letterSpacingMain: '0.36px',
  letterSpacingSecondary: '0.4px',
  letterSpacingSmallMain: '0.3px',
  lineHeightMain: '28px',
  lineHeightMainXs: '20px',
  lineHeightSecondary: '18px',
  lineHeightSmallMain: '22px',
  lineHeightSmallMainXs: '20px',
  linkColor: 'rgb(244, 67, 54)',
  linkDisabledColor: 'rgb(153, 153, 153)',
  linkFontFamily: "'Open Sans', sans-serif",
  linkFontWeight: 400,
  linkHoverColor: 'rgb(0, 0, 0)',
  linkHoverOutline: 'none',
  linkHoverTextDecoration: 'none',
  navColor: 'rgb(102, 102, 102)',
  navHoverColor: 'rgb(0, 0, 0)',
  navSelectedColor: 'rgb(244, 67, 54)',
  navTabsBorderBottom: '1px solid rgb(204, 211, 219)',
  paginationPageLinkBackgroundColor: 'rgba(0, 0, 0, 0)',
  paginationPageLinkBorder: 'none',
  paginationPageLinkColor: 'rgb(244, 67, 54)',
  paginationPageLinkFontSize: '15px',
  paginationPageLinkFontWeight: 400,
  paginationPageLinkHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
  paginationPageLinkHoverColor: 'rgb(0, 0, 0)',
  paginationPageLinkIconFontSize: '20px',
  paginationPageLinkIconPadding: '9px 0',
  paginationPageLinkLineHeight: '22px',
  paginationPageLinkMargin: '6px 3px',
  paginationPageLinkMarginVertical: '6px',
  paginationPageLinkPadding: '7px',
  paginationPageLinkSelectedBackgroundColor: 'rgb(241, 241, 241)',
  paginationPageLinkSelectedFontWeight: 700,
  paginationPageLinkSize: '36px',
  panelBodyOffsetVertical: '22px',
  radioBoxBorderRadius: '15px',
  radioBoxSelectedBorderRadius: '7px',
  radioBoxSelectedOffset: '8px',
  radioBoxSelectedSize: '14px',
  radioBoxSize: '30px',
  requestActionsPanelBackgroundColor: 'rgb(255, 255, 255)',
  requestActionsPanelBorder: '1px solid rgb(204, 204, 204)',
  requestActionsPanelBorderHeight: '1px',
  requestActionsPanelHeight: '85px',
  requestActionsPanelPadding: '12px 0',
  requestActionsPanelPaddingVertical: '12px',
  requestActionsPanelTransitionActionsHeight: '60px',
  requiredColor: 'rgb(244, 67, 54)',
  selectBorderWidth: '2px',
  selectChoicesBackgroundColor: 'rgba(0, 0, 0, 0) !important',
  selectChoicesButtonBorderRadius: 0,
  selectChoicesButtonHeight: '10px',
  selectChoicesButtonIconSize: '10px',
  selectChoicesButtonMargin: '0 0 0 11px',
  selectChoicesButtonOpacity: 1,
  selectChoicesButtonPadding: 0,
  selectChoicesButtonRight: '74px',
  selectChoicesButtonWidth: '10px',
  selectChoicesPlaceholderColor: 'rgb(102, 102, 102)',
  selectChoicesPlaceholderOpacity: 1,
  selectDisabledInputBackgroundColor: 'rgb(245, 245, 245)',
  selectDropdownBackgroundColor: 'rgb(255, 255, 255)',
  selectDropdownBorder: '2px solid rgb(0, 0, 0)',
  selectDropdownBorderColor: 'rgb(0, 0, 0)',
  selectDropdownBorderRadius: '0 0 4px 4px',
  selectDropdownMarginTop: '-2px',
  selectDropdownSearchColor: 'rgb(153, 153, 153)',
  selectDropdownSearchFontSize: '15px',
  selectDropdownSearchPadding: '4px 5px 4px 23px',
  selectIconArrowColor: 'rgb(244, 67, 54)',
  selectIconArrowHeight: '7px',
  selectIconArrowHoverColor: 'rgb(0, 0, 0)',
  selectIconArrowLineHeight: '7px',
  selectIconArrowRight: '25px',
  selectIconArrowSize: '10px',
  selectIconArrowTransitionColor: 'color ease-in-out 0.15s transform ease-in-out 0.15s',
  selectIconArrowWidth: '10px',
  selectInputColor: 'rgb(0, 0, 0)',
  selectInputFontSize: '18px',
  selectInputLineHeight: '28px',
  selectListColor: 'rgb(153, 153, 153)',
  selectListFontSize: '15px',
  selectListItemMarginBottom: '2px',
  selectListItemPadding: '0 5px 3px 23px !important',
  selectListPadding: '10px 0 !important',
  selectListSelectableBackgroundColor: 'rgb(241, 241, 241)',
  selectListSelectableColor: 'rgb(102, 102, 102)',
  selectMultipleChoicesBorder: '2px solid rgb(153, 153, 153)',
  selectMultipleChoicesBorderWidth: '2px',
  selectMultipleChoicesColor: 'rgb(0, 0, 0)',
  selectMultipleChoicesFontSize: '15px',
  selectMultipleChoicesFontWeight: 400,
  selectMultipleChoicesHeight: '30px',
  selectMultipleChoicesHoverBorderColor: 'rgb(0, 0, 0)',
  selectMultipleChoicesHoverColor: 'rgb(0, 0, 0)',
  selectMultipleChoicesHoverIconColor: 'rgb(0, 0, 0)',
  selectMultipleChoicesLineHeight: '20px',
  selectMultipleChoicesMargin: '0 6px 6px 0',
  selectMultipleChoicesMarginBottom: '6px',
  selectMultipleChoicesMarginRight: '6px',
  selectMultipleChoicesPadding: '0 10px 0 11px',
  selectMultipleChoicesTransition: 'color ease-in-out 0.15s border-color ease-in-out 0.15s',
  selectOpenIconColor: 'rgb(0, 0, 0)',
  selectSingleChoicesPaddingRight: '42px',
  selectSinglePaddingRight: '17px',
  textAccentColor: 'rgb(0, 0, 0)',
  textContrastColor: 'rgb(255, 255, 255)',
  textHeadingsColor: 'rgb(0, 0, 0)',
  textLinkColor: 'rgb(244, 67, 54)',
  textMainColor: 'rgb(102, 102, 102)',
  textSecondaryColor: 'rgb(153, 153, 153)',
  textSelectedItemColor: 'rgb(244, 67, 54)',
  textTransformSecondary: 'uppercase',
  textareaDisabledBorder: '1px solid rgb(204, 204, 204)',
  viewOnlyComponentFieldsetCardBodyDlLastChildMarginBottom: '0 !important',
  viewOnlyComponentFieldsetCardBodyPadding: '38px 24px 40px',
  viewOnlyComponentFieldsetMarginBottom: '36px',
  viewOnlyComponentFieldsetWidth: '100%',
  viewOnlyDatagridCellPaddingLeft: '36px',
  viewOnlyDatagridLastTrPaddingBottom: '36px',
  viewOnlyDatagridMarginBottom: '36px',
  viewOnlyDatagridThPaddingTop: '38px',
  viewOnlyDatagridWidth: '100%',
  viewOnlyDlFloat: 'left',
  viewOnlyDlWidth: '50%',
  viewOnlyFieldLabelColor: 'rgb(153, 153, 153)',
  viewOnlyFieldLabelFontSize: '15px',
  viewOnlyFieldLabelFontWeight: 400,
  viewOnlyFieldLabelLineHeight: '22px',
  viewOnlyFieldLabelMarginBottom: '10px',
  viewOnlyFieldValueColor: 'rgb(0, 0, 0)',
  viewOnlyFieldValueFontSize: '18px',
  viewOnlyFieldValueFontWeight: 400,
  viewOnlyFieldValueLineHeight: '28px',
  viewOnlyFieldsetColumnsBorder: 'none',
  viewOnlyFieldsetColumnsFormioComponentColumnsDlFloat: 'none',
  viewOnlyFieldsetColumnsFormioComponentColumnsDlWidth: '100%',
  viewOnlyFieldsetColumnsFormioComponentColumnsFormioComponentFileMarginBottom: '6px',
  viewOnlyFieldsetColumnsFormioComponentColumnsPaddingTop: 0,
  viewOnlyFieldsetColumnsMarginHorizontal: '18px',
  viewOnlyFieldsetColumnsPMargin: 0,
  viewOnlyFieldsetColumnsPadding: 0,
  viewOnlyFormioComponentColumnsWidth: '100%',
  viewOnlyPanelDefaultLastChildPanelBodyPaddingBottom: '18px',
  viewOnlyPanelDefaultPanelBodyPaddingBottom: '41px',
  viewOnlyPanelDefaultPanelBodyPaddingTop: '43px',
  viewOnlyTableSecondaryHeaderMarginBottom: '-4px',
  viewOnlyTableSecondaryHeaderMarginTop: '14px'
};

var createAppTheme = function createAppTheme(store, createOptions) {
  if (createOptions === void 0) {
    createOptions = createAppThemeOptions;
  }

  var themeOptions = createOptions(store.themeOverrides);
  var themeVariables = themeOptions.variables;
  return createMuiTheme(_extends({}, themeOptions, {
    variables: _extends({}, themeVariables, {
      sass: _extends({}, sassVars, {}, themeVariables.sass)
    })
  }), ruRU);
};
var createLandingThemeCreator = function createLandingThemeCreator(store) {
  var landingOptions = createLandingThemeOptions(store.themeOverrides);
  return function (appTheme) {
    return createMuiTheme(_extends({}, appTheme, {}, landingOptions), ruRU);
  };
};
var createThemes = {
  createAppTheme: createAppTheme,
  createLandingThemeCreator: createLandingThemeCreator
};

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n        font-family: 'Roboto', sans-serif;\n        font-size: 18px;\n        line-height: 1.67;\n        font-weight: 300;\n        letter-spacing: 0.27px;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n        font-family: 'Roboto', sans-serif;\n        margin: 0;\n        font-size: 47px;\n        line-height: 1.34;\n        font-weight: 900;\n        letter-spacing: normal;\n    "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n        font-family: 'Roboto', sans-serif;\n        margin: 0;\n        font-size: 75px;\n        line-height: 1.08;\n        font-weight: 900;\n        letter-spacing: normal;\n\n        span:nth-child(2) {\n            display: none;\n        }\n\n        &:hover {\n            span:first-child {\n                display: none;\n            }\n\n            span:nth-child(2) {\n                display: inline;\n            }\n        }\n    "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n        text-align: center;\n    "]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var StartPageStyledContainerInj = withTheme(styled(Container)(_templateObject$7()));
var StartPageTotXTypographyInj = withTheme(styled.h1(_templateObject2$2()));
var StartPageICSTypographyInj = withTheme(styled.h2(_templateObject3$1()));
var StartPageLandingTypographyInj = withTheme(styled(Box)(_templateObject4()));
var StartPage = observer$1(function () {
  var _di = di([StartPageStyledContainerInj], StartPage),
      StartPageStyledContainer = _di[0];

  var _di2 = di([StartPageTotXTypographyInj], StartPage),
      StartPageTotXTypography = _di2[0];

  var _di3 = di([StartPageICSTypographyInj], StartPage),
      StartPageICSTypography = _di3[0];

  var _di4 = di([StartPageLandingTypographyInj], StartPage),
      StartPageLandingTypography = _di4[0];

  var _di5 = di([createLandingThemeCreator], StartPage),
      createLandingThemeCreator$1 = _di5[0];

  var rootStore = useStore();
  var startPageText = rootStore.env.startPageText;

  var _useFeature = useFeature('startPageDefaultText'),
      startPageDefaultText = _useFeature[0];

  var landingThemeCreator = createLandingThemeCreator$1(rootStore);
  return React__default.createElement(ThemeProvider, {
    theme: landingThemeCreator
  }, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(StartPageStyledContainer, {
    maxWidth: !startPageDefaultText ? 'sm' : 'xs'
  }, React__default.createElement(Box, {
    mr: 6
  }, startPageDefaultText ? React__default.createElement(React__default.Fragment, null, React__default.createElement(StartPageTotXTypography, null, "TOT\xA0", React__default.createElement("span", null, "X"), React__default.createElement("span", null, "ICS")), React__default.createElement(StartPageICSTypography, null, "Intellectual capital solution"), React__default.createElement(StartPageLandingTypography, {
    mt: 3,
    component: "p"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.productDescription"
  }))) : React__default.createElement(Typography, {
    variant: "h3",
    component: "h1",
    color: "primary"
  }, startPageText)))));
});

var StartPageMenuItems = function StartPageMenuItems(props) {
  var _useStore = useStore(),
      authenticationStore = _useStore.authenticationStore,
      api = _useStore.api,
      personStore = _useStore.personStore;

  var _useFeature = useFeature('loginWithoutRegister'),
      loginWithoutRegister = _useFeature[0];

  var history = useHistory();

  var loginAnonymously = function loginAnonymously() {
    try {
      return Promise.resolve(authenticationStore.loginAnonymously()).then(function () {
        return Promise.resolve(api.authVerify()).then(function () {
          history.push(clientRoute.campaigns);
          return Promise.resolve(personStore.getInfo()).then(function () {});
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var open = props.open,
      anchorRef = props.anchorRef,
      handleClose = props.handleClose,
      handleToggle = props.handleToggle;
  var location = useLocation();
  return React__default.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true
  }, function (_ref) {
    var TransitionProps = _ref.TransitionProps,
        placement = _ref.placement;
    return React__default.createElement(Grow, Object.assign({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), React__default.createElement(Paper, null, React__default.createElement(ClickAwayListener, {
      onClickAway: handleClose
    }, React__default.createElement(MenuList, {
      id: "split-button-menu"
    }, loginWithoutRegister && React__default.createElement(MenuItem, {
      onClick: loginAnonymously
    }, React__default.createElement(FormattedMessage, {
      id: "startPage.headerLinks.loginAnonymously"
    })), React__default.createElement(MenuItem, {
      component: Link,
      to: {
        pathname: clientRoute.login,
        search: location.search
      },
      onClick: handleToggle
    }, React__default.createElement(FormattedMessage, {
      id: "startPage.headerLinks.loginAccount"
    }))))));
  });
};

var preventDefault = function preventDefault(event) {
  return event.preventDefault();
};

var StartPageHeaderLinks = function StartPageHeaderLinks() {
  var _di = di([StartPageHeaderLink], StartPageHeaderLinks),
      HeaderLink = _di[0];

  var _di2 = di([StartAuthHeaderLink], StartPageHeaderLinks),
      StartAuthHeaderLink$1 = _di2[0];

  var _di3 = di([createLandingThemeCreator], StartPageHeaderLinks),
      createLandingThemeCreator$1 = _di3[0];

  var _di4 = di([StartPageMenuItems], StartPageHeaderLinks),
      StartPageMenuItems$1 = _di4[0];

  var rootStore = useStore();
  var landingThemeCreator = createLandingThemeCreator$1(rootStore);

  var _React$useState = React__default.useState(false),
      open = _React$useState[0],
      setOpen = _React$useState[1];

  var anchorRef = React__default.useRef(null);

  var _useFeature = useFeature('startPageLinks'),
      startPageLinks = _useFeature[0];

  var handleToggle = function handleToggle() {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };

  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    justify: startPageLinks ? 'space-around' : 'flex-end'
  }, React__default.createElement(ThemeProvider, {
    theme: landingThemeCreator
  }, startPageLinks && React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(HeaderLink, {
    href: "#",
    onClick: preventDefault,
    color: "secondary",
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.headerLinks.about"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(HeaderLink, {
    href: "#",
    onClick: preventDefault,
    color: "secondary",
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.headerLinks.news"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(HeaderLink, {
    href: "#",
    onClick: preventDefault,
    color: "secondary",
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.headerLinks.documents"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(HeaderLink, {
    href: "#",
    onClick: preventDefault,
    color: "secondary",
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.headerLinks.resources"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(HeaderLink, {
    href: "#",
    onClick: preventDefault,
    color: "secondary",
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.headerLinks.contacts"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(HeaderLink, {
    href: "http://radar-dev.tot-dev.ru/",
    target: "_blank",
    color: "secondary",
    underline: "none"
  }, React__default.createElement(FormattedMessage, {
    id: "startPage.headerLinks.radar"
  })))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(StartAuthHeaderLink$1, {
    handleToggle: handleToggle,
    anchorRef: anchorRef
  }))), React__default.createElement(StartPageMenuItems$1, {
    open: open,
    anchorRef: anchorRef,
    handleClose: handleClose,
    handleToggle: handleToggle
  }));
};

const UserListBlockButton = withConfirmDialog(props => React__default.createElement(Tooltip, {
  title: props.allowed ? React__default.createElement(FormattedMessage, {
    id: "users.actions.block"
  }) : React__default.createElement(FormattedMessage, {
    id: "users.notAllowed"
  })
}, React__default.createElement("span", null, React__default.createElement(IconButton, {
  disabled: !props.allowed,
  onClick: props.openConfirmDialog
}, React__default.createElement(PersonAddDisabledIcon, null)))));

const UserListDeleteButton = withConfirmDialog(props => {
  return React__default.createElement(Tooltip, {
    title: props.allowed ? React__default.createElement(FormattedMessage, {
      id: "common.delete"
    }) : React__default.createElement(FormattedMessage, {
      id: "users.notAllowed"
    })
  }, React__default.createElement("span", null, React__default.createElement(IconButton, {
    disabled: !props.allowed,
    onClick: props.openConfirmDialog
  }, React__default.createElement(DeleteForeverIcon, null))));
});

const UserListFilterPanel = observer$1(props => {
  const {
    model
  } = props;
  const {
    filtering
  } = model;
  const intl = useIntl();
  return React__default.createElement(ExpansionPanel, null, React__default.createElement(ExpansionPanelSummary, {
    expandIcon: React__default.createElement(ExpandMore, null)
  }, React__default.createElement(Typography, {
    variant: "subtitle2"
  }, React__default.createElement(FormattedMessage, {
    id: "common.filters"
  }))), React__default.createElement(ExpansionPanelDetails, null, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 6
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 6
  }, React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(TextField, Object.assign({}, textFieldProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "users.fields.login"
    }),
    placeholder: intl.formatMessage({
      id: 'common.all'
    }),
    value: filtering.login.value,
    onChange: filtering.login.onChange
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, React__default.createElement(TextField, Object.assign({}, textFieldProps, {
    label: React__default.createElement(FormattedMessage, {
      id: "users.fields.name"
    }),
    placeholder: intl.formatMessage({
      id: 'common.all'
    }),
    value: filtering.name.value,
    onChange: filtering.name.onChange
  })))))));
});

function useError() {
  var _useState = useState(false),
      isError = _useState[0],
      setError = _useState[1];

  var _useState2 = useState(''),
      errorText = _useState2[0],
      setErrorText = _useState2[1];

  var enableError = function enableError(text) {
    setError(true);
    setErrorText(text);
  };

  var resetError = function resetError() {
    setError(false);
    setErrorText('');
  };

  return [isError, errorText, enableError, resetError];
}

const UserListPage = observer$1(() => {
  const [UserListBlockButton$1] = di([UserListBlockButton], UserListPage);
  const [UserListDeleteButton$1] = di([UserListDeleteButton], UserListPage);
  const [TotTablePagination$1] = di([TotTablePagination], UserListPage);
  const [UserListFilterPanel$1] = di([UserListFilterPanel], UserListPage);
  const [ErrorDialog$1] = di([ErrorDialog], UserListPage);
  const [ErrorMessage$1] = di([ErrorMessage], UserListPage);
  const [BreadcrumbsComponent$1] = di([BreadcrumbsComponent], UserListPage);
  const [AuthorizationCheck$1] = di([AuthorizationCheck], UserListPage);
  const [isError, errorText, enableError, resetError] = useError();
  const {
    userStore,
    breadcrumbsStore
  } = useStore();
  const {
    breadCrumbsSettings
  } = breadcrumbsStore;
  const [model] = useState(() => new UserListModel(userStore));

  const handleErrorDeletion = error => {
    const errorText = ErrorMessage$1(error);
    enableError(errorText);
  };

  const blockUser = id => {
    return () => model.blockUser(id)().catch(handleErrorDeletion);
  };

  const unblockUser = id => {
    return () => model.unblockUser(id)().catch(handleErrorDeletion);
  };

  const deleteUser = id => {
    return () => model.deleteUser(id)().catch(handleErrorDeletion);
  };

  const renderBlockUnblock = (user, allowed) => {
    const {
      id,
      title
    } = user.login;
    return user.status === 'blocked' ? React__default.createElement(Tooltip, {
      title: allowed ? React__default.createElement(FormattedMessage, {
        id: "users.actions.unblock"
      }) : React__default.createElement(FormattedMessage, {
        id: "users.notAllowed"
      })
    }, React__default.createElement("span", null, React__default.createElement(IconButton, {
      disabled: !allowed,
      onClick: unblockUser(id)
    }, React__default.createElement(PersonAddIcon, null)))) : React__default.createElement(UserListBlockButton$1, {
      id: "block-user",
      title: React__default.createElement(FormattedMessage, {
        id: "users.confirmBlock"
      }),
      message: React__default.createElement(FormattedMessage, {
        id: "users.confirmBlockInfoText",
        values: {
          login: title
        }
      }),
      onConfirm: blockUser(id),
      wrappedComponentProps: {
        allowed
      }
    });
  };

  const renderBody = () => {
    return model.rows.map(user => {
      const {
        id,
        title
      } = user.login;
      return React__default.createElement(TableRow, {
        key: id,
        hover: true
      }, React__default.createElement(TableCell, null, React__default.createElement(Link$1, {
        component: NavLink,
        underline: "always",
        to: generatePath(clientRoute.user, {
          id
        })
      }, title)), React__default.createElement(TableCell, null, React__default.createElement(FormattedMessage, {
        id: statusTextId(user.status)
      })), React__default.createElement(TableCell, null, user.name), React__default.createElement(TableCell, null, user.roles), React__default.createElement(TableCell, null, React__default.createElement(AuthorizationCheck$1, {
        entityId: id,
        entityCode: entities.User,
        permCode: permissions.User.Update
      }, allowed => React__default.createElement(Box, {
        style: {
          whiteSpace: 'nowrap'
        }
      }, renderBlockUnblock(user, allowed), React__default.createElement(UserListDeleteButton$1, {
        id: "delete-user",
        title: React__default.createElement(FormattedMessage, {
          id: "users.deleteUser"
        }),
        message: React__default.createElement(FormattedMessage, {
          id: "users.deleteUserConfirmText",
          values: {
            login: title
          }
        }),
        onConfirm: deleteUser(id),
        wrappedComponentProps: {
          allowed
        }
      })))));
    });
  };

  const statusTextId = statusCode => {
    switch (statusCode) {
      case 'active':
        return 'users.status.active';

      case 'blocked':
        return 'users.status.blocked';

      case 'inactive':
        return 'users.status.inactive';
    }
  };

  useEffect(() => {
    return model.dispose;
  }, [model]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ErrorDialog$1, {
    message: errorText,
    open: isError,
    onClose: resetError
  }), React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 5.5,
    pb: 15
  }, React__default.createElement(Box, {
    pb: 5
  }, React__default.createElement(BreadcrumbsComponent$1, {
    breadcrumbsSettings: breadCrumbsSettings
  })), React__default.createElement(Box, {
    pb: 10
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "users.listTitle"
  }))), React__default.createElement(Box, {
    pb: 10
  }, React__default.createElement(UserListFilterPanel$1, {
    model: model
  })), React__default.createElement(Box, null, React__default.createElement(TableContainer, {
    component: Paper
  }, model.isLoading && React__default.createElement(LinearProgress, null), React__default.createElement(Table, null, React__default.createElement(TableHead, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, {
    style: {
      width: '23%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "users.fields.login"
  }))), React__default.createElement(TableCell, {
    style: {
      width: '23%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "users.fields.status"
  }))), React__default.createElement(TableCell, {
    style: {
      width: '23%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "users.fields.name"
  }))), React__default.createElement(TableCell, {
    style: {
      width: '23%'
    }
  }, React__default.createElement(Typography, null, React__default.createElement(FormattedMessage, {
    id: "users.fields.roles"
  }))), React__default.createElement(TableCell, null))), React__default.createElement(TableBody, null, renderBody()), React__default.createElement(TableFooter, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, {
    colSpan: 100
  }, React__default.createElement(TotTablePagination$1, {
    count: model.rowsCount,
    page: model.pageNumber,
    onChangePage: model.onChangePage,
    onChangeRowsPerPage: model.onChangePageSize,
    rowsPerPage: model.pageSize,
    rowsPerPageOptions: model.pageSizeOptions,
    pagingInfoMessageId: "users.registryPagingInfo",
    pagingInfoMessageIdIfNull: "users.registryPagingInfoIfNull"
  }))))))))));
});

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 48px !important;\n    height: 48px !important;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var IconButtonLarge = styled(React__default.forwardRef(function (props, ref) {
  return React__default.createElement(IconButton, Object.assign({}, props));
}))(_templateObject$8());

var _path$e;

function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}

function SvgDelete(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20
  }, props), _path$e || (_path$e = /*#__PURE__*/createElement("path", {
    d: "M16.998 6h-.999v10.999a3 3 0 01-3 3h-8a3 3 0 01-3.001-3V6H.999a1.001 1.001 0 010-2.001h4v-1a3 3 0 013-3h2a3 3 0 013 3v1h3.999a1 1 0 110 2.001zm-5.999-3.001c0-.552-.449-1-1-1h-2a1 1 0 00-1 1v1h4v-1zM13.998 6H3.999v10.999a1 1 0 001 1h8a1 1 0 00.999-1V6z"
  })));
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n    border-top: ", ";\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var TotObjectActionsBarStyled = withTheme(styled(Toolbar)(_templateObject$9(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.contrastText;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.variables.palette.textDark;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid " + theme.variables.palette.hoverInLists;
}));
var TotObjectActionsBar = withTheme(function (props) {
  return React__default.createElement(TotObjectActionsBarStyled, {
    style: _extends({}, props.style)
  }, props.children);
});
var TotObjectDeleteButton = withConfirmDialog(function (props) {
  return React__default.createElement(Tooltip, {
    title: React__default.createElement(FormattedMessage, {
      id: props.tooltipTitleId
    })
  }, React__default.createElement(IconButtonLarge, {
    onClick: props.openConfirmDialog
  }, React__default.createElement(SvgDelete, null)));
});

var UserControlPanel = observer$1(function (props) {
  var userPersonModel = props.userPersonModel,
      saveForm = props.saveForm;
  var id = userPersonModel.id;

  var _di = di([StickyWrapper], UserControlPanel),
      StickyWrapper$1 = _di[0];

  var _di2 = di([TotObjectActionsBar], UserControlPanel),
      TotObjectActionsBar$1 = _di2[0];

  return React__default.createElement(StickyWrapper$1, {
    mode: "bottom"
  }, React__default.createElement(TotObjectActionsBar$1, null, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Grid, {
    alignItems: "center",
    container: true
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    spacing: 3,
    alignItems: "center",
    justify: "center",
    container: true
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    exact: true,
    path: clientRoute.user
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    component: NavLink,
    to: generatePath(clientRoute.userEdit, {
      id: id
    }),
    size: "small",
    color: "primary",
    variant: "contained"
  }, React__default.createElement(FormattedMessage, {
    id: "common.edit"
  }))))))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    spacing: 3,
    alignItems: "center",
    justify: "center",
    container: true
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    exact: true,
    path: clientRoute.userEdit
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "primary",
    variant: "contained",
    onClick: saveForm
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    color: "secondary",
    variant: "contained",
    component: NavLink,
    to: generatePath(clientRoute.user, {
      id: id
    })
  }, React__default.createElement(FormattedMessage, {
    id: "common.discardChanges"
  })))))))))));
});

var ru = 'ru';
var en = 'en';
var TOT_X_LANG_LOCALIZATION = 'TotXLangLocalization';
var defaultLocale = ru;
var defaultFormsLocale = ru;
var IntlStore = /*#__PURE__*/function () {
  function IntlStore(rootStore, locales) {
    this.savedLocale = localStorage.getItem(TOT_X_LANG_LOCALIZATION);
    this.messagesCache = {};
    this.locales = [ru, en];
    this.messagesCache = locales;
    this.rootStore = rootStore;
    this.locale = this.savedLocale || defaultLocale;
    document.documentElement.lang = this.locale;
    this.intlCache = createIntlCache();
    this.intl = createIntl({
      locale: this.locale,
      messages: this.messages,
      defaultLocale: defaultLocale
    }, this.intlCache);
    this.formatMessage = this.changeMessageFormatter();
    this.api = rootStore.api;
  }

  var _proto = IntlStore.prototype;

  _proto.changeMessageFormatter = function changeMessageFormatter() {
    var _this = this;

    return function (id, values) {
      return _this.intl.formatMessage({
        id: id
      }, values);
    };
  };

  _proto.changeLocale = function changeLocale(locale) {
    var _this2 = this;

    if (this.api.authStatus === 'ok') {
      this.api.client(apiConfigs.setLang(locale)).then(function () {
        _this2.setLocalLocalization(locale);
      });
    } else {
      this.setLocalLocalization(locale);
    }
  };

  _proto.setLocalLocalization = function setLocalLocalization(locale) {
    localStorage.setItem(TOT_X_LANG_LOCALIZATION, locale);
    this.locale = locale;
    this.intl = createIntl({
      locale: this.locale,
      messages: this.messages
    }, this.intlCache);
    this.formatMessage = this.changeMessageFormatter();
    document.documentElement.lang = locale;
  };

  _proto.extendMessages = function extendMessages(_extendMessages) {
    this.messagesCache[this.locale] = _extends({}, this.messagesCache[this.locale], {}, _extendMessages);
  };

  _createClass(IntlStore, [{
    key: "messages",
    get: function get() {
      return this.messagesCache[this.locale];
    }
  }]);

  return IntlStore;
}();

__decorate([observable], IntlStore.prototype, "messagesCache", void 0);

__decorate([observable], IntlStore.prototype, "intl", void 0);

__decorate([observable], IntlStore.prototype, "rootStore", void 0);

__decorate([observable], IntlStore.prototype, "api", void 0);

__decorate([observable], IntlStore.prototype, "locale", void 0);

__decorate([observable], IntlStore.prototype, "formatMessage", void 0);

__decorate([action.bound], IntlStore.prototype, "changeMessageFormatter", null);

__decorate([action.bound], IntlStore.prototype, "changeLocale", null);

__decorate([action.bound], IntlStore.prototype, "setLocalLocalization", null);

__decorate([computed], IntlStore.prototype, "messages", null);

var getIntlStore = function getIntlStore() {
  var _di = di([IntlStore], getIntlStore),
      _IntlStore = _di[0];

  return _IntlStore;
};

var UserEditDialog = observer$1(function (props) {
  var userPersonModel = props.userPersonModel,
      isOpen = props.isOpen,
      close = props.close;

  var _di = di([renderAutoCompleteInput], UserEditDialog),
      renderAutoCompleteInput$1 = _di[0];

  var _di2 = di([ErrorDialog], UserEditDialog),
      ErrorDialog$1 = _di2[0];

  var _di3 = di([ErrorMessage], UserEditDialog),
      ErrorMessage$1 = _di3[0];

  var _useState = useState([]),
      userRolesSelectData = _useState[0],
      setUserRolesSelectData = _useState[1];

  var _useState2 = useState(createViewModel(userPersonModel)),
      viewModel = _useState2[0];

  var _useState3 = useState(false),
      validationStarted = _useState3[0],
      setValidationStarted = _useState3[1];

  var _useError = useError(),
      isError = _useError[0],
      errorText = _useError[1],
      enableError = _useError[2],
      resetError = _useError[3];

  var _useStore = useStore(),
      userStore = _useStore.userStore;

  var intl = useIntl();
  useEffect(function () {
    userStore.userRoleList().then(function (roles) {
      setUserRolesSelectData(roles);
    });
  }, [userStore, setUserRolesSelectData]);

  var handleCancel = function handleCancel() {
    viewModel.reset();
    close();
  };

  var handleSave = function handleSave() {
    try {
      var submit = viewModel.submit;
      setValidationStarted(true);

      var _temp4 = function () {
        if (viewModel.roles.length && viewModel.login) {
          function _temp5() {
            close();
            setValidationStarted(false);
          }

          var _temp6 = _catch(function () {
            return Promise.resolve(userStore.saveUserHead(viewModel)).then(function () {
              submit();
            });
          }, function (e) {
            var errorText = ErrorMessage$1(e);
            enableError(errorText);
          });

          return _temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6);
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var onChangeRoles = function onChangeRoles(event, value) {
    if (value) {
      viewModel.roles = observable.array(value);
    }
  };

  var errorRoles = useMemo(function () {
    if (validationStarted && !viewModel.roles.length) {
      return intl.formatMessage({
        id: 'validation.required'
      });
    }

    return '';
  }, [validationStarted, viewModel.roles, intl]);

  var onChangeLogin = function onChangeLogin(event) {
    viewModel.login = event.target.value;
  };

  var errorLogin = useMemo(function () {
    if (validationStarted && !viewModel.login) {
      return intl.formatMessage({
        id: 'validation.required'
      });
    }

    return '';
  }, [validationStarted, viewModel.login, intl]);

  var onChangeLang = function onChangeLang(event) {
    viewModel.lang = event.target.checked ? en : ru;
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Portal, null, React__default.createElement(Dialog, {
    maxWidth: "sm",
    fullWidth: true,
    open: isOpen,
    scroll: "paper"
  }, React__default.createElement(DialogTitle$1, null, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(FormattedMessage, {
    id: "users.editUser"
  }))), React__default.createElement(DialogContent$1, {
    dividers: true
  }, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 6,
    direction: "column",
    justify: "center"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TextField, {
    required: true,
    onChange: onChangeLogin,
    fullWidth: true,
    label: React__default.createElement(FormattedMessage, {
      id: "users.fields.login"
    }),
    variant: "outlined",
    error: !!errorLogin,
    helperText: errorLogin,
    defaultValue: viewModel.login
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Autocomplete, {
    onChange: onChangeRoles,
    getOptionSelected: function getOptionSelected(option, value) {
      return option.code === value.code;
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.title;
    },
    options: userRolesSelectData.slice(),
    value: viewModel.roles.slice(),
    multiple: true,
    renderInput: renderAutoCompleteInput$1(intl.formatMessage({
      id: 'users.fields.roles'
    }), true, errorRoles)
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FormControlLabel, {
    value: "top",
    control: React__default.createElement(Checkbox, Object.assign({}, checkboxProps$1, {
      checked: viewModel.lang === en,
      onChange: onChangeLang
    })),
    label: React__default.createElement(FormattedMessage, {
      id: "users.fields.lang"
    }),
    labelPlacement: "end"
  }))))), React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(DialogActions$1, null, React__default.createElement(Button, {
    size: "large",
    fullWidth: true,
    variant: "contained",
    onClick: handleCancel
  }, React__default.createElement(FormattedMessage, {
    id: "common.cancel"
  })), React__default.createElement(Button, {
    size: "large",
    fullWidth: true,
    variant: "contained",
    color: "primary",
    onClick: handleSave
  }, React__default.createElement(FormattedMessage, {
    id: "common.save"
  })))))), React__default.createElement(ErrorDialog$1, {
    message: errorText,
    open: isError,
    onClose: resetError
  }));
});

var _path$f;

function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$g.apply(this, arguments);
}

function SvgEdit(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path$f || (_path$f = /*#__PURE__*/createElement("path", {
    d: "M16.868 8.778l-6.92 6.931a1.002 1.002 0 01-.71.289h-4.24a1 1 0 01-1-1v-4.24a.999.999 0 01.29-.71l6.941-6.93 2.819-2.83a1.004 1.004 0 011.42 0l4.239 4.291a.996.996 0 010 1.419l-2.839 2.78zm-10.87 2.391v2.829h2.831l5.93-5.93-2.831-2.829-5.93 5.93zm8.761-8.761l-1.421 1.421 2.83 2.829 1.42-1.419-2.829-2.831zm4.239 7.59a1 1 0 011 1.001v6a3 3 0 01-3 2.999h-14a3 3 0 01-3-2.999V2.998a3 3 0 013-3h6a1 1 0 010 2h-6a.999.999 0 00-.999 1v14.001c0 .552.446.999.999.999h14a1 1 0 001-.999v-6a1 1 0 011-1.001z"
  })));
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", " !important;\n    font-size: 15px;\n\n    &:hover {\n        color: ", " !important;\n    }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n        color: ", ";\n        border-bottom: ", ";\n        background-color: ", ";\n        padding: ", ";\n    "]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var TotObjectHeader = withTheme(styled(Box)(_templateObject$a(), function (_ref) {
  var theme = _ref.theme;
  return theme.variables.palette.textDark;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid " + theme.variables.palette.hoverInLists;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.primary.contrastText;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(4) + "px 0";
}));
var TotObjectHeaderLabel = withTheme(function (_ref5) {
  var theme = _ref5.theme,
      children = _ref5.children;
  return React__default.createElement(Box, {
    color: theme === null || theme === void 0 ? void 0 : theme.palette.primary.light
  }, React__default.createElement(Typography, {
    variant: "body1",
    component: "span"
  }, children));
});
var TotObjectHeaderValue = function TotObjectHeaderValue(_ref6) {
  var children = _ref6.children;
  return React__default.createElement(Typography, {
    variant: "body2",
    component: "span",
    style: {
      fontWeight: 'bold'
    }
  }, children);
};
var TotObjectHeaderLink = withTheme(styled(Link$1)(_templateObject2$3(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.primary.main;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.variables.palette.textDark;
}));

var UserHeader = observer$1(function (props) {
  var userPersonModel = props.userPersonModel,
      loginAsUser = props.loginAsUser;

  var _di = di([TotObjectHeader], UserHeader),
      TotObjectHeader$1 = _di[0];

  var _di2 = di([TotObjectHeaderLabel], UserHeader),
      TotObjectHeaderLabel$1 = _di2[0];

  var _di3 = di([TotObjectHeaderValue], UserHeader),
      TotObjectHeaderValue$1 = _di3[0];

  var _di4 = di([UserEditDialog], UserHeader),
      UserEditDialog$1 = _di4[0];

  var _di5 = di([AuthorizationCheck], UserHeader),
      AuthorizationCheck$1 = _di5[0];

  var _useModal = useModal(),
      isModalOpen = _useModal[0],
      setModalIsOpen = _useModal[1],
      setModalIsClosed = _useModal[2];

  return React__default.createElement(TotObjectHeader$1, null, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    spacing: 2
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, getOrElse(userPersonModel.login, userPersonModel.login, '-'))), React__default.createElement(Route, {
    path: clientRoute.user,
    exact: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    entityId: userPersonModel.id,
    permCode: permissions.System.Administration
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Tooltip, {
    title: React__default.createElement(FormattedMessage, {
      id: "users.editUser"
    })
  }, React__default.createElement(IconButtonLarge, {
    onClick: setModalIsOpen
  }, React__default.createElement(SvgEdit, null))), React__default.createElement(UserEditDialog$1, {
    userPersonModel: userPersonModel,
    isOpen: isModalOpen,
    close: setModalIsClosed
  })))))), React__default.createElement(Route, {
    path: clientRoute.user,
    exact: true
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.User,
    permCode: permissions.User.LoginAs,
    entityId: userPersonModel.id
  }, React__default.createElement(Button, {
    onClick: loginAsUser,
    variant: "contained",
    color: "primary"
  }, React__default.createElement(FormattedMessage, {
    id: "users.loginAsUser"
  })))))), React__default.createElement(Grid, {
    item: true,
    container: true,
    spacing: 6,
    direction: "row"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "baseline",
    spacing: 2
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TotObjectHeaderLabel$1, null, React__default.createElement(FormattedMessage, {
    id: "users.fields.roles"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TotObjectHeaderValue$1, null, userPersonModel.roles.map(function (r) {
    return React__default.createElement(Box, {
      pr: 1,
      component: "span",
      key: r.code
    }, React__default.createElement(Chip, {
      label: r.title
    }));
  })))))))));
});

var TotObjectMain = withTheme$1(function (props) {
  var _props$theme;

  return React__default.createElement(Grid, {
    item: true,
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, React__default.createElement(Box, {
    bgcolor: (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.variables.palette.hoverInLists,
    height: "100%"
  }, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Box, {
    pt: 10,
    pb: 10
  }, props.children))));
});

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    background-color: ", ";\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var PageContentContainer = withTheme(styled(Grid)(_templateObject$b(), function (_ref) {
  var theme = _ref.theme;
  return theme === null || theme === void 0 ? void 0 : theme.variables.palette.hoverInLists;
}));

var UserPage = observer$1(function () {
  var _di = di([UserHeader], UserPage),
      UserHeader$1 = _di[0];

  var _di2 = di([UserControlPanel], UserPage),
      UserControlPanel$1 = _di2[0];

  var _di3 = di([TotObjectMain], UserPage),
      TotObjectMain$1 = _di3[0];

  var _di4 = di([PageContentContainer], UserPage),
      PageContentContainer$1 = _di4[0];

  var _di5 = di([AuthorizationCheck], UserPage),
      AuthorizationCheck$1 = _di5[0];

  var _useStore = useStore(),
      userStore = _useStore.userStore,
      personStore = _useStore.personStore,
      intlStore = _useStore.intlStore;

  var locale = intlStore.locale;

  var _useParams = useParams(),
      id = _useParams.id;

  var history = useHistory();

  var _useState = useState(new UserPersonModel(id)),
      userModel = _useState[0];

  var _useState2 = useState(),
      formApi = _useState2[0],
      setFormApi = _useState2[1];

  var personForm = userModel.personForm;
  useEffect(function () {
    userStore.loadUser(id).then(userModel.load);
  }, [userStore, id, userModel]);

  var onFormReady = function onFormReady(form) {
    setFormApi(form);
  };

  var savePersonForm = function savePersonForm() {
    if (formApi && formApi.validate()) {
      userStore.saveUser(userModel.id, formApi);
    }
  };

  var loginAsUser = function loginAsUser() {
    var loginAsUser = userStore.loginAsUser;
    var id = userModel.id;
    loginAsUser(id).then(function () {
      personStore.getInfo().then(function () {
        history.push(generatePath(personStore.redirectPath));
      });
    });
  };

  return React__default.createElement(PageContentContainer$1, {
    container: true,
    direction: "column"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(UserHeader$1, {
    userPersonModel: userModel,
    loginAsUser: loginAsUser
  })), React__default.createElement(TotObjectMain$1, null, React__default.createElement(Grid, {
    container: true,
    spacing: 10
  }, React__default.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    spacing: 10
  }, React__default.createElement(Grid, {
    item: true,
    style: {
      maxWidth: '100%'
    }
  }, React__default.createElement(Switch, null, React__default.createElement(Route, {
    exact: true,
    path: clientRoute.userEdit
  }, React__default.createElement(MultiLangFormEdit, {
    intlStore: intlStore,
    form: personForm,
    onFormReady: onFormReady
  })), React__default.createElement(Route, {
    exact: true,
    path: clientRoute.user
  }, React__default.createElement(FormView, {
    locale: locale,
    form: personForm,
    onFormReady: onFormReady,
    multiLang: true
  }))))))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.User,
    entityId: userModel.id,
    permCode: permissions.User.UpdateForm
  }, React__default.createElement(UserControlPanel$1, {
    userPersonModel: userModel,
    saveForm: savePersonForm
  }))));
});

var UserPages = function UserPages() {
  var _di = di([Authentication], UserPages),
      Authentication$1 = _di[0];

  var _di2 = di([UserPage], UserPages),
      UserPage$1 = _di2[0];

  var _di3 = di([UserListPage], UserPages),
      UserListPage$1 = _di3[0];

  return React__default.createElement(Authentication$1, null, React__default.createElement(Switch, null, React__default.createElement(Route, {
    path: clientRoute.user
  }, React__default.createElement(UserPage$1, null)), React__default.createElement(Route, {
    path: clientRoute.users
  }, React__default.createElement(UserListPage$1, null))));
};

if (!useState) {
  throw new Error("mobx-react-lite requires React with Hooks support");
}

if (!spy) {
  throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
}

function _extends$h() {
  _extends$h = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$h.apply(this, arguments);
}

function useForceUpdate() {
  var _useState = useState(0),
      setTick = _useState[1];

  var update = useCallback(function () {
    setTick(function (tick) {
      return tick + 1;
    });
  }, []);
  return update;
}
function getSymbol(name) {
  if (typeof Symbol === "function") {
    return Symbol.for(name);
  }

  return "__$mobx-react " + name + "__";
}
var mockGlobal = {};
function getGlobal() {
  if (typeof window !== "undefined") {
    return window;
  }

  if (typeof global !== "undefined") {
    return global;
  }

  if (typeof self !== "undefined") {
    return self;
  }

  return mockGlobal;
}

var observerBatchingConfiguredSymbol =
/*#__PURE__*/
getSymbol("observerBatching");
var isObserverBatched = function isObserverBatched() {
  return getGlobal()[observerBatchingConfiguredSymbol];
};

function printDebugValue(v) {
  return getDependencyTree(v);
}

function createTrackingData(reaction) {
  var trackingData = {
    cleanAt: Date.now() + CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS,
    reaction: reaction
  };
  return trackingData;
}
/**
 * The minimum time before we'll clean up a Reaction created in a render
 * for a component that hasn't managed to run its effects. This needs to
 * be big enough to ensure that a component won't turn up and have its
 * effects run without being re-rendered.
 */

var CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS = 10000;
/**
 * The frequency with which we'll check for leaked reactions.
 */

var CLEANUP_TIMER_LOOP_MILLIS = 10000;
/**
 * Reactions created by components that have yet to be fully mounted.
 */

var uncommittedReactionRefs =
/*#__PURE__*/
new Set();
/**
 * Latest 'uncommitted reactions' cleanup timer handle.
 */

var reactionCleanupHandle;

function ensureCleanupTimerRunning() {
  if (reactionCleanupHandle === undefined) {
    reactionCleanupHandle = setTimeout(cleanUncommittedReactions, CLEANUP_TIMER_LOOP_MILLIS);
  }
}

function scheduleCleanupOfReactionIfLeaked(ref) {
  uncommittedReactionRefs.add(ref);
  ensureCleanupTimerRunning();
}
function recordReactionAsCommitted(reactionRef) {
  uncommittedReactionRefs.delete(reactionRef);
}
/**
 * Run by the cleanup timer to dispose any outstanding reactions
 */

function cleanUncommittedReactions() {
  reactionCleanupHandle = undefined; // Loop through all the candidate leaked reactions; those older
  // than CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS get tidied.

  var now = Date.now();

  for (var _iterator = uncommittedReactionRefs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var ref = _ref;
    var tracking = ref.current;

    if (tracking) {
      if (now >= tracking.cleanAt) {
        // It's time to tidy up this leaked reaction.
        tracking.reaction.dispose();
        ref.current = null;
        uncommittedReactionRefs.delete(ref);
      }
    }
  }

  if (uncommittedReactionRefs.size > 0) {
    // We've just finished a round of cleanups but there are still
    // some leak candidates outstanding.
    ensureCleanupTimerRunning();
  }
}

var EMPTY_OBJECT = {};

function observerComponentNameFor(baseComponentName) {
  return "observer" + baseComponentName;
}

var warnedAboutBatching = false;
function useObserver(fn, baseComponentName, options) {
  if (baseComponentName === void 0) {
    baseComponentName = "observed";
  }

  if (options === void 0) {
    options = EMPTY_OBJECT;
  }

  if (process.env.NODE_ENV !== "production" && !warnedAboutBatching && !isObserverBatched()) {
    console.warn("[MobX] You haven't configured observer batching which might result in unexpected behavior in some cases. See more at https://github.com/mobxjs/mobx-react-lite/#observer-batching");
    warnedAboutBatching = true;
  }

  var wantedForceUpdateHook = options.useForceUpdate || useForceUpdate;
  var forceUpdate = wantedForceUpdateHook(); // StrictMode/ConcurrentMode/Suspense may mean that our component is
  // rendered and abandoned multiple times, so we need to track leaked
  // Reactions.

  var reactionTrackingRef = React__default.useRef(null);

  if (!reactionTrackingRef.current) {
    // First render for this component (or first time since a previous
    // reaction from an abandoned render was disposed).
    var newReaction = new Reaction(observerComponentNameFor(baseComponentName), function () {
      // Observable has changed, meaning we want to re-render
      // BUT if we're a component that hasn't yet got to the useEffect()
      // stage, we might be a component that _started_ to render, but
      // got dropped, and we don't want to make state changes then.
      // (It triggers warnings in StrictMode, for a start.)
      if (trackingData.mounted) {
        // We have reached useEffect(), so we're mounted, and can trigger an update
        forceUpdate();
      } else {
        // We haven't yet reached useEffect(), so we'll need to trigger a re-render
        // when (and if) useEffect() arrives.  The easiest way to do that is just to
        // drop our current reaction and allow useEffect() to recreate it.
        newReaction.dispose();
        reactionTrackingRef.current = null;
      }
    });
    var trackingData = createTrackingData(newReaction);
    reactionTrackingRef.current = trackingData;
    scheduleCleanupOfReactionIfLeaked(reactionTrackingRef);
  }

  var reaction = reactionTrackingRef.current.reaction;
  React__default.useDebugValue(reaction, printDebugValue);
  React__default.useEffect(function () {
    // Called on first mount only
    recordReactionAsCommitted(reactionTrackingRef);

    if (reactionTrackingRef.current) {
      // Great. We've already got our reaction from our render;
      // all we need to do is to record that it's now mounted,
      // to allow future observable changes to trigger re-renders
      reactionTrackingRef.current.mounted = true;
    } else {
      // The reaction we set up in our render has been disposed.
      // This is either due to bad timings of renderings, e.g. our
      // component was paused for a _very_ long time, and our
      // reaction got cleaned up, or we got a observable change
      // between render and useEffect
      // Re-create the reaction
      reactionTrackingRef.current = {
        reaction: new Reaction(observerComponentNameFor(baseComponentName), function () {
          // We've definitely already been mounted at this point
          forceUpdate();
        }),
        cleanAt: Infinity
      };
      forceUpdate();
    }

    return function () {
      reactionTrackingRef.current.reaction.dispose();
      reactionTrackingRef.current = null;
    };
  }, []); // render the original component, but have the
  // reaction track the observables, so that rendering
  // can be invalidated (see above) once a dependency changes

  var rendering;
  var exception;
  reaction.track(function () {
    try {
      rendering = fn();
    } catch (e) {
      exception = e;
    }
  });

  if (exception) {
    throw exception; // re-throw any exceptions catched during rendering
  }

  return rendering;
}

function observer(baseComponent, options) {

  var realOptions = _extends$h({
    forwardRef: false
  }, options);

  var baseComponentName = baseComponent.displayName || baseComponent.name;

  var wrappedComponent = function wrappedComponent(props, ref) {
    return useObserver(function () {
      return baseComponent(props, ref);
    }, baseComponentName);
  };

  wrappedComponent.displayName = baseComponentName; // memo; we are not intested in deep updates
  // in props; we assume that if deep objects are changed,
  // this is in observables, which would have been tracked anyway

  var memoComponent;

  if (realOptions.forwardRef) {
    // we have to use forwardRef here because:
    // 1. it cannot go before memo, only after it
    // 2. forwardRef converts the function into an actual component, so we can't let the baseComponent do it
    //    since it wouldn't be a callable function anymore
    memoComponent = memo(forwardRef(wrappedComponent));
  } else {
    memoComponent = memo(wrappedComponent);
  }

  copyStaticProperties(baseComponent, memoComponent);
  memoComponent.displayName = baseComponentName;
  return memoComponent;
} // based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js

var hoistBlackList = {
  $$typeof: true,
  render: true,
  compare: true,
  type: true
};

function copyStaticProperties(base, target) {
  Object.keys(base).forEach(function (key) {
    if (!hoistBlackList[key]) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    }
  });
}
//# sourceMappingURL=mobxreactlite.esm.js.map

const useStyles$5 = makeStyles$1(() => ({
  buttonWrapper: {
    transition: transitionDefault,
    opacity: 0.5,
    '&:hover ': {
      opacity: 1
    }
  }
}));
const ResultConsoleControls = observer(props => {
  const {
    model
  } = props;
  const {
    clearResult,
    copyResult
  } = model;
  const intl = useIntl();
  const classes = useStyles$5();
  return createElement(Grid, {
    container: true
  }, createElement(Grid, {
    item: true,
    className: classes.buttonWrapper
  }, createElement(Tooltip, {
    title: intl.formatMessage({
      id: 'common.clear'
    })
  }, createElement(IconButton, {
    onClick: clearResult
  }, createElement(DeleteOutlinedIcon, null)))), createElement(Grid, {
    item: true,
    className: classes.buttonWrapper
  }, createElement(Tooltip, {
    title: intl.formatMessage({
      id: 'common.copy'
    })
  }, createElement(IconButton, {
    onClick: copyResult
  }, createElement(FileCopyOutlinedIcon, null)))));
});

var useConsoleStyles = makeStyles$1(function (theme) {
  return {
    wrapper: {
      height: '100%',
      paddingTop: theme.spacing(5.5),
      paddingBottom: theme.spacing(15)
    },
    inner: {
      height: '100%'
    },
    mainBlock: {
      marginBottom: theme.spacing(5),
      maxWidth: '100% !important'
    },
    fullGrow: {
      flexGrow: 1
    },
    editorWrapper: {
      flexGrow: 1,
      maxWidth: '100% !important'
    },
    editorInner: {
      maxHeight: '60vh',
      height: '100%',
      width: '100%',
      border: "1px solid " + theme.palette.grey[300],
      overflowY: 'auto'
    },
    columnTitleWrapper: {
      marginBottom: theme.spacing(2)
    },
    columnTitle: {
      fontSize: '14px',
      fontWeight: 600
    },
    resultWrapper: {
      position: 'relative'
    },
    codeWrapperLeft: {
      paddingRight: '8px'
    },
    codeWrapperRight: {
      paddingLeft: '8px'
    },
    resultControlsWrapper: {
      position: 'absolute',
      top: 5,
      right: 5,
      zIndex: 10
    }
  };
});
var consoleEditorStyles = {
  fontFamily: '"Fira code", "Fira Mono", monospace',
  fontSize: 12,
  minHeight: '100%'
};

var handleHighlight = function handleHighlight(code) {
  return highlight(code, languages.scala, 'scala');
};

var ConsolePage = observer$1(function () {
  var _cn;

  var _di = di([ResultConsoleControls], ConsolePage),
      ResultConsoleControls$1 = _di[0];

  var _di2 = di([useConsoleStyles], ConsolePage),
      useConsoleStyles$1 = _di2[0];

  var rootStore = useStore();
  var model = useMemo(function () {
    return new ConsoleModel(rootStore);
  }, [rootStore]);
  var code = model.code,
      result = model.result,
      error = model.error,
      setCode = model.setCode,
      runScript = model.runScript;

  var _useAntiDoubleClick = useAntiDoubleClick(runScript),
      isSending = _useAntiDoubleClick[0],
      endIcon = _useAntiDoubleClick[1],
      actionHandler = _useAntiDoubleClick[2];

  var classes = useConsoleStyles$1();
  var generalEditorProps = {
    onValueChange: setCode,
    highlight: handleHighlight,
    style: consoleEditorStyles,
    padding: 10,
    tabSize: tabSize
  };
  var resultClasses = classNames(consoleEditorClass, (_cn = {}, _cn[consoleErrorClass] = !!error, _cn));
  var resultValue = error || result;
  var isRunBtnDisabled = isSending || !code.replace(/\s/g, '');
  return React__default.createElement(Container, {
    maxWidth: "lg",
    className: classes.wrapper
  }, React__default.createElement(Grid, {
    container: true,
    direction: "column",
    className: classes.inner
  }, React__default.createElement(Grid, {
    item: true,
    className: classes.mainBlock
  }, React__default.createElement(Typography, {
    variant: "h1",
    component: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "console.title"
  }))), React__default.createElement(Grid, {
    container: true,
    item: true,
    wrap: "nowrap",
    justify: "space-between",
    className: classNames(classes.mainBlock, classes.fullGrow)
  }, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    className: classes.codeWrapperLeft,
    xs: 6
  }, React__default.createElement(Grid, {
    item: true,
    className: classes.columnTitleWrapper
  }, React__default.createElement(Typography, {
    className: classes.columnTitle
  }, React__default.createElement(FormattedMessage, {
    id: "console.script"
  }), ":")), React__default.createElement(Grid, {
    item: true,
    className: classes.editorWrapper
  }, React__default.createElement(Box, {
    className: classes.editorInner
  }, React__default.createElement(Editor, Object.assign({}, generalEditorProps, {
    textareaClassName: consoleEditorClass,
    preClassName: consoleEditorClass,
    value: code
  }))))), React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    className: classes.codeWrapperRight,
    xs: 6
  }, React__default.createElement(Grid, {
    item: true,
    className: classes.columnTitleWrapper
  }, React__default.createElement(Typography, {
    className: classes.columnTitle
  }, React__default.createElement(FormattedMessage, {
    id: "common.result"
  }), ":")), React__default.createElement(Grid, {
    item: true,
    className: classNames(classes.editorWrapper, classes.resultWrapper)
  }, React__default.createElement(Box, {
    className: classes.editorInner
  }, React__default.createElement(Box, {
    className: classes.resultControlsWrapper
  }, React__default.createElement(ResultConsoleControls$1, {
    model: model
  })), !!resultValue && React__default.createElement(Editor, Object.assign({}, generalEditorProps, {
    textareaClassName: resultClasses,
    preClassName: resultClasses,
    value: resultValue,
    readOnly: true
  })))))), React__default.createElement(Grid, {
    container: true,
    item: true,
    justify: "flex-end"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    onClick: actionHandler,
    disabled: isRunBtnDisabled,
    color: "primary",
    variant: "contained",
    endIcon: endIcon
  }, React__default.createElement(FormattedMessage, {
    id: "console.runScript"
  }))))));
});

var Logout = observer$1(function () {
  var _useStore = useStore(),
      authenticationStore = _useStore.authenticationStore;

  var history = useHistory();
  useEffect(function () {
    authenticationStore.logout().then(function () {
      history.push(clientRoute.root);
    });
  }, [authenticationStore]);
  return React__default.createElement(React__default.Fragment, null);
});

var NotAllowed = function NotAllowed() {
  var _di = di([TotBackground], NotAllowed),
      TotBackground$1 = _di[0];

  return React__default.createElement(TotBackground$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Container, {
    maxWidth: "xs"
  }, React__default.createElement(Paper, {
    elevation: 0
  }, React__default.createElement(Box, {
    p: 12,
    textAlign: "center"
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, "403"), React__default.createElement(Typography, {
    variant: "subtitle1",
    component: "p"
  }, React__default.createElement(FormattedMessage, {
    id: "common.actionNotAllowed"
  })))))));
};

var NotFound = function NotFound() {
  var _di = di([TotBackground], NotFound),
      TotBackground$1 = _di[0];

  return React__default.createElement(TotBackground$1, null, React__default.createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center",
    justify: "center"
  }, React__default.createElement(Container, {
    maxWidth: "xs"
  }, React__default.createElement(Paper, {
    elevation: 0
  }, React__default.createElement(Box, {
    p: 12,
    textAlign: "center"
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, "404"), React__default.createElement(Typography, {
    variant: "subtitle1",
    component: "p"
  }, React__default.createElement(FormattedMessage, {
    id: "common.pageNotFound"
  })))))));
};

var registryCodeTTable = 'logging';
var RequestLogTable = observer$1(function (props) {
  var _di = di([AuthorizationCheck], RequestLogTable),
      AuthorizationCheck$1 = _di[0];

  var requestNumber = props.requestNumber;

  var _useStore = useStore(),
      requestStore = _useStore.requestStore,
      presetStore = _useStore.presetStore,
      intlStore = _useStore.intlStore,
      catalogStore = _useStore.catalogStore,
      userStore = _useStore.userStore;

  var _useParams = useParams(),
      id = _useParams.id;

  var saveListPresets = function saveListPresets(settings) {
    return presetStore.saveListPresets(settings);
  };

  var registry = function registry(registryCode, query) {
    return requestStore.registryRequestLog(registryCode, id, query);
  };

  var upload = function upload(query) {
    return requestStore.uploadRequestLog(query, registryCodeTTable, id, requestNumber);
  };

  return React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.System,
    permCode: permissions.System.Administration
  }, function (allowed) {
    return React__default.createElement(TTable, {
      registryCode: registryCodeTTable,
      fetchData: registry,
      fetchColumns: requestStore.registryRequestLogColumns,
      fetchCatalog: catalogStore.getCatalog,
      presetsSetting: presetStore,
      visibleSettings: {
        isWithPresets: false,
        isWithAddCustomColumns: false,
        isWithDraggableColumns: false
      },
      fetchSelectDataByUrl: catalogStore.getSelectDataByUrl,
      upload: upload,
      lang: intlStore.locale,
      saveListPresets: saveListPresets,
      fetchUserRoleList: userStore.userRoleList,
      isAdmin: allowed
    });
  });
});

var RequestLogPage = function RequestLogPage() {
  var _di = di([RequestLogTable], RequestLogPage),
      RequestLogTable$1 = _di[0];

  var _di2 = di([PageContentContainer], RequestLogPage),
      PageContentContainer$1 = _di2[0];

  var _di3 = di([TotObjectHeader], RequestLogPage),
      TotObjectHeader$1 = _di3[0];

  var _useStore = useStore(),
      requestStore = _useStore.requestStore;

  var _useParams = useParams(),
      id = _useParams.id;

  var _useState = useState(''),
      requestNumber = _useState[0],
      setRequestNumber = _useState[1];

  useEffect(function () {
    requestStore.getRequestDTO(id).then(function (data) {
      return setRequestNumber(data.number);
    });
  }, [requestStore]);
  return React__default.createElement(PageContentContainer$1, {
    container: true,
    direction: "column",
    wrap: "nowrap"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TotObjectHeader$1, null, React__default.createElement(Container, {
    maxWidth: "xl"
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column",
    alignItems: "flex-start"
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: generatePath(clientRoute.request, {
      id: id
    })
  }, React__default.createElement(FormattedMessage, {
    id: "requestLog.backToRequest"
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, React__default.createElement(FormattedMessage, {
    id: "requestLog.title",
    values: {
      number: requestNumber
    }
  }))))))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Container, {
    maxWidth: "xl"
  }, React__default.createElement(Box, {
    pb: 10,
    pt: 10
  }, React__default.createElement(RequestLogTable$1, {
    requestNumber: requestNumber
  })))));
};

function useAntiDoubleClick(actionFunc) {
  var _di = di([StyledCircularProgress], App),
      StyledCircularProgress$1 = _di[0];

  var _useState = useState(false),
      isActionInProgress = _useState[0],
      setIsActionInProgress = _useState[1];

  var endIcon = isActionInProgress && React__default.createElement(StyledCircularProgress$1, null);

  var actionHandler = function actionHandler() {
    setIsActionInProgress(true);
    actionFunc().finally(function () {
      setIsActionInProgress(false);
    });
  };

  return [isActionInProgress, endIcon, actionHandler];
}

var useFormStyles = makeStyles(function () {
  return createStyles$1({
    formWithNoOffset: {
      margin: '-20px -23px 0'
    }
  });
});

function useLoading() {
  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var enableLoading = function enableLoading() {
    setIsLoading(true);
  };

  var disableLoading = function disableLoading() {
    setIsLoading(false);
  };

  return [isLoading, enableLoading, disableLoading];
}

function useReload() {
  var _useState = useState(0),
      reloadKey = _useState[0],
      setReloadKey = _useState[1];

  var reloadIncrement = useCallback(function () {
    setReloadKey(function (reloadKey) {
      return reloadKey + 1;
    });
  }, [setReloadKey]);
  return [reloadKey, reloadIncrement];
}

var Api = /*#__PURE__*/function () {
  function Api(rootStore) {
    this.authStatus = 'pending';
    this.rootStore = rootStore;
    this.client = axios.create({
      baseURL: this.rootStore.env.apiUrl,
      withCredentials: true
    });
    this.client.interceptors.response.use(function (_) {
      return _;
    }, this.authInterceptor);
  }

  var _proto = Api.prototype;

  _proto.authInterceptor = function authInterceptor(error) {
    var response = error.response || {};

    if (response.status === 401) {
      this.authStatus = 'unauthorized';
    }

    throw error;
  };

  _proto.authVerify = function authVerify() {
    try {
      var _this2 = this;

      _this2.authStatus = 'pending';
      return Promise.resolve(_this2.client(apiConfigs.authorizationCheck([])).then(function (r) {
        return r;
      })).then(function () {
        _this2.authStatus = 'ok';
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Api;
}();

__decorate([observable], Api.prototype, "rootStore", void 0);

__decorate([observable], Api.prototype, "authStatus", void 0);

__decorate([action.bound], Api.prototype, "authInterceptor", null);

__decorate([action.bound], Api.prototype, "authVerify", null);

var getApi = function getApi() {
  var _di = di([Api], getApi),
      _Api = _di[0];

  return _Api;
};

var ApprovalStore = /*#__PURE__*/function () {
  function ApprovalStore(rootStore) {
    var _this = this;

    this.isSheetsLoading = false;

    this.updateApprovalSheet = function (sheetId) {
      return _this.api.client(apiConfigs.getApprovalSheet(sheetId)).then(function (r) {
        return r.data;
      }).then(function (updatedSheet) {
        updatedSheet.groups = _this.mapSheetGroups(updatedSheet.groups, updatedSheet.activeGroupId);

        if (_this.sheets) {
          var sheetIndex = _this.sheets.findIndex(function (sheet) {
            return sheet.id === sheetId;
          });

          if (sheetIndex !== -1) {
            _this.sheets.splice(sheetIndex, 1, updatedSheet);
          }
        }
      });
    };

    this.changeApprovalSheetStatus = function (reloadModel) {
      return function (sheetId, status) {
        return _this.api.client(apiConfigs.changeApprovalSheetStatus(sheetId, status)).then(function (r) {
          return r.data;
        }).then(function () {
          return _this.updateApprovalSheet(sheetId);
        }).then(reloadModel);
      };
    };

    this.sendApprovalSheetResolution = function (reloadModel) {
      return function (sheetId, resolution, participantId) {
        return _this.api.client(apiConfigs.sendApprovalSheetResolution(sheetId, resolution, participantId)).then(function (r) {
          return r.data;
        }).then(function () {
          return _this.updateApprovalSheet(sheetId);
        }).then(reloadModel);
      };
    };

    this.saveApprovalSheetGroups = function (dto) {
      var sheetId = dto.sheetId;
      return _this.api.client(apiConfigs.saveApprovalSheetGroups(dto)).then(function (r) {
        return r.data;
      }).then(function () {
        return _this.updateApprovalSheet(sheetId);
      });
    };

    this.getAllUsers = function () {
      return _this.api.client(apiConfigs.getAllActiveNonBlockedUsers()).then(function (r) {
        return r.data;
      });
    };

    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = ApprovalStore.prototype;

  _proto.loadApprovalSheets = function loadApprovalSheets(requestId) {
    try {
      var _this3 = this;

      _this3.setSheetsLoading(true);

      var _temp2 = _catch(function () {
        return Promise.resolve(_this3.api.client(apiConfigs.loadRequestApprovalSheets(requestId))).then(function (response) {
          var listsOrUndefined = response.data;

          if (listsOrUndefined) {
            _this3.setApprovalSheets(listsOrUndefined);
          }

          _this3.setSheetsLoading(false);
        });
      }, function () {
        _this3.setSheetsLoading(false);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setApprovalSheets = function setApprovalSheets(sheets) {
    var _this4 = this;

    sheets.forEach(function (sheet) {
      sheet.groups = _this4.mapSheetGroups(sheet.groups, sheet.activeGroupId);
    });
    this.sheets = observable.array(sheets);
  };

  _proto.setSheetsLoading = function setSheetsLoading(state) {
    this.isSheetsLoading = state;
  };

  _proto.mapSheetGroups = function mapSheetGroups(groups, activeGroupId) {
    if (activeGroupId === void 0) {
      activeGroupId = '';
    }

    var activeGroup = groups.find(function (group) {
      return group.id === activeGroupId;
    });
    var activeGroupIndex = (activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.index) || -1;
    return groups.map(function (group) {
      var isActiveGroup = group.id === activeGroupId;
      var isAfterActiveGroup = group.index >= activeGroupIndex;
      return _extends({}, group, {
        isActiveGroup: isActiveGroup,
        isAfterActiveGroup: isAfterActiveGroup
      });
    });
  };

  _createClass(ApprovalStore, [{
    key: "hasApprovalTab",
    get: function get() {
      return !!this.sheets && this.sheets.length > 0;
    }
  }]);

  return ApprovalStore;
}();

__decorate([observable], ApprovalStore.prototype, "rootStore", void 0);

__decorate([observable], ApprovalStore.prototype, "api", void 0);

__decorate([observable], ApprovalStore.prototype, "sheets", void 0);

__decorate([observable], ApprovalStore.prototype, "isSheetsLoading", void 0);

__decorate([asyncAction, action.bound], ApprovalStore.prototype, "loadApprovalSheets", null);

__decorate([action.bound], ApprovalStore.prototype, "setApprovalSheets", null);

__decorate([computed], ApprovalStore.prototype, "hasApprovalTab", null);

__decorate([action.bound], ApprovalStore.prototype, "updateApprovalSheet", void 0);

__decorate([action.bound], ApprovalStore.prototype, "changeApprovalSheetStatus", void 0);

__decorate([action.bound], ApprovalStore.prototype, "sendApprovalSheetResolution", void 0);

__decorate([action.bound], ApprovalStore.prototype, "saveApprovalSheetGroups", void 0);

__decorate([action.bound], ApprovalStore.prototype, "getAllUsers", void 0);

__decorate([action.bound], ApprovalStore.prototype, "setSheetsLoading", null);

var getApprovalStore = function getApprovalStore() {
  var _di = di([ApprovalStore], getApprovalStore),
      _ApprovalStore = _di[0];

  return _ApprovalStore;
};

var AuthenticationStore = /*#__PURE__*/function () {
  function AuthenticationStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = AuthenticationStore.prototype;

  _proto.esiaGetAuthUrl = function esiaGetAuthUrl() {
    return this.api.client(apiConfigs.esiaAuthUrl).then(function (r) {
      return r.data;
    });
  };

  _proto.samlGetAuthUrl = function samlGetAuthUrl(provider, backUrl) {
    return this.api.client(apiConfigs.samlAuthUrl(provider, backUrl)).then(function (r) {
      return r.data;
    });
  };

  _proto.esiaLogin = function esiaLogin(search) {
    return this.api.client(apiConfigs.esiaLogin(search)).then(function (r) {
      return r.data;
    });
  };

  _proto.logout = function logout() {
    return this.api.client(apiConfigs.logout);
  };

  _proto.loginAnonymously = function loginAnonymously() {
    return this.api.client(apiConfigs.loginAnonymously);
  };

  _createClass(AuthenticationStore, [{
    key: "loginModel",
    get: function get() {
      return new LoginModel(this.rootStore.api, this.rootStore.intlStore, this.rootStore.personStore);
    }
  }, {
    key: "registrationModel",
    get: function get() {
      return new RegistrationModel(this.rootStore.api, this.rootStore.intlStore);
    }
  }, {
    key: "registrationConfirmModel",
    get: function get() {
      return new RegistrationConfirmModel(this.rootStore.api, this.rootStore.intlStore);
    }
  }, {
    key: "recoveryPasswordModel",
    get: function get() {
      return new RecoveryPasswordModel(this.rootStore.api, this.rootStore.intlStore);
    }
  }, {
    key: "newPasswordModel",
    get: function get() {
      return new NewPasswordModel(this.rootStore.api, this.rootStore.intlStore);
    }
  }]);

  return AuthenticationStore;
}();

__decorate([observable], AuthenticationStore.prototype, "rootStore", void 0);

__decorate([observable], AuthenticationStore.prototype, "api", void 0);

__decorate([computed], AuthenticationStore.prototype, "loginModel", null);

__decorate([computed], AuthenticationStore.prototype, "registrationModel", null);

__decorate([computed], AuthenticationStore.prototype, "registrationConfirmModel", null);

__decorate([computed], AuthenticationStore.prototype, "recoveryPasswordModel", null);

__decorate([computed], AuthenticationStore.prototype, "newPasswordModel", null);

__decorate([action.bound], AuthenticationStore.prototype, "esiaGetAuthUrl", null);

__decorate([action.bound], AuthenticationStore.prototype, "samlGetAuthUrl", null);

__decorate([action.bound], AuthenticationStore.prototype, "esiaLogin", null);

__decorate([asyncAction, action.bound], AuthenticationStore.prototype, "logout", null);

__decorate([action.bound], AuthenticationStore.prototype, "loginAnonymously", null);

var getAuthenticationStore = function getAuthenticationStore() {
  var _di = di([AuthenticationStore], getAuthenticationStore),
      _AuthenticationStore = _di[0];

  return _AuthenticationStore;
};

var AuthorizationStore = /*#__PURE__*/function () {
  function AuthorizationStore(rootStore) {
    this.api = rootStore.api;
    this.dataLoader = new DataLoader(this.loadGrants, {
      cache: false
    });
  }

  var _proto = AuthorizationStore.prototype;

  _proto.check = function check(query) {
    return this.dataLoader.load(query);
  };

  _proto.checkAll = function checkAll(queries) {
    var _this = this;

    return Promise.all(queries.map(function (query) {
      return _this.dataLoader.load(query);
    }));
  };

  _proto.loadGrants = function loadGrants(keys) {
    return this.api.client(apiConfigs.authorizationCheck(keys)).then(function (r) {
      return r.data;
    }).then(function (checkResults) {
      return checkResults.map(function (r) {
        return r.allowed;
      });
    });
  };

  return AuthorizationStore;
}();

__decorate([observable], AuthorizationStore.prototype, "api", void 0);

__decorate([action.bound], AuthorizationStore.prototype, "check", null);

__decorate([action.bound], AuthorizationStore.prototype, "checkAll", null);

__decorate([action.bound], AuthorizationStore.prototype, "loadGrants", null);

var getAuthorizationStore = function getAuthorizationStore() {
  var _di = di([AuthorizationStore], getAuthorizationStore),
      _AuthorizationStore = _di[0];

  return _AuthorizationStore;
};

var CampaignsStore = /*#__PURE__*/function () {
  function CampaignsStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = CampaignsStore.prototype;

  _proto.getCampaignInfoModel = function getCampaignInfoModel(id) {
    var model = new CampaignInfoModel(this.rootStore.env.apiUrl);
    this.loadCampaignInfo(id).then(model.load);
    return observable(model);
  };

  _proto.createCampaign = function createCampaign(lifecycleCode) {
    return this.api.client(apiConfigs.createCampaign(lifecycleCode)).then(function (r) {
      return r.data.id;
    });
  };

  _proto.loadFile = function loadFile(id) {
    return this.api.client(apiConfigs.campaignFile(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.loadCampaignInfo = function loadCampaignInfo(id) {
    var _this = this;

    return this.api.client(apiConfigs.campaign(id)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.loadCampaignForm = function loadCampaignForm(id) {
    var _this2 = this;

    return this.api.client(apiConfigs.campaignForm(id)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this2.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this2.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.saveCampaignForm = function saveCampaignForm(id, submission) {
    return this.api.client(apiConfigs.editCampaign(id, submission)).then(function (r) {
      return r.data;
    });
  };

  _proto.downloadFile = function downloadFile$1(file) {
    return this.api.client(apiConfigs.campaignFile(file.fileId)).then(function (r) {
      return r.data;
    }).then(function (f) {
      return downloadFile(f, file.filename, file.mimeType);
    });
  };

  _proto.downloadRegFormFile = function downloadRegFormFile(file) {
    return this.api.client(apiConfigs.regFormFile(file.fileId)).then(function (r) {
      return r.data;
    }).then(function (f) {
      return downloadFile(f, file.filename, file.mimeType);
    });
  };

  _proto.createRegForm = function createRegForm(campaignId) {
    return this.api.client(apiConfigs.createRegForm(campaignId)).then(function (r) {
      return r.data.id;
    });
  };

  _proto.loadRegForms = function loadRegForms(campaignId, minimal, edit) {
    var _this3 = this;

    if (minimal === void 0) {
      minimal = false;
    }

    return this.api.client(apiConfigs.regForms(campaignId, minimal, edit)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this3.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this3.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.changeRegFormsPosition = function changeRegFormsPosition(id, newPosition) {
    return this.api.client(apiConfigs.changeRegFormsPosition(id, newPosition));
  };

  _proto.regFormsByCampaignsForSelect = function regFormsByCampaignsForSelect(campaigns) {
    if (campaigns === void 0) {
      campaigns = [];
    }

    return this.api.client(apiConfigs.regFormsByCampaignsForSelect(campaigns)).then(function (r) {
      return r.data;
    });
  };

  _proto.loadRegFormInfo = function loadRegFormInfo(id) {
    var _this4 = this;

    return this.api.client(apiConfigs.regFormCard(id)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this4.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this4.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.loadRegForm = function loadRegForm(id) {
    var _this5 = this;

    return this.api.client(apiConfigs.regForm(id)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this5.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this5.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.saveRegForm = function saveRegForm(id, submission) {
    return this.api.client(apiConfigs.editRegForm(id, submission)).then(function (r) {
      return r.data;
    });
  };

  _proto.deleteRegForm = function deleteRegForm(id) {
    return this.api.client(apiConfigs.deleteRegForm(id));
  };

  _proto.deleteCampaign = function deleteCampaign(id) {
    return this.api.client(apiConfigs.deleteCampaign(id));
  };

  _proto.getRegFormModel = function getRegFormModel(id) {
    var model = new FormModel(id);
    this.loadRegForm(id).then(model.load);
    return model;
  };

  _proto.getRegFormInfoModel = function getRegFormInfoModel(id) {
    var model = new CampaignRegFormInfoModel(id);
    this.loadRegFormInfo(id).then(model.load);
    return model;
  };

  _proto.loadTemplates = function loadTemplates(regFormId) {
    var _this6 = this;

    return this.api.client(apiConfigs.templates(regFormId)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this6.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this6.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.loadTemplate = function loadTemplate(id) {
    var _this7 = this;

    return this.api.client(apiConfigs.template(id)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this7.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this7.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.createTemplate = function createTemplate(regFormId, model) {
    return this.api.client(apiConfigs.createTemplate(regFormId, model.formData)).then(function (r) {
      return r.data;
    });
  };

  _proto.saveTemplate = function saveTemplate(model) {
    return this.api.client(apiConfigs.saveTemplate(model.id, model.formData)).then(function (r) {
      return r.data;
    });
  };

  _proto.deleteTemplate = function deleteTemplate(id) {
    return this.api.client(apiConfigs.deleteTemplate(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.changeTemplatePosition = function changeTemplatePosition(templateId, newPosition) {
    return this.api.client(apiConfigs.changeTemplatePosition(templateId, newPosition));
  };

  _proto.downloadTemplateFile = function downloadTemplateFile(fileDTO) {
    this.api.client(apiConfigs.downloadTemplateFile(fileDTO.id)).then(function (r) {
      return r.data;
    }).then(function (f) {
      return downloadFile(f, fileDTO.filename, fileDTO.mimeType);
    });
  };

  _proto.getLifecycleList = function getLifecycleList() {
    return this.api.client(apiConfigs.getLifecycleList).then(function (r) {
      return r.data;
    });
  };

  _proto.getActualCampaignList = function getActualCampaignList() {
    return this.api.client(apiConfigs.getActualCampaignList).then(function (r) {
      return r.data;
    });
  };

  _proto.getTransitionCampaign = function getTransitionCampaign(requestId) {
    return this.api.client(apiConfigs.transitionCampaign(requestId)).then(function (r) {
      return r.data;
    });
  };

  _proto.transitionToNextLifeCycleStepCampaign = function transitionToNextLifeCycleStepCampaign(transitionId, requestId) {
    return this.api.client(apiConfigs.transitionToNextLifeCycleStepCampaign(transitionId, requestId)).then(function (r) {
      return r.data;
    });
  };

  _proto.getCampaignDTO = function getCampaignDTO(campaignId) {
    var _this8 = this;

    return this.api.client(apiConfigs.campaign(campaignId)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this8.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this8.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.getFormForGeneralSettings = function getFormForGeneralSettings(campaignId) {
    var model = new FormModel(campaignId);
    this.loadFormForGeneralSettings(campaignId).then(model.load);
    return model;
  };

  _proto.loadFormForGeneralSettings = function loadFormForGeneralSettings(campaignId) {
    var _this9 = this;

    return this.api.client(apiConfigs.getFormForGeneralSettings(campaignId)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this9.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this9.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.saveFormForGeneralSettings = function saveFormForGeneralSettings(id, submission) {
    return this.api.client(apiConfigs.saveFormForGeneralSettings(id, submission));
  };

  _proto.requestFormSettings = function requestFormSettings(regFormId) {
    return this.api.client(apiConfigs.requestFormSettings(regFormId)).then(function (r) {
      return r.data;
    });
  };

  _proto.loadExecutors = function loadExecutors() {
    return this.api.client(apiConfigs.loadExecutors()).then(function (r) {
      return r.data;
    });
  };

  _proto.loadPermissions = function loadPermissions() {
    return this.api.client(apiConfigs.loadPermissions()).then(function (r) {
      return r.data;
    });
  };

  _proto.loadStates = function loadStates(id) {
    return this.api.client(apiConfigs.loadStates(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.loadFormCode = function loadFormCode() {
    return this.api.client(apiConfigs.loadFormCode()).then(function (r) {
      return r.data;
    });
  };

  _proto.createRequestFormSetting = function createRequestFormSetting(regFormId, dto) {
    return this.api.client(apiConfigs.createRequestFormSetting(regFormId, dto)).then(function (r) {
      return r.data.id;
    });
  };

  _proto.loadRequestFormSetting = function loadRequestFormSetting(id) {
    return this.api.client(apiConfigs.loadRequestFormSetting(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.getRequestFormSetting = function getRequestFormSetting(model, id) {
    this.loadRequestFormSetting(id).then(model.load);
  };

  _proto.saveRequestFormSetting = function saveRequestFormSetting(id, dto) {
    return this.api.client(apiConfigs.saveRequestFormSetting(id, dto)).then(function (r) {
      return r.data;
    });
  };

  _proto.deleteRequestFormSetting = function deleteRequestFormSetting(id) {
    var _this10 = this;

    return this.api.client(apiConfigs.deleteRequestFormSetting(id)).then(function (r) {
      return r.data;
    }).catch(function (error) {
      _this10.notificationStore.onError(error.response.data);
    });
  };

  _proto.changePositionRequestFormSetting = function changePositionRequestFormSetting(id, position) {
    return this.api.client(apiConfigs.changePositionRequestFormSetting(id, position)).then(function (r) {
      return r.data;
    });
  };

  _proto.fetchExecutorList = function fetchExecutorList(regFormId) {
    return this.api.client(apiConfigs.fetchExecutorList(regFormId)).then(function (r) {
      return r.data;
    });
  };

  _proto.fetchExecutorsSettings = function fetchExecutorsSettings(regFormId) {
    return this.api.client(apiConfigs.fetchExecutorsSettings(regFormId)).then(function (r) {
      return r.data;
    });
  };

  _proto.fetchUsers = function fetchUsers() {
    try {
      var _this12 = this;

      var model = new UserNameModel();
      return Promise.resolve(_this12.api.client(apiConfigs.fetchUsers())).then(function (_ref) {
        var data = _ref.data;
        return data.map(function (user) {
          model.load(user);
          return model.asIdTitle;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.fetchAllEmployee = function fetchAllEmployee() {
    try {
      var _this14 = this;

      return Promise.resolve(_this14.api.client(apiConfigs.getAllActiveEmployees()).then(function (r) {
        return r.data;
      }).then(function (employees) {
        return employees.map(function (employee) {
          var author = new UserNameModel().load(_extends({}, employee, {
            name: employee.person.firstName
          }));
          return {
            id: employee.userId,
            title: author.name
          };
        });
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.addExecutor = function addExecutor(regFormId, settings) {
    return this.api.client(apiConfigs.addExecutor(regFormId, settings)).then(function (r) {
      return r.data;
    });
  };

  _proto.deleteExecutor = function deleteExecutor(regFormId, settingsExecId) {
    return this.api.client(apiConfigs.deleteExecutor(regFormId, settingsExecId)).then(function (r) {
      return r.data;
    });
  };

  _proto.createRequest = function createRequest(campaignId) {
    var _this15 = this;

    var requestStore = this.rootStore.requestStore;
    return this.loadRegForms(campaignId).then(function (regForms) {
      if (regForms.length === 1) {
        var regFormId = regForms[0].id;
        requestStore.createRequest(regFormId).then(function (requestId) {
          _this15.history.push(generatePath(clientRoute.requestEdit, {
            id: requestId
          }));
        });
      } else {
        _this15.history.push(generatePath(clientRoute.regFormSelect, {
          campaignId: campaignId
        }));
      }
    });
  };

  _proto.loadTemplatePermissions = function loadTemplatePermissions(settingsId) {
    return this.api.client(apiConfigs.loadTemplatePermissions(settingsId)).then(function (r) {
      return r.data;
    });
  };

  _proto.saveTemplatePermissions = function saveTemplatePermissions(settingsId, permissions) {
    return this.api.client(apiConfigs.savedTemplatePermissions(settingsId, permissions)).then(function (r) {
      return r.data;
    });
  };

  _createClass(CampaignsStore, [{
    key: "history",
    get: function get() {
      return this.rootStore.history;
    }
  }, {
    key: "notificationStore",
    get: function get() {
      return this.rootStore.notificationStore;
    }
  }]);

  return CampaignsStore;
}();

__decorate([observable], CampaignsStore.prototype, "rootStore", void 0);

__decorate([observable], CampaignsStore.prototype, "api", void 0);

__decorate([computed], CampaignsStore.prototype, "history", null);

__decorate([computed], CampaignsStore.prototype, "notificationStore", null);

__decorate([action.bound], CampaignsStore.prototype, "getCampaignInfoModel", null);

__decorate([action.bound], CampaignsStore.prototype, "createCampaign", null);

__decorate([action.bound], CampaignsStore.prototype, "loadFile", null);

__decorate([action.bound], CampaignsStore.prototype, "loadCampaignInfo", null);

__decorate([action.bound], CampaignsStore.prototype, "loadCampaignForm", null);

__decorate([action.bound], CampaignsStore.prototype, "saveCampaignForm", null);

__decorate([action.bound], CampaignsStore.prototype, "downloadFile", null);

__decorate([action.bound], CampaignsStore.prototype, "downloadRegFormFile", null);

__decorate([action.bound], CampaignsStore.prototype, "createRegForm", null);

__decorate([action.bound], CampaignsStore.prototype, "loadRegForms", null);

__decorate([action.bound], CampaignsStore.prototype, "changeRegFormsPosition", null);

__decorate([action.bound], CampaignsStore.prototype, "regFormsByCampaignsForSelect", null);

__decorate([action.bound], CampaignsStore.prototype, "loadRegFormInfo", null);

__decorate([action.bound], CampaignsStore.prototype, "loadRegForm", null);

__decorate([action.bound], CampaignsStore.prototype, "saveRegForm", null);

__decorate([action.bound], CampaignsStore.prototype, "deleteRegForm", null);

__decorate([action.bound], CampaignsStore.prototype, "deleteCampaign", null);

__decorate([action.bound], CampaignsStore.prototype, "getRegFormModel", null);

__decorate([action.bound], CampaignsStore.prototype, "getRegFormInfoModel", null);

__decorate([action.bound], CampaignsStore.prototype, "loadTemplates", null);

__decorate([action.bound], CampaignsStore.prototype, "loadTemplate", null);

__decorate([action.bound], CampaignsStore.prototype, "createTemplate", null);

__decorate([action.bound], CampaignsStore.prototype, "saveTemplate", null);

__decorate([action.bound], CampaignsStore.prototype, "deleteTemplate", null);

__decorate([action.bound], CampaignsStore.prototype, "changeTemplatePosition", null);

__decorate([action.bound], CampaignsStore.prototype, "downloadTemplateFile", null);

__decorate([action.bound], CampaignsStore.prototype, "getLifecycleList", null);

__decorate([action.bound], CampaignsStore.prototype, "getActualCampaignList", null);

__decorate([action.bound], CampaignsStore.prototype, "getTransitionCampaign", null);

__decorate([action.bound], CampaignsStore.prototype, "transitionToNextLifeCycleStepCampaign", null);

__decorate([action.bound], CampaignsStore.prototype, "getCampaignDTO", null);

__decorate([action.bound], CampaignsStore.prototype, "loadFormForGeneralSettings", null);

__decorate([action.bound], CampaignsStore.prototype, "saveFormForGeneralSettings", null);

__decorate([action.bound], CampaignsStore.prototype, "requestFormSettings", null);

__decorate([action.bound], CampaignsStore.prototype, "loadExecutors", null);

__decorate([action.bound], CampaignsStore.prototype, "loadPermissions", null);

__decorate([action.bound], CampaignsStore.prototype, "loadStates", null);

__decorate([action.bound], CampaignsStore.prototype, "loadFormCode", null);

__decorate([action.bound], CampaignsStore.prototype, "createRequestFormSetting", null);

__decorate([action.bound], CampaignsStore.prototype, "loadRequestFormSetting", null);

__decorate([action.bound], CampaignsStore.prototype, "getRequestFormSetting", null);

__decorate([action.bound], CampaignsStore.prototype, "saveRequestFormSetting", null);

__decorate([action.bound], CampaignsStore.prototype, "deleteRequestFormSetting", null);

__decorate([action.bound], CampaignsStore.prototype, "changePositionRequestFormSetting", null);

__decorate([action.bound], CampaignsStore.prototype, "fetchExecutorList", null);

__decorate([action.bound], CampaignsStore.prototype, "fetchExecutorsSettings", null);

__decorate([action.bound], CampaignsStore.prototype, "fetchUsers", null);

__decorate([action.bound], CampaignsStore.prototype, "fetchAllEmployee", null);

__decorate([action.bound], CampaignsStore.prototype, "addExecutor", null);

__decorate([action.bound], CampaignsStore.prototype, "deleteExecutor", null);

__decorate([action.bound], CampaignsStore.prototype, "createRequest", null);

__decorate([action.bound], CampaignsStore.prototype, "loadTemplatePermissions", null);

__decorate([action.bound], CampaignsStore.prototype, "saveTemplatePermissions", null);

var getCampaignsStore = function getCampaignsStore() {
  var _di = di([CampaignsStore], getCampaignsStore),
      _CampaignsStore = _di[0];

  return _CampaignsStore;
};

var FormioSignatureStore = /*#__PURE__*/function () {
  function FormioSignatureStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = FormioSignatureStore.prototype;

  _proto.setOnSuccessForFormioInstance = function setOnSuccessForFormioInstance(onSuccess) {
    this.onSuccessForFormioInstance = onSuccess;
  };

  _proto.getFileByte = function getFileByte(url) {
    var _this = this;

    return function () {
      return _this.api.client(apiConfigs.getFormioFileByte(url)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.uploadSignature = function uploadSignature(url) {
    var _this2 = this;

    return function (signature) {
      return _this2.api.client(apiConfigs.uploadFormioSignature(url, signature)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.uploadSignatureFile = function uploadSignatureFile(url) {
    var _this3 = this;

    return function (signatureFile) {
      return _this3.api.client(apiConfigs.uploadFormioSignatureFile(url, signatureFile)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.getSignatureInfo = function getSignatureInfo(url) {
    var _this4 = this;

    return function () {
      return _this4.api.client(apiConfigs.getFormioSignatureInfo(url)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.downloadSignature = function downloadSignature(url) {
    var _this5 = this;

    return function (isWithFile) {
      return _this5.api.client(apiConfigs.downloadFormioSignature(url, isWithFile)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.deleteSignature = function deleteSignature(url) {
    var _this6 = this;

    return function () {
      return _this6.api.client(apiConfigs.deleteFormioSignature(url)).then(function (r) {
        return r.data;
      });
    };
  };

  return FormioSignatureStore;
}();

__decorate([observable], FormioSignatureStore.prototype, "rootStore", void 0);

__decorate([observable], FormioSignatureStore.prototype, "api", void 0);

__decorate([observable], FormioSignatureStore.prototype, "onSuccessForFormioInstance", void 0);

__decorate([action.bound], FormioSignatureStore.prototype, "setOnSuccessForFormioInstance", null);

__decorate([action.bound], FormioSignatureStore.prototype, "getFileByte", null);

__decorate([action.bound], FormioSignatureStore.prototype, "uploadSignature", null);

__decorate([action.bound], FormioSignatureStore.prototype, "uploadSignatureFile", null);

__decorate([action.bound], FormioSignatureStore.prototype, "getSignatureInfo", null);

__decorate([action.bound], FormioSignatureStore.prototype, "downloadSignature", null);

__decorate([action.bound], FormioSignatureStore.prototype, "deleteSignature", null);

var getFormioSignatureStore = function getFormioSignatureStore() {
  var _di = di([FormioSignatureStore], getFormioSignatureStore),
      _FormioSignatureStore = _di[0];

  return _FormioSignatureStore;
};

var FormioStore = /*#__PURE__*/function () {
  function FormioStore(rootStore) {
    this.rootStore = rootStore;
    this.apiUrl = rootStore.env.apiUrl;
    Components.setComponents(AllComponents);
    Components.addComponent('select', withFunctionCallComponents.select({
      baseUrl: this.apiUrl,
      catalogsUrl: this.apiUrl
    }));
    this.hackFormioFetch();
  }

  var _proto = FormioStore.prototype;

  _proto.addComponentsWithMaterialTheme = function addComponentsWithMaterialTheme() {
    var fileProps = {
      baseUrl: this.apiUrl,
      catalogsUrl: this.apiUrl,
      materialUiTheme: this.rootStore.appTheme,
      intlStore: this.rootStore.intlStore,
      signatureStore: this.rootStore.formioSignatureStore
    };
    var multilevelCatalogProps = {
      client: this.rootStore.api.client,
      intlStore: this.rootStore.intlStore,
      theme: this.rootStore.appTheme
    };
    Components.addComponent('file', withFunctionCallComponents.styledFile(fileProps));
    Components.addComponent('categoryFile', withFunctionCallComponents.categoryFile(fileProps));
    Components.addComponent('multilevelCatalog', withFunctionCallComponents.multilevelCatalog(multilevelCatalogProps));
  };

  _proto.hackFormioFetch = function hackFormioFetch() {
    var globalWithFormio = global;
    var formio = globalWithFormio.Formio;

    if (formio && formio.fetch) {
      var formioFetch = formio.fetch;

      globalWithFormio.Formio.fetch = function (url, options) {
        var fetchOptions = {
          credentials: 'include'
        };

        if (!!options) {
          fetchOptions = Object.assign(fetchOptions, options);
        }

        return formioFetch(url, fetchOptions);
      };
    }
  };

  return FormioStore;
}();

__decorate([observable], FormioStore.prototype, "rootStore", void 0);

__decorate([observable], FormioStore.prototype, "apiUrl", void 0);

__decorate([action.bound], FormioStore.prototype, "addComponentsWithMaterialTheme", null);

__decorate([action.bound], FormioStore.prototype, "hackFormioFetch", null);

var getFormioStore = function getFormioStore() {
  var _di = di([FormioStore], getFormioStore),
      _FormioStore = _di[0];

  return _FormioStore;
};

var HeaderHeightStore = /*#__PURE__*/function () {
  function HeaderHeightStore() {}

  var _proto = HeaderHeightStore.prototype;

  _proto.setHeaderHeight = function setHeaderHeight(height) {
    this.headerHeight = height;
  };

  return HeaderHeightStore;
}();

__decorate([observable], HeaderHeightStore.prototype, "headerHeight", void 0);

__decorate([action.bound], HeaderHeightStore.prototype, "setHeaderHeight", null);

var getHeaderHeightStore = function getHeaderHeightStore() {
  var _di = di([HeaderHeightStore], getHeaderHeightStore),
      _HeaderHeightStore = _di[0];

  return _HeaderHeightStore;
};

var ConsoleStore = /*#__PURE__*/function () {
  function ConsoleStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = ConsoleStore.prototype;

  _proto.runScript = function runScript(script) {
    return this.api.client(apiConfigs.runScript(script)).then(function (r) {
      var isFile = r.headers['content-type'] === fileContentType;
      var fileName = isFile ? getFileName(r.headers['content-disposition']) : '';
      return {
        blob: r.data,
        isFile: isFile,
        fileName: fileName
      };
    });
  };

  return ConsoleStore;
}();

__decorate([observable], ConsoleStore.prototype, "rootStore", void 0);

__decorate([observable], ConsoleStore.prototype, "api", void 0);

__decorate([action.bound], ConsoleStore.prototype, "runScript", null);

var getConsoleStore = function getConsoleStore() {
  var _di = di([ConsoleStore], getConsoleStore),
      _ConsoleStore = _di[0];

  return _ConsoleStore;
};

var _path$g;

function _extends$i() {
  _extends$i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$i.apply(this, arguments);
}

function SvgFileDocumentBoxMultipleOutline(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "currentColor"
  }, props), _path$g || (_path$g = /*#__PURE__*/createElement("path", {
    d: "M3.997 13.999v-2h5v2zm0-4v-2h8v2zm0-4V4h8v2zm12-4v14a2 2 0 01-2 2h-12a2 2 0 01-2-2V2c0-1.11.89-2 2-2h12a2 2 0 012 2zm-14 14h12V2h-12z"
  })));
}

var _defs$1, _g$1, _path$h;

function _extends$j() {
  _extends$j = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$j.apply(this, arguments);
}

function SvgFolder(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "5 0 20 18",
    fill: "currentColor"
  }, props), _defs$1 || (_defs$1 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
    id: "folder_svg__a",
    width: 112,
    height: 128,
    x: -41,
    y: -46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("feOffset", {
    dy: 18,
    in: "SourceGraphic",
    result: "FeOffset1090Out"
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    in: "FeOffset1090Out",
    result: "FeGaussianBlur1091Out",
    stdDeviation: "14.4 14.4"
  })), /*#__PURE__*/createElement("mask", {
    id: "folder_svg__b",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M5 0h20v18H5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M22 3a3 3 0 012.999 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3V3a3 3 0 013-3h4.56a3.001 3.001 0 012.84 2l.32 1zm1 3a1 1 0 00-1-1h-7a1 1 0 01-.951-.68l-.54-1.64a1 1 0 00-.95-.68h-4.56a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V6z"
  })))), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    filter: "url(#folder_svg__a)"
  }, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M22 3a3 3 0 012.999 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3V3a3 3 0 013-3h4.56a3.001 3.001 0 012.84 2l.32 1zm1 3a1 1 0 00-1-1h-7a1 1 0 01-.951-.68l-.54-1.64a1 1 0 00-.95-.68h-4.56a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V6z",
    mask: "url(\"#b\")"
  }), /*#__PURE__*/createElement("path", {
    fillOpacity: 0.03,
    d: "M22 3a3 3 0 012.999 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3V3a3 3 0 013-3h4.56a3.001 3.001 0 012.84 2l.32 1zm1 3a1 1 0 00-1-1h-7a1 1 0 01-.951-.68l-.54-1.64a1 1 0 00-.95-.68h-4.56a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V6z"
  }))), _path$h || (_path$h = /*#__PURE__*/createElement("path", {
    d: "M22 3a3 3 0 012.999 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3V3a3 3 0 013-3h4.56a3.001 3.001 0 012.84 2l.32 1zm1 3a1 1 0 00-1-1h-7a1 1 0 01-.951-.68l-.54-1.64a1 1 0 00-.95-.68h-4.56a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V6z"
  })));
}

var HeaderLinksStore = /*#__PURE__*/function () {
  function HeaderLinksStore() {}

  _createClass(HeaderLinksStore, [{
    key: "mainLinks",
    get: function get() {
      return [{
        key: 'requests',
        to: clientRoute.requests,
        icon: React__default.createElement(FormatListNumbered, {
          style: {
            fontSize: '24px'
          }
        }),
        isActiveCallback: function isActiveCallback(match, location) {
          if (!match) {
            return false;
          }

          return location.pathname !== clientRoute.requestsNew;
        },
        messageID: 'homePage.headerLinks.requests',
        query: {
          entityCode: entities.System,
          permCode: permissions.System.ViewCampRequestList
        }
      }, {
        key: 'requestsNew',
        to: clientRoute.requestsNew,
        icon: React__default.createElement(SvgFileDocumentBoxMultipleOutline, null),
        messageID: 'homePage.headerLinks.requestsNew',
        query: {
          entityCode: entities.System,
          permCode: permissions.System.ViewCampRequestRegistry
        }
      }, {
        key: 'campaigns',
        to: clientRoute.campaigns,
        icon: React__default.createElement(SvgFolder, null),
        messageID: 'homePage.headerLinks.campaigns',
        query: {
          entityCode: entities.System,
          permCode: permissions.System.ViewCampaignList
        }
      }, {
        key: 'users',
        to: clientRoute.users,
        icon: React__default.createElement(PeopleIcon, null),
        messageID: 'homePage.headerLinks.users',
        query: {
          entityCode: entities.System,
          permCode: permissions.System.ViewUserList
        }
      }, {
        key: 'console',
        to: clientRoute.console,
        messageID: 'homePage.headerLinks.console',
        icon: React__default.createElement(CodeOutlinedIcon, null),
        query: {
          entityCode: entities.System,
          permCode: permissions.System.Administration
        }
      }];
    }
  }, {
    key: "additionalLinks",
    get: function get() {
      return [];
    }
  }, {
    key: "avgLinkWidth",
    get: function get() {
      return 155;
    }
  }]);

  return HeaderLinksStore;
}();

__decorate([computed], HeaderLinksStore.prototype, "mainLinks", null);

__decorate([computed], HeaderLinksStore.prototype, "additionalLinks", null);

__decorate([computed], HeaderLinksStore.prototype, "avgLinkWidth", null);

var getHeaderLinksStore = function getHeaderLinksStore() {
  var _di = di([HeaderLinksStore], getHeaderLinksStore),
      _HeaderLinksStore = _di[0];

  return _HeaderLinksStore;
};

var LkNotificationStore = /*#__PURE__*/function () {
  function LkNotificationStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = LkNotificationStore.prototype;

  _proto.loadNotifications = function loadNotifications(queryData) {
    return this.api.client(apiConfigs.loadNotifications(queryData)).then(function (res) {
      return res.data;
    });
  };

  _proto.loadCountNotViewedMessages = function loadCountNotViewedMessages() {
    return this.api.client(apiConfigs.loadCountNotViewedMessages()).then(function (res) {
      return res.data;
    });
  };

  _proto.changeViewed = function changeViewed(id, viewed) {
    return this.api.client(apiConfigs.changeViewed(id, viewed)).then(function (res) {
      return res.data;
    });
  };

  _proto.deleteNotification = function deleteNotification(id) {
    return this.api.client(apiConfigs.deleteNotification(id)).then(function (res) {
      return res.data;
    });
  };

  return LkNotificationStore;
}();

__decorate([observable], LkNotificationStore.prototype, "rootStore", void 0);

__decorate([observable], LkNotificationStore.prototype, "api", void 0);

__decorate([action.bound], LkNotificationStore.prototype, "loadNotifications", null);

__decorate([action.bound], LkNotificationStore.prototype, "loadCountNotViewedMessages", null);

__decorate([action.bound], LkNotificationStore.prototype, "changeViewed", null);

__decorate([action.bound], LkNotificationStore.prototype, "deleteNotification", null);

var getLkNotificationStore = function getLkNotificationStore() {
  var _di = di([LkNotificationStore], getLkNotificationStore),
      _LkNotificationStore = _di[0];

  return _LkNotificationStore;
};

var ModulesStore = /*#__PURE__*/function () {
  function ModulesStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = ModulesStore.prototype;

  _proto.loadModulesList = function loadModulesList() {
    return this.api.client(apiConfigs.loadModulesList()).then(function (res) {
      return res.data;
    });
  };

  return ModulesStore;
}();

__decorate([observable], ModulesStore.prototype, "rootStore", void 0);

__decorate([observable], ModulesStore.prototype, "api", void 0);

__decorate([action.bound], ModulesStore.prototype, "loadModulesList", null);

var getModulesStore = function getModulesStore() {
  var _di = di([ModulesStore], getModulesStore),
      _ModulesStore = _di[0];

  return _ModulesStore;
};

var severityVariants = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};
var NotificationStore = /*#__PURE__*/function () {
  function NotificationStore() {
    this.model = new NotificationListModel();
  }

  var _proto = NotificationStore.prototype;

  _proto.onSuccess = function onSuccess(text) {
    this.model.pushNotification(text, severityVariants.success);
  };

  _proto.onError = function onError(text) {
    this.model.pushNotification(text, severityVariants.error);
  };

  _proto.onInfo = function onInfo(text) {
    this.model.pushNotification(text, severityVariants.info);
  };

  _proto.onWarning = function onWarning(text) {
    this.model.pushNotification(text, severityVariants.warning);
  };

  return NotificationStore;
}();

__decorate([observable], NotificationStore.prototype, "model", void 0);

__decorate([action.bound], NotificationStore.prototype, "onSuccess", null);

__decorate([action.bound], NotificationStore.prototype, "onError", null);

__decorate([action.bound], NotificationStore.prototype, "onInfo", null);

__decorate([action.bound], NotificationStore.prototype, "onWarning", null);

var getNotificationStore = function getNotificationStore() {
  var _di = di([NotificationStore], getNotificationStore),
      _NotificationStore = _di[0];

  return _NotificationStore;
};

var loginRedirectByRole = {
  User: clientRoute.requests,
  Employee: clientRoute.requestsNew,
  SeniorEmployee: clientRoute.requestsNew,
  Moderator: clientRoute.requestsNew
};
var rolePriorities = {
  User: 0,
  Employee: 1,
  SeniorEmployee: 2,
  Moderator: 3
};
var getRouteByRoles = function getRouteByRoles(roles, rolePriorities, loginRedirectByRole) {
  var rolesLength = roles.length;
  var redirect = '';
  var priority = 0;

  for (var index = 0; index < rolesLength; index++) {
    var role = roles[index];
    var rolePriority = rolePriorities[role];

    if ((rolePriority || rolePriority === 0) && rolePriority >= priority) {
      priority = rolePriority;
      redirect = loginRedirectByRole[role];
    }
  }

  if (redirect) {
    return redirect;
  }

  return clientRoute.campaigns;
};
var PersonStore = /*#__PURE__*/function () {
  function PersonStore(rootStore) {
    this.user = new UserModel();
    this.person = new PersonModel();
    this.roles = [];
    this.rootStore = rootStore;
    this.intlStore = rootStore.intlStore;
    this.api = rootStore.api;
  }

  var _proto = PersonStore.prototype;

  _proto.getInfo = function getInfo() {
    try {
      var _this2 = this;

      return Promise.resolve(_this2.api.client(apiConfigs.person(_this2.intlStore.locale))).then(function (response) {
        var info = response.data;
        _this2.user = info.user;

        _this2.person.load(info.person);

        _this2.roles = info.roles;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.clearPerson = function clearPerson() {
    this.user = new UserModel();
    this.person = new PersonModel();
    this.roles = [];
  };

  _createClass(PersonStore, [{
    key: "rolePriorities",
    get: function get() {
      return rolePriorities;
    }
  }, {
    key: "loginRedirectByRole",
    get: function get() {
      return loginRedirectByRole;
    }
  }, {
    key: "redirectPath",
    get: function get() {
      return getRouteByRoles(this.roles, this.rolePriorities, this.loginRedirectByRole);
    }
  }]);

  return PersonStore;
}();

__decorate([observable], PersonStore.prototype, "rootStore", void 0);

__decorate([observable], PersonStore.prototype, "intlStore", void 0);

__decorate([observable], PersonStore.prototype, "api", void 0);

__decorate([observable], PersonStore.prototype, "user", void 0);

__decorate([observable], PersonStore.prototype, "person", void 0);

__decorate([observable], PersonStore.prototype, "roles", void 0);

__decorate([asyncAction, action.bound], PersonStore.prototype, "getInfo", null);

__decorate([action.bound], PersonStore.prototype, "clearPerson", null);

__decorate([computed], PersonStore.prototype, "redirectPath", null);

var getPersonStore = function getPersonStore() {
  var _di = di([PersonStore], getPersonStore),
      _PersonStore = _di[0];

  return _PersonStore;
};

var PresetStore = /*#__PURE__*/function () {
  function PresetStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = PresetStore.prototype;

  _proto.listPreset = function listPreset(registryCode) {
    return this.api.client(apiConfigs.listPreset(registryCode)).then(function (_) {
      return _.data;
    });
  };

  _proto.savePreset = function savePreset(preset) {
    return this.api.client(apiConfigs.savePreset(preset)).then(function (_) {
      return _.data;
    });
  };

  _proto.deletePreset = function deletePreset(presetId) {
    return this.api.client(apiConfigs.deletePreset(presetId)).then(function (_) {
      return _.data;
    });
  };

  _proto.saveListPresets = function saveListPresets(presets) {
    try {
      var _this2 = this;

      var _temp2 = _catch(function () {
        return Promise.resolve(_this2.api.client(apiConfigs.saveListPresets(presets))).then(function () {});
      }, function (error) {
        console.log(error);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getLastPresetId = function getLastPresetId(registryCode) {
    return this.api.client(apiConfigs.getLastPreset(registryCode)).then(function (res) {
      var _res$data;

      return ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.presetId) || null;
    });
  };

  _proto.setLastPreset = function setLastPreset(preset) {
    try {
      var _this4 = this;

      var id = preset.id,
          registryCode = preset.registryCode;

      if (id) {
        _this4.api.client(apiConfigs.saveLastPreset(registryCode, id));
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return PresetStore;
}();

__decorate([observable], PresetStore.prototype, "rootStore", void 0);

__decorate([observable], PresetStore.prototype, "api", void 0);

__decorate([action.bound], PresetStore.prototype, "listPreset", null);

__decorate([action.bound], PresetStore.prototype, "savePreset", null);

__decorate([action.bound], PresetStore.prototype, "deletePreset", null);

__decorate([action.bound], PresetStore.prototype, "saveListPresets", null);

__decorate([action.bound], PresetStore.prototype, "getLastPresetId", null);

__decorate([action.bound], PresetStore.prototype, "setLastPreset", null);

var getPresetStore = function getPresetStore() {
  var _di = di([PresetStore], getPresetStore),
      _PresetStore = _di[0];

  return _PresetStore;
};

var RequestStore = /*#__PURE__*/function () {
  function RequestStore(rootStore) {
    this.showValidation = false;
    this.rootStore = rootStore;
    this.api = rootStore.api;
    this.notificationStore = rootStore.notificationStore;
  }

  var _proto = RequestStore.prototype;

  _proto.getRequestModel = function getRequestModel(requestId) {
    var model = new RequestModel(requestId, this.rootStore);
    this.getRequestDTO(requestId).then(model.load);
    return observable(model);
  };

  _proto.getRequestDTO = function getRequestDTO(requestId) {
    var _this = this;

    return this.api.client(apiConfigs.getRequest(requestId)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.getDeadlinesDTO = function getDeadlinesDTO(requestId) {
    return this.api.client(apiConfigs.getDeadlines(requestId)).then(function (r) {
      return r.data;
    });
  };

  _proto.createRequest = function createRequest(regFormId) {
    return this.api.client(apiConfigs.createRequest(regFormId)).then(function (r) {
      return r.data;
    });
  };

  _proto.loadRequestForm = function loadRequestForm(formId) {
    var _this2 = this;

    return this.api.client(apiConfigs.loadRequestForm(formId)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this2.history.replace(clientRoute.notAllowed);
      },
      404: function _() {
        return _this2.history.replace(clientRoute.notFound);
      }
    }));
  };

  _proto.requestFormCheckEditable = function requestFormCheckEditable(requestFormId) {
    return this.api.client(apiConfigs.requestFormCheckEditable(requestFormId)).then(function (r) {
      return r.data;
    });
  };

  _proto.getRequestFormModel = function getRequestFormModel(formId) {
    var _this3 = this;

    var model = new RequestFormModel(formId);
    return this.loadRequestForm(formId).then(model.load).then(function () {
      return observable(model);
    }).catch(function (error) {
      _this3.notificationStore.onError(error.response.data);

      return Promise.reject(error);
    });
  };

  _proto.saveRequestForm = function saveRequestForm(id, submission) {
    return this.api.client(apiConfigs.saveRequestForm(id, submission)).then(function (r) {
      return r.data;
    });
  };

  _proto.deleteRequest = function deleteRequest(id) {
    return this.api.client(apiConfigs.deleteRequest(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.exportListXls = function exportListXls(queryData) {
    var filename = this.rootStore.intlStore.formatMessage('campaignRequest.registryTitle');
    this.api.client(apiConfigs.requestListXls(queryData)).then(function (r) {
      return r.data;
    }).then(function (f) {
      return downloadFile(f, filename + ".xlsx", 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    });
  };

  _proto.getTransitionRequest = function getTransitionRequest(requestId) {
    return this.api.client(apiConfigs.transitionRequest(requestId)).then(function (r) {
      return r.data;
    });
  };

  _proto.transitionToNextLifeCycleStep = function transitionToNextLifeCycleStep(transitionId, requestId) {
    return this.api.client(apiConfigs.transitionToNextLifeCycleStep(transitionId, requestId)).then(function (r) {
      return r.data;
    });
  };

  _proto.loadPrintForms = function loadPrintForms(formId) {
    return this.api.client(apiConfigs.requestPrintForms(formId)).then(function (r) {
      return r.data;
    });
  };

  _proto.getPrintForm = function getPrintForm(templateId, formId) {
    return this.api.client(apiConfigs.getPrintForm(templateId, formId)).then(function (r) {
      return r.data;
    });
  };

  _proto.generatePrintForm = function generatePrintForm(formId, templateId, submission) {
    return this.api.client(apiConfigs.generatePrintForm(formId, templateId, submission)).then(function (r) {
      return r.data;
    });
  };

  _proto.downloadPrintFormFile = function downloadPrintFormFile(fileDTO) {
    this.api.client(apiConfigs.downloadPrintFormFile(fileDTO.id)).then(function (r) {
      return r.data;
    }).then(function (f) {
      return downloadFile(f, fileDTO.filename, fileDTO.mimeType);
    });
  };

  _proto.downloadAllPrintFormFiles = function downloadAllPrintFormFiles(formId) {
    return this.api.client(apiConfigs.downloadAllPrintFormFiles(formId));
  };

  _proto.getEmployeesList = function getEmployeesList() {
    return this.api.client(apiConfigs.getAllActiveEmployees()).then(function (r) {
      return r.data;
    });
  };

  _proto.getRequestExecutorList = function getRequestExecutorList(requestId) {
    return this.getEmployeesList();
  };

  _proto.setCurrentUserAsExecutor = function setCurrentUserAsExecutor(requestId) {
    return this.api.client(apiConfigs.setCurrentUserAsExecutor(requestId)).then(function (r) {
      return r.data;
    });
  };

  _proto.getExecutorSettings = function getExecutorSettings(requestId) {
    return this.api.client(apiConfigs.getExecutorSettings(requestId)).then(function (r) {
      return r.data;
    });
  };

  _proto.editExecutorSettings = function editExecutorSettings(requestId, userId) {
    return this.api.client(apiConfigs.editExecutorSettings(requestId, userId)).then(function (r) {
      return r.data;
    });
  };

  _proto.registry = function registry(registryCode, query) {
    var _this4 = this;

    return this.api.client(apiConfigs.registry(registryCode, query)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this4.history.replace(clientRoute.notAllowed);
      }
    }));
  };

  _proto.registryColumns = function registryColumns(registryCode) {
    var _this5 = this;

    return this.api.client(apiConfigs.registryColumns(registryCode)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this5.history.replace(clientRoute.notAllowed);
      }
    }));
  };

  _proto.registryRequestLog = function registryRequestLog(registryCode, entityId, query) {
    var _this6 = this;

    return this.api.client(apiConfigs.registryRequestLog(registryCode, entityId, query)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this6.history.replace(clientRoute.notAllowed);
      }
    }));
  };

  _proto.registryRequestLogColumns = function registryRequestLogColumns(registryCode) {
    var _this7 = this;

    return this.api.client(apiConfigs.registryRequestLogColumns(registryCode)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this7.history.replace(clientRoute.notAllowed);
      }
    }));
  };

  _proto.uploadRequestLog = function uploadRequestLog(tableQueryData, registryCode, entityId, entityNumber) {
    try {
      var _this9 = this;

      var _temp2 = _catch(function () {
        return Promise.resolve(_this9.api.client(apiConfigs.uploadRequestLog(tableQueryData, registryCode, entityId))).then(function (_ref) {
          var data = _ref.data;

          var filename = _this9.rootStore.intlStore.formatMessage('requestLog.title', {
            number: entityNumber
          });

          return Promise.resolve(downloadFile(data, filename + ".xlsx")).then(function () {});
        });
      }, function (error) {
        console.error(error);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.mapDtoToRow = function mapDtoToRow(dto) {
    return {
      id: dto.id,
      number: dto.customData.number,
      authorName: dto.customData.author.title,
      authorUserId: dto.customData.author.id,
      campaignId: dto.customData.campaign.id,
      campaignTitle: dto.customData.campaign.title,
      regFormTitle: dto.customData.regForm.title,
      created: dto.customData.created,
      sent: dto.customData.sent,
      state: dto.customData.state.id,
      executors: []
    };
  };

  _proto.upload = function upload(tableQueryData) {
    try {
      var _this11 = this;

      var _temp4 = _catch(function () {
        return Promise.resolve(_this11.api.client(apiConfigs.upload(tableQueryData))).then(function (_ref2) {
          var data = _ref2.data;

          var filename = _this11.rootStore.intlStore.formatMessage('homePage.headerLinks.requestsNew');

          return Promise.resolve(downloadFile(data, filename + ".xlsx")).then(function () {});
        });
      }, function (error) {
        console.error(error);
      });

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.checkEditablePf = function checkEditablePf(customFormId) {
    return this.api.client(apiConfigs.checkEditablePf(customFormId)).then(function (r) {
      return r.data;
    });
  };

  _createClass(RequestStore, [{
    key: "history",
    get: function get() {
      return this.rootStore.history;
    }
  }]);

  return RequestStore;
}();

__decorate([observable], RequestStore.prototype, "rootStore", void 0);

__decorate([observable], RequestStore.prototype, "api", void 0);

__decorate([observable], RequestStore.prototype, "notificationStore", void 0);

__decorate([observable], RequestStore.prototype, "showValidation", void 0);

__decorate([computed], RequestStore.prototype, "history", null);

__decorate([action.bound], RequestStore.prototype, "getRequestModel", null);

__decorate([action.bound], RequestStore.prototype, "getRequestDTO", null);

__decorate([action.bound], RequestStore.prototype, "getDeadlinesDTO", null);

__decorate([action.bound], RequestStore.prototype, "createRequest", null);

__decorate([action.bound], RequestStore.prototype, "loadRequestForm", null);

__decorate([action.bound], RequestStore.prototype, "requestFormCheckEditable", null);

__decorate([action.bound], RequestStore.prototype, "getRequestFormModel", null);

__decorate([action.bound], RequestStore.prototype, "saveRequestForm", null);

__decorate([action.bound], RequestStore.prototype, "deleteRequest", null);

__decorate([action.bound], RequestStore.prototype, "exportListXls", null);

__decorate([action.bound], RequestStore.prototype, "getTransitionRequest", null);

__decorate([action.bound], RequestStore.prototype, "transitionToNextLifeCycleStep", null);

__decorate([action.bound], RequestStore.prototype, "loadPrintForms", null);

__decorate([action.bound], RequestStore.prototype, "getPrintForm", null);

__decorate([action.bound], RequestStore.prototype, "generatePrintForm", null);

__decorate([action.bound], RequestStore.prototype, "downloadPrintFormFile", null);

__decorate([action.bound], RequestStore.prototype, "downloadAllPrintFormFiles", null);

__decorate([action.bound], RequestStore.prototype, "getEmployeesList", null);

__decorate([action.bound], RequestStore.prototype, "getRequestExecutorList", null);

__decorate([action.bound], RequestStore.prototype, "setCurrentUserAsExecutor", null);

__decorate([action.bound], RequestStore.prototype, "getExecutorSettings", null);

__decorate([action.bound], RequestStore.prototype, "editExecutorSettings", null);

__decorate([action.bound], RequestStore.prototype, "registry", null);

__decorate([action.bound], RequestStore.prototype, "registryColumns", null);

__decorate([action.bound], RequestStore.prototype, "registryRequestLog", null);

__decorate([action.bound], RequestStore.prototype, "registryRequestLogColumns", null);

__decorate([action.bound], RequestStore.prototype, "uploadRequestLog", null);

__decorate([action.bound], RequestStore.prototype, "mapDtoToRow", null);

__decorate([action.bound], RequestStore.prototype, "upload", null);

__decorate([action.bound], RequestStore.prototype, "checkEditablePf", null);

var getRequestStore = function getRequestStore() {
  var _di = di([RequestStore], getRequestStore),
      _RequestStore = _di[0];

  return _RequestStore;
};

function recordToLang(record) {
  var result = {};

  function objectToDotNotation(obj, currentKey) {
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
      var value = obj[key];
      var newKey = currentKey ? currentKey + "." + key : key;

      if (value && typeof value === 'object') {
        objectToDotNotation(value, newKey);
      } else {
        result[newKey] = value;
      }
    });
  }

  objectToDotNotation(record);
  return result;
}

const authentication = {
  loginTitle: 'Sign in',
  email: 'Email',
  password: 'Password',
  rememberMe: 'Remember me',
  login: 'Sign in',
  forgotPassword: 'Forgot password?',
  register: 'Sign up',
  loginFailed: 'Incorrect email or password',
  registrationTitle: 'Registration',
  firstName: 'First name',
  middleName: 'Middle name',
  lastName: 'Last name',
  termsOfService: 'Terms of service',
  termsIsAccepted: 'I accept the terms of {link}',
  termsLinkTitle: 'Data Usage Policy',
  emailAlreadyExists: 'Email is already registered',
  emailNotExist: 'User with this email was not found',
  emailNotConfirmed: 'Email not verified',
  userBlocked: 'Your account is unavailable',
  confirmingEmailReminder: 'We already sent confirm link to your email. Please check your email (link expires in 15 minutes) or try to register again later',
  confirmingEmailSent: 'A confirmation email was sent',
  confirmingEmailExpired: 'Sorry, your link has expired. We have already sent you a new one.',
  confirmingEmailNotFound: 'The link is incorrect or has already been used to navigate earlier.',
  recoveryTitle: 'Recovery password',
  goBackToSignIn: 'Go back to sign in',
  alreadyHaveAccount: 'Already have an account? Sign in',
  sendToken: 'Send',
  recoveryInfo: 'You will receive an email with the link',
  recoveryLinkSent: 'We sent you an email with the link',
  recoveryPasswordFailed: 'This email is not registered or recovery attempts were too frequent',
  newPasswordTitle: 'Change password',
  newPassword: 'New password',
  repeatPassword: 'Repeat password',
  confirm: 'Confirm',
  passwordsMustMatch: 'Passwords must match',
  linkInvalidOrExpired: 'This link is invalid or expired',
  logout: 'Sign out',
  loginEsia: 'Log in with Gosuslugi',
  samlAuth: 'Log in with {title}',
  error: 'An error has occurred',
  alertInfo: 'For the correct operation of the portal functions, it is recommended to use the following browsers: Mozilla Firefox version 72 and higher, Google Chrome version 78 and higher, Opera version 63 and higher'
};

const breadcrumbs = {
  mainPage: 'Main page',
  campaigns: 'Campaigns',
  campaign: 'Campaign',
  requests: 'Register of requests',
  requestsNew: 'Register of requests',
  campaignSettings: 'Campaign settings',
  regFormSelect: 'Selection of the application form',
  users: 'Users'
};

const campaign = {
  titleCampaignListPage: 'Categories',
  noCategoriesText: 'There are currently no active categories to apply for',
  newCampaign: 'New category',
  titleCreateCampaignPage: 'Create category',
  create: 'Create',
  createCampaign: 'Create category',
  editCampaign: 'Edit category',
  sections: 'Sections',
  description: 'Description: ',
  files: 'Files',
  campaignPeriod: 'Campaign period',
  createRequest: 'Create request',
  campaignRequests: 'Campaign requests',
  campaignSettings: 'Campaign settings',
  tabsSettings: 'Tabs settings',
  pfTemplates: 'PF templates',
  noTemplates: 'No templates configured',
  campaignDescription: 'Campaign description',
  campaignDescriptionEdit: 'Campaign editing',
  campaignRegForms: 'Request forms',
  campaignRegForm: 'Request {count, plural, one {form} other {forms}}',
  addCampaignRegFormButton: 'Add request form',
  newCampaignRegForm: 'New request form',
  editCampaignRegForm: 'Editing the "{formTitle}" request form',
  deleteCampaignRegForm: 'Delete request form',
  confirmDeleteCampaignRegForm: 'Are you sure you want to delete the request form "{formTitle}"?',
  noRegForms: 'There is no registration forms',
  regFormInfo: 'Primary information',
  regFormExecutors: 'Responsible executors',
  templatesAndExport: 'Templates and export',
  campaignManagement: 'Category management',
  export: 'Export',
  templates: 'Templates',
  addTemplate: 'Add template',
  editTemplate: 'Edit template',
  editPermission: 'Edit permission',
  generate: 'Generate',
  accessSetting: 'Access setting',
  confirmDeletionTemplateInfoText: 'Are you sure you want to delete the template "{title}"?',
  lifecycle: 'Lifecycle',
  tabSettingForm: {
    title: "Tab's title",
    identifier: 'Identifier',
    formCode: "Form's code",
    fileSize: 'The size of the package of uploaded documents in MB',
    executor: 'Responsible executor',
    access: 'Access',
    edit: 'Edit',
    view: 'View'
  },
  tabSettingFormTable: {
    role: 'Role',
    status: 'Lifecycle status',
    access: 'Access',
    allStatuses: 'All statuses'
  },
  templateForm: {
    title: 'Title',
    description: 'Description',
    regForms: 'Request forms',
    file: 'Template file',
    templateIsRequired: 'Template is required for generation'
  },
  templateFormErrors: {
    notUniqueTemplateName: 'Template name must be unique',
    executorsNotAllowed: 'This method of appointment is not available, since the method of assigning persons in charge has been selected in fact'
  },
  documentCategory: 'Document category',
  tabs: 'Tabs',
  campaignManagementDelete: 'Are you sure you want to delete the category "{campaignName}"?',
  deleteCampaign: 'Delete category',
  campaignTitle: 'Category management {campaignName}',
  generalSettings: 'General Settings',
  requestFormSettingsTitle: 'Setting for request tabs',
  requestFormSetting: 'Tab setting',
  createRequestFormSettings: 'Create tab',
  confirmDeletionRequestFormSettingInfoText: 'Are you sure you want to delete the tab "{title}"?',
  requestFormSettings: {
    title: 'Title',
    formTitle: 'Form'
  },
  fileFormat: 'Format',
  campaignRegFormExecutorEmployee: 'Employee',
  campaignRegFormExecutorResponsibleExecutor: 'Responsible executor',
  campaignRegFormExecutorRequestTab: 'Application tab',
  campaignRegFormExecutorAdd: 'Add',
  confirmDeletionInfoText: 'Are you sure you want to remove the responsible executive {executorName}?',
  employeeLabel: 'Employee',
  requestTabLabel: 'Request tab',
  editFormDialogTitle: 'Change responsible executor',
  collectionCompleted: 'Collection completed',
  createRequestError: 'Creation of requests by category is not available'
};

const campaignRequest = {
  registryTitle: 'Requests',
  withoutNumber: 'Without a number',
  RequestN: 'Request № {number}',
  registryColumns: {
    number: 'Number',
    author: 'Author',
    campaign: 'Category',
    regForm: 'Registration form',
    state: 'State',
    created: 'Created',
    sent: 'Sent',
    executor: 'Responsible executor'
  },
  modalTitle: 'Status change',
  modalInfoText: 'Status will be changed to "{toState}"',
  registryPagingInfo: 'Total {count, number} requests. Displayed from {from, number} to {to, number}.',
  invalidDateMessage: 'Invalid date format',
  maxDateMessage: 'Date should not be after than the current date',
  confirmDeletionInfoText: 'Are you sure you want to delete the request № {number}?',
  resultsOption: 'Results not found',
  readonlyRequestValidationMsg: 'The request form is filled out incorrectly. Go to <a>edit</a> to fix errors.',
  printFormsTable: {
    loading: 'Please, wait, preparation for the generation of printed forms of documents is in progress',
    title: 'Printed forms',
    fileColumnName: 'File',
    authorColumnName: 'Author',
    dateColumnName: 'Date',
    generateAction: 'Generate',
    updateAction: 'Update',
    cannotGenerateError: 'Printed form cannot be generated: request form is filled out incorrectly',
    cannotGenerateErrorWithLink: 'Printed form cannot be generated: request form is filled out incorrectly. Go to <a>edit</a> to fix errors.',
    generationError: 'An error occurred while generating the print form',
    downloadAllButton: 'Download all',
    taskStatus: 'Generation status'
  },
  taskStatus: {
    generating: 'Generation',
    completed: 'Generated',
    failed: 'Generation failed'
  },
  regFormCard: {
    description: 'Description',
    registrationStartDate: 'Registration start',
    registrationEndDate: 'Registration end',
    afterDeadline: 'Reception after deadline',
    instruction: 'Instruction'
  },
  regFormsPageTitle: 'Selection of the application form',
  createRequest: 'Create request',
  newRequest: 'New request',
  dialog: {
    closeMessage: 'Are you sure you want to close edit mode without saving your changes?',
    leaveMessage: 'Are you sure you want to leave the current ticket without saving your changes?',
    tooltipMessage: 'To save the changes made, click the "Save" button on the page below.',
    title: 'Confirmation of closing edit mode',
    confirm: 'Confirm',
    cancel: 'Cancel',
    executorsTitle: 'Confirmation of the choice of the responsible executor',
    executorsMessage: 'You will be appointed as the responsible executor for the application',
    editExecutorTitle: 'Appoint a responsible executor',
    changeExecutorTitle: 'Change a responsible executor'
  },
  registryPagingInfoIfNull: 'Total 0 requests. Displayed 0 requests',
  allFiles: 'All documents for {title}',
  takeToWork: 'Take to Work',
  deleteRequest: 'Delete request',
  openEditMode: 'Edit',
  saveChanges: 'Save',
  chooseExecutor: 'Appoint a responsible executor',
  actions: {
    appointExecutor: 'Appoint a responsible executor',
    changeExecutor: 'Change a responsible executor',
    requestToWork: 'Take request to work'
  },
  expandWorkArea: 'Expand work area',
  reduceWorkArea: 'Reduce work area',
  deadlines: {
    entity: 'Total deadline',
    state: 'Deadline',
    error: 'Error. Failed to calculate deadline',
    notRelevant: 'Not relevant in this status',
    notRelevantTooltip: 'The time spent in this status is not taken into account in the total duration of the work. Completion date will be recalculated upon transition to a different status'
  },
  requestLog: 'Request log'
};

const common = {
  edit: 'Edit',
  save: 'Save',
  delete: 'Delete',
  close: 'Close',
  error: 'Error',
  errorText: 'Something went wrong',
  cancel: 'Cancel',
  discardChanges: 'Discard changes',
  confirm: 'Confirm',
  noData: 'No data',
  from: 'from',
  to: 'to',
  until: 'until',
  State: 'State',
  result: 'Result',
  copy: 'Copy',
  clear: 'Clear',
  rowsPerPage: 'Rows per page:',
  pagingInfo: 'Displayed from {from, number} to {to, number}. Total {count, number} elements.',
  resetFilters: 'Reset',
  filters: 'Filters',
  all: 'All',
  actions: 'Actions',
  export: 'Export',
  confirmDeletion: 'Confirm deletion',
  dropzoneText: 'Drag and drop a file here or click',
  pageNotFound: 'Page not found',
  actionNotAllowed: 'Action not allowed',
  downloadFile: 'Download {fileName}',
  defaultErrorMessage: 'Something went wrong',
  yes: 'Yes',
  no: 'No',
  lifeCycleConfirmTitle: 'Status change',
  lifeCycleConfirmText: 'Status will be changed to "{toState}"',
  tabExecutor: 'Responsible executor: {name}',
  responsibleExecutor: 'Responsible executor:'
};

const console$1 = {
  title: 'Console',
  script: 'Script',
  runScript: 'Run script'
};

const digitalSignature = {
  form: {
    signatureEnabled: 'Enable use of electronic signature',
    signatureRequired: 'Signature is required',
    signatureVariants: 'Signing variants',
    signatureBrowserPlugin: 'Browser plugin',
    signatureUpload: 'Uploading a signature or a file with an attached signature'
  }
};

const homePage = {
  headerLinks: {
    requests: 'My requests',
    requestsNew: 'Requests',
    campaigns: 'Categories',
    users: 'Users',
    console: 'Console'
  }
};

const notFoundPage = {
  notExist: 'Page not found ',
  goTo: 'Go to ',
  main: 'Main ',
  orReturn: 'or return ',
  back: 'Back'
};

const notifications = {
  success: 'Data saved successfully'
};

const requestLog = {
  title: 'Request log № {number}',
  backToRequest: 'Go to request'
};

const sidebar$1 = {
  scrollToError: 'Scroll to error{count, plural, one {} other {s}}',
  collapse: 'Collapse sidebar',
  expand: 'Expand sidebar'
};

const startPage = {
  headerLinks: {
    about: 'About product',
    news: 'News',
    documents: 'Documents',
    resources: 'Other resources',
    contacts: 'Contacts',
    radar: 'Radar',
    login: 'Sign in',
    loginAnonymously: 'Login without registration',
    loginAccount: 'Login to your account'
  },
  productDescription: 'A customizable information environment for managing the intellectual capital of an organization',
  logoAlt: 'TOT X logo',
  footerLogoAlt: 'TOT X logo'
};

const users = {
  listTitle: 'Users',
  fields: {
    login: 'Login',
    status: 'Status',
    name: 'Full name',
    roles: 'Roles',
    lang: 'English speaking user'
  },
  status: {
    blocked: 'Blocked',
    active: 'Active',
    inactive: 'Inactive'
  },
  actions: {
    block: 'Block',
    unblock: 'Unblock'
  },
  loginAsUser: 'Login as user',
  editUser: 'Edit user',
  registryPagingInfo: 'Total {count, number} users. Displayed from {from, number} to {to, number}',
  confirmBlock: 'Confirm block',
  confirmBlockInfoText: 'Are you sure you want to block {login}?',
  deleteUser: 'Delete user',
  deleteUserConfirmText: 'The user will be deleted. Confirm action?',
  registryPagingInfoIfNull: 'Total 0 users. Displayed 0 users',
  notAllowed: 'It is impossible to perform this action on your account',
  profile: 'User profile'
};

const validation = {
  required: 'Required field',
  isEmail: 'Enter correct email',
  minLength: 'Minimal length {length, number} {length, plural, one {symbol} other {symbols}}',
  maxLength: 'Maximum length {length, number} {length, plural, one {symbol} other {symbols}}',
  dropzoneError: 'File does not match type "doc" or "docx"',
  isNumber: 'Enter correct number',
  bannedSymbols: 'Symbols cannot be used in the field: « {symbols} »',
  withoutSignatureMethod: 'Choose at least one signing method'
};

var lang = recordToLang({
  productTitle: 'TOT X',
  authentication: authentication,
  validation: validation,
  startPage: startPage,
  homePage: homePage,
  campaign: campaign,
  campaignRequest: campaignRequest,
  users: users,
  common: common,
  sidebar: sidebar$1,
  breadcrumbs: breadcrumbs,
  notifications: notifications,
  digitalSignature: digitalSignature,
  requestLog: requestLog,
  console: console$1,
  ttable: ttable_en,
  multilevelCatalog: multilevelCatalog_en,
  notFoundPage: notFoundPage
});

const authentication$1 = {
  loginTitle: 'Вход в кабинет',
  email: 'Email',
  password: 'Пароль',
  rememberMe: 'Запомнить меня',
  login: 'Войти',
  forgotPassword: 'Забыли пароль?',
  register: 'Зарегистрироваться',
  loginFailed: 'Неверный email или пароль',
  registrationTitle: 'Регистрация',
  firstName: 'Имя',
  middleName: 'Отчество',
  lastName: 'Фамилия',
  termsOfService: 'Пользовательское соглашение',
  termsIsAccepted: 'Я принимаю условия {link}',
  termsLinkTitle: 'Политики использования данных',
  emailAlreadyExists: 'Такой email уже зарегистрирован',
  emailNotExist: 'Пользователь с таким email не найден',
  emailNotConfirmed: 'Email не подтвержден',
  userBlocked: 'Ваша учетная запись недоступна',
  confirmingEmailReminder: 'На указанный email уже отправлена ссылка для подтверждения. Пожалуйста, перейдите по ней (время действия ссылки – 15 минут), или попробуйте зарегистрироваться позже',
  confirmingEmailSent: 'На указанный email отправлено письмо для подтверждения.',
  confirmingEmailExpired: 'К сожалению, срок действия вашей ссылки истёк. Мы уже отправили вам новую, пожалуйста, перейдите по ней (время действия новой ссылки – 15 минут).',
  confirmingEmailNotFound: 'Ссылка, по которой был осуществлен переход, некорректна или уже была использована для перехода ранее.',
  recoveryTitle: 'Восстановление пароля',
  goBackToSignIn: 'Вернуться ко входу в Систему',
  alreadyHaveAccount: 'Уже есть учетная запись? Войти',
  sendToken: 'Отправить',
  recoveryInfo: 'На указанный email придет письмо со ссылкой для восстановления пароля',
  recoveryLinkSent: 'На указанный email отправлено письмо со ссылкой для восстановления пароля',
  recoveryPasswordFailed: 'Такой email не зарегистрирован или попытки восстановления были слишком частыми',
  newPasswordTitle: 'Смена пароля',
  newPassword: 'Новый пароль',
  repeatPassword: 'Повторите пароль',
  confirm: 'Подтвердить',
  passwordsMustMatch: 'Пароли должны совпадать',
  linkInvalidOrExpired: 'Ссылка неверная или срок её действия истёк',
  logout: 'Выход',
  loginEsia: 'Войти через Госуслуги',
  samlAuth: 'Войти через {title}',
  error: 'Произошла ошибка',
  alertInfo: 'Для корректной работы функций портала рекомендуется использовать браузеры: Mozilla Firefox версии 72 и выше, Google Chrome версии 78 и выше, Opera версии от 63 и выше'
};

const breadcrumbs$1 = {
  mainPage: 'Главная страница',
  campaigns: 'Категории',
  campaign: 'Категория',
  requests: 'Реестр заявок',
  requestsNew: 'Реестр заявок',
  campaignSettings: 'Настройки категории',
  regFormSelect: 'Выбор формы участия заявки',
  users: 'Пользователи'
};

const campaign$1 = {
  titleCampaignListPage: 'Категории',
  titleCreateCampaignPage: 'Создание категории',
  noCategoriesText: 'В данный момент нет активных категорий для подачи заявки',
  newCampaign: 'Новая категория',
  create: 'Создать',
  createCampaign: 'Создать категорию',
  editCampaign: 'Редактирование категории',
  sections: 'Разделы',
  description: 'Описание: ',
  files: 'Файлы',
  campaignPeriod: 'Подача заявок',
  createRequest: 'Создать заявку',
  campaignRequests: 'Заявки категории',
  campaignSettings: 'Настройка категории',
  tabsSettings: 'Настройка вкладок',
  pfTemplates: 'Шаблоны ПФ',
  noTemplates: 'Нет настроенных шаблонов',
  campaignDescription: 'Описание категории',
  campaignDescriptionEdit: 'Редактирование категории',
  campaignRegForms: 'Формы заявок',
  campaignRegForm: '{count, plural, one {Форма} other {Формы}} заявки',
  addCampaignRegFormButton: 'Добавить форму заявки',
  newCampaignRegForm: 'Новая форма заявки',
  editCampaignRegForm: 'Редактирование формы заявки "{formTitle}"',
  deleteCampaignRegForm: 'Удаление формы заявки',
  confirmDeleteCampaignRegForm: 'Вы действительно хотите удалить форму заявки "{formTitle}"?',
  noRegForms: 'Формы регистрации отсутствуют',
  regFormInfo: 'Основная информация',
  regFormExecutors: 'Ответственные исполнители',
  templatesAndExport: 'Шаблоны и выгрузки',
  campaignManagement: 'Управление категорией',
  export: 'Выгрузки',
  templates: 'Шаблоны',
  addTemplate: 'Добавить шаблон',
  editTemplate: 'Редактировать шаблон',
  editPermission: 'Настроить доступ',
  generate: 'Генерация',
  accessSetting: 'Настройка доступа',
  confirmDeletionTemplateInfoText: 'Вы действительно хотите удалить шаблон "{title}"?',
  lifecycle: 'Жизненный цикл',
  tabSettingForm: {
    title: 'Наименование вкладки',
    identifier: 'Идентификатор',
    formCode: 'Код используемой формы',
    fileSize: 'Размер пакета загружаемых документов в Мб',
    executor: 'Ответственный исполнитель',
    access: 'Доступ',
    edit: 'Редактирование',
    view: 'Просмотр'
  },
  tabSettingFormTable: {
    role: 'Роль',
    status: 'Статус ЖЦ',
    access: 'Доступ',
    allStatuses: 'Все статусы'
  },
  templateForm: {
    title: 'Название',
    description: 'Описание',
    regForms: 'Формы заявок',
    file: 'Файл шаблона',
    templateIsRequired: 'Является обязательным для генерации'
  },
  templateFormErrors: {
    notUniqueTemplateName: 'Название шаблона должно быть уникальным',
    executorsNotAllowed: 'Данный способ назначения недоступен, так как выбран способ назначения ответственных по факту'
  },
  documentCategory: 'Категория документа',
  tabs: 'Вкладки',
  campaignManagementDelete: 'Вы действительно хотите удалить категорию "{campaignName}"?',
  deleteCampaign: 'Удалить категорию',
  campaignTitle: 'Управление категорией {campaignName}',
  generalSettings: 'Общие настройки',
  requestFormSettingsTitle: 'Настройка вкладок для заявки',
  requestFormSetting: 'Настройка вкладки',
  createRequestFormSettings: 'Создать вкладку',
  confirmDeletionRequestFormSettingInfoText: 'Вы действительно хотите удалить вкладку "{title}"?',
  requestFormSettings: {
    title: 'Название',
    formTitle: 'Форма'
  },
  fileFormat: 'Формат',
  campaignRegFormExecutorEmployee: 'Сотрудник',
  campaignRegFormExecutorResponsibleExecutor: 'Ответственный исполнитель',
  campaignRegFormExecutorRequestTab: 'Вкладка заявки',
  campaignRegFormExecutorAdd: 'Добавить',
  confirmDeletionInfoText: 'Вы действительно хотите удалить ответственного исполнителя {executorName}?',
  employeeLabel: 'Сотрудник',
  requestTabLabel: 'Вкладка заявки',
  editFormDialogTitle: 'Изменить ответственного исполнителя',
  collectionCompleted: 'Сбор завершен',
  createRequestError: 'Создание заявок по категории недоступно'
};

const campaignRequest$1 = {
  registryTitle: 'Заявки',
  withoutNumber: 'Без номера',
  RequestN: 'Заявка № {number}',
  registryColumns: {
    number: 'Номер заявки',
    author: 'Автор',
    campaign: 'Категория',
    regForm: 'Форма заявки',
    state: 'Состояние',
    created: 'Дата создания',
    sent: 'Дата подачи',
    executor: 'Ответственный исполнитель'
  },
  modalTitle: 'Изменение статуса',
  modalInfoText: 'Статус будет изменен на "{toState}"',
  registryPagingInfo: 'Всего {count, number} заяв{count, plural, one {ка} few {ки} other {ок}}. ' + 'Отображены c {from, number} по {to, number}',
  invalidDateMessage: 'Недопустимый формат даты',
  maxDateMessage: 'Дата не может быть позже текущей даты',
  confirmDeletionInfoText: 'Вы действительно хотите удалить заявку № {number}?',
  resultsOption: 'Результаты не найдены',
  readonlyRequestValidationMsg: 'Форма заявки заполнена некорректно. Для исправления ошибок перейдите к <a>редактированию</a>.',
  printFormsTable: {
    loading: 'Пожалуйста подождите, идет подготовка к генерации печатных форм документов',
    title: 'Печатные формы документов',
    fileColumnName: 'Файл',
    authorColumnName: 'ФИО',
    dateColumnName: 'Дата',
    generateAction: 'Сгенерировать',
    updateAction: 'Обновить',
    cannotGenerateError: 'Невозможно сгенерировать печатную форму: форма заявки заполнена некорректно',
    cannotGenerateErrorWithLink: 'Невозможно сгенерировать печатную форму: форма заявки заполнена некорректно. Для исправления ошибок перейдите к <a>редактированию</a>.',
    generationError: 'При генерации печатной формы произошла ошибка',
    downloadAllButton: 'Скачать все',
    taskStatus: 'Статус генерации'
  },
  taskStatus: {
    generating: 'Идет генерация',
    completed: 'Сгенерирован',
    failed: 'Ошибка генерации'
  },
  regFormCard: {
    description: 'Описание',
    registrationStartDate: 'Начало регистрации',
    registrationEndDate: 'Окончание регистрации',
    afterDeadline: 'Прием после дедлайна',
    instruction: 'Инструкция'
  },
  regFormsPageTitle: 'Выбор формы участия заявки',
  createRequest: 'Создать заявку',
  newRequest: 'Новая заявка',
  dialog: {
    closeMessage: 'Вы действительно хотите закрыть режим редактирования без сохранения изменений?',
    leaveMessage: 'Вы действительно хотите покинуть текущую заявку без сохранения изменений?',
    tooltipMessage: ' Для сохранения внесенных изменений нажмите кнопку "Сохранить" внизу страницы',
    title: 'Подтверждение закрытия режима редактирования',
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    executorsTitle: 'Подтверждение выбора ответственного исполнителя',
    executorsMessage: 'Вы будете назначены ответственным исполнителем по заявке',
    editExecutorTitle: 'Назначить ответственного исполнителя',
    changeExecutorTitle: 'Изменить ответственного исполнителя'
  },
  registryPagingInfoIfNull: 'Всего 0 заявок. Отображено 0 заявок',
  allFiles: 'Все документы по {title}',
  takeToWork: 'Взять в работу',
  deleteRequest: 'Удалить заявку',
  openEditMode: 'Редактировать',
  saveChanges: 'Сохранить',
  chooseExecutor: 'Назначить ответственного',
  actions: {
    appointExecutor: 'Назначить ответственного',
    changeExecutor: 'Изменить ответственного',
    requestToWork: 'Взять заявку в работу'
  },
  expandWorkArea: 'Увеличить рабочую область',
  reduceWorkArea: 'Уменьшить рабочую область',
  deadlines: {
    entity: 'Общий срок завершения',
    state: 'Контрольный срок',
    error: 'Ошибка. Не удалось рассчитать срок',
    notRelevant: 'Не актуален в этом статусе',
    notRelevantTooltip: 'Время нахождения в этом статусе не учитывается в общей длительности работ. Срок завершения будет пересчитан при переходе в другой статус'
  },
  requestLog: 'Журнал заявки'
};

const common$1 = {
  edit: 'Редактировать',
  save: 'Сохранить',
  delete: 'Удалить',
  cancel: 'Отмена',
  discardChanges: 'Отменить изменения',
  close: 'Закрыть',
  error: 'Ошибка',
  errorText: 'Что-то пошло не так',
  confirm: 'Подтвердить',
  noData: 'Нет данных',
  from: 'c',
  to: 'до',
  until: 'по',
  State: 'Состояние',
  result: 'Результат',
  copy: 'Копировать',
  clear: 'Очистить',
  rowsPerPage: 'Отображать по:',
  pagingInfo: 'Отображено c {from, number} по {to, number}. Всего элементов {count, number}',
  resetFilters: 'Сбросить',
  filters: 'Фильтры',
  all: 'Все',
  actions: 'Действия',
  export: 'Выгрузить',
  confirmDeletion: 'Подтвердите удаление',
  dropzoneText: 'Перетащите или выберите файл',
  pageNotFound: 'Страница не найдена',
  actionNotAllowed: 'У вас недостаточно прав для совершения данного действия',
  downloadFile: 'Скачать {fileName}',
  defaultErrorMessage: 'Что-то пошло не так',
  yes: 'Да',
  no: 'Нет',
  lifeCycleConfirmTitle: 'Изменение статуса',
  lifeCycleConfirmText: 'Статус будет изменен на "{toState}"',
  tabExecutor: 'Ответственный исполнитель: {name}',
  responsibleExecutor: 'Ответственный исполнитель:'
};

const console$2 = {
  title: 'Консоль',
  script: 'Скрипт',
  runScript: 'Запустить скрипт'
};

const digitalSignature$1 = {
  form: {
    signatureEnabled: 'Включить использование электронной подписи',
    signatureRequired: 'Обязательно наличие подписи',
    signatureVariants: 'Способы подписания',
    signatureBrowserPlugin: 'Плагин браузера',
    signatureUpload: 'Загрузка подписи или файла с прикреплённой подписью'
  }
};

const homePage$1 = {
  headerLinks: {
    requests: 'Мои заявки',
    requestsNew: 'Заявки',
    campaigns: 'Категории',
    users: 'Пользователи',
    console: 'Консоль'
  }
};

const notFoundPage$1 = {
  notExist: 'Такой страницы не существует',
  goTo: 'Перейдите на ',
  main: 'Главную ',
  orReturn: 'или вернитесь ',
  back: 'Назад'
};

const notifications$1 = {
  success: 'Данные успешно сохранены'
};

const requestLog$1 = {
  title: 'Журнал заявки № {number}',
  backToRequest: 'К заявке'
};

const sidebar$2 = {
  scrollToError: 'Перейти к ошибк{count, plural, one {e} other {ам}}',
  collapse: 'Свернуть боковую панель',
  expand: 'Развернуть боковую панель'
};

const startPage$1 = {
  headerLinks: {
    about: 'O продукте',
    news: 'Новости',
    documents: 'Документы',
    resources: 'Другие ресурсы',
    contacts: 'Контакты',
    radar: 'Радар',
    login: 'Войти в систему',
    loginAnonymously: 'Войти без регистрации',
    loginAccount: 'Войти в личный кабинет'
  },
  productDescription: 'Настраиваемая информационная среда для управления интеллектуальным капиталом организации',
  logoAlt: 'TOT X logo',
  footerLogoAlt: 'TOT X logo'
};

const users$1 = {
  listTitle: 'Пользователи',
  fields: {
    login: 'Логин',
    status: 'Статус',
    name: 'ФИО',
    roles: 'Роли',
    lang: 'Англоязычный пользователь'
  },
  actions: {
    block: 'Заблокировать',
    unblock: 'Активировать'
  },
  status: {
    blocked: 'Заблокирован',
    active: 'Активный',
    inactive: 'Неактивный'
  },
  loginAsUser: 'Авторизоваться под пользователем',
  editUser: 'Редактировать пользователя',
  registryPagingInfo: 'Всего {count, number} пользовател{count, plural, one {ь} few {я} other {ей}}. ' + 'Отображены c {from, number} по {to, number}',
  confirmBlock: 'Подтвердите блокирование',
  confirmBlockInfoText: 'Вы действительно хотите заблокировать {login}?',
  deleteUser: 'Удаление пользователя',
  deleteUserConfirmText: 'Пользователь будет удален. Подтвердить действие?',
  registryPagingInfoIfNull: 'Всего 0 пользователей. Отображено 0 пользователей',
  notAllowed: 'Невозможно произвести данное действие над своей учетной записью',
  profile: 'Профиль пользователя'
};

const validation$1 = {
  required: 'Обязательное поле',
  isEmail: 'Введите корректный email',
  minLength: 'Минимальная длина {length, number} {length, plural, one {символ} few {символа} other {символов}}',
  maxLength: 'Максимальная длина {length, number} {length, plural, one {символ} few {символа} other {символов}}',
  dropzoneError: 'Файл не соответствует типу "doc" или "docx"',
  isNumber: 'Введите корректное число',
  bannedSymbols: 'В названии нельзя использовать символы: « {symbols} »',
  withoutSignatureMethod: 'Выберите минимум один способ подписания'
};

var lang$1 = recordToLang({
  productTitle: 'TOT X',
  authentication: authentication$1,
  validation: validation$1,
  startPage: startPage$1,
  homePage: homePage$1,
  campaign: campaign$1,
  campaignRequest: campaignRequest$1,
  users: users$1,
  common: common$1,
  sidebar: sidebar$2,
  breadcrumbs: breadcrumbs$1,
  notifications: notifications$1,
  digitalSignature: digitalSignature$1,
  requestLog: requestLog$1,
  console: console$2,
  ttable: ttable_ru,
  multilevelCatalog: multilevelCatalog_ru,
  notFoundPage: notFoundPage$1
});

var BreadcrumbsStore = /*#__PURE__*/function () {
  function BreadcrumbsStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  _createClass(BreadcrumbsStore, [{
    key: "mainPageRoute",
    get: function get() {
      return '/';
    }
  }, {
    key: "names",
    get: function get() {
      return names;
    }
  }, {
    key: "mainRoutes",
    get: function get() {
      return mainRoutes;
    }
  }, {
    key: "routesWithParams",
    get: function get() {
      return routesWithParams;
    }
  }, {
    key: "breadCrumbsSettings",
    get: function get() {
      var names = this.names,
          mainRoutes = this.mainRoutes,
          routesWithParams = this.routesWithParams;
      return {
        names: names,
        mainRoutes: mainRoutes,
        routesWithParams: routesWithParams
      };
    }
  }]);

  return BreadcrumbsStore;
}();

__decorate([observable], BreadcrumbsStore.prototype, "rootStore", void 0);

__decorate([observable], BreadcrumbsStore.prototype, "api", void 0);

__decorate([computed], BreadcrumbsStore.prototype, "mainPageRoute", null);

__decorate([computed], BreadcrumbsStore.prototype, "names", null);

__decorate([computed], BreadcrumbsStore.prototype, "mainRoutes", null);

__decorate([computed], BreadcrumbsStore.prototype, "routesWithParams", null);

__decorate([computed], BreadcrumbsStore.prototype, "breadCrumbsSettings", null);

var getBreadcrumbsStore = function getBreadcrumbsStore() {
  var _di = di([BreadcrumbsStore], getBreadcrumbsStore),
      _BreadcrumbsStore = _di[0];

  return _BreadcrumbsStore;
};

var SignatureStore = /*#__PURE__*/function () {
  function SignatureStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = SignatureStore.prototype;

  _proto.getFileByte = function getFileByte(printFormId) {
    var _this = this;

    return function () {
      return _this.api.client(apiConfigs.getFileByte(printFormId)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.uploadSignature = function uploadSignature(printFormId) {
    var _this2 = this;

    return function (signature) {
      return _this2.api.client(apiConfigs.uploadSignature(printFormId, signature)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.uploadSignatureFile = function uploadSignatureFile(printFormId) {
    var _this3 = this;

    return function (signatureFile) {
      return _this3.api.client(apiConfigs.uploadSignatureFile(printFormId, signatureFile)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.getSignatureInfo = function getSignatureInfo(printFormId) {
    var _this4 = this;

    return function () {
      return _this4.api.client(apiConfigs.getSignatureInfo(printFormId)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.downloadSignature = function downloadSignature(printFormId) {
    var _this5 = this;

    return function (isWithFile) {
      return _this5.api.client(apiConfigs.downloadSignature(printFormId, isWithFile)).then(function (r) {
        return r.data;
      });
    };
  };

  _proto.deleteSignature = function deleteSignature(printFormId) {
    var _this6 = this;

    return function () {
      return _this6.api.client(apiConfigs.deleteSignature(printFormId)).then(function (r) {
        return r.data;
      });
    };
  };

  return SignatureStore;
}();

__decorate([observable], SignatureStore.prototype, "rootStore", void 0);

__decorate([observable], SignatureStore.prototype, "api", void 0);

__decorate([action.bound], SignatureStore.prototype, "getFileByte", null);

__decorate([action.bound], SignatureStore.prototype, "uploadSignature", null);

__decorate([action.bound], SignatureStore.prototype, "uploadSignatureFile", null);

__decorate([action.bound], SignatureStore.prototype, "getSignatureInfo", null);

__decorate([action.bound], SignatureStore.prototype, "downloadSignature", null);

__decorate([action.bound], SignatureStore.prototype, "deleteSignature", null);

var getSignatureStore = function getSignatureStore() {
  var _di = di([SignatureStore], getSignatureStore),
      _CampaignsStore = _di[0];

  return _CampaignsStore;
};

var UserStore = /*#__PURE__*/function () {
  function UserStore(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api;
  }

  var _proto = UserStore.prototype;

  _proto.loginAsUser = function loginAsUser(id) {
    return this.api.client(apiConfigs.loginAsUser(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.loadUser = function loadUser(id) {
    var _this = this;

    return this.api.client(apiConfigs.loadUser(id)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      404: function _() {
        return _this.history.replace(clientRoute.notFound);
      },
      403: function _() {
        return _this.history.replace(clientRoute.notAllowed);
      }
    }));
  };

  _proto.getUserPersonModel = function getUserPersonModel(id) {
    var model = new UserPersonModel(id);
    this.loadUser(id).then(model.load);
    return model;
  };

  _proto.saveUser = function saveUser(id, formApi) {
    var _this2 = this;

    return formApi.submit(false).then(function () {
      return _this2.api.client(apiConfigs.saveUser(id, formApi.getSubmission()));
    }).then(function (r) {
      return r.data;
    }).then(function () {
      _this2.history.push(generatePath(clientRoute.user, {
        id: id
      }));
    });
  };

  _proto.saveUserHead = function saveUserHead(user) {
    var id = user.id,
        roles = user.roles,
        login = user.login,
        lang = user.lang;
    return this.api.client(apiConfigs.saveUserHead(id, {
      email: login,
      lang: lang,
      roles: roles.map(function (_) {
        return _.code;
      })
    })).then(function (r) {
      return r.data;
    });
  };

  _proto.userRoleList = function userRoleList() {
    return this.api.client(apiConfigs.userRoleList).then(function (r) {
      return r.data;
    });
  };

  _proto.loadList = function loadList(queryData) {
    var _this3 = this;

    return this.api.client(apiConfigs.userList(queryData)).then(function (r) {
      return r.data;
    }).catch(handleAxiosErrorByResponseStatus({
      403: function _() {
        return _this3.history.replace(clientRoute.notAllowed);
      }
    }));
  };

  _proto.blockUser = function blockUser(id) {
    return this.api.client(apiConfigs.blockUser(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.unblockUser = function unblockUser(id) {
    return this.api.client(apiConfigs.unblockUser(id)).then(function (r) {
      return r.data;
    });
  };

  _proto.deleteUser = function deleteUser(id) {
    return this.api.client(apiConfigs.deleteUser(id)).then(function (r) {
      return r.data;
    });
  };

  _createClass(UserStore, [{
    key: "history",
    get: function get() {
      return this.rootStore.history;
    }
  }]);

  return UserStore;
}();

__decorate([observable], UserStore.prototype, "rootStore", void 0);

__decorate([observable], UserStore.prototype, "api", void 0);

__decorate([computed], UserStore.prototype, "history", null);

__decorate([action.bound], UserStore.prototype, "loginAsUser", null);

__decorate([action.bound], UserStore.prototype, "loadUser", null);

__decorate([action.bound], UserStore.prototype, "getUserPersonModel", null);

__decorate([action.bound], UserStore.prototype, "saveUser", null);

__decorate([action.bound], UserStore.prototype, "saveUserHead", null);

__decorate([action.bound], UserStore.prototype, "userRoleList", null);

__decorate([action.bound], UserStore.prototype, "loadList", null);

__decorate([action.bound], UserStore.prototype, "blockUser", null);

__decorate([action.bound], UserStore.prototype, "unblockUser", null);

__decorate([action.bound], UserStore.prototype, "deleteUser", null);

var getUserStore = function getUserStore() {
  var _di = di([UserStore], getUserStore),
      _UserStore = _di[0];

  return _UserStore;
};

var RootStore = /*#__PURE__*/function () {
  function RootStore(props) {
    var _this = this;

    this.features = {};
    this.env = {};
    this.themeOverrides = {};
    this.services = {
      formVersionLink: function formVersionLink(formVersionId) {
        return _this.env.formServiceUrl + "/form/" + formVersionId;
      }
    };
    var Api = getApi();
    var AuthenticationStore = getAuthenticationStore();
    var AuthorizationStore = getAuthorizationStore();
    var IntlStore = getIntlStore();
    var UserStore = getUserStore();
    var PersonStore = getPersonStore();
    var FormioStore = getFormioStore();
    var CampaignsStore = getCampaignsStore();
    var NotificationStore = getNotificationStore();
    var RequestStore = getRequestStore();
    var CatalogStore = getCatalogStore();
    var PresetStore = getPresetStore();
    var LkNotificationStore = getLkNotificationStore();
    var ModulesStore = getModulesStore();
    var SignatureStore = getSignatureStore();
    var FormioSignatureStore = getFormioSignatureStore();
    var HeaderHeightStore = getHeaderHeightStore();
    var HeaderLinksStore = getHeaderLinksStore();
    var ApprovalStore = getApprovalStore();
    var BreadcrumbsStore = getBreadcrumbsStore();
    var ConsoleStore = getConsoleStore();
    this.setObservables(props);
    this.api = new Api(this);
    this.authenticationStore = new AuthenticationStore(this);
    this.authorizationStore = new AuthorizationStore(this);
    var locales = props.locales,
        history = props.history;
    var messages = {
      ru: _extends({}, lang$1, {}, locales.ru),
      en: _extends({}, lang, {}, locales.en)
    };
    this.intlStore = new IntlStore(this, messages);
    this.history = history;
    this.userStore = new UserStore(this);
    this.personStore = new PersonStore(this);
    this.formioStore = new FormioStore(this);
    this.campaignsStore = new CampaignsStore(this);
    this.notificationStore = new NotificationStore();
    this.requestStore = new RequestStore(this);
    this.formioSidebarStore = new FormioSidebarStore();
    this.catalogStore = new CatalogStore(this);
    this.presetStore = new PresetStore(this);
    this.lkNotificationStore = new LkNotificationStore(this);
    this.modulesStore = new ModulesStore(this);
    this.signatureStore = new SignatureStore(this);
    this.formioSignatureStore = new FormioSignatureStore(this);
    this.headerHeightStore = new HeaderHeightStore();
    this.headerLinksStore = new HeaderLinksStore();
    this.approvalStore = new ApprovalStore(this);
    this.breadcrumbsStore = new BreadcrumbsStore(this);
    this.consoleStore = new ConsoleStore(this);
  }

  var _proto = RootStore.prototype;

  _proto.setObservables = function setObservables(props) {
    var env = props.env,
        features = props.features,
        themeOverrides = props.themeOverrides;
    this.env = env;
    this.features = features;
    this.themeOverrides = themeOverrides;
  };

  _proto.setAppTheme = function setAppTheme(appTheme) {
    this.appTheme = appTheme;
    this.formioStore.addComponentsWithMaterialTheme();
  };

  return RootStore;
}();

__decorate([observable], RootStore.prototype, "history", void 0);

__decorate([observable], RootStore.prototype, "api", void 0);

__decorate([observable], RootStore.prototype, "authenticationStore", void 0);

__decorate([observable], RootStore.prototype, "authorizationStore", void 0);

__decorate([observable], RootStore.prototype, "intlStore", void 0);

__decorate([observable], RootStore.prototype, "userStore", void 0);

__decorate([observable], RootStore.prototype, "personStore", void 0);

__decorate([observable], RootStore.prototype, "formioStore", void 0);

__decorate([observable], RootStore.prototype, "campaignsStore", void 0);

__decorate([observable], RootStore.prototype, "requestStore", void 0);

__decorate([observable], RootStore.prototype, "formioSidebarStore", void 0);

__decorate([observable], RootStore.prototype, "catalogStore", void 0);

__decorate([observable], RootStore.prototype, "notificationStore", void 0);

__decorate([observable], RootStore.prototype, "presetStore", void 0);

__decorate([observable], RootStore.prototype, "lkNotificationStore", void 0);

__decorate([observable], RootStore.prototype, "modulesStore", void 0);

__decorate([observable], RootStore.prototype, "signatureStore", void 0);

__decorate([observable], RootStore.prototype, "formioSignatureStore", void 0);

__decorate([observable], RootStore.prototype, "approvalStore", void 0);

__decorate([observable], RootStore.prototype, "breadcrumbsStore", void 0);

__decorate([observable], RootStore.prototype, "consoleStore", void 0);

__decorate([observable], RootStore.prototype, "features", void 0);

__decorate([observable], RootStore.prototype, "env", void 0);

__decorate([observable], RootStore.prototype, "themeOverrides", void 0);

__decorate([observable], RootStore.prototype, "appTheme", void 0);

__decorate([observable], RootStore.prototype, "headerHeightStore", void 0);

__decorate([observable], RootStore.prototype, "headerLinksStore", void 0);

__decorate([action.bound], RootStore.prototype, "setObservables", null);

__decorate([action.bound], RootStore.prototype, "setAppTheme", null);

var useLogo = function useLogo() {
  var _useFeature = useFeature('logo'),
      logoConfig = _useFeature[1];

  var _useStore = useStore(),
      intlStore = _useStore.intlStore;

  var locale = intlStore.locale;
  return useMemo(function () {
    var _ref = logoConfig.locales[locale] || logoConfig.locales[defaultLocale],
        alt = _ref.alt,
        src = _ref.src;

    return React__default.createElement("img", {
      src: src,
      alt: alt,
      style: logoConfig.style
    });
  }, [logoConfig, locale]);
};

var _path$i;

function _extends$k() {
  _extends$k = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$k.apply(this, arguments);
}

function SvgBurgerIconOpen(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18
  }, props), _path$i || (_path$i = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M9.984 0H12v12.984H9.984V0zM0 0h2.015v12.984H0V0zm5.015 0h1.969v9.984H5.015V0zm4.594 18L6 14.437 2.39 18 .984 16.594 6 11.578l5.015 5.016L9.609 18z"
  })));
}

var _path$j;

function _extends$l() {
  _extends$l = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$l.apply(this, arguments);
}

function SvgBurgerIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12
  }, props), _path$j || (_path$j = /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M16.594 11.015L11.578 6 16.594.984 18 2.39 14.437 6 18 9.609l-1.406 1.406zM0 0h12.984v2.016H0V0zm12.984 12H0V9.984h12.984V12zM0 5.016h9.984v1.968H0V5.016z"
  })));
}

const AppHeaderLinksList = props => {
  const {
    elementsArray
  } = props;
  return React__default.createElement(React__default.Fragment, null, elementsArray.map(({
    key,
    to,
    icon,
    messageID,
    isActiveCallback
  }) => React__default.createElement(Grid, {
    item: true,
    key: key
  }, React__default.createElement(Button, {
    component: NavLink,
    to: to,
    variant: "text",
    color: "secondary",
    isActive: isActiveCallback,
    startIcon: icon
  }, React__default.createElement(FormattedMessage, {
    id: messageID
  })))));
};

var BurgerMenu = function BurgerMenu(props) {
  var isSmSize = props.isSmSize,
      isOpenMenu = props.isOpenMenu,
      hiddenLinksArray = props.hiddenLinksArray;
  return React__default.createElement(Collapse, {
    in: isOpenMenu,
    timeout: "auto"
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    justify: isSmSize ? 'center' : 'flex-end',
    spacing: 3
  }, hiddenLinksArray && React__default.createElement(AppHeaderLinksList, {
    elementsArray: hiddenLinksArray
  })));
};

var _path$k;

function _extends$m() {
  _extends$m = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$m.apply(this, arguments);
}

function SvgUserPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "currentColor"
  }, props), _path$k || (_path$k = /*#__PURE__*/createElement("path", {
    d: "M11.3 9.22A8.002 8.002 0 0116 16.5a1 1 0 11-2 0 6 6 0 00-12.001 0 1 1 0 11-2 0 8 8 0 014.7-7.28 4.92 4.92 0 01-1.7-3.72 5.001 5.001 0 0110 0 4.92 4.92 0 01-1.7 3.72zM8 8.5a3 3 0 10-.002-6.001 3 3 0 00.001 6z"
  })));
}

var UserButton = observer$1(function () {
  var _di = di([MenuButton], UserButton),
      MenuButton$1 = _di[0];

  var _di2 = di([AuthorizationCheck], UserButton),
      AuthorizationCheck$1 = _di2[0];

  var _useStore = useStore(),
      authenticationStore = _useStore.authenticationStore,
      personStore = _useStore.personStore,
      api = _useStore.api;

  var history = useHistory();

  var handleLogout = function handleLogout(hideMenu) {
    return function () {
      try {
        return Promise.resolve(authenticationStore.logout().then(function (response) {
          personStore.clearPerson();

          if (response.data.redirect) {
            window.location.href = response.data.redirect;
          }
        }).catch(hideMenu)).then(function () {
          return Promise.resolve(api.authVerify()).then(function () {
            return Promise.resolve(personStore.getInfo()).then(function () {});
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
  };

  var renderMenuItems = function renderMenuItems(withProfile) {
    return function (hideMenu) {
      var onProfileClick = function onProfileClick() {
        hideMenu();
        history.push(generatePath(clientRoute.user, {
          id: personStore.person.userId
        }));
      };

      return [React__default.createElement(Box, {
        mb: 2,
        key: 'person'
      }, React__default.createElement(MenuItem, {
        dense: true,
        button: false,
        tabIndex: -1
      }, React__default.createElement(Box, {
        pb: 2,
        fontWeight: "fontWeightBold"
      }, personStore.person.lastNameWithInitials)), withProfile && React__default.createElement(MenuItem, {
        dense: true,
        tabIndex: 0,
        onClick: onProfileClick
      }, React__default.createElement(FormattedMessage, {
        id: "users.profile"
      }))), React__default.createElement(Box, {
        key: 'divider',
        mb: 2
      }, React__default.createElement(Divider, null)), React__default.createElement(AuthorizationCheck$1, {
        entityCode: entities.System,
        permCode: permissions.System.Logout
      }, React__default.createElement(MenuItem, {
        dense: true,
        key: 'logout',
        button: true,
        onClick: handleLogout(hideMenu),
        tabIndex: 0
      }, React__default.createElement(FormattedMessage, {
        id: "authentication.logout"
      })))];
    };
  };

  var renderButton = function renderButton(onClick) {
    return React__default.createElement(IconButton, {
      color: "secondary",
      onClick: onClick
    }, React__default.createElement(SvgUserPlus, null));
  };

  return React__default.createElement(React__default.Fragment, null, personStore.person.userId && React__default.createElement(AuthorizationCheck$1, {
    entityCode: entities.User,
    permCode: permissions.User.View,
    entityId: personStore.person.userId
  }, function (allowed) {
    return React__default.createElement(MenuButton$1, {
      reloadKey: personStore.person.lastNameWithInitials,
      renderButton: renderButton,
      renderMenuItems: renderMenuItems(allowed)
    });
  }));
});

const HeaderLinksListWrapper = withTheme$1(styled(Grid)`
        height: 50px;
        overflow: hidden;

        ${({
  theme
}) => theme.breakpoints.down('sm')} {
            height: auto;
        }
    `);
const HeaderLinksGridWrapper = styled(Grid)`
    height: auto;
    width: 100%;
    white-space: nowrap;
    position: relative;
`;

const additionalLinksInj = [];
const AppHeaderLinks = observer$1(props => {
  const {
    isSmSize,
    isOpenMenu,
    handleBurgerChange
  } = props;
  const {
    personStore,
    intlStore,
    lkNotificationStore,
    authorizationStore,
    headerLinksStore
  } = useStore();
  const {
    additionalLinks,
    mainLinks,
    avgLinkWidth
  } = headerLinksStore;
  const {
    loadNotifications,
    loadCountNotViewedMessages,
    changeViewed,
    deleteNotification
  } = lkNotificationStore;
  const [helpIcon] = useFeature('helpIcon');
  const [notificationIcon] = useFeature('notificationIcon');
  const [verifiedLinks, setVerifiedLinks] = useState([]);
  const [visibleLinks, setVisibleLinks] = useState([]);
  const [hiddenLinks, setHiddenLinks] = useState([]);
  const wrapperRef = useRef(null);
  useEffect(() => {
    personStore.getInfo();
  }, [personStore]);
  const updateNavLinks = useCallback(linksCount => {
    if (isSmSize) {
      setVisibleLinks([]);
      setHiddenLinks([...verifiedLinks.slice(0)]);
      return;
    }

    setVisibleLinks([...verifiedLinks.slice(0, linksCount)]);
    setHiddenLinks([...verifiedLinks.slice(linksCount)]);
  }, [verifiedLinks, isSmSize]);
  const handleNavbarChange = useCallback(() => {
    const navbarWrapper = wrapperRef.current;

    if (!navbarWrapper) {
      return;
    }

    const wrapperWidth = navbarWrapper.clientWidth;
    const verifiedLinksCount = verifiedLinks.length;
    const maxLinksCount = Math.floor(wrapperWidth / avgLinkWidth);
    const linksCount = verifiedLinksCount < maxLinksCount ? verifiedLinksCount : maxLinksCount;
    updateNavLinks(linksCount);
  }, [verifiedLinks, avgLinkWidth, updateNavLinks]);
  const getQueriesArray = useCallback(() => {
    const {
      check
    } = authorizationStore;
    const allLinks = [...additionalLinks, ...mainLinks];
    return allLinks.map(link => {
      if (link.query) {
        return check(link.query).then(allowed => ({
          link,
          allowed
        }));
      }

      return Promise.resolve({
        link,
        allowed: true
      });
    });
  }, [authorizationStore, mainLinks, additionalLinks]);
  const checkLinksPermission = useCallback(() => {
    Promise.all(getQueriesArray()).then(links => {
      const allowedLinks = links.filter(({
        link,
        allowed
      }) => allowed);
      setVerifiedLinks(allowedLinks.map(({
        link
      }) => link));
    });
  }, [getQueriesArray]);
  useEffect(() => {
    checkLinksPermission();
  }, [checkLinksPermission, personStore.user.id]);
  useEffect(() => {
    handleNavbarChange();
    window.addEventListener('resize', handleNavbarChange);
    return () => {
      window.removeEventListener('resize', handleNavbarChange);
    };
  }, [verifiedLinks, handleNavbarChange]);
  return React__default.createElement(Box, {
    pt: 0.5
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "flex-end",
    spacing: 3,
    wrap: "nowrap"
  }, React__default.createElement(HeaderLinksGridWrapper, {
    item: true
  }, React__default.createElement(HeaderLinksListWrapper, {
    container: true,
    direction: "row",
    alignItems: "center",
    justify: isSmSize ? 'center' : 'flex-end',
    spacing: 3,
    key: personStore.user.id,
    ref: wrapperRef
  }, React__default.createElement(AppHeaderLinksList, {
    elementsArray: visibleLinks
  })), React__default.createElement(Box, {
    pt: 3
  }, React__default.createElement(BurgerMenu, {
    isSmSize: isSmSize,
    isOpenMenu: isOpenMenu,
    hiddenLinksArray: hiddenLinks
  }))), React__default.createElement(Grid, {
    item: true
  }, hiddenLinks.length !== 0 ? React__default.createElement(IconButton, {
    color: "secondary",
    onClick: handleBurgerChange,
    className: "t-toggleMenu-button"
  }, isOpenMenu ? React__default.createElement(SvgBurgerIconOpen, null) : React__default.createElement(SvgBurgerIcon, null)) : null), helpIcon && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(IconButton, {
    color: "secondary"
  }, React__default.createElement(SvgQuestionCircle, null))), notificationIcon && React__default.createElement(AuthorizationCheck, {
    key: personStore.user.id,
    entityCode: entities.System,
    permCode: permissions.System.ViewNotifications
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(NotificationWidget, {
    locale: intlStore.locale,
    loadNotifications: loadNotifications,
    loadCountNotViewedMessages: loadCountNotViewedMessages,
    changeViewed: changeViewed,
    deleteNotification: deleteNotification,
    key: personStore.person.userId
  }))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(UserButton, null))));
});

var MenuButton = observer$1(function (props) {
  var _useState = useState(null),
      buttonRef = _useState[0],
      setButtonRef = _useState[1];

  var renderButton = props.renderButton,
      renderMenuItems = props.renderMenuItems,
      children = props.children,
      disablePortal = props.disablePortal,
      handleClose = props.handleClose,
      reloadKey = props.reloadKey;

  var hideMenu = function hideMenu() {
    setButtonRef(null);
  };

  var closeMenu = function closeMenu() {
    handleClose && handleClose();
    hideMenu();
  };

  var handleClick = function handleClick(event) {
    setButtonRef(event.currentTarget);
  };

  var isMenuOpen = !!buttonRef;
  return React__default.createElement(React__default.Fragment, null, renderButton(handleClick), React__default.createElement(Popover, {
    open: isMenuOpen,
    anchorEl: buttonRef,
    disablePortal: disablePortal,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, React__default.createElement(Paper, null, React__default.createElement(ClickAwayListener, {
    onClickAway: closeMenu
  }, React__default.createElement(MenuList, {
    id: "language-menu",
    role: "menu",
    key: reloadKey
  }, renderMenuItems && renderMenuItems(hideMenu), children)))));
});

var LanguageButton = observer$1(function () {
  var _useStore = useStore(),
      intlStore = _useStore.intlStore;

  var handleClose = function handleClose(locale) {
    return function () {
      intlStore.changeLocale(locale);
    };
  };

  var renderMenuItems = function renderMenuItems(hideMenu) {
    return intlStore.locales.map(function (l) {
      var handleSelect = function handleSelect() {
        handleClose(l)();
        hideMenu();
      };

      return React__default.createElement(MenuItem, {
        dense: true,
        key: l,
        role: "menuitem",
        button: true,
        selected: intlStore.locale === l,
        onClick: handleSelect,
        tabIndex: 0
      }, l);
    });
  };

  var renderButton = function renderButton(onClick) {
    return React__default.createElement(IconButton, {
      color: "secondary",
      onClick: onClick
    }, React__default.createElement(Language, null));
  };

  return React__default.createElement(MenuButton, {
    renderButton: renderButton,
    handleClose: handleClose(intlStore.locale),
    renderMenuItems: renderMenuItems
  });
});

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n        color: ", ";\n        font-size: 30px;\n        font-weight: bold;\n        line-height: 1.4;\n        letter-spacing: 0.6px;\n    "]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var TotXLogo = withTheme(styled.span(_templateObject$c(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.contrastText;
}));
var LogoImg = observer$1(function (props) {
  var logoConfig = props.logoConfig;
  var logo = useLogo();
  return logoConfig.withText ? React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    item: true,
    style: {
      paddingBottom: '0'
    }
  }, React__default.createElement(Box, {
    pr: 3
  }, logo)), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(TotXLogo, null, React__default.createElement(FormattedMessage, {
    id: "productTitle"
  })))) : React__default.createElement(Grid, {
    item: true
  }, logo);
});

var useTotAppBarStyles = makeStyles$1(function () {
  return createStyles$1({
    wrapper: {
      position: 'relative',
      zIndex: 1000
    }
  });
});
var AdditionalHeaderInj = function AdditionalHeaderInj() {
  return React__default.createElement(React__default.Fragment, null);
};
var TotAppBar = observer$1(function () {
  var _useStore = useStore(),
      intlStore = _useStore.intlStore,
      modulesStore = _useStore.modulesStore,
      personStore = _useStore.personStore,
      headerHeightStore = _useStore.headerHeightStore;

  var loadModulesList = modulesStore.loadModulesList;
  var userId = personStore.user.id;

  var _di = di([AdditionalHeaderInj], TotAppBar),
      AdditionalHeader = _di[0];

  var _di2 = di([LogoImg], TotAppBar),
      LogoImg$1 = _di2[0];

  var _useFeature = useFeature('modularNavigation'),
      modularNavigation = _useFeature[0];

  var _useFeature2 = useFeature('stickyHeader'),
      stickyHeader = _useFeature2[0];

  var _useFeature3 = useFeature('startPage'),
      startPage = _useFeature3[0];

  var _useFeature4 = useFeature('logo'),
      logoConfig = _useFeature4[1];

  var _useFeature5 = useFeature('changeLanguage'),
      changeLanguage = _useFeature5[0];

  var setHeaderHeight = headerHeightStore.setHeaderHeight;
  var classes = useTotAppBarStyles();

  var _useState = useState(false),
      isMenuOpen = _useState[0],
      setIsMenuOpen = _useState[1];

  var isSmSize = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });
  var headerObserverRef = useRef(new ResizeObserver(function (entries) {
    var headerEntry = entries[0];

    if (headerEntry) {
      setHeaderHeight(headerEntry.contentRect.height);
    }
  }));
  var headerContentWrapperRef = useRef(null);
  useEffect(function () {
    if (headerContentWrapperRef.current) {
      headerObserverRef.current.observe(headerContentWrapperRef.current);
    }

    return function () {
      headerObserverRef.current.disconnect();
    };
  }, [headerContentWrapperRef]);

  var handleBurgerChange = function handleBurgerChange() {
    setIsMenuOpen(function (isOpenMenu) {
      return !isOpenMenu;
    });
  };

  return React__default.createElement(RenderPropSticky, {
    scrollElement: "#root",
    disabled: !stickyHeader
  }, function (_ref) {
    var wrapperStyles = _ref.wrapperStyles,
        wrapperRef = _ref.wrapperRef,
        holderStyles = _ref.holderStyles,
        holderRef = _ref.holderRef;
    return React__default.createElement("div", {
      ref: holderRef,
      style: holderStyles
    }, React__default.createElement("div", {
      ref: wrapperRef,
      className: classes.wrapper,
      style: _extends({}, wrapperStyles)
    }, React__default.createElement("div", {
      ref: headerContentWrapperRef
    }, React__default.createElement(AdditionalHeader, null), React__default.createElement(AppBar, {
      color: "default",
      position: "static",
      elevation: 0
    }, React__default.createElement(Container, {
      maxWidth: "lg"
    }, React__default.createElement(Box, {
      pt: 3.75,
      pb: 3.75
    }, React__default.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "flex-start",
      justify: "space-between",
      wrap: "nowrap"
    }, React__default.createElement(Grid, {
      item: true,
      style: {
        flexShrink: 0
      }
    }, React__default.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center"
    }, React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(Link$1, {
      component: Link,
      to: clientRoute.root,
      underline: "none"
    }, React__default.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center"
    }, React__default.createElement(LogoImg$1, {
      logoConfig: logoConfig
    })))), modularNavigation && userId && React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(ModularNavigationWidget, {
      key: userId,
      loadModulesList: loadModulesList,
      locale: intlStore.locale
    })))), React__default.createElement(Grid, {
      item: true,
      style: {
        flexGrow: 1
      }
    }, React__default.createElement(Box, {
      mr: 3,
      ml: 3,
      pt: 2.5
    }, React__default.createElement(Switch, null, React__default.createElement(Route, {
      exact: true,
      path: [clientRoute.root, clientRoute.login]
    }, startPage && React__default.createElement(StartPageHeaderLinks, null)), React__default.createElement(Route, {
      path: [clientRoute.notAllowed, clientRoute.notFound, clientRoute.recoveryPassword, clientRoute.registration, clientRoute.authenticationInfo]
    }), React__default.createElement(Route, null, React__default.createElement(AppHeaderLinks, {
      isSmSize: isSmSize,
      isOpenMenu: isMenuOpen,
      handleBurgerChange: handleBurgerChange
    }))))), React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(Box, {
      pt: 3
    }, React__default.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center",
      spacing: 3,
      wrap: "nowrap"
    }, changeLanguage && React__default.createElement(Grid, {
      item: true
    }, React__default.createElement(LanguageButton, null))))))))))));
  });
});

var names = {
  mainPage: 'breadcrumbs.mainPage',
  campaigns: 'breadcrumbs.campaigns',
  campaign: 'breadcrumbs.campaign',
  requests: 'breadcrumbs.requests',
  requestsNew: 'breadcrumbs.requestsNew',
  campaignSettings: 'breadcrumbs.campaignSettings',
  regFormSelect: 'breadcrumbs.regFormSelect',
  users: 'breadcrumbs.users'
};
var mainRoutes = {
  mainPage: '/',
  campaigns: '/campaigns',
  requests: '/requests',
  requestsNew: '/requests/new',
  users: '/users'
};
var routesWithParams = {
  campaign: function campaign(objectId) {
    return generatePath(clientRoute.campaign, {
      id: objectId
    });
  },
  request: function request(objectId) {
    return generatePath(clientRoute.request, {
      id: objectId
    });
  },
  campaignSettings: function campaignSettings(objectId) {
    return generatePath(clientRoute.campaignSettings, {
      id: objectId
    });
  },
  regFormSelect: function regFormSelect(objectId) {
    return generatePath(clientRoute.regFormSelect, {
      campaignId: objectId
    });
  }
};
var breadCrumbsSettings = {
  names: names,
  mainRoutes: mainRoutes,
  routesWithParams: routesWithParams
};

var _path$l;

function _extends$n() {
  _extends$n = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$n.apply(this, arguments);
}

function SvgAngleDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7,
    viewBox: "0 0 12 6",
    fill: "currentColor"
  }, props), _path$l || (_path$l = /*#__PURE__*/createElement("path", {
    d: "M11 .17a1 1 0 010 1.42L6.708 5.83a.999.999 0 01-1.42 0L1.05 1.59a.999.999 0 010-1.42 1 1 0 011.41 0L6 3.71 9.59.17a1 1 0 011.41 0z"
  })));
}

var AngleIconButton = function AngleIconButton(props) {
  var transform = props.isUp ? 'rotate(180deg)' : '';
  var className = props.isActive ? 'active' : '';
  var transition = 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
  return React__default.createElement(IconButton, {
    onClick: props.onClick,
    className: className
  }, React__default.createElement(SvgAngleDown, {
    style: {
      transform: transform,
      transition: transition
    }
  }));
};

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n        color: ", ";\n        text-transform: none;\n        font-size: 15px;\n        line-height: 1.47;\n        letter-spacing: 0.3px;\n    "]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var FooterTypography = withTheme(styled(Typography)(_templateObject$d(), function (_ref) {
  var theme = _ref.theme;
  return theme === null || theme === void 0 ? void 0 : theme.variables.palette.footer.textMain;
}));

var _defs$2, _g$2, _path$m;

function _extends$o() {
  _extends$o = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$o.apply(this, arguments);
}

function SvgPhoneAlt(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "2 0 20 20",
    fill: "currentColor"
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
    id: "phone-alt_svg__a",
    width: 112,
    height: 130,
    x: -44,
    y: -46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("feOffset", {
    dy: 18,
    in: "SourceGraphic",
    result: "FeOffset1157Out"
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    in: "FeOffset1157Out",
    result: "FeGaussianBlur1158Out",
    stdDeviation: "14.4 14.4"
  })), /*#__PURE__*/createElement("mask", {
    id: "phone-alt_svg__b",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M2 0h20v20H2z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.438 11a3 3 0 012.47 2.9v3a3.005 3.005 0 01-1 2.249 3 3 0 01-2 .76h-.38a19 19 0 01-16.52-16.46 3.002 3.002 0 013-3.41h3a3 3 0 013 2.49c.03.23.07.46.12.68.1.445.231.882.39 1.31a2 2 0 01-1 2.48l-.42.28a12.15 12.15 0 002 2.66 12.16 12.16 0 002.66 2l.22-.45a1.999 1.999 0 012.48-1c.426.161.865.292 1.31.39.22.05.45.12.67.12zm.48 2.879c.01-.48-1.2-1.06-1.6-1.15a13.752 13.752 0 01-1.58-.46l-.62 1.4c-.114.242-.318.43-.571.52-.242.1-.515.1-.759 0a14.489 14.489 0 01-7-7 1 1 0 01.49-1.33l1.4-.65c-.192-.505-.55-1.95-.61-2.36a1 1 0 00-1-.79h-3a.995.995 0 00-.75.34 1.091 1.091 0 00-.25.82 17 17 0 0014.71 14.78c.297.036.594-.055.821-.25.215-.19.339-.463.339-.75l-.02-3.12z"
  })))), _g$2 || (_g$2 = /*#__PURE__*/createElement("g", {
    filter: "url(#phone-alt_svg__a)"
  }, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M19.438 11a3 3 0 012.47 2.9v3a3.005 3.005 0 01-1 2.249 3 3 0 01-2 .76h-.38a19 19 0 01-16.52-16.46 3.002 3.002 0 013-3.41h3a3 3 0 013 2.49c.03.23.07.46.12.68.1.445.231.882.39 1.31a2 2 0 01-1 2.48l-.42.28a12.15 12.15 0 002 2.66 12.16 12.16 0 002.66 2l.22-.45a1.999 1.999 0 012.48-1c.426.161.865.292 1.31.39.22.05.45.12.67.12zm.48 2.879c.01-.48-1.2-1.06-1.6-1.15a13.752 13.752 0 01-1.58-.46l-.62 1.4c-.114.242-.318.43-.571.52-.242.1-.515.1-.759 0a14.489 14.489 0 01-7-7 1 1 0 01.49-1.33l1.4-.65c-.192-.505-.55-1.95-.61-2.36a1 1 0 00-1-.79h-3a.995.995 0 00-.75.34 1.091 1.091 0 00-.25.82 17 17 0 0014.71 14.78c.297.036.594-.055.821-.25.215-.19.339-.463.339-.75l-.02-3.12z",
    mask: "url(\"#b\")"
  }), /*#__PURE__*/createElement("path", {
    fillOpacity: 0.03,
    d: "M19.438 11a3 3 0 012.47 2.9v3a3.005 3.005 0 01-1 2.249 3 3 0 01-2 .76h-.38a19 19 0 01-16.52-16.46 3.002 3.002 0 013-3.41h3a3 3 0 013 2.49c.03.23.07.46.12.68.1.445.231.882.39 1.31a2 2 0 01-1 2.48l-.42.28a12.15 12.15 0 002 2.66 12.16 12.16 0 002.66 2l.22-.45a1.999 1.999 0 012.48-1c.426.161.865.292 1.31.39.22.05.45.12.67.12zm.48 2.879c.01-.48-1.2-1.06-1.6-1.15a13.752 13.752 0 01-1.58-.46l-.62 1.4c-.114.242-.318.43-.571.52-.242.1-.515.1-.759 0a14.489 14.489 0 01-7-7 1 1 0 01.49-1.33l1.4-.65c-.192-.505-.55-1.95-.61-2.36a1 1 0 00-1-.79h-3a.995.995 0 00-.75.34 1.091 1.091 0 00-.25.82 17 17 0 0014.71 14.78c.297.036.594-.055.821-.25.215-.19.339-.463.339-.75l-.02-3.12z"
  }))), _path$m || (_path$m = /*#__PURE__*/createElement("path", {
    d: "M19.438 11a3 3 0 012.47 2.9v3a3.005 3.005 0 01-1 2.249 3 3 0 01-2 .76h-.38a19 19 0 01-16.52-16.46 3.002 3.002 0 013-3.41h3a3 3 0 013 2.49c.03.23.07.46.12.68.1.445.231.882.39 1.31a2 2 0 01-1 2.48l-.42.28a12.15 12.15 0 002 2.66 12.16 12.16 0 002.66 2l.22-.45a1.999 1.999 0 012.48-1c.426.161.865.292 1.31.39.22.05.45.12.67.12zm.48 2.879c.01-.48-1.2-1.06-1.6-1.15a13.752 13.752 0 01-1.58-.46l-.62 1.4c-.114.242-.318.43-.571.52-.242.1-.515.1-.759 0a14.489 14.489 0 01-7-7 1 1 0 01.49-1.33l1.4-.65c-.192-.505-.55-1.95-.61-2.36a1 1 0 00-1-.79h-3a.995.995 0 00-.75.34 1.091 1.091 0 00-.25.82 17 17 0 0014.71 14.78c.297.036.594-.055.821-.25.215-.19.339-.463.339-.75l-.02-3.12z"
  })));
}

var _defs$3, _g$3, _path$n;

function _extends$p() {
  _extends$p = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$p.apply(this, arguments);
}

function SvgEnvelope(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "7 0 20 16",
    fill: "currentColor"
  }, props), _defs$3 || (_defs$3 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
    id: "envelope_svg__a",
    width: 112,
    height: 126,
    x: -39,
    y: -46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("feOffset", {
    dy: 18,
    in: "SourceGraphic",
    result: "FeOffset1204Out"
  }), /*#__PURE__*/createElement("feGaussianBlur", {
    in: "FeOffset1204Out",
    result: "FeGaussianBlur1205Out",
    stdDeviation: "14.4 14.4"
  })), /*#__PURE__*/createElement("mask", {
    id: "envelope_svg__b",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M7 0h20v16H7z"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.998 0a3 3 0 013 3v10a3 3 0 01-3 3h-14a3 3 0 01-3-3V3a3 3 0 013-3zm-13.59 2l5.88 5.88a1.004 1.004 0 001.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 01-4.24 0l-5.88-5.88V13a1 1 0 001 .999h14a.999.999 0 001-1z"
  })))), _g$3 || (_g$3 = /*#__PURE__*/createElement("g", {
    filter: "url(#envelope_svg__a)"
  }, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M23.998 0a3 3 0 013 3v10a3 3 0 01-3 3h-14a3 3 0 01-3-3V3a3 3 0 013-3zm-13.59 2l5.88 5.88a1.004 1.004 0 001.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 01-4.24 0l-5.88-5.88V13a1 1 0 001 .999h14a.999.999 0 001-1z",
    mask: "url(\"#b\")"
  }), /*#__PURE__*/createElement("path", {
    fillOpacity: 0.03,
    d: "M23.998 0a3 3 0 013 3v10a3 3 0 01-3 3h-14a3 3 0 01-3-3V3a3 3 0 013-3zm-13.59 2l5.88 5.88a1.004 1.004 0 001.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 01-4.24 0l-5.88-5.88V13a1 1 0 001 .999h14a.999.999 0 001-1z"
  }))), _path$n || (_path$n = /*#__PURE__*/createElement("path", {
    d: "M23.998 0a3 3 0 013 3v10a3 3 0 01-3 3h-14a3 3 0 01-3-3V3a3 3 0 013-3zm-13.59 2l5.88 5.88a1.004 1.004 0 001.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 01-4.24 0l-5.88-5.88V13a1 1 0 001 .999h14a.999.999 0 001-1z"
  })));
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n        .MuiButton-label {\n            align-items: center;\n        }\n\n        .MuiTypography-root {\n            font-weight: bold;\n        }\n    "]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var FooterButtonInj = withTheme(styled(Button)(_templateObject$e()));
var FooterContactInformation = function FooterContactInformation(props) {
  var _di = di([FooterButtonInj], FooterContactInformation),
      FooterButton = _di[0];

  var _di2 = di([FooterTypography], FooterContactInformation),
      FooterTypography$1 = _di2[0];

  var _di3 = di([getEmailFromText], FooterContactInformation),
      getEmailFromText$1 = _di3[0];

  var _di4 = di([getPhoneNumberFromText], FooterContactInformation),
      getPhoneNumberFromText$1 = _di4[0];

  var _useFeature = useFeature('phoneNumber'),
      phoneNumber = _useFeature[0];

  var _useFeature2 = useFeature('email'),
      email = _useFeature2[0];

  var _props$phoneNumberTex = props.phoneNumberText,
      phoneNumberText = _props$phoneNumberTex === void 0 ? '' : _props$phoneNumberTex,
      _props$emailText = props.emailText,
      emailText = _props$emailText === void 0 ? '' : _props$emailText;
  var hrefTel = getPhoneNumberFromText$1(phoneNumberText);
  var hrefEmail = getEmailFromText$1(emailText);
  return React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    justify: "flex-end"
  }, phoneNumber && hrefTel && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Box, {
    pr: 3
  }, React__default.createElement(FooterButton, {
    component: "a",
    href: "tel:" + hrefTel,
    startIcon: React__default.createElement(SvgPhoneAlt, null),
    variant: "text",
    color: "secondary"
  }, React__default.createElement(FooterTypography$1, {
    component: "span"
  }, phoneNumberText)))), email && hrefEmail && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FooterButton, {
    component: "a",
    href: "mailto:" + hrefEmail,
    startIcon: React__default.createElement(SvgEnvelope, null),
    variant: "text",
    color: "secondary"
  }, React__default.createElement(FooterTypography$1, {
    component: "span"
  }, emailText)))));
};

var FooterLogo = function FooterLogo() {
  var intl = useIntl();

  var _useFeature = useFeature('footerLogo'),
      footerLogo = _useFeature[0],
      footerLogoConfig = _useFeature[1];

  var isFooterLogoEnabled = footerLogoConfig.isEnabled,
      footerLogoSrc = footerLogoConfig.src,
      footerLogoStyle = footerLogoConfig.style;
  var footerLogoAlt = intl.formatMessage({
    id: 'startPage.footerLogoAlt'
  });
  return React__default.createElement(React__default.Fragment, null, footerLogo && isFooterLogoEnabled && footerLogoSrc && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement("img", Object.assign({
    src: footerLogoSrc,
    alt: footerLogoAlt
  }, footerLogoStyle && {
    style: footerLogoStyle
  }))));
};

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n        position: relative;\n        padding: ", ";\n        background-color: ", ";\n        bottom: 0;\n\n        &:before {\n            content: '';\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 100%;\n        }\n    "]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var FooterWrapperInj = withTheme(styled.footer(_templateObject$f(), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(theme.variables.palette.footer.padding) + "px 0";
}, function (_ref2) {
  var theme = _ref2.theme;
  return "" + theme.variables.palette.appBar.mainContrast;
}));
var Footer = observer$1(function () {
  var _di = di([FooterWrapperInj], Footer),
      FooterWrapper = _di[0];

  var _di2 = di([FooterTypography], Footer),
      FooterTypography$1 = _di2[0];

  var _di3 = di([FooterLogo], Footer),
      FooterLogo$1 = _di3[0];

  var _di4 = di([FooterContactInformation], Footer),
      FooterContactInformation$1 = _di4[0];

  var _useStore = useStore(),
      env = _useStore.env;

  var totCopyright = env.totCopyright,
      totTel = env.totTel,
      totMail = env.totMail;
  return React__default.createElement(FooterWrapper, null, React__default.createElement(Container, {
    maxWidth: "lg"
  }, React__default.createElement(Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap",
    alignItems: "center",
    justify: "space-between",
    spacing: 3
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(FooterTypography$1, {
    component: "small",
    color: "primary"
  }, totCopyright)), React__default.createElement(FooterContactInformation$1, {
    phoneNumberText: totTel,
    emailText: totMail
  }), React__default.createElement(FooterLogo$1, null))));
});

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n        color: ", " !important;\n        text-decoration: underline !important;\n\n        &:hover {\n            color: ", " !important;\n        }\n    "]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var AlertLink = withTheme(styled(Link$1)(_templateObject$g(), function (_ref) {
  var theme = _ref.theme;
  return theme.variables.alertLink.color;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.variables.alertLink.hoverColor;
}));

var AppRouterLink = function AppRouterLink(props) {
  var children = props.children,
      restProps = _objectWithoutPropertiesLoose(props, ["children"]);

  return React__default.createElement(Link$1, Object.assign({
    component: Link
  }, restProps), children);
};

var topPositionMultiplier = 69;
var topGap = 10;
var useStyles$6 = makeStyles$1(function () {
  return createStyles$1({
    box: {
      wordBreak: 'break-word',
      maxWidth: '400px'
    }
  });
});
var SnackbarComponent = function SnackbarComponent(props) {
  var severity = props.severity,
      text = props.text,
      index = props.index,
      closeMessage = props.closeMessage,
      isOpen = props.isOpen;
  var top = topGap + index * topPositionMultiplier;
  var classes = useStyles$6();
  return React__default.createElement(Portal, null, React__default.createElement(Snackbar, {
    className: "t-notification",
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: isOpen,
    style: {
      top: top + "px"
    }
  }, React__default.createElement(Alert$1, {
    variant: "filled",
    severity: severity,
    onClose: closeMessage
  }, React__default.createElement(Box, {
    className: classes.box
  }, text))));
};

var NotificationComponent = observer$1(function () {
  var _useStore = useStore(),
      notificationStore = _useStore.notificationStore;

  var model = notificationStore.model;

  var closeMessage = function closeMessage(id) {
    return function () {
      return model.deleteNotification(id);
    };
  };

  return React__default.createElement(React__default.Fragment, null, model.notifications.map(function (m, index) {
    return React__default.createElement(SnackbarComponent, {
      key: m.id,
      isOpen: m.isOpen,
      closeMessage: closeMessage(m.id),
      index: index + 1,
      text: m.title,
      severity: m.severity
    });
  }));
});

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: ", "px;\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    background: ", ";\n\n    & svg {\n        margin-left: 9px;\n        margin-top: 7px;\n        fill: ", ";\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-bottom: ", "px;\n    "]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n        display: flex;\n        align-items: center;\n        position: absolute;\n        top: 0;\n        left: ", "px;\n        width: ", "px;\n        height: ", "px;\n    "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n        color: ", " !important;\n        width: ", "px !important;\n        height: ", "px !important;\n        font-weight: bold;\n\n        .MuiIconButton-label {\n            border-radius: 50%;\n            border: 1px solid ", ";\n            background: ", ";\n\n            &:hover {\n                color: ", " !important;\n                background-color: transparent !important;\n            }\n        }\n    "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n        width: ", "px;\n        transition: ", ";\n\n        .sidebar {\n            position: relative;\n            right: 0;\n            top: ", "px;\n            max-width: ", "px;\n            width: 100%;\n            max-height: ", ";\n            overflow-y: auto;\n\n            &.sticky {\n                position: fixed;\n                right: auto;\n                z-index: 1;\n                &.stickyHeader {\n                    ", "\n                }\n            }\n\n            .sidebar-list {\n                position: relative;\n                padding-left: ", "px;\n                margin: 0;\n\n                &--closed {\n                    overflow: hidden;\n                    display: none;\n                }\n            }\n\n            .sidebar-link {\n                word-break: break-word;\n            }\n\n            .sidebar-item,\n            .sidebar-subitem {\n                display: flex;\n                align-items: center;\n                position: relative;\n                overflow: visible;\n                border: none;\n                min-height: ", "px;\n            }\n\n            .sidebar-item {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                padding-bottom: ", "px;\n                padding-left: ", "px;\n\n                &.open,\n                &:last-child {\n                    padding-bottom: 0;\n                }\n\n                &:not(.has-subitems) {\n                    padding-right: ", "px;\n                }\n            }\n\n            .sidebar-subitem {\n                padding-right: ", "px;\n                padding-left: ", "px;\n\n                &.last {\n                    padding-bottom: ", "px;\n                }\n            }\n        }\n\n        ", " {\n            width: ", ";\n\n            .sidebar {\n                width: ", ";\n            }\n        }\n    "]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSidebar = withTheme(styled(Grid)(_templateObject$h(), function (_ref) {
  var theme = _ref.theme,
      open = _ref.open;
  return open ? theme.variables.sidebar.width + theme.spacing(5) * 2 : theme.variables.sidebar.collapseIconWidth;
}, transitionDefault, function (_ref2) {
  var theme = _ref2.theme;
  return theme.variables.sidebar.offsetVertical;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.variables.sidebar.width;
}, function (_ref4) {
  var theme = _ref4.theme,
      _ref4$headerHeight = _ref4.headerHeight,
      headerHeight = _ref4$headerHeight === void 0 ? 0 : _ref4$headerHeight,
      stickyHeader = _ref4.stickyHeader;
  var offset = theme.variables.sidebar.offsetVertical * 2 + theme.variables.requestPanel.height + theme.variables.footer.height;

  if (stickyHeader) {
    offset += headerHeight;
  }

  return "calc(100vh - " + offset + "px)";
}, function (_ref5) {
  var headerHeight = _ref5.headerHeight;
  return headerHeight ? "margin-top: " + headerHeight + "px" : null;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.variables.button.sizes.medium + theme.variables.sidebar.errorSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.variables.button.sizes.medium;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacing(3);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.spacing(2);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.variables.button.sizes.medium;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.variables.button.sizes.medium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing(2);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing(3);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.up('xxl');
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.variables.sidebar.widthXl;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.variables.sidebar.widthXl;
}));
var ErrorButton = withTheme(styled(IconButton)(_templateObject2$4(), function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.common.white;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.variables.sidebar.errorSize;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.variables.sidebar.errorSize;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.palette.error.main;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.palette.error.main;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.palette.error.main;
}));
var ErrorButtonContainer = withTheme(styled.div(_templateObject3$2(), function (_ref23) {
  var theme = _ref23.theme;
  return -theme.variables.sidebar.errorSize + theme.spacing(1);
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.variables.sidebar.errorSize;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.variables.button.sizes.medium;
}));
var SidebarCollapseButton = withTheme(styled(IconButton)(_templateObject4$1(), function (_ref26) {
  var theme = _ref26.theme;
  return theme.spacing(2);
}));
var SidebarIconWrapper = withTheme(styled.div(_templateObject5(), function (_ref27) {
  var theme = _ref27.theme;
  return -theme.variables.button.sizes.medium - theme.variables.sidebar.errorSize;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.variables.button.sizes.medium;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.variables.button.sizes.medium;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.variables.button.sizes.medium / 2;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.variables.palette.panel.markerBackgroundColor;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.variables.palette.panel.markerColor;
}));

var _path$o;

function _extends$q() {
  _extends$q = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$q.apply(this, arguments);
}

function SvgIconAllIconsUniconsPuzzlePiece24(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path$o || (_path$o = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M18.179 15.299a3.859 3.859 0 01-2.18.7v3a1 1 0 01-1 1h-12a3 3 0 01-3-3v-10a3 3 0 013-3h.999a4.002 4.002 0 017.3-2.18 3.86 3.86 0 01.701 2.18h3a1 1 0 011 1v3a4 4 0 012.18 7.3zm-.66-4.62a1.892 1.892 0 00-2.171-.55.999.999 0 01-1.329-.95v-3.18h-3.2a1 1 0 01-1.001-1.33 1.771 1.771 0 00-.229-1.74 1.942 1.942 0 00-3.001-.43c-.397.395-.612.94-.589 1.5.002.23.046.457.13.67a1 1 0 01-.95 1.33h-2.18a1 1 0 00-1 1v10a1 1 0 001 1h10.999v-3.18a.994.994 0 01.421-.819.998.998 0 01.91-.131c.58.237 1.242.15 1.739-.23a2 2 0 00.931-1.37 2.005 2.005 0 00-.48-1.59z"
  })));
}

var Sidebar = observer$1(function (props) {
  var _props$sidebarItems = props.sidebarItems,
      sidebarItems = _props$sidebarItems === void 0 ? [] : _props$sidebarItems,
      open = props.open,
      toggleSidebar = props.toggleSidebar;
  var theme = useTheme$1();

  var _useFeature = useFeature('stickyHeader'),
      stickyHeader = _useFeature[0];

  var _useFeature2 = useFeature('customSidebarIcon'),
      customSidebarIcon = _useFeature2[0],
      customSidebarIconConfig = _useFeature2[1];

  var sidebarContainerRef = useRef();
  var root = document.getElementById('root');

  var _useStore = useStore(),
      headerHeightStore = _useStore.headerHeightStore;

  var _headerHeightStore$he = headerHeightStore.headerHeight,
      headerHeight = _headerHeightStore$he === void 0 ? 0 : _headerHeightStore$he;
  var localStore = useLocalStore(function () {
    return {
      rootScrollTop: 0,
      spiedEntities: [],
      isSidebarSticky: false,
      openItemId: '',
      activeItem: {},
      activeSubItem: {},
      sidebarItems: [],
      hoveredItemId: ''
    };
  });

  var scrollHandler = function scrollHandler() {
    var currentScrollTop = root === null || root === void 0 ? void 0 : root.scrollTop;

    if (localStore.rootScrollTop !== currentScrollTop) {
      spyHandler();
      stickyHandler();
    }

    localStore.rootScrollTop = currentScrollTop || 0;
  };

  useEffect(function () {
    scrollHandler();
    root === null || root === void 0 ? void 0 : root.addEventListener('scroll', scrollHandler);
    return function () {
      return root === null || root === void 0 ? void 0 : root.removeEventListener('scroll', scrollHandler);
    };
  }, []);
  useEffect(function () {
    var newSpiedEntities = [];
    sidebarItems.forEach(function (item) {
      if (item.isShown) {
        if (item.subItems.length > 0) {
          item.subItems.forEach(function (subItem) {
            if (subItem.isShown) {
              newSpiedEntities.push(subItem);
            }
          });
        } else {
          newSpiedEntities.push(item);
        }
      }
    });
    localStore.spiedEntities = newSpiedEntities;
    localStore.sidebarItems = sidebarItems;
    spyHandler();
  }, [sidebarItems]);

  var openPanelAndScrollById = function openPanelAndScrollById(item) {
    return function () {
      var itemId = item.id;
      var headerHeightForScroll = stickyHeader && headerHeight || 0;
      BootstrapPanelUtils.openPanelById(itemId);
      ScrollUtils.scrollToElementById(itemId, headerHeightForScroll);
    };
  };

  var setNewOpenItemId = function setNewOpenItemId(id) {
    return function () {
      var newOpenItemId = localStore.openItemId === id ? '' : id;
      localStore.openItemId = newOpenItemId;
    };
  };

  var setNewHoveredItemId = function setNewHoveredItemId(id) {
    return function () {
      var newHoveredItemId = localStore.hoveredItemId === id ? '' : id;
      localStore.hoveredItemId = newHoveredItemId;
    };
  };

  var renderItem = function renderItem(item, itemId, subItems) {
    if (item.isShown && localStore.activeItem) {
      var onMouseEvent = setNewHoveredItemId(itemId);
      var active = localStore.activeItem.id === itemId;
      var hasSubItems = subItems.length > 0;

      var _open = localStore.openItemId === itemId && hasSubItems;

      var hovered = localStore.hoveredItemId === itemId;
      return React__default.createElement("li", {
        key: itemId,
        className: classNames('sidebar-item', {
          'has-subitems': hasSubItems
        }, {
          open: _open
        })
      }, item.hasError && React__default.createElement(Tooltip, {
        title: React__default.createElement(FormattedMessage, {
          id: "sidebar.scrollToError",
          values: {
            count: item.errorsCount
          }
        })
      }, React__default.createElement(ErrorButtonContainer, null, React__default.createElement(ErrorButton, {
        size: "small",
        color: "secondary",
        onClick: openPanelAndScrollById(item)
      }, item.errorsCount && item.errorsCount))), React__default.createElement(Box, {
        fontWeight: "bold"
      }, (active || hovered) && React__default.createElement(SidebarIconWrapper, null, customSidebarIcon ? React__default.createElement("img", {
        src: customSidebarIconConfig.src,
        style: {
          maxWidth: '36px'
        }
      }) : React__default.createElement(SvgIconAllIconsUniconsPuzzlePiece24, null)), React__default.createElement(UpperLink, {
        underline: "none",
        color: "textPrimary",
        className: classNames('sidebar-link', {
          active: active
        }, {
          hovered: hovered
        }),
        onClick: openPanelAndScrollById(item),
        onMouseEnter: onMouseEvent,
        onMouseLeave: onMouseEvent
      }, item.title)), hasSubItems && React__default.createElement(AngleIconButton, {
        isUp: _open,
        isActive: active,
        onClick: setNewOpenItemId(itemId)
      }));
    }

    return null;
  };

  var renderSubItems = function renderSubItems(itemId, subItems) {
    var onMouseEvent = setNewHoveredItemId(itemId);

    if (localStore.openItemId === itemId) {
      var subItemsLastIndex = subItems.length - 1;
      return subItems.map(function (subItem, index) {
        var _localStore$activeSub;

        var subItemId = subItem.id;
        var activeSubItemId = (_localStore$activeSub = localStore.activeSubItem) === null || _localStore$activeSub === void 0 ? void 0 : _localStore$activeSub.id;
        var active = activeSubItemId === subItemId;
        var last = index === subItemsLastIndex;
        var onClickEvent = openPanelAndScrollById(subItem);
        return React__default.createElement(React__default.Fragment, {
          key: subItemId
        }, subItem.isShown && React__default.createElement("li", {
          key: subItemId,
          className: classNames('sidebar-subitem', {
            last: last
          })
        }, React__default.createElement("div", {
          onMouseEnter: onMouseEvent,
          onMouseLeave: onMouseEvent
        }, subItem.hasError && React__default.createElement(Tooltip, {
          title: React__default.createElement(FormattedMessage, {
            id: "sidebar.scrollToError",
            values: {
              count: subItem.errorsCount
            }
          })
        }, React__default.createElement(ErrorButtonContainer, null, React__default.createElement(ErrorButton, {
          size: "small",
          color: "secondary",
          onClick: onClickEvent
        }, subItem.errorsCount && subItem.errorsCount))), React__default.createElement(Link$1, {
          underline: "none",
          color: "textPrimary",
          className: classNames({
            active: active
          }),
          onClick: onClickEvent
        }, subItem.title))));
      });
    }

    return null;
  };

  var spyHandler = function spyHandler() {
    var panelHeight = theme === null || theme === void 0 ? void 0 : theme.variables.requestPanel.height;
    var spiedElementsLength = localStore.spiedEntities.length;

    for (var i = 0; i < spiedElementsLength; i++) {
      var entity = localStore.spiedEntities[i];
      var element = document.querySelector("#" + entity.id);

      if (element && ElementPositionUtils.isPartOfElementInView(element, headerHeight, panelHeight)) {
        if (entity.parentId) {
          setNewActiveSubItem(entity);
        } else {
          setNewActiveItem(entity);
        }

        break;
      }
    }
  };

  var stickyHandler = function stickyHandler() {
    if (sidebarContainerRef.current) {
      var newStickyStatus = !ElementPositionUtils.isTopOfElementInView(sidebarContainerRef.current, headerHeight || 0);

      if (localStore.isSidebarSticky !== newStickyStatus) {
        localStore.isSidebarSticky = newStickyStatus;
      }
    }
  };

  var setNewActiveItem = function setNewActiveItem(item) {
    localStore.activeItem = item;
    localStore.activeSubItem = findActiveSubItem(item);
    localStore.openItemId = item.id;
  };

  var setNewActiveSubItem = function setNewActiveSubItem(subItem) {
    var parentId = subItem.parentId;
    var newActiveItem = localStore.sidebarItems.find(function (item) {
      return item.id === parentId;
    });
    localStore.activeItem = newActiveItem;
    localStore.activeSubItem = subItem;
    localStore.openItemId = parentId;
  };

  var findActiveSubItem = function findActiveSubItem(parentItem) {
    return parentItem.subItems.find(function (subItem) {
      return subItem.isShown;
    });
  };

  return React__default.createElement(StyledSidebar, {
    item: true,
    open: open,
    headerHeight: headerHeight,
    stickyHeader: stickyHeader,
    className: "sidebar-container",
    ref: sidebarContainerRef
  }, React__default.createElement("nav", {
    className: classNames('sidebar', {
      sticky: localStore.isSidebarSticky,
      stickyHeader: stickyHeader,
      'sidebar--closed': !open
    })
  }, React__default.createElement(Tooltip, {
    title: React__default.createElement(FormattedMessage, {
      id: open ? 'campaignRequest.expandWorkArea' : 'campaignRequest.reduceWorkArea'
    })
  }, React__default.createElement(SidebarCollapseButton, {
    onClick: toggleSidebar
  }, open ? React__default.createElement(SwapHorizSharpIcon, null) : React__default.createElement(CompareArrowsSharpIcon, null))), React__default.createElement("ul", {
    className: classNames('sidebar-list', {
      'sidebar-list--closed': !open
    })
  }, sidebarItems.map(function (item) {
    var itemId = item.id;
    var subItems = item.subItems;
    var Item = renderItem(item, itemId, subItems);
    var SubItems = renderSubItems(itemId, subItems);
    return [Item, SubItems];
  }))));
});

var AuthorizedTab = observer$1(function (props) {
  var permCode = props.permCode,
      entityCode = props.entityCode,
      entityId = props.entityId,
      pendingElement = props.pendingElement,
      onAllowed = props.onAllowed,
      errorElement = props.errorElement,
      restProps = _objectWithoutPropertiesLoose(props, ["permCode", "entityCode", "entityId", "pendingElement", "onAllowed", "errorElement"]);

  var _di = di([AuthorizationCheck], AuthorizedTab),
      AuthorizationCheck$1 = _di[0];

  return React__default.createElement(AuthorizationCheck$1, {
    entityCode: entityCode,
    permCode: permCode,
    entityId: entityId,
    pendingElement: pendingElement,
    onAllowed: onAllowed,
    errorElement: errorElement
  }, React__default.createElement(Tab, Object.assign({}, restProps)));
});

var DisabledAuthorizedTab = function DisabledAuthorizedTab(props) {
  var to = props.to,
      entityCode = props.entityCode,
      entityId = props.entityId,
      permCode = props.permCode,
      label = props.label,
      index = props.index,
      tooltipTitle = props.tooltipTitle;
  return React__default.createElement(AuthorizationCheck, {
    entityCode: entityCode,
    entityId: entityId,
    permCode: permCode
  }, function (allowed) {
    return React__default.createElement(Tooltip, {
      title: allowed ? '' : tooltipTitle
    }, React__default.createElement("span", null, React__default.createElement(Tab, {
      disabled: !allowed,
      key: index,
      tabIndex: index,
      value: index,
      component: NavLink,
      to: to,
      label: label
    })));
  });
};

var ActionMenuItem = function ActionMenuItem(props) {
  var path = props.path,
      messageId = props.messageId,
      rest = _objectWithoutPropertiesLoose(props, ["path", "messageId"]);

  return React__default.createElement(MenuItem, Object.assign({
    dense: true,
    button: true
  }, rest), path ? React__default.createElement(Link$1, {
    component: NavLink,
    underline: "none",
    to: path,
    style: {
      color: 'inherit'
    }
  }, React__default.createElement(FormattedMessage, {
    id: messageId
  })) : React__default.createElement(FormattedMessage, {
    id: messageId
  }));
};

function _templateObject$i() {
  var data = _taggedTemplateLiteralLoose(["\n        flex-grow: 1;\n        flex-shrink: 1;\n        flex-basis: 0;\n    "]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var AppContentContainer = withTheme(styled.main.attrs(function () {
  return {
    className: 'app-content-container'
  };
})(_templateObject$i()));

var DeleteActionMenuItem = function DeleteActionMenuItem(props) {
  var tabIndex = props.tabIndex,
      onClick = props.onClick;
  return React__default.createElement(MenuItem, {
    dense: true,
    button: true,
    tabIndex: tabIndex,
    onClick: onClick
  }, React__default.createElement(FormattedMessage, {
    id: "common.delete"
  }));
};

var useFileDownloadStyles = makeStyles$1(function (theme) {
  return {
    link: {
      textAlign: 'left'
    },
    requiredField: {
      color: theme.palette.error.main,
      paddingLeft: theme.spacing(1),
      display: 'inline'
    }
  };
});
var FileDownload = function FileDownload(props) {
  var fileName = props.fileName,
      title = props.title,
      downloadFile = props.downloadFile,
      fontSize = props.fontSize,
      required = props.required;
  var classes = useFileDownloadStyles();

  var _useStore = useStore(),
      intl = _useStore.intlStore;

  if (!fileName) {
    return React__default.createElement(React__default.Fragment, null, title, required && React__default.createElement("span", {
      className: classes.requiredField
    }, "*"));
  }

  return React__default.createElement(Tooltip, {
    title: intl.formatMessage('common.downloadFile', {
      fileName: fileName
    })
  }, React__default.createElement(Link$1, {
    className: classes.link,
    component: "button",
    underline: "none",
    onClick: downloadFile
  }, React__default.createElement(Typography, {
    variant: "subtitle2"
  }, React__default.createElement(Box, Object.assign({}, fontSize && {
    fontSize: fontSize
  }), title, required && React__default.createElement("span", {
    className: classes.requiredField
  }, "*")))));
};

var RouteLeavingGuard = function RouteLeavingGuard(props) {
  var when = props.when,
      navigate = props.navigate,
      shouldBlockNavigation = props.shouldBlockNavigation,
      title = props.title,
      message = props.message;

  var _di = di([ConfirmationDialog], RouteLeavingGuard),
      ConfirmationDialog$1 = _di[0];

  var _useModal = useModal(),
      isModalOpen = _useModal[0],
      setModalIsOpen = _useModal[1],
      setModalIsClosed = _useModal[2];

  var _useState = useState(null),
      lastLocation = _useState[0],
      setLastLocation = _useState[1];

  var _useState2 = useState(false),
      confirmedNavigation = _useState2[0],
      setConfirmedNavigation = _useState2[1];

  var handleBlockedNavigation = function handleBlockedNavigation(nextLocation) {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setModalIsOpen();
      setLastLocation(nextLocation);
      return false;
    }

    return true;
  };

  var handleConfirmNavigationClick = function handleConfirmNavigationClick() {
    setModalIsOpen();
    setConfirmedNavigation(true);
    return Promise.resolve();
  };

  useEffect(function () {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.pathname);
    }
  }, [confirmedNavigation, lastLocation, navigate]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Prompt, {
    when: when,
    message: handleBlockedNavigation
  }), React__default.createElement(ConfirmationDialog$1, {
    id: "prompt-dialog",
    open: isModalOpen,
    onConfirm: handleConfirmNavigationClick,
    onCancel: setModalIsClosed,
    title: title,
    message: message,
    keepMounted: true
  }));
};

var TotDropzoneArea = withStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    dropZone: {
      minHeight: 'unset',
      outlineColor: palette.primary.main
    }
  };
})(DropzoneArea);

var TotIntlProvider = observer$1(function (props) {
  var children = props.children;

  var _useStore = useStore(),
      intlStore = _useStore.intlStore;

  return React__default.createElement(RawIntlProvider, {
    value: intlStore.intl
  }, children);
});

var YMetrika = observer$1(function () {
  var _useStore = useStore(),
      env = _useStore.env,
      personStore = _useStore.personStore,
      authorizationStore = _useStore.authorizationStore,
      history = _useStore.history;

  var _useState = useState(true),
      isAdmin = _useState[0],
      setIsAdmin = _useState[1];

  useEffect(function () {
    var entityCode = entities.System;
    var permCode = permissions.System.Administration;

    if (!personStore.user.id || !env.yaMetrikaId) {
      return;
    }

    authorizationStore.check({
      entityCode: entityCode,
      permCode: permCode
    }).then(function (allowed) {
      setIsAdmin(allowed);

      if (allowed) {
        return;
      }

      history.listen(function (location) {
        ym('hit', location.pathname);
      });
    });
  }, [authorizationStore, env, history, personStore.user.id, setIsAdmin]);

  if (!isAdmin && env.yaMetrikaId && personStore.user.id) {
    return React__default.createElement(YMInitializer, {
      accounts: [env.yaMetrikaId],
      options: {
        defer: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
      },
      version: "2"
    });
  }

  return React__default.createElement(React__default.Fragment, null);
});

var RootUnwrapped = observer$1(function () {
  var _useStore = useStore(),
      appTheme = _useStore.appTheme;

  var _useFeature = useFeature('yaMetrika'),
      yaMetrika = _useFeature[0];

  return React__default.createElement(React__default.Fragment, null, yaMetrika && React__default.createElement(YMetrika, null), React__default.createElement(ThemeProvider, {
    theme: appTheme
  }, React__default.createElement(TotIntlProvider, null, React__default.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils,
    locale: ru$1
  }, React__default.createElement(App, null)))));
});
var RootWithFeatures = observer$1(function () {
  var _useStore2 = useStore(),
      features = _useStore2.features;

  return React__default.createElement(FeaturesProvider, {
    features: features
  }, React__default.createElement(RootUnwrapped, null));
});

var RootWithStore = function RootWithStore(props) {
  var _di = di([RootStore], RootWithStore),
      RootStore$1 = _di[0];

  var store = new RootStore$1(props);
  var theme = createAppTheme(store, props.createAppThemeOptions);
  store.setAppTheme(theme);
  return React__default.createElement(Router, {
    history: store.history
  }, React__default.createElement(Provider, Object.assign({}, store), React__default.createElement(StoreContext.Provider, {
    value: store
  }, React__default.createElement(RootWithFeatures, null))));
};

var Root = function Root(props) {
  return React__default.createElement(DiProvider, {
    use: props.use || []
  }, React__default.createElement(RootWithStore, Object.assign({}, props)));
};

export { AccentText, ActionMenuItem, AddPfTemplateButton, AdditionalCampaignPagesInj, AdditionalCampaignRegFormPagesInj, AdditionalCampaignSectionsInj, AdditionalCampaignSettingTabsInj, AdditionalCampaignSettingsPagesInj, AdditionalFiltersInj, AdditionalHeaderInj, AdditionalTitleLinkInj, AlertLink, AngleIconButton, Api, App, AppContentContainer, AppHeaderLinks, AppHeaderLinksList, AppRouterLink, ApprovalStore, Authentication, AuthenticationInfoPage, AuthenticationStore, AuthorizationCheck, AuthorizationCheckAll, AuthorizationStore, AuthorizedTab, AutocompleteProps, BreadcrumbsComponent, BreadcrumbsStore, BurgerMenu, CampaignCancelButton, CampaignCancelButtonWithDialog, CampaignCard, CampaignCardContent, CampaignCardWrapper, CampaignCreateDialog, CampaignEditButton, CampaignEditModeButtonsWithDialog, CampaignForm, CampaignGeneralSettings, CampaignHeadWithBackground, CampaignInfoModel, CampaignListModel, CampaignListPage, CampaignManagement, CampaignPage, CampaignPages, CampaignPfTemplateCard, CampaignPfTemplateFormDialog, CampaignPfTemplateListModel, CampaignPfTemplateModel, CampaignPfTemplateTab, CampaignRegForm, CampaignRegFormCard, CampaignRegFormInfoModel, CampaignRegFormTabs, CampaignRegFormsList, CampaignRequestActionsBtns, CampaignRequestCreateDialog, CampaignRequestForm, CampaignRequestListFilterPanel, CampaignRequestListModel, CampaignRequestListPage, CampaignRequestListPageNew, CampaignRequestPage, CampaignRequestPages, CampaignRequestPfListModel, CampaignRequestPfModel, CampaignRequestPrintForms, CampaignRequestPrintFormsList, CampaignRequestPrintFormsRow, CampaignRequestPrintFormsSignature, CampaignRequestPrintFormsTable, CampaignRequestRoutes, CampaignRequestStyledTab, CampaignRequestTable, CampaignRequestTabs, CampaignRequestsButton, CampaignSaveButton, CampaignSettingTabs, CampaignSettingsDeleteButton, CampaignSettingsPage, CampaignViewModeButtons, CampaignsStore, CampaingPfTemplateTabModel, CancelButtonButtonWithDialogInj, CardCampaignLink, CardLabel, CardTitle, CardValue, CatalogCodes, CatalogStore, ClearFilterButton, ConfirmationButtons, ConfirmationDialog, ConsoleModel, ConsolePage, ConsoleStore, CreateCampaignPage, DateRangeFilter, DateUtils, DeadlineStatus, DeleteActionMenuItem, DeleteRequestButtonInj, DigitalSignaturePfFormFields, DigitalSignaturePfFormFieldsCheckbox, DisabledAuthorizedTab, EditPermissionDialog, EllipsisBox, EmailField, ErrorButton, ErrorButtonContainer, ErrorDialog, ErrorIcon, ErrorMessage, EsiaGetAuthUrlPage, EsiaLoginPage, EsiaPages, ExecutorEditDialog, FileComponent, FileDownload, FileListComponent, Filter, Footer, FooterButtonInj, FooterContactInformation, FooterLogo, FooterTypography, FooterWrapperInj, FormioSignatureStore, FormioStore, HeaderHeightStore, HeaderLinksGridWrapper, HeaderLinksListWrapper, HeaderLinksStore, IconButtonLarge, IconLink, InSetFilter, IntlStore, LanguageButton, LifeCycleTransitionConfirmationDialog, LikeFilter, LkNotificationStore, LoginDialog, LoginModel, LogoImg, Logout, MenuButton, ModulesStore, NewPasswordModel, NewPasswordPage, NotAccentText, NotAllowed, NotFound, NotificationComponent, NotificationListModel, NotificationModel, NotificationStore, PageContentContainer, PaginationModel, PasswordField, PersonModel, PersonStore, PfListTooltipFileInj, PresetStore, RecoveryPasswordModel, RecoveryPasswordPage, RegFormCard, RegFormFilter, RegFormListModel, RegFormSelect, RegFormSelectPage, RegistrationConfirmModel, RegistrationConfirmPage, RegistrationModel, RegistrationPage, RequestActionsBar, RequestControlPanel, RequestDeadline, RequestDeadlineBoxInj, RequestFormModel, RequestFormPermissionSettingsTable, RequestFormSettingModel, RequestFormTabsSettingDialog, RequestFormTabsSettings, RequestFormTabsSettingsDroppableTableBody, RequestFormTabsSettingsTable, RequestFromTabsSettingsHeader, RequestHeader, RequestHeaderButtonWithDialogInj, RequestLogPage, RequestLogTable, RequestModel, RequestRowModel, RequestStateBoxInj, RequestStore, ReversedKeyboardTabIconInj, Root, RootStore, RouteLeavingGuard, RoutedTabs, SamlGetAuthUrlPage, SamlPages, Select, SelectCheckbox, SelectRegFormInj, Sidebar, SidebarCollapseButton, SidebarIconWrapper, SignatureStore, SnackbarComponent, Sort, StartAuthHeaderLink, StartPage, StartPageHeaderLink, StartPageHeaderLinks, StartPageICSTypographyInj, StartPageLandingTypographyInj, StartPageLoginLink, StartPageMenuItems, StartPageStyledContainerInj, StartPageTotXTypographyInj, StickyWrapper, StoreContext, StyledCircularProgress, StyledIconButtonInj, StyledPaginationItemInj, StyledSidebar, TableModel, TableToolbar, TemplatePermissionSettingsDialog, TitleWrapper, TotAppBar, TotBackground, TotBackgroundWithAvailableHeader, TotDropzoneArea, TotIntlProvider, TotObjectActionsBar, TotObjectDeleteButton, TotObjectHeader, TotObjectHeaderLabel, TotObjectHeaderLink, TotObjectHeaderValue, TotObjectMain, TotObjectTransitions, TotTablePagination, TransitionDialog, UpperLink, UserButton, UserControlPanel, UserEditDialog, UserHeader, UserListBlockButton, UserListDeleteButton, UserListFilterPanel, UserListModel, UserListPage, UserModel, UserNameModel, UserPage, UserPages, UserPersonModel, UserStore, YMetrika, additionalLinksInj, additionalPagesInj, apiConfigs, authSchemeConfig, bannedSymbols, breadCrumbsSettings, checkboxProps$1 as checkboxProps, chipProps, clientRoute, codeTitleToIdTitle, consoleEditorClass, consoleEditorStyles, consoleErrorClass, createAppTheme, createLandingThemeCreator, createThemes, defaultFormsLocale, defaultLocale, editMessage, en, entities, fileContentType, fileNameRegex, getAdditionalCampaignRegFormTabsRoutes, getAdditionalCampaignRegFormTabsRoutesInj, getAdditionalCampaignSettingTabsRoutesInj, getApi, getApprovalStore, getAuthenticationStore, getAuthorizationStore, getBreadcrumbsStore, getCampaignsStore, getCatalogStore, getConsoleStore, getEmailFromText, getFileName, getFormioSignatureStore, getFormioStore, getHeaderHeightStore, getHeaderLinksStore, getIntlStore, getLkNotificationStore, getModulesStore, getNotificationStore, getOrElse, getPersonStore, getPhoneNumberFromText, getPresetStore, getRequestStore, getRouteByRoles, getSignatureStore, getUserStore, handleAxiosErrorByResponseStatus, inputHeight, isEmail, loginRedirectByRole, mainRoutes, names, noOptionsText, permissions, permissionsConfig, pickerProps, recordToLang, renderAutoCompleteInput, renderDraggableRequestFormTabsSettingsTableRow, renderDroppableRequestFormTabsSettingsTableBodyInj, renderLink, renderOptionCampaignRegForm, renderPaginationItem, renderTransitions, reorderList, roleMessage, rolePriorities, rootElement, routesWithParams, ru, sassVars, settingsConfirmDialog, severityVariants, spacing, statusMessage, tabSize, tabsProps, taskStatus, textFieldProps, transitionDefault, useAccessPermissionStyles, useAntiDoubleClick, useCampaignRegFormsListStylesInj, useCampaignRequestPageStylesInj, useCampaignRequestTableStylesInj, useConsoleStyles, useDigitalSignatureCheckboxStylesInj, useDraggableRequestFormTabsSettingsTableRowStyle, useError, useFormStyles, useLoading, useLogo, useModal, usePermissionsActionButtons, useReload, useSettingsConfirmDialog, useStore, useTabStylesInj, validationErrorLink, withConfirmDialog };
//# sourceMappingURL=index.modern.js.map
